
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hAhso", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3ea27"));

});
parcelRegister("3ea27", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $259a76427006bc82$export$ffb0004e005737fa; }, function (v) { return $259a76427006bc82$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $259a76427006bc82$export$34b9dba7ce09269b; }, function (v) { return $259a76427006bc82$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $259a76427006bc82$export$25062201e9e25d76; }, function (v) { return $259a76427006bc82$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $259a76427006bc82$export$ffb0004e005737fa;
var $259a76427006bc82$export$34b9dba7ce09269b;
var $259a76427006bc82$export$25062201e9e25d76;
"use strict";

var $jzmb2 = parcelRequire("jzmb2");
var $259a76427006bc82$var$k = Symbol.for("react.element"), $259a76427006bc82$var$l = Symbol.for("react.fragment"), $259a76427006bc82$var$m = Object.prototype.hasOwnProperty, $259a76427006bc82$var$n = $jzmb2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $259a76427006bc82$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $259a76427006bc82$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$259a76427006bc82$var$m.call(a, b) && !$259a76427006bc82$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $259a76427006bc82$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $259a76427006bc82$var$n.current
    };
}
$259a76427006bc82$export$ffb0004e005737fa = $259a76427006bc82$var$l;
$259a76427006bc82$export$34b9dba7ce09269b = $259a76427006bc82$var$q;
$259a76427006bc82$export$25062201e9e25d76 = $259a76427006bc82$var$q;

});
parcelRegister("jzmb2", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kCUaG"));

});
parcelRegister("kCUaG", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f042edb789009059$export$dca3b0875bd9a954; }, function (v) { return $f042edb789009059$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f042edb789009059$export$16fa2f45be04daa8; }, function (v) { return $f042edb789009059$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f042edb789009059$export$ffb0004e005737fa; }, function (v) { return $f042edb789009059$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f042edb789009059$export$e2c29f18771995cb; }, function (v) { return $f042edb789009059$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f042edb789009059$export$221d75b3f55bb0bd; }, function (v) { return $f042edb789009059$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f042edb789009059$export$5f8d39834fd61797; }, function (v) { return $f042edb789009059$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f042edb789009059$export$74bf444e3cd11ea5; }, function (v) { return $f042edb789009059$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f042edb789009059$export$ae55be85d98224ed; }, function (v) { return $f042edb789009059$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f042edb789009059$export$e530037191fcd5d7; }, function (v) { return $f042edb789009059$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f042edb789009059$export$fd42f52fd3ae1109; }, function (v) { return $f042edb789009059$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f042edb789009059$export$c8a8987d4410bf2d; }, function (v) { return $f042edb789009059$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f042edb789009059$export$d38cd72104c1f0e9; }, function (v) { return $f042edb789009059$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f042edb789009059$export$7d1e3a5e95ceca43; }, function (v) { return $f042edb789009059$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f042edb789009059$export$257a8862b851cb5b; }, function (v) { return $f042edb789009059$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f042edb789009059$export$a8257692ac88316c; }, function (v) { return $f042edb789009059$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f042edb789009059$export$488013bae63b21da; }, function (v) { return $f042edb789009059$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f042edb789009059$export$7c73462e0d25e514; }, function (v) { return $f042edb789009059$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f042edb789009059$export$7568632d0d33d16d; }, function (v) { return $f042edb789009059$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f042edb789009059$export$88948ce120ea2619; }, function (v) { return $f042edb789009059$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f042edb789009059$export$35808ee640e87ca7; }, function (v) { return $f042edb789009059$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f042edb789009059$export$fae74005e78b1a27; }, function (v) { return $f042edb789009059$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f042edb789009059$export$dc8fbce3eb94dc1e; }, function (v) { return $f042edb789009059$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f042edb789009059$export$6a7bc4e911dc01cf; }, function (v) { return $f042edb789009059$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f042edb789009059$export$6d9c69b0de29b591; }, function (v) { return $f042edb789009059$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f042edb789009059$export$f680877a34711e37; }, function (v) { return $f042edb789009059$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f042edb789009059$export$d5a552a76deda3c2; }, function (v) { return $f042edb789009059$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f042edb789009059$export$aaabe4eda9ed9969; }, function (v) { return $f042edb789009059$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f042edb789009059$export$e5c5a5f917a5871c; }, function (v) { return $f042edb789009059$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f042edb789009059$export$1538c33de8887b59; }, function (v) { return $f042edb789009059$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f042edb789009059$export$13e3392192263954; }, function (v) { return $f042edb789009059$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f042edb789009059$export$b8f5890fc79d6aca; }, function (v) { return $f042edb789009059$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f042edb789009059$export$60241385465d0a34; }, function (v) { return $f042edb789009059$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f042edb789009059$export$306c0aa65ff9ec16; }, function (v) { return $f042edb789009059$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f042edb789009059$export$7b286972b8d8ccbf; }, function (v) { return $f042edb789009059$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f042edb789009059$export$83d89fbfd8236492; }, function (v) { return $f042edb789009059$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f042edb789009059$export$dca3b0875bd9a954;
var $f042edb789009059$export$16fa2f45be04daa8;
var $f042edb789009059$export$ffb0004e005737fa;
var $f042edb789009059$export$e2c29f18771995cb;
var $f042edb789009059$export$221d75b3f55bb0bd;
var $f042edb789009059$export$5f8d39834fd61797;
var $f042edb789009059$export$74bf444e3cd11ea5;
var $f042edb789009059$export$ae55be85d98224ed;
var $f042edb789009059$export$e530037191fcd5d7;
var $f042edb789009059$export$fd42f52fd3ae1109;
var $f042edb789009059$export$c8a8987d4410bf2d;
var $f042edb789009059$export$d38cd72104c1f0e9;
var $f042edb789009059$export$7d1e3a5e95ceca43;
var $f042edb789009059$export$257a8862b851cb5b;
var $f042edb789009059$export$a8257692ac88316c;
var $f042edb789009059$export$488013bae63b21da;
var $f042edb789009059$export$7c73462e0d25e514;
var $f042edb789009059$export$7568632d0d33d16d;
var $f042edb789009059$export$88948ce120ea2619;
var $f042edb789009059$export$35808ee640e87ca7;
var $f042edb789009059$export$fae74005e78b1a27;
var $f042edb789009059$export$dc8fbce3eb94dc1e;
var $f042edb789009059$export$6a7bc4e911dc01cf;
var $f042edb789009059$export$6d9c69b0de29b591;
var $f042edb789009059$export$f680877a34711e37;
var $f042edb789009059$export$d5a552a76deda3c2;
var $f042edb789009059$export$aaabe4eda9ed9969;
var $f042edb789009059$export$e5c5a5f917a5871c;
var $f042edb789009059$export$1538c33de8887b59;
var $f042edb789009059$export$13e3392192263954;
var $f042edb789009059$export$b8f5890fc79d6aca;
var $f042edb789009059$export$60241385465d0a34;
var $f042edb789009059$export$306c0aa65ff9ec16;
var $f042edb789009059$export$7b286972b8d8ccbf;
var $f042edb789009059$export$83d89fbfd8236492;
"use strict";
var $f042edb789009059$var$l = Symbol.for("react.element"), $f042edb789009059$var$n = Symbol.for("react.portal"), $f042edb789009059$var$p = Symbol.for("react.fragment"), $f042edb789009059$var$q = Symbol.for("react.strict_mode"), $f042edb789009059$var$r = Symbol.for("react.profiler"), $f042edb789009059$var$t = Symbol.for("react.provider"), $f042edb789009059$var$u = Symbol.for("react.context"), $f042edb789009059$var$v = Symbol.for("react.forward_ref"), $f042edb789009059$var$w = Symbol.for("react.suspense"), $f042edb789009059$var$x = Symbol.for("react.memo"), $f042edb789009059$var$y = Symbol.for("react.lazy"), $f042edb789009059$var$z = Symbol.iterator;
function $f042edb789009059$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f042edb789009059$var$z && a[$f042edb789009059$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f042edb789009059$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f042edb789009059$var$C = Object.assign, $f042edb789009059$var$D = {};
function $f042edb789009059$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f042edb789009059$var$D;
    this.updater = e || $f042edb789009059$var$B;
}
$f042edb789009059$var$E.prototype.isReactComponent = {};
$f042edb789009059$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f042edb789009059$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f042edb789009059$var$F() {}
$f042edb789009059$var$F.prototype = $f042edb789009059$var$E.prototype;
function $f042edb789009059$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f042edb789009059$var$D;
    this.updater = e || $f042edb789009059$var$B;
}
var $f042edb789009059$var$H = $f042edb789009059$var$G.prototype = new $f042edb789009059$var$F;
$f042edb789009059$var$H.constructor = $f042edb789009059$var$G;
$f042edb789009059$var$C($f042edb789009059$var$H, $f042edb789009059$var$E.prototype);
$f042edb789009059$var$H.isPureReactComponent = !0;
var $f042edb789009059$var$I = Array.isArray, $f042edb789009059$var$J = Object.prototype.hasOwnProperty, $f042edb789009059$var$K = {
    current: null
}, $f042edb789009059$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f042edb789009059$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f042edb789009059$var$J.call(b, d) && !$f042edb789009059$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f042edb789009059$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f042edb789009059$var$K.current
    };
}
function $f042edb789009059$var$N(a, b) {
    return {
        $$typeof: $f042edb789009059$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f042edb789009059$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f042edb789009059$var$l;
}
function $f042edb789009059$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f042edb789009059$var$P = /\/+/g;
function $f042edb789009059$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f042edb789009059$var$escape("" + a.key) : b.toString(36);
}
function $f042edb789009059$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f042edb789009059$var$l:
                case $f042edb789009059$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f042edb789009059$var$Q(h, 0) : d, $f042edb789009059$var$I(c) ? (e = "", null != a && (e = a.replace($f042edb789009059$var$P, "$&/") + "/"), $f042edb789009059$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f042edb789009059$var$O(c) && (c = $f042edb789009059$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f042edb789009059$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f042edb789009059$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f042edb789009059$var$Q(k, g);
        h += $f042edb789009059$var$R(k, b, e, f, c);
    }
    else if (f = $f042edb789009059$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f042edb789009059$var$Q(k, g++), h += $f042edb789009059$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f042edb789009059$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f042edb789009059$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f042edb789009059$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f042edb789009059$var$U = {
    current: null
}, $f042edb789009059$var$V = {
    transition: null
}, $f042edb789009059$var$W = {
    ReactCurrentDispatcher: $f042edb789009059$var$U,
    ReactCurrentBatchConfig: $f042edb789009059$var$V,
    ReactCurrentOwner: $f042edb789009059$var$K
};
$f042edb789009059$export$dca3b0875bd9a954 = {
    map: $f042edb789009059$var$S,
    forEach: function(a, b, e) {
        $f042edb789009059$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f042edb789009059$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f042edb789009059$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f042edb789009059$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f042edb789009059$export$16fa2f45be04daa8 = $f042edb789009059$var$E;
$f042edb789009059$export$ffb0004e005737fa = $f042edb789009059$var$p;
$f042edb789009059$export$e2c29f18771995cb = $f042edb789009059$var$r;
$f042edb789009059$export$221d75b3f55bb0bd = $f042edb789009059$var$G;
$f042edb789009059$export$5f8d39834fd61797 = $f042edb789009059$var$q;
$f042edb789009059$export$74bf444e3cd11ea5 = $f042edb789009059$var$w;
$f042edb789009059$export$ae55be85d98224ed = $f042edb789009059$var$W;
$f042edb789009059$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f042edb789009059$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f042edb789009059$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f042edb789009059$var$J.call(b, f) && !$f042edb789009059$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f042edb789009059$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f042edb789009059$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f042edb789009059$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f042edb789009059$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f042edb789009059$export$c8a8987d4410bf2d = $f042edb789009059$var$M;
$f042edb789009059$export$d38cd72104c1f0e9 = function(a) {
    var b = $f042edb789009059$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f042edb789009059$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f042edb789009059$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f042edb789009059$var$v,
        render: a
    };
};
$f042edb789009059$export$a8257692ac88316c = $f042edb789009059$var$O;
$f042edb789009059$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f042edb789009059$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f042edb789009059$var$T
    };
};
$f042edb789009059$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f042edb789009059$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f042edb789009059$export$7568632d0d33d16d = function(a) {
    var b = $f042edb789009059$var$V.transition;
    $f042edb789009059$var$V.transition = {};
    try {
        a();
    } finally{
        $f042edb789009059$var$V.transition = b;
    }
};
$f042edb789009059$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$f042edb789009059$export$35808ee640e87ca7 = function(a, b) {
    return $f042edb789009059$var$U.current.useCallback(a, b);
};
$f042edb789009059$export$fae74005e78b1a27 = function(a) {
    return $f042edb789009059$var$U.current.useContext(a);
};
$f042edb789009059$export$dc8fbce3eb94dc1e = function() {};
$f042edb789009059$export$6a7bc4e911dc01cf = function(a) {
    return $f042edb789009059$var$U.current.useDeferredValue(a);
};
$f042edb789009059$export$6d9c69b0de29b591 = function(a, b) {
    return $f042edb789009059$var$U.current.useEffect(a, b);
};
$f042edb789009059$export$f680877a34711e37 = function() {
    return $f042edb789009059$var$U.current.useId();
};
$f042edb789009059$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f042edb789009059$var$U.current.useImperativeHandle(a, b, e);
};
$f042edb789009059$export$aaabe4eda9ed9969 = function(a, b) {
    return $f042edb789009059$var$U.current.useInsertionEffect(a, b);
};
$f042edb789009059$export$e5c5a5f917a5871c = function(a, b) {
    return $f042edb789009059$var$U.current.useLayoutEffect(a, b);
};
$f042edb789009059$export$1538c33de8887b59 = function(a, b) {
    return $f042edb789009059$var$U.current.useMemo(a, b);
};
$f042edb789009059$export$13e3392192263954 = function(a, b, e) {
    return $f042edb789009059$var$U.current.useReducer(a, b, e);
};
$f042edb789009059$export$b8f5890fc79d6aca = function(a) {
    return $f042edb789009059$var$U.current.useRef(a);
};
$f042edb789009059$export$60241385465d0a34 = function(a) {
    return $f042edb789009059$var$U.current.useState(a);
};
$f042edb789009059$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f042edb789009059$var$U.current.useSyncExternalStore(a, b, e);
};
$f042edb789009059$export$7b286972b8d8ccbf = function() {
    return $f042edb789009059$var$U.current.useTransition();
};
$f042edb789009059$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("kEmcy", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f088c3cfa4ce44ec$export$ae55be85d98224ed; }, function (v) { return $f088c3cfa4ce44ec$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $f088c3cfa4ce44ec$export$d39a5bbd09211389; }, function (v) { return $f088c3cfa4ce44ec$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $f088c3cfa4ce44ec$export$882461b6382ed46c; }, function (v) { return $f088c3cfa4ce44ec$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $f088c3cfa4ce44ec$export$466bfc07425424d5; }, function (v) { return $f088c3cfa4ce44ec$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $f088c3cfa4ce44ec$export$cd75ccfd720a3cd4; }, function (v) { return $f088c3cfa4ce44ec$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $f088c3cfa4ce44ec$export$fa8d919ba61d84db; }, function (v) { return $f088c3cfa4ce44ec$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $f088c3cfa4ce44ec$export$757ceba2d55c277e; }, function (v) { return $f088c3cfa4ce44ec$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $f088c3cfa4ce44ec$export$b3890eb0ae9dca99; }, function (v) { return $f088c3cfa4ce44ec$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $f088c3cfa4ce44ec$export$502457920280e6be; }, function (v) { return $f088c3cfa4ce44ec$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $f088c3cfa4ce44ec$export$c78a37762a8d58e1; }, function (v) { return $f088c3cfa4ce44ec$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $f088c3cfa4ce44ec$export$dc54d992c10e8a18; }, function (v) { return $f088c3cfa4ce44ec$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $f088c3cfa4ce44ec$export$83d89fbfd8236492; }, function (v) { return $f088c3cfa4ce44ec$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f088c3cfa4ce44ec$export$ae55be85d98224ed;
var $f088c3cfa4ce44ec$export$d39a5bbd09211389;
var $f088c3cfa4ce44ec$export$882461b6382ed46c;
var $f088c3cfa4ce44ec$export$466bfc07425424d5;
var $f088c3cfa4ce44ec$export$cd75ccfd720a3cd4;
var $f088c3cfa4ce44ec$export$fa8d919ba61d84db;
var $f088c3cfa4ce44ec$export$757ceba2d55c277e;
var $f088c3cfa4ce44ec$export$b3890eb0ae9dca99;
var $f088c3cfa4ce44ec$export$502457920280e6be;
var $f088c3cfa4ce44ec$export$c78a37762a8d58e1;
var $f088c3cfa4ce44ec$export$dc54d992c10e8a18;
var $f088c3cfa4ce44ec$export$83d89fbfd8236492;
"use strict";

var $jzmb2 = parcelRequire("jzmb2");

var $lNe8F = parcelRequire("lNe8F");
function $f088c3cfa4ce44ec$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f088c3cfa4ce44ec$var$da = new Set, $f088c3cfa4ce44ec$var$ea = {};
function $f088c3cfa4ce44ec$var$fa(a, b) {
    $f088c3cfa4ce44ec$var$ha(a, b);
    $f088c3cfa4ce44ec$var$ha(a + "Capture", b);
}
function $f088c3cfa4ce44ec$var$ha(a, b) {
    $f088c3cfa4ce44ec$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f088c3cfa4ce44ec$var$da.add(b[a]);
}
var $f088c3cfa4ce44ec$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f088c3cfa4ce44ec$var$ja = Object.prototype.hasOwnProperty, $f088c3cfa4ce44ec$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f088c3cfa4ce44ec$var$la = {}, $f088c3cfa4ce44ec$var$ma = {};
function $f088c3cfa4ce44ec$var$oa(a) {
    if ($f088c3cfa4ce44ec$var$ja.call($f088c3cfa4ce44ec$var$ma, a)) return !0;
    if ($f088c3cfa4ce44ec$var$ja.call($f088c3cfa4ce44ec$var$la, a)) return !1;
    if ($f088c3cfa4ce44ec$var$ka.test(a)) return $f088c3cfa4ce44ec$var$ma[a] = !0;
    $f088c3cfa4ce44ec$var$la[a] = !0;
    return !1;
}
function $f088c3cfa4ce44ec$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f088c3cfa4ce44ec$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f088c3cfa4ce44ec$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f088c3cfa4ce44ec$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f088c3cfa4ce44ec$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f088c3cfa4ce44ec$var$z[b] = new $f088c3cfa4ce44ec$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f088c3cfa4ce44ec$var$ra = /[\-:]([a-z])/g;
function $f088c3cfa4ce44ec$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f088c3cfa4ce44ec$var$ra, $f088c3cfa4ce44ec$var$sa);
    $f088c3cfa4ce44ec$var$z[b] = new $f088c3cfa4ce44ec$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f088c3cfa4ce44ec$var$ra, $f088c3cfa4ce44ec$var$sa);
    $f088c3cfa4ce44ec$var$z[b] = new $f088c3cfa4ce44ec$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f088c3cfa4ce44ec$var$ra, $f088c3cfa4ce44ec$var$sa);
    $f088c3cfa4ce44ec$var$z[b] = new $f088c3cfa4ce44ec$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f088c3cfa4ce44ec$var$z.xlinkHref = new $f088c3cfa4ce44ec$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f088c3cfa4ce44ec$var$z[a] = new $f088c3cfa4ce44ec$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f088c3cfa4ce44ec$var$ta(a, b, c, d) {
    var e = $f088c3cfa4ce44ec$var$z.hasOwnProperty(b) ? $f088c3cfa4ce44ec$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f088c3cfa4ce44ec$var$qa(b, c, e, d) && (c = null), d || null === e ? $f088c3cfa4ce44ec$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f088c3cfa4ce44ec$var$ua = $jzmb2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f088c3cfa4ce44ec$var$va = Symbol.for("react.element"), $f088c3cfa4ce44ec$var$wa = Symbol.for("react.portal"), $f088c3cfa4ce44ec$var$ya = Symbol.for("react.fragment"), $f088c3cfa4ce44ec$var$za = Symbol.for("react.strict_mode"), $f088c3cfa4ce44ec$var$Aa = Symbol.for("react.profiler"), $f088c3cfa4ce44ec$var$Ba = Symbol.for("react.provider"), $f088c3cfa4ce44ec$var$Ca = Symbol.for("react.context"), $f088c3cfa4ce44ec$var$Da = Symbol.for("react.forward_ref"), $f088c3cfa4ce44ec$var$Ea = Symbol.for("react.suspense"), $f088c3cfa4ce44ec$var$Fa = Symbol.for("react.suspense_list"), $f088c3cfa4ce44ec$var$Ga = Symbol.for("react.memo"), $f088c3cfa4ce44ec$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f088c3cfa4ce44ec$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f088c3cfa4ce44ec$var$Ja = Symbol.iterator;
function $f088c3cfa4ce44ec$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f088c3cfa4ce44ec$var$Ja && a[$f088c3cfa4ce44ec$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f088c3cfa4ce44ec$var$A = Object.assign, $f088c3cfa4ce44ec$var$La;
function $f088c3cfa4ce44ec$var$Ma(a) {
    if (void 0 === $f088c3cfa4ce44ec$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f088c3cfa4ce44ec$var$La = b && b[1] || "";
    }
    return "\n" + $f088c3cfa4ce44ec$var$La + a;
}
var $f088c3cfa4ce44ec$var$Na = !1;
function $f088c3cfa4ce44ec$var$Oa(a, b) {
    if (!a || $f088c3cfa4ce44ec$var$Na) return "";
    $f088c3cfa4ce44ec$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f088c3cfa4ce44ec$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f088c3cfa4ce44ec$var$Ma(a) : "";
}
function $f088c3cfa4ce44ec$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f088c3cfa4ce44ec$var$Ma(a.type);
        case 16:
            return $f088c3cfa4ce44ec$var$Ma("Lazy");
        case 13:
            return $f088c3cfa4ce44ec$var$Ma("Suspense");
        case 19:
            return $f088c3cfa4ce44ec$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f088c3cfa4ce44ec$var$Oa(a.type, !1), a;
        case 11:
            return a = $f088c3cfa4ce44ec$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f088c3cfa4ce44ec$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f088c3cfa4ce44ec$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f088c3cfa4ce44ec$var$ya:
            return "Fragment";
        case $f088c3cfa4ce44ec$var$wa:
            return "Portal";
        case $f088c3cfa4ce44ec$var$Aa:
            return "Profiler";
        case $f088c3cfa4ce44ec$var$za:
            return "StrictMode";
        case $f088c3cfa4ce44ec$var$Ea:
            return "Suspense";
        case $f088c3cfa4ce44ec$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f088c3cfa4ce44ec$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f088c3cfa4ce44ec$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f088c3cfa4ce44ec$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f088c3cfa4ce44ec$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f088c3cfa4ce44ec$var$Qa(a.type) || "Memo";
        case $f088c3cfa4ce44ec$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f088c3cfa4ce44ec$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f088c3cfa4ce44ec$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f088c3cfa4ce44ec$var$Qa(b);
        case 8:
            return b === $f088c3cfa4ce44ec$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f088c3cfa4ce44ec$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f088c3cfa4ce44ec$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f088c3cfa4ce44ec$var$Ua(a) {
    var b = $f088c3cfa4ce44ec$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f088c3cfa4ce44ec$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f088c3cfa4ce44ec$var$Ua(a));
}
function $f088c3cfa4ce44ec$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f088c3cfa4ce44ec$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f088c3cfa4ce44ec$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f088c3cfa4ce44ec$var$Ya(a, b) {
    var c = b.checked;
    return $f088c3cfa4ce44ec$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f088c3cfa4ce44ec$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f088c3cfa4ce44ec$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f088c3cfa4ce44ec$var$ab(a, b) {
    b = b.checked;
    null != b && $f088c3cfa4ce44ec$var$ta(a, "checked", b, !1);
}
function $f088c3cfa4ce44ec$var$bb(a, b) {
    $f088c3cfa4ce44ec$var$ab(a, b);
    var c = $f088c3cfa4ce44ec$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f088c3cfa4ce44ec$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f088c3cfa4ce44ec$var$cb(a, b.type, $f088c3cfa4ce44ec$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f088c3cfa4ce44ec$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f088c3cfa4ce44ec$var$cb(a, b, c) {
    if ("number" !== b || $f088c3cfa4ce44ec$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f088c3cfa4ce44ec$var$eb = Array.isArray;
function $f088c3cfa4ce44ec$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f088c3cfa4ce44ec$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f088c3cfa4ce44ec$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f088c3cfa4ce44ec$var$p(91));
    return $f088c3cfa4ce44ec$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f088c3cfa4ce44ec$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f088c3cfa4ce44ec$var$p(92));
            if ($f088c3cfa4ce44ec$var$eb(c)) {
                if (1 < c.length) throw Error($f088c3cfa4ce44ec$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f088c3cfa4ce44ec$var$Sa(c)
    };
}
function $f088c3cfa4ce44ec$var$ib(a, b) {
    var c = $f088c3cfa4ce44ec$var$Sa(b.value), d = $f088c3cfa4ce44ec$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f088c3cfa4ce44ec$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f088c3cfa4ce44ec$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f088c3cfa4ce44ec$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f088c3cfa4ce44ec$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f088c3cfa4ce44ec$var$mb, $f088c3cfa4ce44ec$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f088c3cfa4ce44ec$var$mb = $f088c3cfa4ce44ec$var$mb || document.createElement("div");
        $f088c3cfa4ce44ec$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f088c3cfa4ce44ec$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f088c3cfa4ce44ec$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f088c3cfa4ce44ec$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f088c3cfa4ce44ec$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f088c3cfa4ce44ec$var$pb).forEach(function(a) {
    $f088c3cfa4ce44ec$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f088c3cfa4ce44ec$var$pb[b] = $f088c3cfa4ce44ec$var$pb[a];
    });
});
function $f088c3cfa4ce44ec$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f088c3cfa4ce44ec$var$pb.hasOwnProperty(a) && $f088c3cfa4ce44ec$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f088c3cfa4ce44ec$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f088c3cfa4ce44ec$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f088c3cfa4ce44ec$var$tb = $f088c3cfa4ce44ec$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f088c3cfa4ce44ec$var$ub(a, b) {
    if (b) {
        if ($f088c3cfa4ce44ec$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f088c3cfa4ce44ec$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f088c3cfa4ce44ec$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f088c3cfa4ce44ec$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f088c3cfa4ce44ec$var$p(62));
    }
}
function $f088c3cfa4ce44ec$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f088c3cfa4ce44ec$var$wb = null;
function $f088c3cfa4ce44ec$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f088c3cfa4ce44ec$var$yb = null, $f088c3cfa4ce44ec$var$zb = null, $f088c3cfa4ce44ec$var$Ab = null;
function $f088c3cfa4ce44ec$var$Bb(a) {
    if (a = $f088c3cfa4ce44ec$var$Cb(a)) {
        if ("function" !== typeof $f088c3cfa4ce44ec$var$yb) throw Error($f088c3cfa4ce44ec$var$p(280));
        var b = a.stateNode;
        b && (b = $f088c3cfa4ce44ec$var$Db(b), $f088c3cfa4ce44ec$var$yb(a.stateNode, a.type, b));
    }
}
function $f088c3cfa4ce44ec$var$Eb(a) {
    $f088c3cfa4ce44ec$var$zb ? $f088c3cfa4ce44ec$var$Ab ? $f088c3cfa4ce44ec$var$Ab.push(a) : $f088c3cfa4ce44ec$var$Ab = [
        a
    ] : $f088c3cfa4ce44ec$var$zb = a;
}
function $f088c3cfa4ce44ec$var$Fb() {
    if ($f088c3cfa4ce44ec$var$zb) {
        var a = $f088c3cfa4ce44ec$var$zb, b = $f088c3cfa4ce44ec$var$Ab;
        $f088c3cfa4ce44ec$var$Ab = $f088c3cfa4ce44ec$var$zb = null;
        $f088c3cfa4ce44ec$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f088c3cfa4ce44ec$var$Bb(b[a]);
    }
}
function $f088c3cfa4ce44ec$var$Gb(a, b) {
    return a(b);
}
function $f088c3cfa4ce44ec$var$Hb() {}
var $f088c3cfa4ce44ec$var$Ib = !1;
function $f088c3cfa4ce44ec$var$Jb(a, b, c) {
    if ($f088c3cfa4ce44ec$var$Ib) return a(b, c);
    $f088c3cfa4ce44ec$var$Ib = !0;
    try {
        return $f088c3cfa4ce44ec$var$Gb(a, b, c);
    } finally{
        if ($f088c3cfa4ce44ec$var$Ib = !1, null !== $f088c3cfa4ce44ec$var$zb || null !== $f088c3cfa4ce44ec$var$Ab) $f088c3cfa4ce44ec$var$Hb(), $f088c3cfa4ce44ec$var$Fb();
    }
}
function $f088c3cfa4ce44ec$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f088c3cfa4ce44ec$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f088c3cfa4ce44ec$var$p(231, b, typeof c));
    return c;
}
var $f088c3cfa4ce44ec$var$Lb = !1;
if ($f088c3cfa4ce44ec$var$ia) try {
    var $f088c3cfa4ce44ec$var$Mb = {};
    Object.defineProperty($f088c3cfa4ce44ec$var$Mb, "passive", {
        get: function() {
            $f088c3cfa4ce44ec$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f088c3cfa4ce44ec$var$Mb, $f088c3cfa4ce44ec$var$Mb);
    window.removeEventListener("test", $f088c3cfa4ce44ec$var$Mb, $f088c3cfa4ce44ec$var$Mb);
} catch (a) {
    $f088c3cfa4ce44ec$var$Lb = !1;
}
function $f088c3cfa4ce44ec$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f088c3cfa4ce44ec$var$Ob = !1, $f088c3cfa4ce44ec$var$Pb = null, $f088c3cfa4ce44ec$var$Qb = !1, $f088c3cfa4ce44ec$var$Rb = null, $f088c3cfa4ce44ec$var$Sb = {
    onError: function(a) {
        $f088c3cfa4ce44ec$var$Ob = !0;
        $f088c3cfa4ce44ec$var$Pb = a;
    }
};
function $f088c3cfa4ce44ec$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f088c3cfa4ce44ec$var$Ob = !1;
    $f088c3cfa4ce44ec$var$Pb = null;
    $f088c3cfa4ce44ec$var$Nb.apply($f088c3cfa4ce44ec$var$Sb, arguments);
}
function $f088c3cfa4ce44ec$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f088c3cfa4ce44ec$var$Tb.apply(this, arguments);
    if ($f088c3cfa4ce44ec$var$Ob) {
        if ($f088c3cfa4ce44ec$var$Ob) {
            var l = $f088c3cfa4ce44ec$var$Pb;
            $f088c3cfa4ce44ec$var$Ob = !1;
            $f088c3cfa4ce44ec$var$Pb = null;
        } else throw Error($f088c3cfa4ce44ec$var$p(198));
        $f088c3cfa4ce44ec$var$Qb || ($f088c3cfa4ce44ec$var$Qb = !0, $f088c3cfa4ce44ec$var$Rb = l);
    }
}
function $f088c3cfa4ce44ec$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f088c3cfa4ce44ec$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f088c3cfa4ce44ec$var$Xb(a) {
    if ($f088c3cfa4ce44ec$var$Vb(a) !== a) throw Error($f088c3cfa4ce44ec$var$p(188));
}
function $f088c3cfa4ce44ec$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f088c3cfa4ce44ec$var$Vb(a);
        if (null === b) throw Error($f088c3cfa4ce44ec$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f088c3cfa4ce44ec$var$Xb(e), a;
                if (f === d) return $f088c3cfa4ce44ec$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f088c3cfa4ce44ec$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f088c3cfa4ce44ec$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f088c3cfa4ce44ec$var$p(190));
    }
    if (3 !== c.tag) throw Error($f088c3cfa4ce44ec$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f088c3cfa4ce44ec$var$Zb(a) {
    a = $f088c3cfa4ce44ec$var$Yb(a);
    return null !== a ? $f088c3cfa4ce44ec$var$$b(a) : null;
}
function $f088c3cfa4ce44ec$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f088c3cfa4ce44ec$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f088c3cfa4ce44ec$var$ac = $lNe8F.unstable_scheduleCallback, $f088c3cfa4ce44ec$var$bc = $lNe8F.unstable_cancelCallback, $f088c3cfa4ce44ec$var$cc = $lNe8F.unstable_shouldYield, $f088c3cfa4ce44ec$var$dc = $lNe8F.unstable_requestPaint, $f088c3cfa4ce44ec$var$B = $lNe8F.unstable_now, $f088c3cfa4ce44ec$var$ec = $lNe8F.unstable_getCurrentPriorityLevel, $f088c3cfa4ce44ec$var$fc = $lNe8F.unstable_ImmediatePriority, $f088c3cfa4ce44ec$var$gc = $lNe8F.unstable_UserBlockingPriority, $f088c3cfa4ce44ec$var$hc = $lNe8F.unstable_NormalPriority, $f088c3cfa4ce44ec$var$ic = $lNe8F.unstable_LowPriority, $f088c3cfa4ce44ec$var$jc = $lNe8F.unstable_IdlePriority, $f088c3cfa4ce44ec$var$kc = null, $f088c3cfa4ce44ec$var$lc = null;
function $f088c3cfa4ce44ec$var$mc(a) {
    if ($f088c3cfa4ce44ec$var$lc && "function" === typeof $f088c3cfa4ce44ec$var$lc.onCommitFiberRoot) try {
        $f088c3cfa4ce44ec$var$lc.onCommitFiberRoot($f088c3cfa4ce44ec$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f088c3cfa4ce44ec$var$oc = Math.clz32 ? Math.clz32 : $f088c3cfa4ce44ec$var$nc, $f088c3cfa4ce44ec$var$pc = Math.log, $f088c3cfa4ce44ec$var$qc = Math.LN2;
function $f088c3cfa4ce44ec$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f088c3cfa4ce44ec$var$pc(a) / $f088c3cfa4ce44ec$var$qc | 0) | 0;
}
var $f088c3cfa4ce44ec$var$rc = 64, $f088c3cfa4ce44ec$var$sc = 4194304;
function $f088c3cfa4ce44ec$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f088c3cfa4ce44ec$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f088c3cfa4ce44ec$var$tc(h) : (f &= g, 0 !== f && (d = $f088c3cfa4ce44ec$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f088c3cfa4ce44ec$var$tc(g) : 0 !== f && (d = $f088c3cfa4ce44ec$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f088c3cfa4ce44ec$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f088c3cfa4ce44ec$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f088c3cfa4ce44ec$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f088c3cfa4ce44ec$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f088c3cfa4ce44ec$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f088c3cfa4ce44ec$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f088c3cfa4ce44ec$var$yc() {
    var a = $f088c3cfa4ce44ec$var$rc;
    $f088c3cfa4ce44ec$var$rc <<= 1;
    0 === ($f088c3cfa4ce44ec$var$rc & 4194240) && ($f088c3cfa4ce44ec$var$rc = 64);
    return a;
}
function $f088c3cfa4ce44ec$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f088c3cfa4ce44ec$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f088c3cfa4ce44ec$var$oc(b);
    a[b] = c;
}
function $f088c3cfa4ce44ec$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f088c3cfa4ce44ec$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f088c3cfa4ce44ec$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f088c3cfa4ce44ec$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f088c3cfa4ce44ec$var$C = 0;
function $f088c3cfa4ce44ec$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f088c3cfa4ce44ec$var$Ec, $f088c3cfa4ce44ec$var$Fc, $f088c3cfa4ce44ec$var$Gc, $f088c3cfa4ce44ec$var$Hc, $f088c3cfa4ce44ec$var$Ic, $f088c3cfa4ce44ec$var$Jc = !1, $f088c3cfa4ce44ec$var$Kc = [], $f088c3cfa4ce44ec$var$Lc = null, $f088c3cfa4ce44ec$var$Mc = null, $f088c3cfa4ce44ec$var$Nc = null, $f088c3cfa4ce44ec$var$Oc = new Map, $f088c3cfa4ce44ec$var$Pc = new Map, $f088c3cfa4ce44ec$var$Qc = [], $f088c3cfa4ce44ec$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f088c3cfa4ce44ec$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f088c3cfa4ce44ec$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f088c3cfa4ce44ec$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f088c3cfa4ce44ec$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f088c3cfa4ce44ec$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f088c3cfa4ce44ec$var$Pc.delete(b.pointerId);
    }
}
function $f088c3cfa4ce44ec$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f088c3cfa4ce44ec$var$Cb(b), null !== b && $f088c3cfa4ce44ec$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f088c3cfa4ce44ec$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f088c3cfa4ce44ec$var$Lc = $f088c3cfa4ce44ec$var$Tc($f088c3cfa4ce44ec$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f088c3cfa4ce44ec$var$Mc = $f088c3cfa4ce44ec$var$Tc($f088c3cfa4ce44ec$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f088c3cfa4ce44ec$var$Nc = $f088c3cfa4ce44ec$var$Tc($f088c3cfa4ce44ec$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f088c3cfa4ce44ec$var$Oc.set(f, $f088c3cfa4ce44ec$var$Tc($f088c3cfa4ce44ec$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f088c3cfa4ce44ec$var$Pc.set(f, $f088c3cfa4ce44ec$var$Tc($f088c3cfa4ce44ec$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f088c3cfa4ce44ec$var$Vc(a) {
    var b = $f088c3cfa4ce44ec$var$Wc(a.target);
    if (null !== b) {
        var c = $f088c3cfa4ce44ec$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f088c3cfa4ce44ec$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f088c3cfa4ce44ec$var$Ic(a.priority, function() {
                        $f088c3cfa4ce44ec$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f088c3cfa4ce44ec$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f088c3cfa4ce44ec$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f088c3cfa4ce44ec$var$wb = d;
            c.target.dispatchEvent(d);
            $f088c3cfa4ce44ec$var$wb = null;
        } else return b = $f088c3cfa4ce44ec$var$Cb(c), null !== b && $f088c3cfa4ce44ec$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f088c3cfa4ce44ec$var$Zc(a, b, c) {
    $f088c3cfa4ce44ec$var$Xc(a) && c.delete(b);
}
function $f088c3cfa4ce44ec$var$$c() {
    $f088c3cfa4ce44ec$var$Jc = !1;
    null !== $f088c3cfa4ce44ec$var$Lc && $f088c3cfa4ce44ec$var$Xc($f088c3cfa4ce44ec$var$Lc) && ($f088c3cfa4ce44ec$var$Lc = null);
    null !== $f088c3cfa4ce44ec$var$Mc && $f088c3cfa4ce44ec$var$Xc($f088c3cfa4ce44ec$var$Mc) && ($f088c3cfa4ce44ec$var$Mc = null);
    null !== $f088c3cfa4ce44ec$var$Nc && $f088c3cfa4ce44ec$var$Xc($f088c3cfa4ce44ec$var$Nc) && ($f088c3cfa4ce44ec$var$Nc = null);
    $f088c3cfa4ce44ec$var$Oc.forEach($f088c3cfa4ce44ec$var$Zc);
    $f088c3cfa4ce44ec$var$Pc.forEach($f088c3cfa4ce44ec$var$Zc);
}
function $f088c3cfa4ce44ec$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f088c3cfa4ce44ec$var$Jc || ($f088c3cfa4ce44ec$var$Jc = !0, $lNe8F.unstable_scheduleCallback($lNe8F.unstable_NormalPriority, $f088c3cfa4ce44ec$var$$c)));
}
function $f088c3cfa4ce44ec$var$bd(a) {
    function b(b) {
        return $f088c3cfa4ce44ec$var$ad(b, a);
    }
    if (0 < $f088c3cfa4ce44ec$var$Kc.length) {
        $f088c3cfa4ce44ec$var$ad($f088c3cfa4ce44ec$var$Kc[0], a);
        for(var c = 1; c < $f088c3cfa4ce44ec$var$Kc.length; c++){
            var d = $f088c3cfa4ce44ec$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f088c3cfa4ce44ec$var$Lc && $f088c3cfa4ce44ec$var$ad($f088c3cfa4ce44ec$var$Lc, a);
    null !== $f088c3cfa4ce44ec$var$Mc && $f088c3cfa4ce44ec$var$ad($f088c3cfa4ce44ec$var$Mc, a);
    null !== $f088c3cfa4ce44ec$var$Nc && $f088c3cfa4ce44ec$var$ad($f088c3cfa4ce44ec$var$Nc, a);
    $f088c3cfa4ce44ec$var$Oc.forEach(b);
    $f088c3cfa4ce44ec$var$Pc.forEach(b);
    for(c = 0; c < $f088c3cfa4ce44ec$var$Qc.length; c++)d = $f088c3cfa4ce44ec$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f088c3cfa4ce44ec$var$Qc.length && (c = $f088c3cfa4ce44ec$var$Qc[0], null === c.blockedOn);)$f088c3cfa4ce44ec$var$Vc(c), null === c.blockedOn && $f088c3cfa4ce44ec$var$Qc.shift();
}
var $f088c3cfa4ce44ec$var$cd = $f088c3cfa4ce44ec$var$ua.ReactCurrentBatchConfig, $f088c3cfa4ce44ec$var$dd = !0;
function $f088c3cfa4ce44ec$var$ed(a, b, c, d) {
    var e = $f088c3cfa4ce44ec$var$C, f = $f088c3cfa4ce44ec$var$cd.transition;
    $f088c3cfa4ce44ec$var$cd.transition = null;
    try {
        $f088c3cfa4ce44ec$var$C = 1, $f088c3cfa4ce44ec$var$fd(a, b, c, d);
    } finally{
        $f088c3cfa4ce44ec$var$C = e, $f088c3cfa4ce44ec$var$cd.transition = f;
    }
}
function $f088c3cfa4ce44ec$var$gd(a, b, c, d) {
    var e = $f088c3cfa4ce44ec$var$C, f = $f088c3cfa4ce44ec$var$cd.transition;
    $f088c3cfa4ce44ec$var$cd.transition = null;
    try {
        $f088c3cfa4ce44ec$var$C = 4, $f088c3cfa4ce44ec$var$fd(a, b, c, d);
    } finally{
        $f088c3cfa4ce44ec$var$C = e, $f088c3cfa4ce44ec$var$cd.transition = f;
    }
}
function $f088c3cfa4ce44ec$var$fd(a, b, c, d) {
    if ($f088c3cfa4ce44ec$var$dd) {
        var e = $f088c3cfa4ce44ec$var$Yc(a, b, c, d);
        if (null === e) $f088c3cfa4ce44ec$var$hd(a, b, d, $f088c3cfa4ce44ec$var$id, c), $f088c3cfa4ce44ec$var$Sc(a, d);
        else if ($f088c3cfa4ce44ec$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f088c3cfa4ce44ec$var$Sc(a, d), b & 4 && -1 < $f088c3cfa4ce44ec$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f088c3cfa4ce44ec$var$Cb(e);
                null !== f && $f088c3cfa4ce44ec$var$Ec(f);
                f = $f088c3cfa4ce44ec$var$Yc(a, b, c, d);
                null === f && $f088c3cfa4ce44ec$var$hd(a, b, d, $f088c3cfa4ce44ec$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f088c3cfa4ce44ec$var$hd(a, b, d, null, c);
    }
}
var $f088c3cfa4ce44ec$var$id = null;
function $f088c3cfa4ce44ec$var$Yc(a, b, c, d) {
    $f088c3cfa4ce44ec$var$id = null;
    a = $f088c3cfa4ce44ec$var$xb(d);
    a = $f088c3cfa4ce44ec$var$Wc(a);
    if (null !== a) {
        if (b = $f088c3cfa4ce44ec$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f088c3cfa4ce44ec$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f088c3cfa4ce44ec$var$id = a;
    return null;
}
function $f088c3cfa4ce44ec$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f088c3cfa4ce44ec$var$ec()){
                case $f088c3cfa4ce44ec$var$fc:
                    return 1;
                case $f088c3cfa4ce44ec$var$gc:
                    return 4;
                case $f088c3cfa4ce44ec$var$hc:
                case $f088c3cfa4ce44ec$var$ic:
                    return 16;
                case $f088c3cfa4ce44ec$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f088c3cfa4ce44ec$var$kd = null, $f088c3cfa4ce44ec$var$ld = null, $f088c3cfa4ce44ec$var$md = null;
function $f088c3cfa4ce44ec$var$nd() {
    if ($f088c3cfa4ce44ec$var$md) return $f088c3cfa4ce44ec$var$md;
    var a, b = $f088c3cfa4ce44ec$var$ld, c = b.length, d, e = "value" in $f088c3cfa4ce44ec$var$kd ? $f088c3cfa4ce44ec$var$kd.value : $f088c3cfa4ce44ec$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f088c3cfa4ce44ec$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f088c3cfa4ce44ec$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f088c3cfa4ce44ec$var$pd() {
    return !0;
}
function $f088c3cfa4ce44ec$var$qd() {
    return !1;
}
function $f088c3cfa4ce44ec$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f088c3cfa4ce44ec$var$pd : $f088c3cfa4ce44ec$var$qd;
        this.isPropagationStopped = $f088c3cfa4ce44ec$var$qd;
        return this;
    }
    $f088c3cfa4ce44ec$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f088c3cfa4ce44ec$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f088c3cfa4ce44ec$var$pd);
        },
        persist: function() {},
        isPersistent: $f088c3cfa4ce44ec$var$pd
    });
    return b;
}
var $f088c3cfa4ce44ec$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f088c3cfa4ce44ec$var$td = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$sd), $f088c3cfa4ce44ec$var$ud = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$sd, {
    view: 0,
    detail: 0
}), $f088c3cfa4ce44ec$var$vd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$ud), $f088c3cfa4ce44ec$var$wd, $f088c3cfa4ce44ec$var$xd, $f088c3cfa4ce44ec$var$yd, $f088c3cfa4ce44ec$var$Ad = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f088c3cfa4ce44ec$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f088c3cfa4ce44ec$var$yd && ($f088c3cfa4ce44ec$var$yd && "mousemove" === a.type ? ($f088c3cfa4ce44ec$var$wd = a.screenX - $f088c3cfa4ce44ec$var$yd.screenX, $f088c3cfa4ce44ec$var$xd = a.screenY - $f088c3cfa4ce44ec$var$yd.screenY) : $f088c3cfa4ce44ec$var$xd = $f088c3cfa4ce44ec$var$wd = 0, $f088c3cfa4ce44ec$var$yd = a);
        return $f088c3cfa4ce44ec$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f088c3cfa4ce44ec$var$xd;
    }
}), $f088c3cfa4ce44ec$var$Bd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Ad), $f088c3cfa4ce44ec$var$Cd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$Ad, {
    dataTransfer: 0
}), $f088c3cfa4ce44ec$var$Dd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Cd), $f088c3cfa4ce44ec$var$Ed = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$ud, {
    relatedTarget: 0
}), $f088c3cfa4ce44ec$var$Fd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Ed), $f088c3cfa4ce44ec$var$Gd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f088c3cfa4ce44ec$var$Hd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Gd), $f088c3cfa4ce44ec$var$Id = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f088c3cfa4ce44ec$var$Jd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Id), $f088c3cfa4ce44ec$var$Kd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$sd, {
    data: 0
}), $f088c3cfa4ce44ec$var$Ld = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Kd), $f088c3cfa4ce44ec$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f088c3cfa4ce44ec$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f088c3cfa4ce44ec$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f088c3cfa4ce44ec$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f088c3cfa4ce44ec$var$Od[a]) ? !!b[a] : !1;
}
function $f088c3cfa4ce44ec$var$zd() {
    return $f088c3cfa4ce44ec$var$Pd;
}
var $f088c3cfa4ce44ec$var$Qd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f088c3cfa4ce44ec$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f088c3cfa4ce44ec$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f088c3cfa4ce44ec$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f088c3cfa4ce44ec$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f088c3cfa4ce44ec$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f088c3cfa4ce44ec$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f088c3cfa4ce44ec$var$Rd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Qd), $f088c3cfa4ce44ec$var$Sd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f088c3cfa4ce44ec$var$Td = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Sd), $f088c3cfa4ce44ec$var$Ud = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f088c3cfa4ce44ec$var$zd
}), $f088c3cfa4ce44ec$var$Vd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Ud), $f088c3cfa4ce44ec$var$Wd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f088c3cfa4ce44ec$var$Xd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Wd), $f088c3cfa4ce44ec$var$Yd = $f088c3cfa4ce44ec$var$A({}, $f088c3cfa4ce44ec$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f088c3cfa4ce44ec$var$Zd = $f088c3cfa4ce44ec$var$rd($f088c3cfa4ce44ec$var$Yd), $f088c3cfa4ce44ec$var$$d = [
    9,
    13,
    27,
    32
], $f088c3cfa4ce44ec$var$ae = $f088c3cfa4ce44ec$var$ia && "CompositionEvent" in window, $f088c3cfa4ce44ec$var$be = null;
$f088c3cfa4ce44ec$var$ia && "documentMode" in document && ($f088c3cfa4ce44ec$var$be = document.documentMode);
var $f088c3cfa4ce44ec$var$ce = $f088c3cfa4ce44ec$var$ia && "TextEvent" in window && !$f088c3cfa4ce44ec$var$be, $f088c3cfa4ce44ec$var$de = $f088c3cfa4ce44ec$var$ia && (!$f088c3cfa4ce44ec$var$ae || $f088c3cfa4ce44ec$var$be && 8 < $f088c3cfa4ce44ec$var$be && 11 >= $f088c3cfa4ce44ec$var$be), $f088c3cfa4ce44ec$var$ee = String.fromCharCode(32), $f088c3cfa4ce44ec$var$fe = !1;
function $f088c3cfa4ce44ec$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f088c3cfa4ce44ec$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f088c3cfa4ce44ec$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f088c3cfa4ce44ec$var$ie = !1;
function $f088c3cfa4ce44ec$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f088c3cfa4ce44ec$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f088c3cfa4ce44ec$var$fe = !0;
            return $f088c3cfa4ce44ec$var$ee;
        case "textInput":
            return a = b.data, a === $f088c3cfa4ce44ec$var$ee && $f088c3cfa4ce44ec$var$fe ? null : a;
        default:
            return null;
    }
}
function $f088c3cfa4ce44ec$var$ke(a, b) {
    if ($f088c3cfa4ce44ec$var$ie) return "compositionend" === a || !$f088c3cfa4ce44ec$var$ae && $f088c3cfa4ce44ec$var$ge(a, b) ? (a = $f088c3cfa4ce44ec$var$nd(), $f088c3cfa4ce44ec$var$md = $f088c3cfa4ce44ec$var$ld = $f088c3cfa4ce44ec$var$kd = null, $f088c3cfa4ce44ec$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f088c3cfa4ce44ec$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f088c3cfa4ce44ec$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f088c3cfa4ce44ec$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f088c3cfa4ce44ec$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f088c3cfa4ce44ec$var$ne(a, b, c, d) {
    $f088c3cfa4ce44ec$var$Eb(d);
    b = $f088c3cfa4ce44ec$var$oe(b, "onChange");
    0 < b.length && (c = new $f088c3cfa4ce44ec$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f088c3cfa4ce44ec$var$pe = null, $f088c3cfa4ce44ec$var$qe = null;
function $f088c3cfa4ce44ec$var$re(a) {
    $f088c3cfa4ce44ec$var$se(a, 0);
}
function $f088c3cfa4ce44ec$var$te(a) {
    var b = $f088c3cfa4ce44ec$var$ue(a);
    if ($f088c3cfa4ce44ec$var$Wa(b)) return a;
}
function $f088c3cfa4ce44ec$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f088c3cfa4ce44ec$var$we = !1;
if ($f088c3cfa4ce44ec$var$ia) {
    var $f088c3cfa4ce44ec$var$xe;
    if ($f088c3cfa4ce44ec$var$ia) {
        var $f088c3cfa4ce44ec$var$ye = "oninput" in document;
        if (!$f088c3cfa4ce44ec$var$ye) {
            var $f088c3cfa4ce44ec$var$ze = document.createElement("div");
            $f088c3cfa4ce44ec$var$ze.setAttribute("oninput", "return;");
            $f088c3cfa4ce44ec$var$ye = "function" === typeof $f088c3cfa4ce44ec$var$ze.oninput;
        }
        $f088c3cfa4ce44ec$var$xe = $f088c3cfa4ce44ec$var$ye;
    } else $f088c3cfa4ce44ec$var$xe = !1;
    $f088c3cfa4ce44ec$var$we = $f088c3cfa4ce44ec$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f088c3cfa4ce44ec$var$Ae() {
    $f088c3cfa4ce44ec$var$pe && ($f088c3cfa4ce44ec$var$pe.detachEvent("onpropertychange", $f088c3cfa4ce44ec$var$Be), $f088c3cfa4ce44ec$var$qe = $f088c3cfa4ce44ec$var$pe = null);
}
function $f088c3cfa4ce44ec$var$Be(a) {
    if ("value" === a.propertyName && $f088c3cfa4ce44ec$var$te($f088c3cfa4ce44ec$var$qe)) {
        var b = [];
        $f088c3cfa4ce44ec$var$ne(b, $f088c3cfa4ce44ec$var$qe, a, $f088c3cfa4ce44ec$var$xb(a));
        $f088c3cfa4ce44ec$var$Jb($f088c3cfa4ce44ec$var$re, b);
    }
}
function $f088c3cfa4ce44ec$var$Ce(a, b, c) {
    "focusin" === a ? ($f088c3cfa4ce44ec$var$Ae(), $f088c3cfa4ce44ec$var$pe = b, $f088c3cfa4ce44ec$var$qe = c, $f088c3cfa4ce44ec$var$pe.attachEvent("onpropertychange", $f088c3cfa4ce44ec$var$Be)) : "focusout" === a && $f088c3cfa4ce44ec$var$Ae();
}
function $f088c3cfa4ce44ec$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f088c3cfa4ce44ec$var$te($f088c3cfa4ce44ec$var$qe);
}
function $f088c3cfa4ce44ec$var$Ee(a, b) {
    if ("click" === a) return $f088c3cfa4ce44ec$var$te(b);
}
function $f088c3cfa4ce44ec$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f088c3cfa4ce44ec$var$te(b);
}
function $f088c3cfa4ce44ec$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f088c3cfa4ce44ec$var$He = "function" === typeof Object.is ? Object.is : $f088c3cfa4ce44ec$var$Ge;
function $f088c3cfa4ce44ec$var$Ie(a, b) {
    if ($f088c3cfa4ce44ec$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f088c3cfa4ce44ec$var$ja.call(b, e) || !$f088c3cfa4ce44ec$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f088c3cfa4ce44ec$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f088c3cfa4ce44ec$var$Ke(a, b) {
    var c = $f088c3cfa4ce44ec$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f088c3cfa4ce44ec$var$Je(c);
    }
}
function $f088c3cfa4ce44ec$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f088c3cfa4ce44ec$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f088c3cfa4ce44ec$var$Me() {
    for(var a = window, b = $f088c3cfa4ce44ec$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f088c3cfa4ce44ec$var$Xa(a.document);
    }
    return b;
}
function $f088c3cfa4ce44ec$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f088c3cfa4ce44ec$var$Oe(a) {
    var b = $f088c3cfa4ce44ec$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f088c3cfa4ce44ec$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f088c3cfa4ce44ec$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f088c3cfa4ce44ec$var$Ke(c, f);
                var g = $f088c3cfa4ce44ec$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f088c3cfa4ce44ec$var$Pe = $f088c3cfa4ce44ec$var$ia && "documentMode" in document && 11 >= document.documentMode, $f088c3cfa4ce44ec$var$Qe = null, $f088c3cfa4ce44ec$var$Re = null, $f088c3cfa4ce44ec$var$Se = null, $f088c3cfa4ce44ec$var$Te = !1;
function $f088c3cfa4ce44ec$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f088c3cfa4ce44ec$var$Te || null == $f088c3cfa4ce44ec$var$Qe || $f088c3cfa4ce44ec$var$Qe !== $f088c3cfa4ce44ec$var$Xa(d) || (d = $f088c3cfa4ce44ec$var$Qe, "selectionStart" in d && $f088c3cfa4ce44ec$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f088c3cfa4ce44ec$var$Se && $f088c3cfa4ce44ec$var$Ie($f088c3cfa4ce44ec$var$Se, d) || ($f088c3cfa4ce44ec$var$Se = d, d = $f088c3cfa4ce44ec$var$oe($f088c3cfa4ce44ec$var$Re, "onSelect"), 0 < d.length && (b = new $f088c3cfa4ce44ec$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f088c3cfa4ce44ec$var$Qe)));
}
function $f088c3cfa4ce44ec$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f088c3cfa4ce44ec$var$We = {
    animationend: $f088c3cfa4ce44ec$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f088c3cfa4ce44ec$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f088c3cfa4ce44ec$var$Ve("Animation", "AnimationStart"),
    transitionend: $f088c3cfa4ce44ec$var$Ve("Transition", "TransitionEnd")
}, $f088c3cfa4ce44ec$var$Xe = {}, $f088c3cfa4ce44ec$var$Ye = {};
$f088c3cfa4ce44ec$var$ia && ($f088c3cfa4ce44ec$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f088c3cfa4ce44ec$var$We.animationend.animation, delete $f088c3cfa4ce44ec$var$We.animationiteration.animation, delete $f088c3cfa4ce44ec$var$We.animationstart.animation), "TransitionEvent" in window || delete $f088c3cfa4ce44ec$var$We.transitionend.transition);
function $f088c3cfa4ce44ec$var$Ze(a) {
    if ($f088c3cfa4ce44ec$var$Xe[a]) return $f088c3cfa4ce44ec$var$Xe[a];
    if (!$f088c3cfa4ce44ec$var$We[a]) return a;
    var b = $f088c3cfa4ce44ec$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f088c3cfa4ce44ec$var$Ye) return $f088c3cfa4ce44ec$var$Xe[a] = b[c];
    return a;
}
var $f088c3cfa4ce44ec$var$$e = $f088c3cfa4ce44ec$var$Ze("animationend"), $f088c3cfa4ce44ec$var$af = $f088c3cfa4ce44ec$var$Ze("animationiteration"), $f088c3cfa4ce44ec$var$bf = $f088c3cfa4ce44ec$var$Ze("animationstart"), $f088c3cfa4ce44ec$var$cf = $f088c3cfa4ce44ec$var$Ze("transitionend"), $f088c3cfa4ce44ec$var$df = new Map, $f088c3cfa4ce44ec$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f088c3cfa4ce44ec$var$ff(a, b) {
    $f088c3cfa4ce44ec$var$df.set(a, b);
    $f088c3cfa4ce44ec$var$fa(b, [
        a
    ]);
}
for(var $f088c3cfa4ce44ec$var$gf = 0; $f088c3cfa4ce44ec$var$gf < $f088c3cfa4ce44ec$var$ef.length; $f088c3cfa4ce44ec$var$gf++){
    var $f088c3cfa4ce44ec$var$hf = $f088c3cfa4ce44ec$var$ef[$f088c3cfa4ce44ec$var$gf], $f088c3cfa4ce44ec$var$jf = $f088c3cfa4ce44ec$var$hf.toLowerCase(), $f088c3cfa4ce44ec$var$kf = $f088c3cfa4ce44ec$var$hf[0].toUpperCase() + $f088c3cfa4ce44ec$var$hf.slice(1);
    $f088c3cfa4ce44ec$var$ff($f088c3cfa4ce44ec$var$jf, "on" + $f088c3cfa4ce44ec$var$kf);
}
$f088c3cfa4ce44ec$var$ff($f088c3cfa4ce44ec$var$$e, "onAnimationEnd");
$f088c3cfa4ce44ec$var$ff($f088c3cfa4ce44ec$var$af, "onAnimationIteration");
$f088c3cfa4ce44ec$var$ff($f088c3cfa4ce44ec$var$bf, "onAnimationStart");
$f088c3cfa4ce44ec$var$ff("dblclick", "onDoubleClick");
$f088c3cfa4ce44ec$var$ff("focusin", "onFocus");
$f088c3cfa4ce44ec$var$ff("focusout", "onBlur");
$f088c3cfa4ce44ec$var$ff($f088c3cfa4ce44ec$var$cf, "onTransitionEnd");
$f088c3cfa4ce44ec$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f088c3cfa4ce44ec$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f088c3cfa4ce44ec$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f088c3cfa4ce44ec$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f088c3cfa4ce44ec$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f088c3cfa4ce44ec$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f088c3cfa4ce44ec$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f088c3cfa4ce44ec$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f088c3cfa4ce44ec$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f088c3cfa4ce44ec$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f088c3cfa4ce44ec$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f088c3cfa4ce44ec$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f088c3cfa4ce44ec$var$lf));
function $f088c3cfa4ce44ec$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f088c3cfa4ce44ec$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f088c3cfa4ce44ec$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f088c3cfa4ce44ec$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f088c3cfa4ce44ec$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f088c3cfa4ce44ec$var$Qb) throw a = $f088c3cfa4ce44ec$var$Rb, $f088c3cfa4ce44ec$var$Qb = !1, $f088c3cfa4ce44ec$var$Rb = null, a;
}
function $f088c3cfa4ce44ec$var$D(a, b) {
    var c = b[$f088c3cfa4ce44ec$var$of];
    void 0 === c && (c = b[$f088c3cfa4ce44ec$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f088c3cfa4ce44ec$var$pf(b, a, 2, !1), c.add(d));
}
function $f088c3cfa4ce44ec$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f088c3cfa4ce44ec$var$pf(c, a, d, b);
}
var $f088c3cfa4ce44ec$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f088c3cfa4ce44ec$var$sf(a) {
    if (!a[$f088c3cfa4ce44ec$var$rf]) {
        a[$f088c3cfa4ce44ec$var$rf] = !0;
        $f088c3cfa4ce44ec$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f088c3cfa4ce44ec$var$mf.has(b) || $f088c3cfa4ce44ec$var$qf(b, !1, a), $f088c3cfa4ce44ec$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f088c3cfa4ce44ec$var$rf] || (b[$f088c3cfa4ce44ec$var$rf] = !0, $f088c3cfa4ce44ec$var$qf("selectionchange", !1, b));
    }
}
function $f088c3cfa4ce44ec$var$pf(a, b, c, d) {
    switch($f088c3cfa4ce44ec$var$jd(b)){
        case 1:
            var e = $f088c3cfa4ce44ec$var$ed;
            break;
        case 4:
            e = $f088c3cfa4ce44ec$var$gd;
            break;
        default:
            e = $f088c3cfa4ce44ec$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f088c3cfa4ce44ec$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f088c3cfa4ce44ec$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f088c3cfa4ce44ec$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f088c3cfa4ce44ec$var$Jb(function() {
        var d = f, e = $f088c3cfa4ce44ec$var$xb(c), g = [];
        a: {
            var h = $f088c3cfa4ce44ec$var$df.get(a);
            if (void 0 !== h) {
                var k = $f088c3cfa4ce44ec$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f088c3cfa4ce44ec$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f088c3cfa4ce44ec$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f088c3cfa4ce44ec$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f088c3cfa4ce44ec$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f088c3cfa4ce44ec$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f088c3cfa4ce44ec$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f088c3cfa4ce44ec$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f088c3cfa4ce44ec$var$Vd;
                        break;
                    case $f088c3cfa4ce44ec$var$$e:
                    case $f088c3cfa4ce44ec$var$af:
                    case $f088c3cfa4ce44ec$var$bf:
                        k = $f088c3cfa4ce44ec$var$Hd;
                        break;
                    case $f088c3cfa4ce44ec$var$cf:
                        k = $f088c3cfa4ce44ec$var$Xd;
                        break;
                    case "scroll":
                        k = $f088c3cfa4ce44ec$var$vd;
                        break;
                    case "wheel":
                        k = $f088c3cfa4ce44ec$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f088c3cfa4ce44ec$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f088c3cfa4ce44ec$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f088c3cfa4ce44ec$var$Kb(w, x), null != F && t.push($f088c3cfa4ce44ec$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f088c3cfa4ce44ec$var$wb && (n = c.relatedTarget || c.fromElement) && ($f088c3cfa4ce44ec$var$Wc(n) || n[$f088c3cfa4ce44ec$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f088c3cfa4ce44ec$var$Wc(n) : null, null !== n && (J = $f088c3cfa4ce44ec$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f088c3cfa4ce44ec$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f088c3cfa4ce44ec$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f088c3cfa4ce44ec$var$ue(k);
                        u = null == n ? h : $f088c3cfa4ce44ec$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f088c3cfa4ce44ec$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f088c3cfa4ce44ec$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f088c3cfa4ce44ec$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f088c3cfa4ce44ec$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f088c3cfa4ce44ec$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f088c3cfa4ce44ec$var$vf(t);
                                x = $f088c3cfa4ce44ec$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f088c3cfa4ce44ec$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f088c3cfa4ce44ec$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f088c3cfa4ce44ec$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f088c3cfa4ce44ec$var$ve;
                else if ($f088c3cfa4ce44ec$var$me(h)) {
                    if ($f088c3cfa4ce44ec$var$we) na = $f088c3cfa4ce44ec$var$Fe;
                    else {
                        na = $f088c3cfa4ce44ec$var$De;
                        var xa = $f088c3cfa4ce44ec$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f088c3cfa4ce44ec$var$Ee);
                if (na && (na = na(a, d))) {
                    $f088c3cfa4ce44ec$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f088c3cfa4ce44ec$var$cb(h, "number", h.value);
            }
            xa = d ? $f088c3cfa4ce44ec$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f088c3cfa4ce44ec$var$me(xa) || "true" === xa.contentEditable) $f088c3cfa4ce44ec$var$Qe = xa, $f088c3cfa4ce44ec$var$Re = d, $f088c3cfa4ce44ec$var$Se = null;
                    break;
                case "focusout":
                    $f088c3cfa4ce44ec$var$Se = $f088c3cfa4ce44ec$var$Re = $f088c3cfa4ce44ec$var$Qe = null;
                    break;
                case "mousedown":
                    $f088c3cfa4ce44ec$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f088c3cfa4ce44ec$var$Te = !1;
                    $f088c3cfa4ce44ec$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f088c3cfa4ce44ec$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f088c3cfa4ce44ec$var$Ue(g, c, e);
            }
            var $a;
            if ($f088c3cfa4ce44ec$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f088c3cfa4ce44ec$var$ie ? $f088c3cfa4ce44ec$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f088c3cfa4ce44ec$var$de && "ko" !== c.locale && ($f088c3cfa4ce44ec$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f088c3cfa4ce44ec$var$ie && ($a = $f088c3cfa4ce44ec$var$nd()) : ($f088c3cfa4ce44ec$var$kd = e, $f088c3cfa4ce44ec$var$ld = "value" in $f088c3cfa4ce44ec$var$kd ? $f088c3cfa4ce44ec$var$kd.value : $f088c3cfa4ce44ec$var$kd.textContent, $f088c3cfa4ce44ec$var$ie = !0)), xa = $f088c3cfa4ce44ec$var$oe(d, ba), 0 < xa.length && (ba = new $f088c3cfa4ce44ec$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f088c3cfa4ce44ec$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f088c3cfa4ce44ec$var$ce ? $f088c3cfa4ce44ec$var$je(a, c) : $f088c3cfa4ce44ec$var$ke(a, c)) d = $f088c3cfa4ce44ec$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f088c3cfa4ce44ec$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f088c3cfa4ce44ec$var$se(g, b);
    });
}
function $f088c3cfa4ce44ec$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f088c3cfa4ce44ec$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f088c3cfa4ce44ec$var$Kb(a, c), null != f && d.unshift($f088c3cfa4ce44ec$var$tf(a, f, e)), f = $f088c3cfa4ce44ec$var$Kb(a, b), null != f && d.push($f088c3cfa4ce44ec$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f088c3cfa4ce44ec$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f088c3cfa4ce44ec$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f088c3cfa4ce44ec$var$Kb(c, f), null != k && g.unshift($f088c3cfa4ce44ec$var$tf(c, k, h))) : e || (k = $f088c3cfa4ce44ec$var$Kb(c, f), null != k && g.push($f088c3cfa4ce44ec$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f088c3cfa4ce44ec$var$xf = /\r\n?/g, $f088c3cfa4ce44ec$var$yf = /\u0000|\uFFFD/g;
function $f088c3cfa4ce44ec$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f088c3cfa4ce44ec$var$xf, "\n").replace($f088c3cfa4ce44ec$var$yf, "");
}
function $f088c3cfa4ce44ec$var$Af(a, b, c) {
    b = $f088c3cfa4ce44ec$var$zf(b);
    if ($f088c3cfa4ce44ec$var$zf(a) !== b && c) throw Error($f088c3cfa4ce44ec$var$p(425));
}
function $f088c3cfa4ce44ec$var$Bf() {}
var $f088c3cfa4ce44ec$var$Cf = null, $f088c3cfa4ce44ec$var$Df = null;
function $f088c3cfa4ce44ec$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f088c3cfa4ce44ec$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f088c3cfa4ce44ec$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f088c3cfa4ce44ec$var$Hf = "function" === typeof Promise ? Promise : void 0, $f088c3cfa4ce44ec$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f088c3cfa4ce44ec$var$Hf ? function(a) {
    return $f088c3cfa4ce44ec$var$Hf.resolve(null).then(a).catch($f088c3cfa4ce44ec$var$If);
} : $f088c3cfa4ce44ec$var$Ff;
function $f088c3cfa4ce44ec$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f088c3cfa4ce44ec$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f088c3cfa4ce44ec$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f088c3cfa4ce44ec$var$bd(b);
}
function $f088c3cfa4ce44ec$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f088c3cfa4ce44ec$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f088c3cfa4ce44ec$var$Nf = Math.random().toString(36).slice(2), $f088c3cfa4ce44ec$var$Of = "__reactFiber$" + $f088c3cfa4ce44ec$var$Nf, $f088c3cfa4ce44ec$var$Pf = "__reactProps$" + $f088c3cfa4ce44ec$var$Nf, $f088c3cfa4ce44ec$var$uf = "__reactContainer$" + $f088c3cfa4ce44ec$var$Nf, $f088c3cfa4ce44ec$var$of = "__reactEvents$" + $f088c3cfa4ce44ec$var$Nf, $f088c3cfa4ce44ec$var$Qf = "__reactListeners$" + $f088c3cfa4ce44ec$var$Nf, $f088c3cfa4ce44ec$var$Rf = "__reactHandles$" + $f088c3cfa4ce44ec$var$Nf;
function $f088c3cfa4ce44ec$var$Wc(a) {
    var b = a[$f088c3cfa4ce44ec$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f088c3cfa4ce44ec$var$uf] || c[$f088c3cfa4ce44ec$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f088c3cfa4ce44ec$var$Mf(a); null !== a;){
                if (c = a[$f088c3cfa4ce44ec$var$Of]) return c;
                a = $f088c3cfa4ce44ec$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f088c3cfa4ce44ec$var$Cb(a) {
    a = a[$f088c3cfa4ce44ec$var$Of] || a[$f088c3cfa4ce44ec$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f088c3cfa4ce44ec$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f088c3cfa4ce44ec$var$p(33));
}
function $f088c3cfa4ce44ec$var$Db(a) {
    return a[$f088c3cfa4ce44ec$var$Pf] || null;
}
var $f088c3cfa4ce44ec$var$Sf = [], $f088c3cfa4ce44ec$var$Tf = -1;
function $f088c3cfa4ce44ec$var$Uf(a) {
    return {
        current: a
    };
}
function $f088c3cfa4ce44ec$var$E(a) {
    0 > $f088c3cfa4ce44ec$var$Tf || (a.current = $f088c3cfa4ce44ec$var$Sf[$f088c3cfa4ce44ec$var$Tf], $f088c3cfa4ce44ec$var$Sf[$f088c3cfa4ce44ec$var$Tf] = null, $f088c3cfa4ce44ec$var$Tf--);
}
function $f088c3cfa4ce44ec$var$G(a, b) {
    $f088c3cfa4ce44ec$var$Tf++;
    $f088c3cfa4ce44ec$var$Sf[$f088c3cfa4ce44ec$var$Tf] = a.current;
    a.current = b;
}
var $f088c3cfa4ce44ec$var$Vf = {}, $f088c3cfa4ce44ec$var$H = $f088c3cfa4ce44ec$var$Uf($f088c3cfa4ce44ec$var$Vf), $f088c3cfa4ce44ec$var$Wf = $f088c3cfa4ce44ec$var$Uf(!1), $f088c3cfa4ce44ec$var$Xf = $f088c3cfa4ce44ec$var$Vf;
function $f088c3cfa4ce44ec$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f088c3cfa4ce44ec$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f088c3cfa4ce44ec$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f088c3cfa4ce44ec$var$$f() {
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf);
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$H);
}
function $f088c3cfa4ce44ec$var$ag(a, b, c) {
    if ($f088c3cfa4ce44ec$var$H.current !== $f088c3cfa4ce44ec$var$Vf) throw Error($f088c3cfa4ce44ec$var$p(168));
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$H, b);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Wf, c);
}
function $f088c3cfa4ce44ec$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f088c3cfa4ce44ec$var$p(108, $f088c3cfa4ce44ec$var$Ra(a) || "Unknown", e));
    return $f088c3cfa4ce44ec$var$A({}, c, d);
}
function $f088c3cfa4ce44ec$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f088c3cfa4ce44ec$var$Vf;
    $f088c3cfa4ce44ec$var$Xf = $f088c3cfa4ce44ec$var$H.current;
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$H, a);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Wf, $f088c3cfa4ce44ec$var$Wf.current);
    return !0;
}
function $f088c3cfa4ce44ec$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f088c3cfa4ce44ec$var$p(169));
    c ? (a = $f088c3cfa4ce44ec$var$bg(a, b, $f088c3cfa4ce44ec$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf), $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$H), $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$H, a)) : $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Wf, c);
}
var $f088c3cfa4ce44ec$var$eg = null, $f088c3cfa4ce44ec$var$fg = !1, $f088c3cfa4ce44ec$var$gg = !1;
function $f088c3cfa4ce44ec$var$hg(a) {
    null === $f088c3cfa4ce44ec$var$eg ? $f088c3cfa4ce44ec$var$eg = [
        a
    ] : $f088c3cfa4ce44ec$var$eg.push(a);
}
function $f088c3cfa4ce44ec$var$ig(a) {
    $f088c3cfa4ce44ec$var$fg = !0;
    $f088c3cfa4ce44ec$var$hg(a);
}
function $f088c3cfa4ce44ec$var$jg() {
    if (!$f088c3cfa4ce44ec$var$gg && null !== $f088c3cfa4ce44ec$var$eg) {
        $f088c3cfa4ce44ec$var$gg = !0;
        var a = 0, b = $f088c3cfa4ce44ec$var$C;
        try {
            var c = $f088c3cfa4ce44ec$var$eg;
            for($f088c3cfa4ce44ec$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f088c3cfa4ce44ec$var$eg = null;
            $f088c3cfa4ce44ec$var$fg = !1;
        } catch (e) {
            throw null !== $f088c3cfa4ce44ec$var$eg && ($f088c3cfa4ce44ec$var$eg = $f088c3cfa4ce44ec$var$eg.slice(a + 1)), $f088c3cfa4ce44ec$var$ac($f088c3cfa4ce44ec$var$fc, $f088c3cfa4ce44ec$var$jg), e;
        } finally{
            $f088c3cfa4ce44ec$var$C = b, $f088c3cfa4ce44ec$var$gg = !1;
        }
    }
    return null;
}
var $f088c3cfa4ce44ec$var$kg = [], $f088c3cfa4ce44ec$var$lg = 0, $f088c3cfa4ce44ec$var$mg = null, $f088c3cfa4ce44ec$var$ng = 0, $f088c3cfa4ce44ec$var$og = [], $f088c3cfa4ce44ec$var$pg = 0, $f088c3cfa4ce44ec$var$qg = null, $f088c3cfa4ce44ec$var$rg = 1, $f088c3cfa4ce44ec$var$sg = "";
function $f088c3cfa4ce44ec$var$tg(a, b) {
    $f088c3cfa4ce44ec$var$kg[$f088c3cfa4ce44ec$var$lg++] = $f088c3cfa4ce44ec$var$ng;
    $f088c3cfa4ce44ec$var$kg[$f088c3cfa4ce44ec$var$lg++] = $f088c3cfa4ce44ec$var$mg;
    $f088c3cfa4ce44ec$var$mg = a;
    $f088c3cfa4ce44ec$var$ng = b;
}
function $f088c3cfa4ce44ec$var$ug(a, b, c) {
    $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$rg;
    $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$sg;
    $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$qg;
    $f088c3cfa4ce44ec$var$qg = a;
    var d = $f088c3cfa4ce44ec$var$rg;
    a = $f088c3cfa4ce44ec$var$sg;
    var e = 32 - $f088c3cfa4ce44ec$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f088c3cfa4ce44ec$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f088c3cfa4ce44ec$var$rg = 1 << 32 - $f088c3cfa4ce44ec$var$oc(b) + e | c << e | d;
        $f088c3cfa4ce44ec$var$sg = f + a;
    } else $f088c3cfa4ce44ec$var$rg = 1 << f | c << e | d, $f088c3cfa4ce44ec$var$sg = a;
}
function $f088c3cfa4ce44ec$var$vg(a) {
    null !== a.return && ($f088c3cfa4ce44ec$var$tg(a, 1), $f088c3cfa4ce44ec$var$ug(a, 1, 0));
}
function $f088c3cfa4ce44ec$var$wg(a) {
    for(; a === $f088c3cfa4ce44ec$var$mg;)$f088c3cfa4ce44ec$var$mg = $f088c3cfa4ce44ec$var$kg[--$f088c3cfa4ce44ec$var$lg], $f088c3cfa4ce44ec$var$kg[$f088c3cfa4ce44ec$var$lg] = null, $f088c3cfa4ce44ec$var$ng = $f088c3cfa4ce44ec$var$kg[--$f088c3cfa4ce44ec$var$lg], $f088c3cfa4ce44ec$var$kg[$f088c3cfa4ce44ec$var$lg] = null;
    for(; a === $f088c3cfa4ce44ec$var$qg;)$f088c3cfa4ce44ec$var$qg = $f088c3cfa4ce44ec$var$og[--$f088c3cfa4ce44ec$var$pg], $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg] = null, $f088c3cfa4ce44ec$var$sg = $f088c3cfa4ce44ec$var$og[--$f088c3cfa4ce44ec$var$pg], $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg] = null, $f088c3cfa4ce44ec$var$rg = $f088c3cfa4ce44ec$var$og[--$f088c3cfa4ce44ec$var$pg], $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg] = null;
}
var $f088c3cfa4ce44ec$var$xg = null, $f088c3cfa4ce44ec$var$yg = null, $f088c3cfa4ce44ec$var$I = !1, $f088c3cfa4ce44ec$var$zg = null;
function $f088c3cfa4ce44ec$var$Ag(a, b) {
    var c = $f088c3cfa4ce44ec$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f088c3cfa4ce44ec$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f088c3cfa4ce44ec$var$xg = a, $f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f088c3cfa4ce44ec$var$xg = a, $f088c3cfa4ce44ec$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f088c3cfa4ce44ec$var$qg ? {
                id: $f088c3cfa4ce44ec$var$rg,
                overflow: $f088c3cfa4ce44ec$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f088c3cfa4ce44ec$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f088c3cfa4ce44ec$var$xg = a, $f088c3cfa4ce44ec$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f088c3cfa4ce44ec$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f088c3cfa4ce44ec$var$Eg(a) {
    if ($f088c3cfa4ce44ec$var$I) {
        var b = $f088c3cfa4ce44ec$var$yg;
        if (b) {
            var c = b;
            if (!$f088c3cfa4ce44ec$var$Cg(a, b)) {
                if ($f088c3cfa4ce44ec$var$Dg(a)) throw Error($f088c3cfa4ce44ec$var$p(418));
                b = $f088c3cfa4ce44ec$var$Lf(c.nextSibling);
                var d = $f088c3cfa4ce44ec$var$xg;
                b && $f088c3cfa4ce44ec$var$Cg(a, b) ? $f088c3cfa4ce44ec$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f088c3cfa4ce44ec$var$I = !1, $f088c3cfa4ce44ec$var$xg = a);
            }
        } else {
            if ($f088c3cfa4ce44ec$var$Dg(a)) throw Error($f088c3cfa4ce44ec$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f088c3cfa4ce44ec$var$I = !1;
            $f088c3cfa4ce44ec$var$xg = a;
        }
    }
}
function $f088c3cfa4ce44ec$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f088c3cfa4ce44ec$var$xg = a;
}
function $f088c3cfa4ce44ec$var$Gg(a) {
    if (a !== $f088c3cfa4ce44ec$var$xg) return !1;
    if (!$f088c3cfa4ce44ec$var$I) return $f088c3cfa4ce44ec$var$Fg(a), $f088c3cfa4ce44ec$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f088c3cfa4ce44ec$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f088c3cfa4ce44ec$var$yg)) {
        if ($f088c3cfa4ce44ec$var$Dg(a)) throw $f088c3cfa4ce44ec$var$Hg(), Error($f088c3cfa4ce44ec$var$p(418));
        for(; b;)$f088c3cfa4ce44ec$var$Ag(a, b), b = $f088c3cfa4ce44ec$var$Lf(b.nextSibling);
    }
    $f088c3cfa4ce44ec$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f088c3cfa4ce44ec$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f088c3cfa4ce44ec$var$yg = null;
        }
    } else $f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$xg ? $f088c3cfa4ce44ec$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f088c3cfa4ce44ec$var$Hg() {
    for(var a = $f088c3cfa4ce44ec$var$yg; a;)a = $f088c3cfa4ce44ec$var$Lf(a.nextSibling);
}
function $f088c3cfa4ce44ec$var$Ig() {
    $f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$xg = null;
    $f088c3cfa4ce44ec$var$I = !1;
}
function $f088c3cfa4ce44ec$var$Jg(a) {
    null === $f088c3cfa4ce44ec$var$zg ? $f088c3cfa4ce44ec$var$zg = [
        a
    ] : $f088c3cfa4ce44ec$var$zg.push(a);
}
var $f088c3cfa4ce44ec$var$Kg = $f088c3cfa4ce44ec$var$ua.ReactCurrentBatchConfig;
function $f088c3cfa4ce44ec$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $f088c3cfa4ce44ec$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $f088c3cfa4ce44ec$var$Mg = $f088c3cfa4ce44ec$var$Uf(null), $f088c3cfa4ce44ec$var$Ng = null, $f088c3cfa4ce44ec$var$Og = null, $f088c3cfa4ce44ec$var$Pg = null;
function $f088c3cfa4ce44ec$var$Qg() {
    $f088c3cfa4ce44ec$var$Pg = $f088c3cfa4ce44ec$var$Og = $f088c3cfa4ce44ec$var$Ng = null;
}
function $f088c3cfa4ce44ec$var$Rg(a) {
    var b = $f088c3cfa4ce44ec$var$Mg.current;
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Mg);
    a._currentValue = b;
}
function $f088c3cfa4ce44ec$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f088c3cfa4ce44ec$var$Tg(a, b) {
    $f088c3cfa4ce44ec$var$Ng = a;
    $f088c3cfa4ce44ec$var$Pg = $f088c3cfa4ce44ec$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f088c3cfa4ce44ec$var$Ug = !0), a.firstContext = null);
}
function $f088c3cfa4ce44ec$var$Vg(a) {
    var b = a._currentValue;
    if ($f088c3cfa4ce44ec$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f088c3cfa4ce44ec$var$Og) {
            if (null === $f088c3cfa4ce44ec$var$Ng) throw Error($f088c3cfa4ce44ec$var$p(308));
            $f088c3cfa4ce44ec$var$Og = a;
            $f088c3cfa4ce44ec$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f088c3cfa4ce44ec$var$Og = $f088c3cfa4ce44ec$var$Og.next = a;
    }
    return b;
}
var $f088c3cfa4ce44ec$var$Wg = null;
function $f088c3cfa4ce44ec$var$Xg(a) {
    null === $f088c3cfa4ce44ec$var$Wg ? $f088c3cfa4ce44ec$var$Wg = [
        a
    ] : $f088c3cfa4ce44ec$var$Wg.push(a);
}
function $f088c3cfa4ce44ec$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f088c3cfa4ce44ec$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f088c3cfa4ce44ec$var$Zg(a, d);
}
function $f088c3cfa4ce44ec$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f088c3cfa4ce44ec$var$$g = !1;
function $f088c3cfa4ce44ec$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f088c3cfa4ce44ec$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f088c3cfa4ce44ec$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f088c3cfa4ce44ec$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f088c3cfa4ce44ec$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f088c3cfa4ce44ec$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f088c3cfa4ce44ec$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f088c3cfa4ce44ec$var$Zg(a, c);
}
function $f088c3cfa4ce44ec$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f088c3cfa4ce44ec$var$Cc(a, c);
    }
}
function $f088c3cfa4ce44ec$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f088c3cfa4ce44ec$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $f088c3cfa4ce44ec$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f088c3cfa4ce44ec$var$A({}, q, r);
                            break a;
                        case 2:
                            $f088c3cfa4ce44ec$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f088c3cfa4ce44ec$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f088c3cfa4ce44ec$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f088c3cfa4ce44ec$var$p(191, e));
            e.call(d);
        }
    }
}
var $f088c3cfa4ce44ec$var$jh = (new $jzmb2.Component).refs;
function $f088c3cfa4ce44ec$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f088c3cfa4ce44ec$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f088c3cfa4ce44ec$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f088c3cfa4ce44ec$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f088c3cfa4ce44ec$var$L(), e = $f088c3cfa4ce44ec$var$lh(a), f = $f088c3cfa4ce44ec$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f088c3cfa4ce44ec$var$dh(a, f, e);
        null !== b && ($f088c3cfa4ce44ec$var$mh(b, a, e, d), $f088c3cfa4ce44ec$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f088c3cfa4ce44ec$var$L(), e = $f088c3cfa4ce44ec$var$lh(a), f = $f088c3cfa4ce44ec$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f088c3cfa4ce44ec$var$dh(a, f, e);
        null !== b && ($f088c3cfa4ce44ec$var$mh(b, a, e, d), $f088c3cfa4ce44ec$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f088c3cfa4ce44ec$var$L(), d = $f088c3cfa4ce44ec$var$lh(a), e = $f088c3cfa4ce44ec$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f088c3cfa4ce44ec$var$dh(a, e, d);
        null !== b && ($f088c3cfa4ce44ec$var$mh(b, a, d, c), $f088c3cfa4ce44ec$var$eh(b, a, d));
    }
};
function $f088c3cfa4ce44ec$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f088c3cfa4ce44ec$var$Ie(c, d) || !$f088c3cfa4ce44ec$var$Ie(e, f) : !0;
}
function $f088c3cfa4ce44ec$var$ph(a, b, c) {
    var d = !1, e = $f088c3cfa4ce44ec$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f088c3cfa4ce44ec$var$Vg(f) : (e = $f088c3cfa4ce44ec$var$Zf(b) ? $f088c3cfa4ce44ec$var$Xf : $f088c3cfa4ce44ec$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f088c3cfa4ce44ec$var$Yf(a, e) : $f088c3cfa4ce44ec$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f088c3cfa4ce44ec$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f088c3cfa4ce44ec$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f088c3cfa4ce44ec$var$nh.enqueueReplaceState(b, b.state, null);
}
function $f088c3cfa4ce44ec$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $f088c3cfa4ce44ec$var$jh;
    $f088c3cfa4ce44ec$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f088c3cfa4ce44ec$var$Vg(f) : (f = $f088c3cfa4ce44ec$var$Zf(b) ? $f088c3cfa4ce44ec$var$Xf : $f088c3cfa4ce44ec$var$H.current, e.context = $f088c3cfa4ce44ec$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f088c3cfa4ce44ec$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f088c3cfa4ce44ec$var$nh.enqueueReplaceState(e, e.state, null), $f088c3cfa4ce44ec$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f088c3cfa4ce44ec$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f088c3cfa4ce44ec$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f088c3cfa4ce44ec$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $f088c3cfa4ce44ec$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f088c3cfa4ce44ec$var$p(284));
        if (!c._owner) throw Error($f088c3cfa4ce44ec$var$p(290, a));
    }
    return a;
}
function $f088c3cfa4ce44ec$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f088c3cfa4ce44ec$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f088c3cfa4ce44ec$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $f088c3cfa4ce44ec$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f088c3cfa4ce44ec$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f088c3cfa4ce44ec$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f088c3cfa4ce44ec$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f088c3cfa4ce44ec$var$Ha && $f088c3cfa4ce44ec$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $f088c3cfa4ce44ec$var$sh(a, b, c), d.return = a, d;
        d = $f088c3cfa4ce44ec$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f088c3cfa4ce44ec$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f088c3cfa4ce44ec$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f088c3cfa4ce44ec$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f088c3cfa4ce44ec$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f088c3cfa4ce44ec$var$va:
                    return c = $f088c3cfa4ce44ec$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $f088c3cfa4ce44ec$var$sh(a, null, b), c.return = a, c;
                case $f088c3cfa4ce44ec$var$wa:
                    return b = $f088c3cfa4ce44ec$var$zh(b, a.mode, c), b.return = a, b;
                case $f088c3cfa4ce44ec$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f088c3cfa4ce44ec$var$eb(b) || $f088c3cfa4ce44ec$var$Ka(b)) return b = $f088c3cfa4ce44ec$var$Ah(b, a.mode, c, null), b.return = a, b;
            $f088c3cfa4ce44ec$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f088c3cfa4ce44ec$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f088c3cfa4ce44ec$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f088c3cfa4ce44ec$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f088c3cfa4ce44ec$var$eb(c) || $f088c3cfa4ce44ec$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f088c3cfa4ce44ec$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f088c3cfa4ce44ec$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f088c3cfa4ce44ec$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f088c3cfa4ce44ec$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f088c3cfa4ce44ec$var$eb(d) || $f088c3cfa4ce44ec$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f088c3cfa4ce44ec$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f088c3cfa4ce44ec$var$Ka(h);
        if ("function" !== typeof l) throw Error($f088c3cfa4ce44ec$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f088c3cfa4ce44ec$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f088c3cfa4ce44ec$var$I && $f088c3cfa4ce44ec$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f088c3cfa4ce44ec$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f088c3cfa4ce44ec$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f088c3cfa4ce44ec$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f088c3cfa4ce44ec$var$Ha && $f088c3cfa4ce44ec$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f088c3cfa4ce44ec$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f088c3cfa4ce44ec$var$ya ? (d = $f088c3cfa4ce44ec$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f088c3cfa4ce44ec$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $f088c3cfa4ce44ec$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f088c3cfa4ce44ec$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f088c3cfa4ce44ec$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f088c3cfa4ce44ec$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f088c3cfa4ce44ec$var$eb(f)) return n(a, d, f, h);
            if ($f088c3cfa4ce44ec$var$Ka(f)) return t(a, d, f, h);
            $f088c3cfa4ce44ec$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f088c3cfa4ce44ec$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f088c3cfa4ce44ec$var$Bh = $f088c3cfa4ce44ec$var$vh(!0), $f088c3cfa4ce44ec$var$Ch = $f088c3cfa4ce44ec$var$vh(!1), $f088c3cfa4ce44ec$var$Dh = {}, $f088c3cfa4ce44ec$var$Eh = $f088c3cfa4ce44ec$var$Uf($f088c3cfa4ce44ec$var$Dh), $f088c3cfa4ce44ec$var$Fh = $f088c3cfa4ce44ec$var$Uf($f088c3cfa4ce44ec$var$Dh), $f088c3cfa4ce44ec$var$Gh = $f088c3cfa4ce44ec$var$Uf($f088c3cfa4ce44ec$var$Dh);
function $f088c3cfa4ce44ec$var$Hh(a) {
    if (a === $f088c3cfa4ce44ec$var$Dh) throw Error($f088c3cfa4ce44ec$var$p(174));
    return a;
}
function $f088c3cfa4ce44ec$var$Ih(a, b) {
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Gh, b);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Fh, a);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Eh, $f088c3cfa4ce44ec$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f088c3cfa4ce44ec$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f088c3cfa4ce44ec$var$lb(b, a);
    }
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Eh);
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Eh, b);
}
function $f088c3cfa4ce44ec$var$Jh() {
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Eh);
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Fh);
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Gh);
}
function $f088c3cfa4ce44ec$var$Kh(a) {
    $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Gh.current);
    var b = $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Eh.current);
    var c = $f088c3cfa4ce44ec$var$lb(b, a.type);
    b !== c && ($f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Fh, a), $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Eh, c));
}
function $f088c3cfa4ce44ec$var$Lh(a) {
    $f088c3cfa4ce44ec$var$Fh.current === a && ($f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Eh), $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Fh));
}
var $f088c3cfa4ce44ec$var$M = $f088c3cfa4ce44ec$var$Uf(0);
function $f088c3cfa4ce44ec$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f088c3cfa4ce44ec$var$Nh = [];
function $f088c3cfa4ce44ec$var$Oh() {
    for(var a = 0; a < $f088c3cfa4ce44ec$var$Nh.length; a++)$f088c3cfa4ce44ec$var$Nh[a]._workInProgressVersionPrimary = null;
    $f088c3cfa4ce44ec$var$Nh.length = 0;
}
var $f088c3cfa4ce44ec$var$Ph = $f088c3cfa4ce44ec$var$ua.ReactCurrentDispatcher, $f088c3cfa4ce44ec$var$Qh = $f088c3cfa4ce44ec$var$ua.ReactCurrentBatchConfig, $f088c3cfa4ce44ec$var$Rh = 0, $f088c3cfa4ce44ec$var$N = null, $f088c3cfa4ce44ec$var$O = null, $f088c3cfa4ce44ec$var$P = null, $f088c3cfa4ce44ec$var$Sh = !1, $f088c3cfa4ce44ec$var$Th = !1, $f088c3cfa4ce44ec$var$Uh = 0, $f088c3cfa4ce44ec$var$Vh = 0;
function $f088c3cfa4ce44ec$var$Q() {
    throw Error($f088c3cfa4ce44ec$var$p(321));
}
function $f088c3cfa4ce44ec$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f088c3cfa4ce44ec$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f088c3cfa4ce44ec$var$Xh(a, b, c, d, e, f) {
    $f088c3cfa4ce44ec$var$Rh = f;
    $f088c3cfa4ce44ec$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f088c3cfa4ce44ec$var$Ph.current = null === a || null === a.memoizedState ? $f088c3cfa4ce44ec$var$Yh : $f088c3cfa4ce44ec$var$Zh;
    a = c(d, e);
    if ($f088c3cfa4ce44ec$var$Th) {
        f = 0;
        do {
            $f088c3cfa4ce44ec$var$Th = !1;
            $f088c3cfa4ce44ec$var$Uh = 0;
            if (25 <= f) throw Error($f088c3cfa4ce44ec$var$p(301));
            f += 1;
            $f088c3cfa4ce44ec$var$P = $f088c3cfa4ce44ec$var$O = null;
            b.updateQueue = null;
            $f088c3cfa4ce44ec$var$Ph.current = $f088c3cfa4ce44ec$var$$h;
            a = c(d, e);
        }while ($f088c3cfa4ce44ec$var$Th);
    }
    $f088c3cfa4ce44ec$var$Ph.current = $f088c3cfa4ce44ec$var$ai;
    b = null !== $f088c3cfa4ce44ec$var$O && null !== $f088c3cfa4ce44ec$var$O.next;
    $f088c3cfa4ce44ec$var$Rh = 0;
    $f088c3cfa4ce44ec$var$P = $f088c3cfa4ce44ec$var$O = $f088c3cfa4ce44ec$var$N = null;
    $f088c3cfa4ce44ec$var$Sh = !1;
    if (b) throw Error($f088c3cfa4ce44ec$var$p(300));
    return a;
}
function $f088c3cfa4ce44ec$var$bi() {
    var a = 0 !== $f088c3cfa4ce44ec$var$Uh;
    $f088c3cfa4ce44ec$var$Uh = 0;
    return a;
}
function $f088c3cfa4ce44ec$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f088c3cfa4ce44ec$var$P ? $f088c3cfa4ce44ec$var$N.memoizedState = $f088c3cfa4ce44ec$var$P = a : $f088c3cfa4ce44ec$var$P = $f088c3cfa4ce44ec$var$P.next = a;
    return $f088c3cfa4ce44ec$var$P;
}
function $f088c3cfa4ce44ec$var$di() {
    if (null === $f088c3cfa4ce44ec$var$O) {
        var a = $f088c3cfa4ce44ec$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f088c3cfa4ce44ec$var$O.next;
    var b = null === $f088c3cfa4ce44ec$var$P ? $f088c3cfa4ce44ec$var$N.memoizedState : $f088c3cfa4ce44ec$var$P.next;
    if (null !== b) $f088c3cfa4ce44ec$var$P = b, $f088c3cfa4ce44ec$var$O = a;
    else {
        if (null === a) throw Error($f088c3cfa4ce44ec$var$p(310));
        $f088c3cfa4ce44ec$var$O = a;
        a = {
            memoizedState: $f088c3cfa4ce44ec$var$O.memoizedState,
            baseState: $f088c3cfa4ce44ec$var$O.baseState,
            baseQueue: $f088c3cfa4ce44ec$var$O.baseQueue,
            queue: $f088c3cfa4ce44ec$var$O.queue,
            next: null
        };
        null === $f088c3cfa4ce44ec$var$P ? $f088c3cfa4ce44ec$var$N.memoizedState = $f088c3cfa4ce44ec$var$P = a : $f088c3cfa4ce44ec$var$P = $f088c3cfa4ce44ec$var$P.next = a;
    }
    return $f088c3cfa4ce44ec$var$P;
}
function $f088c3cfa4ce44ec$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f088c3cfa4ce44ec$var$fi(a) {
    var b = $f088c3cfa4ce44ec$var$di(), c = b.queue;
    if (null === c) throw Error($f088c3cfa4ce44ec$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f088c3cfa4ce44ec$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f088c3cfa4ce44ec$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f088c3cfa4ce44ec$var$N.lanes |= m;
                $f088c3cfa4ce44ec$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f088c3cfa4ce44ec$var$He(d, b.memoizedState) || ($f088c3cfa4ce44ec$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f088c3cfa4ce44ec$var$N.lanes |= f, $f088c3cfa4ce44ec$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f088c3cfa4ce44ec$var$gi(a) {
    var b = $f088c3cfa4ce44ec$var$di(), c = b.queue;
    if (null === c) throw Error($f088c3cfa4ce44ec$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f088c3cfa4ce44ec$var$He(f, b.memoizedState) || ($f088c3cfa4ce44ec$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f088c3cfa4ce44ec$var$hi() {}
function $f088c3cfa4ce44ec$var$ii(a, b) {
    var c = $f088c3cfa4ce44ec$var$N, d = $f088c3cfa4ce44ec$var$di(), e = b(), f = !$f088c3cfa4ce44ec$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f088c3cfa4ce44ec$var$Ug = !0);
    d = d.queue;
    $f088c3cfa4ce44ec$var$ji($f088c3cfa4ce44ec$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f088c3cfa4ce44ec$var$P && $f088c3cfa4ce44ec$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f088c3cfa4ce44ec$var$li(9, $f088c3cfa4ce44ec$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $f088c3cfa4ce44ec$var$R) throw Error($f088c3cfa4ce44ec$var$p(349));
        0 !== ($f088c3cfa4ce44ec$var$Rh & 30) || $f088c3cfa4ce44ec$var$ni(c, b, e);
    }
    return e;
}
function $f088c3cfa4ce44ec$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f088c3cfa4ce44ec$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f088c3cfa4ce44ec$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f088c3cfa4ce44ec$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f088c3cfa4ce44ec$var$oi(b) && $f088c3cfa4ce44ec$var$pi(a);
}
function $f088c3cfa4ce44ec$var$ki(a, b, c) {
    return c(function() {
        $f088c3cfa4ce44ec$var$oi(b) && $f088c3cfa4ce44ec$var$pi(a);
    });
}
function $f088c3cfa4ce44ec$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f088c3cfa4ce44ec$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f088c3cfa4ce44ec$var$pi(a) {
    var b = $f088c3cfa4ce44ec$var$Zg(a, 1);
    null !== b && $f088c3cfa4ce44ec$var$mh(b, a, 1, -1);
}
function $f088c3cfa4ce44ec$var$qi(a) {
    var b = $f088c3cfa4ce44ec$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f088c3cfa4ce44ec$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f088c3cfa4ce44ec$var$ri.bind(null, $f088c3cfa4ce44ec$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f088c3cfa4ce44ec$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f088c3cfa4ce44ec$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f088c3cfa4ce44ec$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f088c3cfa4ce44ec$var$si() {
    return $f088c3cfa4ce44ec$var$di().memoizedState;
}
function $f088c3cfa4ce44ec$var$ti(a, b, c, d) {
    var e = $f088c3cfa4ce44ec$var$ci();
    $f088c3cfa4ce44ec$var$N.flags |= a;
    e.memoizedState = $f088c3cfa4ce44ec$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f088c3cfa4ce44ec$var$ui(a, b, c, d) {
    var e = $f088c3cfa4ce44ec$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f088c3cfa4ce44ec$var$O) {
        var g = $f088c3cfa4ce44ec$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $f088c3cfa4ce44ec$var$Wh(d, g.deps)) {
            e.memoizedState = $f088c3cfa4ce44ec$var$li(b, c, f, d);
            return;
        }
    }
    $f088c3cfa4ce44ec$var$N.flags |= a;
    e.memoizedState = $f088c3cfa4ce44ec$var$li(1 | b, c, f, d);
}
function $f088c3cfa4ce44ec$var$vi(a, b) {
    return $f088c3cfa4ce44ec$var$ti(8390656, 8, a, b);
}
function $f088c3cfa4ce44ec$var$ji(a, b) {
    return $f088c3cfa4ce44ec$var$ui(2048, 8, a, b);
}
function $f088c3cfa4ce44ec$var$wi(a, b) {
    return $f088c3cfa4ce44ec$var$ui(4, 2, a, b);
}
function $f088c3cfa4ce44ec$var$xi(a, b) {
    return $f088c3cfa4ce44ec$var$ui(4, 4, a, b);
}
function $f088c3cfa4ce44ec$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f088c3cfa4ce44ec$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f088c3cfa4ce44ec$var$ui(4, 4, $f088c3cfa4ce44ec$var$yi.bind(null, b, a), c);
}
function $f088c3cfa4ce44ec$var$Ai() {}
function $f088c3cfa4ce44ec$var$Bi(a, b) {
    var c = $f088c3cfa4ce44ec$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f088c3cfa4ce44ec$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f088c3cfa4ce44ec$var$Ci(a, b) {
    var c = $f088c3cfa4ce44ec$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f088c3cfa4ce44ec$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f088c3cfa4ce44ec$var$Di(a, b, c) {
    if (0 === ($f088c3cfa4ce44ec$var$Rh & 21)) return a.baseState && (a.baseState = !1, $f088c3cfa4ce44ec$var$Ug = !0), a.memoizedState = c;
    $f088c3cfa4ce44ec$var$He(c, b) || (c = $f088c3cfa4ce44ec$var$yc(), $f088c3cfa4ce44ec$var$N.lanes |= c, $f088c3cfa4ce44ec$var$hh |= c, a.baseState = !0);
    return b;
}
function $f088c3cfa4ce44ec$var$Ei(a, b) {
    var c = $f088c3cfa4ce44ec$var$C;
    $f088c3cfa4ce44ec$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f088c3cfa4ce44ec$var$Qh.transition;
    $f088c3cfa4ce44ec$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f088c3cfa4ce44ec$var$C = c, $f088c3cfa4ce44ec$var$Qh.transition = d;
    }
}
function $f088c3cfa4ce44ec$var$Fi() {
    return $f088c3cfa4ce44ec$var$di().memoizedState;
}
function $f088c3cfa4ce44ec$var$Gi(a, b, c) {
    var d = $f088c3cfa4ce44ec$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f088c3cfa4ce44ec$var$Hi(a)) $f088c3cfa4ce44ec$var$Ii(b, c);
    else if (c = $f088c3cfa4ce44ec$var$Yg(a, b, c, d), null !== c) {
        var e = $f088c3cfa4ce44ec$var$L();
        $f088c3cfa4ce44ec$var$mh(c, a, d, e);
        $f088c3cfa4ce44ec$var$Ji(c, b, d);
    }
}
function $f088c3cfa4ce44ec$var$ri(a, b, c) {
    var d = $f088c3cfa4ce44ec$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f088c3cfa4ce44ec$var$Hi(a)) $f088c3cfa4ce44ec$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f088c3cfa4ce44ec$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f088c3cfa4ce44ec$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f088c3cfa4ce44ec$var$Yg(a, b, e, d);
        null !== c && (e = $f088c3cfa4ce44ec$var$L(), $f088c3cfa4ce44ec$var$mh(c, a, d, e), $f088c3cfa4ce44ec$var$Ji(c, b, d));
    }
}
function $f088c3cfa4ce44ec$var$Hi(a) {
    var b = a.alternate;
    return a === $f088c3cfa4ce44ec$var$N || null !== b && b === $f088c3cfa4ce44ec$var$N;
}
function $f088c3cfa4ce44ec$var$Ii(a, b) {
    $f088c3cfa4ce44ec$var$Th = $f088c3cfa4ce44ec$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f088c3cfa4ce44ec$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f088c3cfa4ce44ec$var$Cc(a, c);
    }
}
var $f088c3cfa4ce44ec$var$ai = {
    readContext: $f088c3cfa4ce44ec$var$Vg,
    useCallback: $f088c3cfa4ce44ec$var$Q,
    useContext: $f088c3cfa4ce44ec$var$Q,
    useEffect: $f088c3cfa4ce44ec$var$Q,
    useImperativeHandle: $f088c3cfa4ce44ec$var$Q,
    useInsertionEffect: $f088c3cfa4ce44ec$var$Q,
    useLayoutEffect: $f088c3cfa4ce44ec$var$Q,
    useMemo: $f088c3cfa4ce44ec$var$Q,
    useReducer: $f088c3cfa4ce44ec$var$Q,
    useRef: $f088c3cfa4ce44ec$var$Q,
    useState: $f088c3cfa4ce44ec$var$Q,
    useDebugValue: $f088c3cfa4ce44ec$var$Q,
    useDeferredValue: $f088c3cfa4ce44ec$var$Q,
    useTransition: $f088c3cfa4ce44ec$var$Q,
    useMutableSource: $f088c3cfa4ce44ec$var$Q,
    useSyncExternalStore: $f088c3cfa4ce44ec$var$Q,
    useId: $f088c3cfa4ce44ec$var$Q,
    unstable_isNewReconciler: !1
}, $f088c3cfa4ce44ec$var$Yh = {
    readContext: $f088c3cfa4ce44ec$var$Vg,
    useCallback: function(a, b) {
        $f088c3cfa4ce44ec$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f088c3cfa4ce44ec$var$Vg,
    useEffect: $f088c3cfa4ce44ec$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f088c3cfa4ce44ec$var$ti(4194308, 4, $f088c3cfa4ce44ec$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f088c3cfa4ce44ec$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f088c3cfa4ce44ec$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f088c3cfa4ce44ec$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f088c3cfa4ce44ec$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f088c3cfa4ce44ec$var$Gi.bind(null, $f088c3cfa4ce44ec$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f088c3cfa4ce44ec$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f088c3cfa4ce44ec$var$qi,
    useDebugValue: $f088c3cfa4ce44ec$var$Ai,
    useDeferredValue: function(a) {
        return $f088c3cfa4ce44ec$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $f088c3cfa4ce44ec$var$qi(!1), b = a[0];
        a = $f088c3cfa4ce44ec$var$Ei.bind(null, a[1]);
        $f088c3cfa4ce44ec$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f088c3cfa4ce44ec$var$N, e = $f088c3cfa4ce44ec$var$ci();
        if ($f088c3cfa4ce44ec$var$I) {
            if (void 0 === c) throw Error($f088c3cfa4ce44ec$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f088c3cfa4ce44ec$var$R) throw Error($f088c3cfa4ce44ec$var$p(349));
            0 !== ($f088c3cfa4ce44ec$var$Rh & 30) || $f088c3cfa4ce44ec$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f088c3cfa4ce44ec$var$vi($f088c3cfa4ce44ec$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f088c3cfa4ce44ec$var$li(9, $f088c3cfa4ce44ec$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f088c3cfa4ce44ec$var$ci(), b = $f088c3cfa4ce44ec$var$R.identifierPrefix;
        if ($f088c3cfa4ce44ec$var$I) {
            var c = $f088c3cfa4ce44ec$var$sg;
            var d = $f088c3cfa4ce44ec$var$rg;
            c = (d & ~(1 << 32 - $f088c3cfa4ce44ec$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f088c3cfa4ce44ec$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f088c3cfa4ce44ec$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f088c3cfa4ce44ec$var$Zh = {
    readContext: $f088c3cfa4ce44ec$var$Vg,
    useCallback: $f088c3cfa4ce44ec$var$Bi,
    useContext: $f088c3cfa4ce44ec$var$Vg,
    useEffect: $f088c3cfa4ce44ec$var$ji,
    useImperativeHandle: $f088c3cfa4ce44ec$var$zi,
    useInsertionEffect: $f088c3cfa4ce44ec$var$wi,
    useLayoutEffect: $f088c3cfa4ce44ec$var$xi,
    useMemo: $f088c3cfa4ce44ec$var$Ci,
    useReducer: $f088c3cfa4ce44ec$var$fi,
    useRef: $f088c3cfa4ce44ec$var$si,
    useState: function() {
        return $f088c3cfa4ce44ec$var$fi($f088c3cfa4ce44ec$var$ei);
    },
    useDebugValue: $f088c3cfa4ce44ec$var$Ai,
    useDeferredValue: function(a) {
        var b = $f088c3cfa4ce44ec$var$di();
        return $f088c3cfa4ce44ec$var$Di(b, $f088c3cfa4ce44ec$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f088c3cfa4ce44ec$var$fi($f088c3cfa4ce44ec$var$ei)[0], b = $f088c3cfa4ce44ec$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f088c3cfa4ce44ec$var$hi,
    useSyncExternalStore: $f088c3cfa4ce44ec$var$ii,
    useId: $f088c3cfa4ce44ec$var$Fi,
    unstable_isNewReconciler: !1
}, $f088c3cfa4ce44ec$var$$h = {
    readContext: $f088c3cfa4ce44ec$var$Vg,
    useCallback: $f088c3cfa4ce44ec$var$Bi,
    useContext: $f088c3cfa4ce44ec$var$Vg,
    useEffect: $f088c3cfa4ce44ec$var$ji,
    useImperativeHandle: $f088c3cfa4ce44ec$var$zi,
    useInsertionEffect: $f088c3cfa4ce44ec$var$wi,
    useLayoutEffect: $f088c3cfa4ce44ec$var$xi,
    useMemo: $f088c3cfa4ce44ec$var$Ci,
    useReducer: $f088c3cfa4ce44ec$var$gi,
    useRef: $f088c3cfa4ce44ec$var$si,
    useState: function() {
        return $f088c3cfa4ce44ec$var$gi($f088c3cfa4ce44ec$var$ei);
    },
    useDebugValue: $f088c3cfa4ce44ec$var$Ai,
    useDeferredValue: function(a) {
        var b = $f088c3cfa4ce44ec$var$di();
        return null === $f088c3cfa4ce44ec$var$O ? b.memoizedState = a : $f088c3cfa4ce44ec$var$Di(b, $f088c3cfa4ce44ec$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $f088c3cfa4ce44ec$var$gi($f088c3cfa4ce44ec$var$ei)[0], b = $f088c3cfa4ce44ec$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f088c3cfa4ce44ec$var$hi,
    useSyncExternalStore: $f088c3cfa4ce44ec$var$ii,
    useId: $f088c3cfa4ce44ec$var$Fi,
    unstable_isNewReconciler: !1
};
function $f088c3cfa4ce44ec$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $f088c3cfa4ce44ec$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f088c3cfa4ce44ec$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f088c3cfa4ce44ec$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f088c3cfa4ce44ec$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $f088c3cfa4ce44ec$var$Oi(a, b, c) {
    c = $f088c3cfa4ce44ec$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f088c3cfa4ce44ec$var$Pi || ($f088c3cfa4ce44ec$var$Pi = !0, $f088c3cfa4ce44ec$var$Qi = d);
        $f088c3cfa4ce44ec$var$Mi(a, b);
    };
    return c;
}
function $f088c3cfa4ce44ec$var$Ri(a, b, c) {
    c = $f088c3cfa4ce44ec$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f088c3cfa4ce44ec$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f088c3cfa4ce44ec$var$Mi(a, b);
        "function" !== typeof d && (null === $f088c3cfa4ce44ec$var$Si ? $f088c3cfa4ce44ec$var$Si = new Set([
            this
        ]) : $f088c3cfa4ce44ec$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f088c3cfa4ce44ec$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f088c3cfa4ce44ec$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f088c3cfa4ce44ec$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $f088c3cfa4ce44ec$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f088c3cfa4ce44ec$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f088c3cfa4ce44ec$var$ch(-1, 1), b.tag = 2, $f088c3cfa4ce44ec$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f088c3cfa4ce44ec$var$Xi = $f088c3cfa4ce44ec$var$ua.ReactCurrentOwner, $f088c3cfa4ce44ec$var$Ug = !1;
function $f088c3cfa4ce44ec$var$Yi(a, b, c, d) {
    b.child = null === a ? $f088c3cfa4ce44ec$var$Ch(b, null, c, d) : $f088c3cfa4ce44ec$var$Bh(b, a.child, c, d);
}
function $f088c3cfa4ce44ec$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f088c3cfa4ce44ec$var$Tg(b, e);
    d = $f088c3cfa4ce44ec$var$Xh(a, b, c, d, f, e);
    c = $f088c3cfa4ce44ec$var$bi();
    if (null !== a && !$f088c3cfa4ce44ec$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f088c3cfa4ce44ec$var$$i(a, b, e);
    $f088c3cfa4ce44ec$var$I && c && $f088c3cfa4ce44ec$var$vg(b);
    b.flags |= 1;
    $f088c3cfa4ce44ec$var$Yi(a, b, d, e);
    return b.child;
}
function $f088c3cfa4ce44ec$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f088c3cfa4ce44ec$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f088c3cfa4ce44ec$var$cj(a, b, f, d, e);
        a = $f088c3cfa4ce44ec$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f088c3cfa4ce44ec$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f088c3cfa4ce44ec$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $f088c3cfa4ce44ec$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f088c3cfa4ce44ec$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f088c3cfa4ce44ec$var$Ie(f, d) && a.ref === b.ref) {
            if ($f088c3cfa4ce44ec$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f088c3cfa4ce44ec$var$Ug = !0);
            else return b.lanes = a.lanes, $f088c3cfa4ce44ec$var$$i(a, b, e);
        }
    }
    return $f088c3cfa4ce44ec$var$dj(a, b, c, d, e);
}
function $f088c3cfa4ce44ec$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$fj, $f088c3cfa4ce44ec$var$gj), $f088c3cfa4ce44ec$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$fj, $f088c3cfa4ce44ec$var$gj), $f088c3cfa4ce44ec$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$fj, $f088c3cfa4ce44ec$var$gj);
            $f088c3cfa4ce44ec$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$fj, $f088c3cfa4ce44ec$var$gj), $f088c3cfa4ce44ec$var$gj |= d;
    $f088c3cfa4ce44ec$var$Yi(a, b, e, c);
    return b.child;
}
function $f088c3cfa4ce44ec$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f088c3cfa4ce44ec$var$dj(a, b, c, d, e) {
    var f = $f088c3cfa4ce44ec$var$Zf(c) ? $f088c3cfa4ce44ec$var$Xf : $f088c3cfa4ce44ec$var$H.current;
    f = $f088c3cfa4ce44ec$var$Yf(b, f);
    $f088c3cfa4ce44ec$var$Tg(b, e);
    c = $f088c3cfa4ce44ec$var$Xh(a, b, c, d, f, e);
    d = $f088c3cfa4ce44ec$var$bi();
    if (null !== a && !$f088c3cfa4ce44ec$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f088c3cfa4ce44ec$var$$i(a, b, e);
    $f088c3cfa4ce44ec$var$I && d && $f088c3cfa4ce44ec$var$vg(b);
    b.flags |= 1;
    $f088c3cfa4ce44ec$var$Yi(a, b, c, e);
    return b.child;
}
function $f088c3cfa4ce44ec$var$ij(a, b, c, d, e) {
    if ($f088c3cfa4ce44ec$var$Zf(c)) {
        var f = !0;
        $f088c3cfa4ce44ec$var$cg(b);
    } else f = !1;
    $f088c3cfa4ce44ec$var$Tg(b, e);
    if (null === b.stateNode) $f088c3cfa4ce44ec$var$jj(a, b), $f088c3cfa4ce44ec$var$ph(b, c, d), $f088c3cfa4ce44ec$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f088c3cfa4ce44ec$var$Vg(l) : (l = $f088c3cfa4ce44ec$var$Zf(c) ? $f088c3cfa4ce44ec$var$Xf : $f088c3cfa4ce44ec$var$H.current, l = $f088c3cfa4ce44ec$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f088c3cfa4ce44ec$var$qh(b, g, d, l);
        $f088c3cfa4ce44ec$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $f088c3cfa4ce44ec$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f088c3cfa4ce44ec$var$Wf.current || $f088c3cfa4ce44ec$var$$g ? ("function" === typeof m && ($f088c3cfa4ce44ec$var$kh(b, c, m, d), k = b.memoizedState), (h = $f088c3cfa4ce44ec$var$$g || $f088c3cfa4ce44ec$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f088c3cfa4ce44ec$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f088c3cfa4ce44ec$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f088c3cfa4ce44ec$var$Vg(k) : (k = $f088c3cfa4ce44ec$var$Zf(c) ? $f088c3cfa4ce44ec$var$Xf : $f088c3cfa4ce44ec$var$H.current, k = $f088c3cfa4ce44ec$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f088c3cfa4ce44ec$var$qh(b, g, d, k);
        $f088c3cfa4ce44ec$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $f088c3cfa4ce44ec$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f088c3cfa4ce44ec$var$Wf.current || $f088c3cfa4ce44ec$var$$g ? ("function" === typeof y && ($f088c3cfa4ce44ec$var$kh(b, c, y, d), n = b.memoizedState), (l = $f088c3cfa4ce44ec$var$$g || $f088c3cfa4ce44ec$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f088c3cfa4ce44ec$var$kj(a, b, c, d, f, e);
}
function $f088c3cfa4ce44ec$var$kj(a, b, c, d, e, f) {
    $f088c3cfa4ce44ec$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f088c3cfa4ce44ec$var$dg(b, c, !1), $f088c3cfa4ce44ec$var$$i(a, b, f);
    d = b.stateNode;
    $f088c3cfa4ce44ec$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f088c3cfa4ce44ec$var$Bh(b, a.child, null, f), b.child = $f088c3cfa4ce44ec$var$Bh(b, null, h, f)) : $f088c3cfa4ce44ec$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f088c3cfa4ce44ec$var$dg(b, c, !0);
    return b.child;
}
function $f088c3cfa4ce44ec$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f088c3cfa4ce44ec$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f088c3cfa4ce44ec$var$ag(a, b.context, !1);
    $f088c3cfa4ce44ec$var$Ih(a, b.containerInfo);
}
function $f088c3cfa4ce44ec$var$mj(a, b, c, d, e) {
    $f088c3cfa4ce44ec$var$Ig();
    $f088c3cfa4ce44ec$var$Jg(e);
    b.flags |= 256;
    $f088c3cfa4ce44ec$var$Yi(a, b, c, d);
    return b.child;
}
var $f088c3cfa4ce44ec$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f088c3cfa4ce44ec$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f088c3cfa4ce44ec$var$pj(a, b, c) {
    var d = b.pendingProps, e = $f088c3cfa4ce44ec$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, e & 1);
    if (null === a) {
        $f088c3cfa4ce44ec$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f088c3cfa4ce44ec$var$qj(g, d, 0, null), a = $f088c3cfa4ce44ec$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f088c3cfa4ce44ec$var$oj(c), b.memoizedState = $f088c3cfa4ce44ec$var$nj, a) : $f088c3cfa4ce44ec$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f088c3cfa4ce44ec$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f088c3cfa4ce44ec$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f088c3cfa4ce44ec$var$wh(h, f) : (f = $f088c3cfa4ce44ec$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f088c3cfa4ce44ec$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f088c3cfa4ce44ec$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f088c3cfa4ce44ec$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f088c3cfa4ce44ec$var$rj(a, b) {
    b = $f088c3cfa4ce44ec$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f088c3cfa4ce44ec$var$tj(a, b, c, d) {
    null !== d && $f088c3cfa4ce44ec$var$Jg(d);
    $f088c3cfa4ce44ec$var$Bh(b, a.child, null, c);
    a = $f088c3cfa4ce44ec$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f088c3cfa4ce44ec$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f088c3cfa4ce44ec$var$Li(Error($f088c3cfa4ce44ec$var$p(422))), $f088c3cfa4ce44ec$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f088c3cfa4ce44ec$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f088c3cfa4ce44ec$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f088c3cfa4ce44ec$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $f088c3cfa4ce44ec$var$oj(g);
        b.memoizedState = $f088c3cfa4ce44ec$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f088c3cfa4ce44ec$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f088c3cfa4ce44ec$var$p(419));
        d = $f088c3cfa4ce44ec$var$Li(f, d, void 0);
        return $f088c3cfa4ce44ec$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f088c3cfa4ce44ec$var$Ug || h) {
        d = $f088c3cfa4ce44ec$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f088c3cfa4ce44ec$var$Zg(a, e), $f088c3cfa4ce44ec$var$mh(d, a, e, -1));
        }
        $f088c3cfa4ce44ec$var$uj();
        d = $f088c3cfa4ce44ec$var$Li(Error($f088c3cfa4ce44ec$var$p(421)));
        return $f088c3cfa4ce44ec$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f088c3cfa4ce44ec$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$Lf(e.nextSibling);
    $f088c3cfa4ce44ec$var$xg = b;
    $f088c3cfa4ce44ec$var$I = !0;
    $f088c3cfa4ce44ec$var$zg = null;
    null !== a && ($f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$rg, $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$sg, $f088c3cfa4ce44ec$var$og[$f088c3cfa4ce44ec$var$pg++] = $f088c3cfa4ce44ec$var$qg, $f088c3cfa4ce44ec$var$rg = a.id, $f088c3cfa4ce44ec$var$sg = a.overflow, $f088c3cfa4ce44ec$var$qg = b);
    b = $f088c3cfa4ce44ec$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f088c3cfa4ce44ec$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f088c3cfa4ce44ec$var$Sg(a.return, b, c);
}
function $f088c3cfa4ce44ec$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f088c3cfa4ce44ec$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f088c3cfa4ce44ec$var$Yi(a, b, d.children, c);
    d = $f088c3cfa4ce44ec$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f088c3cfa4ce44ec$var$wj(a, c, b);
            else if (19 === a.tag) $f088c3cfa4ce44ec$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f088c3cfa4ce44ec$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f088c3cfa4ce44ec$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f088c3cfa4ce44ec$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f088c3cfa4ce44ec$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $f088c3cfa4ce44ec$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f088c3cfa4ce44ec$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f088c3cfa4ce44ec$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f088c3cfa4ce44ec$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f088c3cfa4ce44ec$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f088c3cfa4ce44ec$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f088c3cfa4ce44ec$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f088c3cfa4ce44ec$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $f088c3cfa4ce44ec$var$lj(b);
            $f088c3cfa4ce44ec$var$Ig();
            break;
        case 5:
            $f088c3cfa4ce44ec$var$Kh(b);
            break;
        case 1:
            $f088c3cfa4ce44ec$var$Zf(b.type) && $f088c3cfa4ce44ec$var$cg(b);
            break;
        case 4:
            $f088c3cfa4ce44ec$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, $f088c3cfa4ce44ec$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f088c3cfa4ce44ec$var$pj(a, b, c);
                $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, $f088c3cfa4ce44ec$var$M.current & 1);
                a = $f088c3cfa4ce44ec$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, $f088c3cfa4ce44ec$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f088c3cfa4ce44ec$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, $f088c3cfa4ce44ec$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f088c3cfa4ce44ec$var$ej(a, b, c);
    }
    return $f088c3cfa4ce44ec$var$$i(a, b, c);
}
var $f088c3cfa4ce44ec$var$Aj, $f088c3cfa4ce44ec$var$Bj, $f088c3cfa4ce44ec$var$Cj, $f088c3cfa4ce44ec$var$Dj;
$f088c3cfa4ce44ec$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f088c3cfa4ce44ec$var$Bj = function() {};
$f088c3cfa4ce44ec$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f088c3cfa4ce44ec$var$Ya(a, e);
                d = $f088c3cfa4ce44ec$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f088c3cfa4ce44ec$var$A({}, e, {
                    value: void 0
                });
                d = $f088c3cfa4ce44ec$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f088c3cfa4ce44ec$var$gb(a, e);
                d = $f088c3cfa4ce44ec$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f088c3cfa4ce44ec$var$Bf);
        }
        $f088c3cfa4ce44ec$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f088c3cfa4ce44ec$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f088c3cfa4ce44ec$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f088c3cfa4ce44ec$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f088c3cfa4ce44ec$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f088c3cfa4ce44ec$var$Ej(a, b) {
    if (!$f088c3cfa4ce44ec$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f088c3cfa4ce44ec$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f088c3cfa4ce44ec$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $f088c3cfa4ce44ec$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f088c3cfa4ce44ec$var$S(b), null;
        case 1:
            return $f088c3cfa4ce44ec$var$Zf(b.type) && $f088c3cfa4ce44ec$var$$f(), $f088c3cfa4ce44ec$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f088c3cfa4ce44ec$var$Jh();
            $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf);
            $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$H);
            $f088c3cfa4ce44ec$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f088c3cfa4ce44ec$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f088c3cfa4ce44ec$var$zg && ($f088c3cfa4ce44ec$var$Gj($f088c3cfa4ce44ec$var$zg), $f088c3cfa4ce44ec$var$zg = null));
            $f088c3cfa4ce44ec$var$Bj(a, b);
            $f088c3cfa4ce44ec$var$S(b);
            return null;
        case 5:
            $f088c3cfa4ce44ec$var$Lh(b);
            var e = $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f088c3cfa4ce44ec$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f088c3cfa4ce44ec$var$p(166));
                    $f088c3cfa4ce44ec$var$S(b);
                    return null;
                }
                a = $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Eh.current);
                if ($f088c3cfa4ce44ec$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f088c3cfa4ce44ec$var$Of] = b;
                    d[$f088c3cfa4ce44ec$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f088c3cfa4ce44ec$var$D("cancel", d);
                            $f088c3cfa4ce44ec$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f088c3cfa4ce44ec$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f088c3cfa4ce44ec$var$lf.length; e++)$f088c3cfa4ce44ec$var$D($f088c3cfa4ce44ec$var$lf[e], d);
                            break;
                        case "source":
                            $f088c3cfa4ce44ec$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f088c3cfa4ce44ec$var$D("error", d);
                            $f088c3cfa4ce44ec$var$D("load", d);
                            break;
                        case "details":
                            $f088c3cfa4ce44ec$var$D("toggle", d);
                            break;
                        case "input":
                            $f088c3cfa4ce44ec$var$Za(d, f);
                            $f088c3cfa4ce44ec$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f088c3cfa4ce44ec$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f088c3cfa4ce44ec$var$hb(d, f), $f088c3cfa4ce44ec$var$D("invalid", d);
                    }
                    $f088c3cfa4ce44ec$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f088c3cfa4ce44ec$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f088c3cfa4ce44ec$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f088c3cfa4ce44ec$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f088c3cfa4ce44ec$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f088c3cfa4ce44ec$var$Va(d);
                            $f088c3cfa4ce44ec$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f088c3cfa4ce44ec$var$Va(d);
                            $f088c3cfa4ce44ec$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f088c3cfa4ce44ec$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f088c3cfa4ce44ec$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f088c3cfa4ce44ec$var$Of] = b;
                    a[$f088c3cfa4ce44ec$var$Pf] = d;
                    $f088c3cfa4ce44ec$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f088c3cfa4ce44ec$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f088c3cfa4ce44ec$var$D("cancel", a);
                                $f088c3cfa4ce44ec$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f088c3cfa4ce44ec$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f088c3cfa4ce44ec$var$lf.length; e++)$f088c3cfa4ce44ec$var$D($f088c3cfa4ce44ec$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f088c3cfa4ce44ec$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f088c3cfa4ce44ec$var$D("error", a);
                                $f088c3cfa4ce44ec$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f088c3cfa4ce44ec$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f088c3cfa4ce44ec$var$Za(a, d);
                                e = $f088c3cfa4ce44ec$var$Ya(a, d);
                                $f088c3cfa4ce44ec$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f088c3cfa4ce44ec$var$A({}, d, {
                                    value: void 0
                                });
                                $f088c3cfa4ce44ec$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f088c3cfa4ce44ec$var$hb(a, d);
                                e = $f088c3cfa4ce44ec$var$gb(a, d);
                                $f088c3cfa4ce44ec$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f088c3cfa4ce44ec$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f088c3cfa4ce44ec$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f088c3cfa4ce44ec$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f088c3cfa4ce44ec$var$ob(a, k) : "number" === typeof k && $f088c3cfa4ce44ec$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f088c3cfa4ce44ec$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f088c3cfa4ce44ec$var$D("scroll", a) : null != k && $f088c3cfa4ce44ec$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f088c3cfa4ce44ec$var$Va(a);
                                $f088c3cfa4ce44ec$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f088c3cfa4ce44ec$var$Va(a);
                                $f088c3cfa4ce44ec$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f088c3cfa4ce44ec$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f088c3cfa4ce44ec$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f088c3cfa4ce44ec$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f088c3cfa4ce44ec$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f088c3cfa4ce44ec$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f088c3cfa4ce44ec$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f088c3cfa4ce44ec$var$p(166));
                c = $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Gh.current);
                $f088c3cfa4ce44ec$var$Hh($f088c3cfa4ce44ec$var$Eh.current);
                if ($f088c3cfa4ce44ec$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f088c3cfa4ce44ec$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f088c3cfa4ce44ec$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f088c3cfa4ce44ec$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f088c3cfa4ce44ec$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f088c3cfa4ce44ec$var$Of] = b, b.stateNode = d;
            }
            $f088c3cfa4ce44ec$var$S(b);
            return null;
        case 13:
            $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f088c3cfa4ce44ec$var$I && null !== $f088c3cfa4ce44ec$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f088c3cfa4ce44ec$var$Hg(), $f088c3cfa4ce44ec$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f088c3cfa4ce44ec$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f088c3cfa4ce44ec$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f088c3cfa4ce44ec$var$p(317));
                        f[$f088c3cfa4ce44ec$var$Of] = b;
                    } else $f088c3cfa4ce44ec$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f088c3cfa4ce44ec$var$S(b);
                    f = !1;
                } else null !== $f088c3cfa4ce44ec$var$zg && ($f088c3cfa4ce44ec$var$Gj($f088c3cfa4ce44ec$var$zg), $f088c3cfa4ce44ec$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f088c3cfa4ce44ec$var$M.current & 1) ? 0 === $f088c3cfa4ce44ec$var$T && ($f088c3cfa4ce44ec$var$T = 3) : $f088c3cfa4ce44ec$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f088c3cfa4ce44ec$var$S(b);
            return null;
        case 4:
            return $f088c3cfa4ce44ec$var$Jh(), $f088c3cfa4ce44ec$var$Bj(a, b), null === a && $f088c3cfa4ce44ec$var$sf(b.stateNode.containerInfo), $f088c3cfa4ce44ec$var$S(b), null;
        case 10:
            return $f088c3cfa4ce44ec$var$Rg(b.type._context), $f088c3cfa4ce44ec$var$S(b), null;
        case 17:
            return $f088c3cfa4ce44ec$var$Zf(b.type) && $f088c3cfa4ce44ec$var$$f(), $f088c3cfa4ce44ec$var$S(b), null;
        case 19:
            $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M);
            f = b.memoizedState;
            if (null === f) return $f088c3cfa4ce44ec$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f088c3cfa4ce44ec$var$Ej(f, !1);
                else {
                    if (0 !== $f088c3cfa4ce44ec$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f088c3cfa4ce44ec$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f088c3cfa4ce44ec$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, $f088c3cfa4ce44ec$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f088c3cfa4ce44ec$var$B() > $f088c3cfa4ce44ec$var$Hj && (b.flags |= 128, d = !0, $f088c3cfa4ce44ec$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f088c3cfa4ce44ec$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f088c3cfa4ce44ec$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f088c3cfa4ce44ec$var$I) return $f088c3cfa4ce44ec$var$S(b), null;
                    } else 2 * $f088c3cfa4ce44ec$var$B() - f.renderingStartTime > $f088c3cfa4ce44ec$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $f088c3cfa4ce44ec$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f088c3cfa4ce44ec$var$B(), b.sibling = null, c = $f088c3cfa4ce44ec$var$M.current, $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$M, d ? c & 1 | 2 : c & 1), b;
            $f088c3cfa4ce44ec$var$S(b);
            return null;
        case 22:
        case 23:
            return $f088c3cfa4ce44ec$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f088c3cfa4ce44ec$var$gj & 1073741824) && ($f088c3cfa4ce44ec$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f088c3cfa4ce44ec$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f088c3cfa4ce44ec$var$p(156, b.tag));
}
function $f088c3cfa4ce44ec$var$Jj(a, b) {
    $f088c3cfa4ce44ec$var$wg(b);
    switch(b.tag){
        case 1:
            return $f088c3cfa4ce44ec$var$Zf(b.type) && $f088c3cfa4ce44ec$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f088c3cfa4ce44ec$var$Jh(), $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf), $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$H), $f088c3cfa4ce44ec$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f088c3cfa4ce44ec$var$Lh(b), null;
        case 13:
            $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f088c3cfa4ce44ec$var$p(340));
                $f088c3cfa4ce44ec$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M), null;
        case 4:
            return $f088c3cfa4ce44ec$var$Jh(), null;
        case 10:
            return $f088c3cfa4ce44ec$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $f088c3cfa4ce44ec$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f088c3cfa4ce44ec$var$Kj = !1, $f088c3cfa4ce44ec$var$U = !1, $f088c3cfa4ce44ec$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $f088c3cfa4ce44ec$var$V = null;
function $f088c3cfa4ce44ec$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f088c3cfa4ce44ec$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f088c3cfa4ce44ec$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f088c3cfa4ce44ec$var$W(a, b, d);
    }
}
var $f088c3cfa4ce44ec$var$Oj = !1;
function $f088c3cfa4ce44ec$var$Pj(a, b) {
    $f088c3cfa4ce44ec$var$Cf = $f088c3cfa4ce44ec$var$dd;
    a = $f088c3cfa4ce44ec$var$Me();
    if ($f088c3cfa4ce44ec$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f088c3cfa4ce44ec$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f088c3cfa4ce44ec$var$dd = !1;
    for($f088c3cfa4ce44ec$var$V = b; null !== $f088c3cfa4ce44ec$var$V;)if (b = $f088c3cfa4ce44ec$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f088c3cfa4ce44ec$var$V = a;
    else for(; null !== $f088c3cfa4ce44ec$var$V;){
        b = $f088c3cfa4ce44ec$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f088c3cfa4ce44ec$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f088c3cfa4ce44ec$var$p(163));
            }
        } catch (F) {
            $f088c3cfa4ce44ec$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f088c3cfa4ce44ec$var$V = a;
            break;
        }
        $f088c3cfa4ce44ec$var$V = b.return;
    }
    n = $f088c3cfa4ce44ec$var$Oj;
    $f088c3cfa4ce44ec$var$Oj = !1;
    return n;
}
function $f088c3cfa4ce44ec$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f088c3cfa4ce44ec$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f088c3cfa4ce44ec$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f088c3cfa4ce44ec$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f088c3cfa4ce44ec$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f088c3cfa4ce44ec$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f088c3cfa4ce44ec$var$Of], delete b[$f088c3cfa4ce44ec$var$Pf], delete b[$f088c3cfa4ce44ec$var$of], delete b[$f088c3cfa4ce44ec$var$Qf], delete b[$f088c3cfa4ce44ec$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f088c3cfa4ce44ec$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f088c3cfa4ce44ec$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f088c3cfa4ce44ec$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f088c3cfa4ce44ec$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f088c3cfa4ce44ec$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f088c3cfa4ce44ec$var$Wj(a, b, c), a = a.sibling; null !== a;)$f088c3cfa4ce44ec$var$Wj(a, b, c), a = a.sibling;
}
function $f088c3cfa4ce44ec$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f088c3cfa4ce44ec$var$Xj(a, b, c), a = a.sibling; null !== a;)$f088c3cfa4ce44ec$var$Xj(a, b, c), a = a.sibling;
}
var $f088c3cfa4ce44ec$var$X = null, $f088c3cfa4ce44ec$var$Yj = !1;
function $f088c3cfa4ce44ec$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$f088c3cfa4ce44ec$var$ak(a, b, c), c = c.sibling;
}
function $f088c3cfa4ce44ec$var$ak(a, b, c) {
    if ($f088c3cfa4ce44ec$var$lc && "function" === typeof $f088c3cfa4ce44ec$var$lc.onCommitFiberUnmount) try {
        $f088c3cfa4ce44ec$var$lc.onCommitFiberUnmount($f088c3cfa4ce44ec$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f088c3cfa4ce44ec$var$U || $f088c3cfa4ce44ec$var$Mj(c, b);
        case 6:
            var d = $f088c3cfa4ce44ec$var$X, e = $f088c3cfa4ce44ec$var$Yj;
            $f088c3cfa4ce44ec$var$X = null;
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
            $f088c3cfa4ce44ec$var$X = d;
            $f088c3cfa4ce44ec$var$Yj = e;
            null !== $f088c3cfa4ce44ec$var$X && ($f088c3cfa4ce44ec$var$Yj ? (a = $f088c3cfa4ce44ec$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f088c3cfa4ce44ec$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f088c3cfa4ce44ec$var$X && ($f088c3cfa4ce44ec$var$Yj ? (a = $f088c3cfa4ce44ec$var$X, c = c.stateNode, 8 === a.nodeType ? $f088c3cfa4ce44ec$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f088c3cfa4ce44ec$var$Kf(a, c), $f088c3cfa4ce44ec$var$bd(a)) : $f088c3cfa4ce44ec$var$Kf($f088c3cfa4ce44ec$var$X, c.stateNode));
            break;
        case 4:
            d = $f088c3cfa4ce44ec$var$X;
            e = $f088c3cfa4ce44ec$var$Yj;
            $f088c3cfa4ce44ec$var$X = c.stateNode.containerInfo;
            $f088c3cfa4ce44ec$var$Yj = !0;
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
            $f088c3cfa4ce44ec$var$X = d;
            $f088c3cfa4ce44ec$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f088c3cfa4ce44ec$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f088c3cfa4ce44ec$var$Nj(c, b, g) : 0 !== (f & 4) && $f088c3cfa4ce44ec$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
            break;
        case 1:
            if (!$f088c3cfa4ce44ec$var$U && ($f088c3cfa4ce44ec$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f088c3cfa4ce44ec$var$W(c, b, h);
            }
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
            break;
        case 21:
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f088c3cfa4ce44ec$var$U = (d = $f088c3cfa4ce44ec$var$U) || null !== c.memoizedState, $f088c3cfa4ce44ec$var$Zj(a, b, c), $f088c3cfa4ce44ec$var$U = d) : $f088c3cfa4ce44ec$var$Zj(a, b, c);
            break;
        default:
            $f088c3cfa4ce44ec$var$Zj(a, b, c);
    }
}
function $f088c3cfa4ce44ec$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f088c3cfa4ce44ec$var$Lj);
        b.forEach(function(b) {
            var d = $f088c3cfa4ce44ec$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f088c3cfa4ce44ec$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f088c3cfa4ce44ec$var$X = h.stateNode;
                        $f088c3cfa4ce44ec$var$Yj = !1;
                        break a;
                    case 3:
                        $f088c3cfa4ce44ec$var$X = h.stateNode.containerInfo;
                        $f088c3cfa4ce44ec$var$Yj = !0;
                        break a;
                    case 4:
                        $f088c3cfa4ce44ec$var$X = h.stateNode.containerInfo;
                        $f088c3cfa4ce44ec$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f088c3cfa4ce44ec$var$X) throw Error($f088c3cfa4ce44ec$var$p(160));
            $f088c3cfa4ce44ec$var$ak(f, g, e);
            $f088c3cfa4ce44ec$var$X = null;
            $f088c3cfa4ce44ec$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f088c3cfa4ce44ec$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f088c3cfa4ce44ec$var$ek(b, a), b = b.sibling;
}
function $f088c3cfa4ce44ec$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            if (d & 4) {
                try {
                    $f088c3cfa4ce44ec$var$Qj(3, a, a.return), $f088c3cfa4ce44ec$var$Rj(3, a);
                } catch (t) {
                    $f088c3cfa4ce44ec$var$W(a, a.return, t);
                }
                try {
                    $f088c3cfa4ce44ec$var$Qj(5, a, a.return);
                } catch (t) {
                    $f088c3cfa4ce44ec$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            d & 512 && null !== c && $f088c3cfa4ce44ec$var$Mj(c, c.return);
            break;
        case 5:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            d & 512 && null !== c && $f088c3cfa4ce44ec$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f088c3cfa4ce44ec$var$ob(e, "");
                } catch (t) {
                    $f088c3cfa4ce44ec$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f088c3cfa4ce44ec$var$ab(e, f);
                    $f088c3cfa4ce44ec$var$vb(h, g);
                    var l = $f088c3cfa4ce44ec$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f088c3cfa4ce44ec$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f088c3cfa4ce44ec$var$nb(e, q) : "children" === m ? $f088c3cfa4ce44ec$var$ob(e, q) : $f088c3cfa4ce44ec$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f088c3cfa4ce44ec$var$bb(e, f);
                            break;
                        case "textarea":
                            $f088c3cfa4ce44ec$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f088c3cfa4ce44ec$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f088c3cfa4ce44ec$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f088c3cfa4ce44ec$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f088c3cfa4ce44ec$var$Pf] = f;
                } catch (t) {
                    $f088c3cfa4ce44ec$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f088c3cfa4ce44ec$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f088c3cfa4ce44ec$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f088c3cfa4ce44ec$var$bd(b.containerInfo);
            } catch (t) {
                $f088c3cfa4ce44ec$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            break;
        case 13:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f088c3cfa4ce44ec$var$gk = $f088c3cfa4ce44ec$var$B()));
            d & 4 && $f088c3cfa4ce44ec$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f088c3cfa4ce44ec$var$U = (l = $f088c3cfa4ce44ec$var$U) || m, $f088c3cfa4ce44ec$var$dk(b, a), $f088c3cfa4ce44ec$var$U = l) : $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f088c3cfa4ce44ec$var$V = a, m = a.child; null !== m;){
                    for(q = $f088c3cfa4ce44ec$var$V = m; null !== $f088c3cfa4ce44ec$var$V;){
                        r = $f088c3cfa4ce44ec$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f088c3cfa4ce44ec$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $f088c3cfa4ce44ec$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f088c3cfa4ce44ec$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f088c3cfa4ce44ec$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f088c3cfa4ce44ec$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f088c3cfa4ce44ec$var$V = y) : $f088c3cfa4ce44ec$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f088c3cfa4ce44ec$var$rb("display", g));
                            } catch (t) {
                                $f088c3cfa4ce44ec$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f088c3cfa4ce44ec$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f088c3cfa4ce44ec$var$dk(b, a);
            $f088c3cfa4ce44ec$var$fk(a);
            d & 4 && $f088c3cfa4ce44ec$var$bk(a);
            break;
        case 21:
            break;
        default:
            $f088c3cfa4ce44ec$var$dk(b, a), $f088c3cfa4ce44ec$var$fk(a);
    }
}
function $f088c3cfa4ce44ec$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f088c3cfa4ce44ec$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f088c3cfa4ce44ec$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f088c3cfa4ce44ec$var$ob(e, ""), d.flags &= -33);
                    var f = $f088c3cfa4ce44ec$var$Vj(a);
                    $f088c3cfa4ce44ec$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f088c3cfa4ce44ec$var$Vj(a);
                    $f088c3cfa4ce44ec$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($f088c3cfa4ce44ec$var$p(161));
            }
        } catch (k) {
            $f088c3cfa4ce44ec$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f088c3cfa4ce44ec$var$ik(a, b, c) {
    $f088c3cfa4ce44ec$var$V = a;
    $f088c3cfa4ce44ec$var$jk(a, b, c);
}
function $f088c3cfa4ce44ec$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f088c3cfa4ce44ec$var$V;){
        var e = $f088c3cfa4ce44ec$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f088c3cfa4ce44ec$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f088c3cfa4ce44ec$var$U;
                h = $f088c3cfa4ce44ec$var$Kj;
                var l = $f088c3cfa4ce44ec$var$U;
                $f088c3cfa4ce44ec$var$Kj = g;
                if (($f088c3cfa4ce44ec$var$U = k) && !l) for($f088c3cfa4ce44ec$var$V = e; null !== $f088c3cfa4ce44ec$var$V;)g = $f088c3cfa4ce44ec$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f088c3cfa4ce44ec$var$kk(e) : null !== k ? (k.return = g, $f088c3cfa4ce44ec$var$V = k) : $f088c3cfa4ce44ec$var$kk(e);
                for(; null !== f;)$f088c3cfa4ce44ec$var$V = f, $f088c3cfa4ce44ec$var$jk(f, b, c), f = f.sibling;
                $f088c3cfa4ce44ec$var$V = e;
                $f088c3cfa4ce44ec$var$Kj = h;
                $f088c3cfa4ce44ec$var$U = l;
            }
            $f088c3cfa4ce44ec$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f088c3cfa4ce44ec$var$V = f) : $f088c3cfa4ce44ec$var$lk(a, b, c);
    }
}
function $f088c3cfa4ce44ec$var$lk(a) {
    for(; null !== $f088c3cfa4ce44ec$var$V;){
        var b = $f088c3cfa4ce44ec$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f088c3cfa4ce44ec$var$U || $f088c3cfa4ce44ec$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f088c3cfa4ce44ec$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f088c3cfa4ce44ec$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f088c3cfa4ce44ec$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f088c3cfa4ce44ec$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f088c3cfa4ce44ec$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f088c3cfa4ce44ec$var$p(163));
                }
                $f088c3cfa4ce44ec$var$U || b.flags & 512 && $f088c3cfa4ce44ec$var$Sj(b);
            } catch (r) {
                $f088c3cfa4ce44ec$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f088c3cfa4ce44ec$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f088c3cfa4ce44ec$var$V = c;
            break;
        }
        $f088c3cfa4ce44ec$var$V = b.return;
    }
}
function $f088c3cfa4ce44ec$var$hk(a) {
    for(; null !== $f088c3cfa4ce44ec$var$V;){
        var b = $f088c3cfa4ce44ec$var$V;
        if (b === a) {
            $f088c3cfa4ce44ec$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f088c3cfa4ce44ec$var$V = c;
            break;
        }
        $f088c3cfa4ce44ec$var$V = b.return;
    }
}
function $f088c3cfa4ce44ec$var$kk(a) {
    for(; null !== $f088c3cfa4ce44ec$var$V;){
        var b = $f088c3cfa4ce44ec$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f088c3cfa4ce44ec$var$Rj(4, b);
                    } catch (k) {
                        $f088c3cfa4ce44ec$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f088c3cfa4ce44ec$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f088c3cfa4ce44ec$var$Sj(b);
                    } catch (k) {
                        $f088c3cfa4ce44ec$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f088c3cfa4ce44ec$var$Sj(b);
                    } catch (k) {
                        $f088c3cfa4ce44ec$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f088c3cfa4ce44ec$var$W(b, b.return, k);
        }
        if (b === a) {
            $f088c3cfa4ce44ec$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f088c3cfa4ce44ec$var$V = h;
            break;
        }
        $f088c3cfa4ce44ec$var$V = b.return;
    }
}
var $f088c3cfa4ce44ec$var$mk = Math.ceil, $f088c3cfa4ce44ec$var$nk = $f088c3cfa4ce44ec$var$ua.ReactCurrentDispatcher, $f088c3cfa4ce44ec$var$ok = $f088c3cfa4ce44ec$var$ua.ReactCurrentOwner, $f088c3cfa4ce44ec$var$pk = $f088c3cfa4ce44ec$var$ua.ReactCurrentBatchConfig, $f088c3cfa4ce44ec$var$K = 0, $f088c3cfa4ce44ec$var$R = null, $f088c3cfa4ce44ec$var$Y = null, $f088c3cfa4ce44ec$var$Z = 0, $f088c3cfa4ce44ec$var$gj = 0, $f088c3cfa4ce44ec$var$fj = $f088c3cfa4ce44ec$var$Uf(0), $f088c3cfa4ce44ec$var$T = 0, $f088c3cfa4ce44ec$var$qk = null, $f088c3cfa4ce44ec$var$hh = 0, $f088c3cfa4ce44ec$var$rk = 0, $f088c3cfa4ce44ec$var$sk = 0, $f088c3cfa4ce44ec$var$tk = null, $f088c3cfa4ce44ec$var$uk = null, $f088c3cfa4ce44ec$var$gk = 0, $f088c3cfa4ce44ec$var$Hj = Infinity, $f088c3cfa4ce44ec$var$vk = null, $f088c3cfa4ce44ec$var$Pi = !1, $f088c3cfa4ce44ec$var$Qi = null, $f088c3cfa4ce44ec$var$Si = null, $f088c3cfa4ce44ec$var$wk = !1, $f088c3cfa4ce44ec$var$xk = null, $f088c3cfa4ce44ec$var$yk = 0, $f088c3cfa4ce44ec$var$zk = 0, $f088c3cfa4ce44ec$var$Ak = null, $f088c3cfa4ce44ec$var$Bk = -1, $f088c3cfa4ce44ec$var$Ck = 0;
function $f088c3cfa4ce44ec$var$L() {
    return 0 !== ($f088c3cfa4ce44ec$var$K & 6) ? $f088c3cfa4ce44ec$var$B() : -1 !== $f088c3cfa4ce44ec$var$Bk ? $f088c3cfa4ce44ec$var$Bk : $f088c3cfa4ce44ec$var$Bk = $f088c3cfa4ce44ec$var$B();
}
function $f088c3cfa4ce44ec$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f088c3cfa4ce44ec$var$K & 2) && 0 !== $f088c3cfa4ce44ec$var$Z) return $f088c3cfa4ce44ec$var$Z & -$f088c3cfa4ce44ec$var$Z;
    if (null !== $f088c3cfa4ce44ec$var$Kg.transition) return 0 === $f088c3cfa4ce44ec$var$Ck && ($f088c3cfa4ce44ec$var$Ck = $f088c3cfa4ce44ec$var$yc()), $f088c3cfa4ce44ec$var$Ck;
    a = $f088c3cfa4ce44ec$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f088c3cfa4ce44ec$var$jd(a.type);
    return a;
}
function $f088c3cfa4ce44ec$var$mh(a, b, c, d) {
    if (50 < $f088c3cfa4ce44ec$var$zk) throw $f088c3cfa4ce44ec$var$zk = 0, $f088c3cfa4ce44ec$var$Ak = null, Error($f088c3cfa4ce44ec$var$p(185));
    $f088c3cfa4ce44ec$var$Ac(a, c, d);
    if (0 === ($f088c3cfa4ce44ec$var$K & 2) || a !== $f088c3cfa4ce44ec$var$R) a === $f088c3cfa4ce44ec$var$R && (0 === ($f088c3cfa4ce44ec$var$K & 2) && ($f088c3cfa4ce44ec$var$rk |= c), 4 === $f088c3cfa4ce44ec$var$T && $f088c3cfa4ce44ec$var$Dk(a, $f088c3cfa4ce44ec$var$Z)), $f088c3cfa4ce44ec$var$Ek(a, d), 1 === c && 0 === $f088c3cfa4ce44ec$var$K && 0 === (b.mode & 1) && ($f088c3cfa4ce44ec$var$Hj = $f088c3cfa4ce44ec$var$B() + 500, $f088c3cfa4ce44ec$var$fg && $f088c3cfa4ce44ec$var$jg());
}
function $f088c3cfa4ce44ec$var$Ek(a, b) {
    var c = a.callbackNode;
    $f088c3cfa4ce44ec$var$wc(a, b);
    var d = $f088c3cfa4ce44ec$var$uc(a, a === $f088c3cfa4ce44ec$var$R ? $f088c3cfa4ce44ec$var$Z : 0);
    if (0 === d) null !== c && $f088c3cfa4ce44ec$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f088c3cfa4ce44ec$var$bc(c);
        if (1 === b) 0 === a.tag ? $f088c3cfa4ce44ec$var$ig($f088c3cfa4ce44ec$var$Fk.bind(null, a)) : $f088c3cfa4ce44ec$var$hg($f088c3cfa4ce44ec$var$Fk.bind(null, a)), $f088c3cfa4ce44ec$var$Jf(function() {
            0 === ($f088c3cfa4ce44ec$var$K & 6) && $f088c3cfa4ce44ec$var$jg();
        }), c = null;
        else {
            switch($f088c3cfa4ce44ec$var$Dc(d)){
                case 1:
                    c = $f088c3cfa4ce44ec$var$fc;
                    break;
                case 4:
                    c = $f088c3cfa4ce44ec$var$gc;
                    break;
                case 16:
                    c = $f088c3cfa4ce44ec$var$hc;
                    break;
                case 536870912:
                    c = $f088c3cfa4ce44ec$var$jc;
                    break;
                default:
                    c = $f088c3cfa4ce44ec$var$hc;
            }
            c = $f088c3cfa4ce44ec$var$Gk(c, $f088c3cfa4ce44ec$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f088c3cfa4ce44ec$var$Hk(a, b) {
    $f088c3cfa4ce44ec$var$Bk = -1;
    $f088c3cfa4ce44ec$var$Ck = 0;
    if (0 !== ($f088c3cfa4ce44ec$var$K & 6)) throw Error($f088c3cfa4ce44ec$var$p(327));
    var c = a.callbackNode;
    if ($f088c3cfa4ce44ec$var$Ik() && a.callbackNode !== c) return null;
    var d = $f088c3cfa4ce44ec$var$uc(a, a === $f088c3cfa4ce44ec$var$R ? $f088c3cfa4ce44ec$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f088c3cfa4ce44ec$var$Jk(a, d);
    else {
        b = d;
        var e = $f088c3cfa4ce44ec$var$K;
        $f088c3cfa4ce44ec$var$K |= 2;
        var f = $f088c3cfa4ce44ec$var$Kk();
        if ($f088c3cfa4ce44ec$var$R !== a || $f088c3cfa4ce44ec$var$Z !== b) $f088c3cfa4ce44ec$var$vk = null, $f088c3cfa4ce44ec$var$Hj = $f088c3cfa4ce44ec$var$B() + 500, $f088c3cfa4ce44ec$var$Lk(a, b);
        for(;;)try {
            $f088c3cfa4ce44ec$var$Mk();
            break;
        } catch (h) {
            $f088c3cfa4ce44ec$var$Nk(a, h);
        }
        $f088c3cfa4ce44ec$var$Qg();
        $f088c3cfa4ce44ec$var$nk.current = f;
        $f088c3cfa4ce44ec$var$K = e;
        null !== $f088c3cfa4ce44ec$var$Y ? b = 0 : ($f088c3cfa4ce44ec$var$R = null, $f088c3cfa4ce44ec$var$Z = 0, b = $f088c3cfa4ce44ec$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f088c3cfa4ce44ec$var$xc(a), 0 !== e && (d = e, b = $f088c3cfa4ce44ec$var$Ok(a, e)));
        if (1 === b) throw c = $f088c3cfa4ce44ec$var$qk, $f088c3cfa4ce44ec$var$Lk(a, 0), $f088c3cfa4ce44ec$var$Dk(a, d), $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B()), c;
        if (6 === b) $f088c3cfa4ce44ec$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f088c3cfa4ce44ec$var$Pk(e) && (b = $f088c3cfa4ce44ec$var$Jk(a, d), 2 === b && (f = $f088c3cfa4ce44ec$var$xc(a), 0 !== f && (d = f, b = $f088c3cfa4ce44ec$var$Ok(a, f))), 1 === b)) throw c = $f088c3cfa4ce44ec$var$qk, $f088c3cfa4ce44ec$var$Lk(a, 0), $f088c3cfa4ce44ec$var$Dk(a, d), $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f088c3cfa4ce44ec$var$p(345));
                case 2:
                    $f088c3cfa4ce44ec$var$Qk(a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk);
                    break;
                case 3:
                    $f088c3cfa4ce44ec$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $f088c3cfa4ce44ec$var$gk + 500 - $f088c3cfa4ce44ec$var$B(), 10 < b)) {
                        if (0 !== $f088c3cfa4ce44ec$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f088c3cfa4ce44ec$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f088c3cfa4ce44ec$var$Ff($f088c3cfa4ce44ec$var$Qk.bind(null, a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk), b);
                        break;
                    }
                    $f088c3cfa4ce44ec$var$Qk(a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk);
                    break;
                case 4:
                    $f088c3cfa4ce44ec$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f088c3cfa4ce44ec$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f088c3cfa4ce44ec$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f088c3cfa4ce44ec$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f088c3cfa4ce44ec$var$Ff($f088c3cfa4ce44ec$var$Qk.bind(null, a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk), d);
                        break;
                    }
                    $f088c3cfa4ce44ec$var$Qk(a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk);
                    break;
                case 5:
                    $f088c3cfa4ce44ec$var$Qk(a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk);
                    break;
                default:
                    throw Error($f088c3cfa4ce44ec$var$p(329));
            }
        }
    }
    $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B());
    return a.callbackNode === c ? $f088c3cfa4ce44ec$var$Hk.bind(null, a) : null;
}
function $f088c3cfa4ce44ec$var$Ok(a, b) {
    var c = $f088c3cfa4ce44ec$var$tk;
    a.current.memoizedState.isDehydrated && ($f088c3cfa4ce44ec$var$Lk(a, b).flags |= 256);
    a = $f088c3cfa4ce44ec$var$Jk(a, b);
    2 !== a && (b = $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$uk = c, null !== b && $f088c3cfa4ce44ec$var$Gj(b));
    return a;
}
function $f088c3cfa4ce44ec$var$Gj(a) {
    null === $f088c3cfa4ce44ec$var$uk ? $f088c3cfa4ce44ec$var$uk = a : $f088c3cfa4ce44ec$var$uk.push.apply($f088c3cfa4ce44ec$var$uk, a);
}
function $f088c3cfa4ce44ec$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f088c3cfa4ce44ec$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f088c3cfa4ce44ec$var$Dk(a, b) {
    b &= ~$f088c3cfa4ce44ec$var$sk;
    b &= ~$f088c3cfa4ce44ec$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f088c3cfa4ce44ec$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f088c3cfa4ce44ec$var$Fk(a) {
    if (0 !== ($f088c3cfa4ce44ec$var$K & 6)) throw Error($f088c3cfa4ce44ec$var$p(327));
    $f088c3cfa4ce44ec$var$Ik();
    var b = $f088c3cfa4ce44ec$var$uc(a, 0);
    if (0 === (b & 1)) return $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B()), null;
    var c = $f088c3cfa4ce44ec$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f088c3cfa4ce44ec$var$xc(a);
        0 !== d && (b = d, c = $f088c3cfa4ce44ec$var$Ok(a, d));
    }
    if (1 === c) throw c = $f088c3cfa4ce44ec$var$qk, $f088c3cfa4ce44ec$var$Lk(a, 0), $f088c3cfa4ce44ec$var$Dk(a, b), $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B()), c;
    if (6 === c) throw Error($f088c3cfa4ce44ec$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f088c3cfa4ce44ec$var$Qk(a, $f088c3cfa4ce44ec$var$uk, $f088c3cfa4ce44ec$var$vk);
    $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B());
    return null;
}
function $f088c3cfa4ce44ec$var$Rk(a, b) {
    var c = $f088c3cfa4ce44ec$var$K;
    $f088c3cfa4ce44ec$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f088c3cfa4ce44ec$var$K = c, 0 === $f088c3cfa4ce44ec$var$K && ($f088c3cfa4ce44ec$var$Hj = $f088c3cfa4ce44ec$var$B() + 500, $f088c3cfa4ce44ec$var$fg && $f088c3cfa4ce44ec$var$jg());
    }
}
function $f088c3cfa4ce44ec$var$Sk(a) {
    null !== $f088c3cfa4ce44ec$var$xk && 0 === $f088c3cfa4ce44ec$var$xk.tag && 0 === ($f088c3cfa4ce44ec$var$K & 6) && $f088c3cfa4ce44ec$var$Ik();
    var b = $f088c3cfa4ce44ec$var$K;
    $f088c3cfa4ce44ec$var$K |= 1;
    var c = $f088c3cfa4ce44ec$var$pk.transition, d = $f088c3cfa4ce44ec$var$C;
    try {
        if ($f088c3cfa4ce44ec$var$pk.transition = null, $f088c3cfa4ce44ec$var$C = 1, a) return a();
    } finally{
        $f088c3cfa4ce44ec$var$C = d, $f088c3cfa4ce44ec$var$pk.transition = c, $f088c3cfa4ce44ec$var$K = b, 0 === ($f088c3cfa4ce44ec$var$K & 6) && $f088c3cfa4ce44ec$var$jg();
    }
}
function $f088c3cfa4ce44ec$var$Ij() {
    $f088c3cfa4ce44ec$var$gj = $f088c3cfa4ce44ec$var$fj.current;
    $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$fj);
}
function $f088c3cfa4ce44ec$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f088c3cfa4ce44ec$var$Gf(c));
    if (null !== $f088c3cfa4ce44ec$var$Y) for(c = $f088c3cfa4ce44ec$var$Y.return; null !== c;){
        var d = c;
        $f088c3cfa4ce44ec$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f088c3cfa4ce44ec$var$$f();
                break;
            case 3:
                $f088c3cfa4ce44ec$var$Jh();
                $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$Wf);
                $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$H);
                $f088c3cfa4ce44ec$var$Oh();
                break;
            case 5:
                $f088c3cfa4ce44ec$var$Lh(d);
                break;
            case 4:
                $f088c3cfa4ce44ec$var$Jh();
                break;
            case 13:
                $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M);
                break;
            case 19:
                $f088c3cfa4ce44ec$var$E($f088c3cfa4ce44ec$var$M);
                break;
            case 10:
                $f088c3cfa4ce44ec$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $f088c3cfa4ce44ec$var$Ij();
        }
        c = c.return;
    }
    $f088c3cfa4ce44ec$var$R = a;
    $f088c3cfa4ce44ec$var$Y = a = $f088c3cfa4ce44ec$var$wh(a.current, null);
    $f088c3cfa4ce44ec$var$Z = $f088c3cfa4ce44ec$var$gj = b;
    $f088c3cfa4ce44ec$var$T = 0;
    $f088c3cfa4ce44ec$var$qk = null;
    $f088c3cfa4ce44ec$var$sk = $f088c3cfa4ce44ec$var$rk = $f088c3cfa4ce44ec$var$hh = 0;
    $f088c3cfa4ce44ec$var$uk = $f088c3cfa4ce44ec$var$tk = null;
    if (null !== $f088c3cfa4ce44ec$var$Wg) {
        for(b = 0; b < $f088c3cfa4ce44ec$var$Wg.length; b++)if (c = $f088c3cfa4ce44ec$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f088c3cfa4ce44ec$var$Wg = null;
    }
    return a;
}
function $f088c3cfa4ce44ec$var$Nk(a, b) {
    do {
        var c = $f088c3cfa4ce44ec$var$Y;
        try {
            $f088c3cfa4ce44ec$var$Qg();
            $f088c3cfa4ce44ec$var$Ph.current = $f088c3cfa4ce44ec$var$ai;
            if ($f088c3cfa4ce44ec$var$Sh) {
                for(var d = $f088c3cfa4ce44ec$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f088c3cfa4ce44ec$var$Sh = !1;
            }
            $f088c3cfa4ce44ec$var$Rh = 0;
            $f088c3cfa4ce44ec$var$P = $f088c3cfa4ce44ec$var$O = $f088c3cfa4ce44ec$var$N = null;
            $f088c3cfa4ce44ec$var$Th = !1;
            $f088c3cfa4ce44ec$var$Uh = 0;
            $f088c3cfa4ce44ec$var$ok.current = null;
            if (null === c || null === c.return) {
                $f088c3cfa4ce44ec$var$T = 1;
                $f088c3cfa4ce44ec$var$qk = b;
                $f088c3cfa4ce44ec$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f088c3cfa4ce44ec$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f088c3cfa4ce44ec$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f088c3cfa4ce44ec$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $f088c3cfa4ce44ec$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f088c3cfa4ce44ec$var$Ti(f, l, b);
                            $f088c3cfa4ce44ec$var$uj();
                            break a;
                        }
                        k = Error($f088c3cfa4ce44ec$var$p(426));
                    }
                } else if ($f088c3cfa4ce44ec$var$I && h.mode & 1) {
                    var J = $f088c3cfa4ce44ec$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f088c3cfa4ce44ec$var$Wi(J, g, h, f, b);
                        $f088c3cfa4ce44ec$var$Jg($f088c3cfa4ce44ec$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $f088c3cfa4ce44ec$var$Ki(k, h);
                4 !== $f088c3cfa4ce44ec$var$T && ($f088c3cfa4ce44ec$var$T = 2);
                null === $f088c3cfa4ce44ec$var$tk ? $f088c3cfa4ce44ec$var$tk = [
                    f
                ] : $f088c3cfa4ce44ec$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f088c3cfa4ce44ec$var$Oi(f, k, b);
                            $f088c3cfa4ce44ec$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f088c3cfa4ce44ec$var$Si || !$f088c3cfa4ce44ec$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f088c3cfa4ce44ec$var$Ri(f, h, b);
                                $f088c3cfa4ce44ec$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f088c3cfa4ce44ec$var$Tk(c);
        } catch (na) {
            b = na;
            $f088c3cfa4ce44ec$var$Y === c && null !== c && ($f088c3cfa4ce44ec$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f088c3cfa4ce44ec$var$Kk() {
    var a = $f088c3cfa4ce44ec$var$nk.current;
    $f088c3cfa4ce44ec$var$nk.current = $f088c3cfa4ce44ec$var$ai;
    return null === a ? $f088c3cfa4ce44ec$var$ai : a;
}
function $f088c3cfa4ce44ec$var$uj() {
    if (0 === $f088c3cfa4ce44ec$var$T || 3 === $f088c3cfa4ce44ec$var$T || 2 === $f088c3cfa4ce44ec$var$T) $f088c3cfa4ce44ec$var$T = 4;
    null === $f088c3cfa4ce44ec$var$R || 0 === ($f088c3cfa4ce44ec$var$hh & 268435455) && 0 === ($f088c3cfa4ce44ec$var$rk & 268435455) || $f088c3cfa4ce44ec$var$Dk($f088c3cfa4ce44ec$var$R, $f088c3cfa4ce44ec$var$Z);
}
function $f088c3cfa4ce44ec$var$Jk(a, b) {
    var c = $f088c3cfa4ce44ec$var$K;
    $f088c3cfa4ce44ec$var$K |= 2;
    var d = $f088c3cfa4ce44ec$var$Kk();
    if ($f088c3cfa4ce44ec$var$R !== a || $f088c3cfa4ce44ec$var$Z !== b) $f088c3cfa4ce44ec$var$vk = null, $f088c3cfa4ce44ec$var$Lk(a, b);
    for(;;)try {
        $f088c3cfa4ce44ec$var$Uk();
        break;
    } catch (e) {
        $f088c3cfa4ce44ec$var$Nk(a, e);
    }
    $f088c3cfa4ce44ec$var$Qg();
    $f088c3cfa4ce44ec$var$K = c;
    $f088c3cfa4ce44ec$var$nk.current = d;
    if (null !== $f088c3cfa4ce44ec$var$Y) throw Error($f088c3cfa4ce44ec$var$p(261));
    $f088c3cfa4ce44ec$var$R = null;
    $f088c3cfa4ce44ec$var$Z = 0;
    return $f088c3cfa4ce44ec$var$T;
}
function $f088c3cfa4ce44ec$var$Uk() {
    for(; null !== $f088c3cfa4ce44ec$var$Y;)$f088c3cfa4ce44ec$var$Vk($f088c3cfa4ce44ec$var$Y);
}
function $f088c3cfa4ce44ec$var$Mk() {
    for(; null !== $f088c3cfa4ce44ec$var$Y && !$f088c3cfa4ce44ec$var$cc();)$f088c3cfa4ce44ec$var$Vk($f088c3cfa4ce44ec$var$Y);
}
function $f088c3cfa4ce44ec$var$Vk(a) {
    var b = $f088c3cfa4ce44ec$var$Wk(a.alternate, a, $f088c3cfa4ce44ec$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f088c3cfa4ce44ec$var$Tk(a) : $f088c3cfa4ce44ec$var$Y = b;
    $f088c3cfa4ce44ec$var$ok.current = null;
}
function $f088c3cfa4ce44ec$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f088c3cfa4ce44ec$var$Fj(c, b, $f088c3cfa4ce44ec$var$gj), null !== c) {
                $f088c3cfa4ce44ec$var$Y = c;
                return;
            }
        } else {
            c = $f088c3cfa4ce44ec$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f088c3cfa4ce44ec$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f088c3cfa4ce44ec$var$T = 6;
                $f088c3cfa4ce44ec$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f088c3cfa4ce44ec$var$Y = b;
            return;
        }
        $f088c3cfa4ce44ec$var$Y = b = a;
    }while (null !== b);
    0 === $f088c3cfa4ce44ec$var$T && ($f088c3cfa4ce44ec$var$T = 5);
}
function $f088c3cfa4ce44ec$var$Qk(a, b, c) {
    var d = $f088c3cfa4ce44ec$var$C, e = $f088c3cfa4ce44ec$var$pk.transition;
    try {
        $f088c3cfa4ce44ec$var$pk.transition = null, $f088c3cfa4ce44ec$var$C = 1, $f088c3cfa4ce44ec$var$Xk(a, b, c, d);
    } finally{
        $f088c3cfa4ce44ec$var$pk.transition = e, $f088c3cfa4ce44ec$var$C = d;
    }
    return null;
}
function $f088c3cfa4ce44ec$var$Xk(a, b, c, d) {
    do $f088c3cfa4ce44ec$var$Ik();
    while (null !== $f088c3cfa4ce44ec$var$xk);
    if (0 !== ($f088c3cfa4ce44ec$var$K & 6)) throw Error($f088c3cfa4ce44ec$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f088c3cfa4ce44ec$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f088c3cfa4ce44ec$var$Bc(a, f);
    a === $f088c3cfa4ce44ec$var$R && ($f088c3cfa4ce44ec$var$Y = $f088c3cfa4ce44ec$var$R = null, $f088c3cfa4ce44ec$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f088c3cfa4ce44ec$var$wk || ($f088c3cfa4ce44ec$var$wk = !0, $f088c3cfa4ce44ec$var$Gk($f088c3cfa4ce44ec$var$hc, function() {
        $f088c3cfa4ce44ec$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f088c3cfa4ce44ec$var$pk.transition;
        $f088c3cfa4ce44ec$var$pk.transition = null;
        var g = $f088c3cfa4ce44ec$var$C;
        $f088c3cfa4ce44ec$var$C = 1;
        var h = $f088c3cfa4ce44ec$var$K;
        $f088c3cfa4ce44ec$var$K |= 4;
        $f088c3cfa4ce44ec$var$ok.current = null;
        $f088c3cfa4ce44ec$var$Pj(a, c);
        $f088c3cfa4ce44ec$var$ek(c, a);
        $f088c3cfa4ce44ec$var$Oe($f088c3cfa4ce44ec$var$Df);
        $f088c3cfa4ce44ec$var$dd = !!$f088c3cfa4ce44ec$var$Cf;
        $f088c3cfa4ce44ec$var$Df = $f088c3cfa4ce44ec$var$Cf = null;
        a.current = c;
        $f088c3cfa4ce44ec$var$ik(c, a, e);
        $f088c3cfa4ce44ec$var$dc();
        $f088c3cfa4ce44ec$var$K = h;
        $f088c3cfa4ce44ec$var$C = g;
        $f088c3cfa4ce44ec$var$pk.transition = f;
    } else a.current = c;
    $f088c3cfa4ce44ec$var$wk && ($f088c3cfa4ce44ec$var$wk = !1, $f088c3cfa4ce44ec$var$xk = a, $f088c3cfa4ce44ec$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($f088c3cfa4ce44ec$var$Si = null);
    $f088c3cfa4ce44ec$var$mc(c.stateNode, d);
    $f088c3cfa4ce44ec$var$Ek(a, $f088c3cfa4ce44ec$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f088c3cfa4ce44ec$var$Pi) throw $f088c3cfa4ce44ec$var$Pi = !1, a = $f088c3cfa4ce44ec$var$Qi, $f088c3cfa4ce44ec$var$Qi = null, a;
    0 !== ($f088c3cfa4ce44ec$var$yk & 1) && 0 !== a.tag && $f088c3cfa4ce44ec$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f088c3cfa4ce44ec$var$Ak ? $f088c3cfa4ce44ec$var$zk++ : ($f088c3cfa4ce44ec$var$zk = 0, $f088c3cfa4ce44ec$var$Ak = a) : $f088c3cfa4ce44ec$var$zk = 0;
    $f088c3cfa4ce44ec$var$jg();
    return null;
}
function $f088c3cfa4ce44ec$var$Ik() {
    if (null !== $f088c3cfa4ce44ec$var$xk) {
        var a = $f088c3cfa4ce44ec$var$Dc($f088c3cfa4ce44ec$var$yk), b = $f088c3cfa4ce44ec$var$pk.transition, c = $f088c3cfa4ce44ec$var$C;
        try {
            $f088c3cfa4ce44ec$var$pk.transition = null;
            $f088c3cfa4ce44ec$var$C = 16 > a ? 16 : a;
            if (null === $f088c3cfa4ce44ec$var$xk) var d = !1;
            else {
                a = $f088c3cfa4ce44ec$var$xk;
                $f088c3cfa4ce44ec$var$xk = null;
                $f088c3cfa4ce44ec$var$yk = 0;
                if (0 !== ($f088c3cfa4ce44ec$var$K & 6)) throw Error($f088c3cfa4ce44ec$var$p(331));
                var e = $f088c3cfa4ce44ec$var$K;
                $f088c3cfa4ce44ec$var$K |= 4;
                for($f088c3cfa4ce44ec$var$V = a.current; null !== $f088c3cfa4ce44ec$var$V;){
                    var f = $f088c3cfa4ce44ec$var$V, g = f.child;
                    if (0 !== ($f088c3cfa4ce44ec$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f088c3cfa4ce44ec$var$V = l; null !== $f088c3cfa4ce44ec$var$V;){
                                    var m = $f088c3cfa4ce44ec$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f088c3cfa4ce44ec$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f088c3cfa4ce44ec$var$V = q;
                                    else for(; null !== $f088c3cfa4ce44ec$var$V;){
                                        m = $f088c3cfa4ce44ec$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f088c3cfa4ce44ec$var$Tj(m);
                                        if (m === l) {
                                            $f088c3cfa4ce44ec$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f088c3cfa4ce44ec$var$V = r;
                                            break;
                                        }
                                        $f088c3cfa4ce44ec$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f088c3cfa4ce44ec$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f088c3cfa4ce44ec$var$V = g;
                    else b: for(; null !== $f088c3cfa4ce44ec$var$V;){
                        f = $f088c3cfa4ce44ec$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f088c3cfa4ce44ec$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f088c3cfa4ce44ec$var$V = x;
                            break b;
                        }
                        $f088c3cfa4ce44ec$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f088c3cfa4ce44ec$var$V = w; null !== $f088c3cfa4ce44ec$var$V;){
                    g = $f088c3cfa4ce44ec$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f088c3cfa4ce44ec$var$V = u;
                    else b: for(g = w; null !== $f088c3cfa4ce44ec$var$V;){
                        h = $f088c3cfa4ce44ec$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f088c3cfa4ce44ec$var$Rj(9, h);
                            }
                        } catch (na) {
                            $f088c3cfa4ce44ec$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f088c3cfa4ce44ec$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f088c3cfa4ce44ec$var$V = F;
                            break b;
                        }
                        $f088c3cfa4ce44ec$var$V = h.return;
                    }
                }
                $f088c3cfa4ce44ec$var$K = e;
                $f088c3cfa4ce44ec$var$jg();
                if ($f088c3cfa4ce44ec$var$lc && "function" === typeof $f088c3cfa4ce44ec$var$lc.onPostCommitFiberRoot) try {
                    $f088c3cfa4ce44ec$var$lc.onPostCommitFiberRoot($f088c3cfa4ce44ec$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f088c3cfa4ce44ec$var$C = c, $f088c3cfa4ce44ec$var$pk.transition = b;
        }
    }
    return !1;
}
function $f088c3cfa4ce44ec$var$Yk(a, b, c) {
    b = $f088c3cfa4ce44ec$var$Ki(c, b);
    b = $f088c3cfa4ce44ec$var$Oi(a, b, 1);
    a = $f088c3cfa4ce44ec$var$dh(a, b, 1);
    b = $f088c3cfa4ce44ec$var$L();
    null !== a && ($f088c3cfa4ce44ec$var$Ac(a, 1, b), $f088c3cfa4ce44ec$var$Ek(a, b));
}
function $f088c3cfa4ce44ec$var$W(a, b, c) {
    if (3 === a.tag) $f088c3cfa4ce44ec$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f088c3cfa4ce44ec$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f088c3cfa4ce44ec$var$Si || !$f088c3cfa4ce44ec$var$Si.has(d))) {
                a = $f088c3cfa4ce44ec$var$Ki(c, a);
                a = $f088c3cfa4ce44ec$var$Ri(b, a, 1);
                b = $f088c3cfa4ce44ec$var$dh(b, a, 1);
                a = $f088c3cfa4ce44ec$var$L();
                null !== b && ($f088c3cfa4ce44ec$var$Ac(b, 1, a), $f088c3cfa4ce44ec$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f088c3cfa4ce44ec$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f088c3cfa4ce44ec$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $f088c3cfa4ce44ec$var$R === a && ($f088c3cfa4ce44ec$var$Z & c) === c && (4 === $f088c3cfa4ce44ec$var$T || 3 === $f088c3cfa4ce44ec$var$T && ($f088c3cfa4ce44ec$var$Z & 130023424) === $f088c3cfa4ce44ec$var$Z && 500 > $f088c3cfa4ce44ec$var$B() - $f088c3cfa4ce44ec$var$gk ? $f088c3cfa4ce44ec$var$Lk(a, 0) : $f088c3cfa4ce44ec$var$sk |= c);
    $f088c3cfa4ce44ec$var$Ek(a, b);
}
function $f088c3cfa4ce44ec$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f088c3cfa4ce44ec$var$sc, $f088c3cfa4ce44ec$var$sc <<= 1, 0 === ($f088c3cfa4ce44ec$var$sc & 130023424) && ($f088c3cfa4ce44ec$var$sc = 4194304)));
    var c = $f088c3cfa4ce44ec$var$L();
    a = $f088c3cfa4ce44ec$var$Zg(a, b);
    null !== a && ($f088c3cfa4ce44ec$var$Ac(a, b, c), $f088c3cfa4ce44ec$var$Ek(a, c));
}
function $f088c3cfa4ce44ec$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f088c3cfa4ce44ec$var$Zk(a, c);
}
function $f088c3cfa4ce44ec$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f088c3cfa4ce44ec$var$p(314));
    }
    null !== d && d.delete(b);
    $f088c3cfa4ce44ec$var$Zk(a, c);
}
var $f088c3cfa4ce44ec$var$Wk;
$f088c3cfa4ce44ec$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f088c3cfa4ce44ec$var$Wf.current) $f088c3cfa4ce44ec$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f088c3cfa4ce44ec$var$Ug = !1, $f088c3cfa4ce44ec$var$zj(a, b, c);
            $f088c3cfa4ce44ec$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f088c3cfa4ce44ec$var$Ug = !1, $f088c3cfa4ce44ec$var$I && 0 !== (b.flags & 1048576) && $f088c3cfa4ce44ec$var$ug(b, $f088c3cfa4ce44ec$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f088c3cfa4ce44ec$var$jj(a, b);
            a = b.pendingProps;
            var e = $f088c3cfa4ce44ec$var$Yf(b, $f088c3cfa4ce44ec$var$H.current);
            $f088c3cfa4ce44ec$var$Tg(b, c);
            e = $f088c3cfa4ce44ec$var$Xh(null, b, d, a, e, c);
            var f = $f088c3cfa4ce44ec$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f088c3cfa4ce44ec$var$Zf(d) ? (f = !0, $f088c3cfa4ce44ec$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f088c3cfa4ce44ec$var$ah(b), e.updater = $f088c3cfa4ce44ec$var$nh, b.stateNode = e, e._reactInternals = b, $f088c3cfa4ce44ec$var$rh(b, d, a, c), b = $f088c3cfa4ce44ec$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $f088c3cfa4ce44ec$var$I && f && $f088c3cfa4ce44ec$var$vg(b), $f088c3cfa4ce44ec$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f088c3cfa4ce44ec$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f088c3cfa4ce44ec$var$$k(d);
                a = $f088c3cfa4ce44ec$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $f088c3cfa4ce44ec$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f088c3cfa4ce44ec$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f088c3cfa4ce44ec$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f088c3cfa4ce44ec$var$aj(null, b, d, $f088c3cfa4ce44ec$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($f088c3cfa4ce44ec$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f088c3cfa4ce44ec$var$Lg(d, e), $f088c3cfa4ce44ec$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f088c3cfa4ce44ec$var$Lg(d, e), $f088c3cfa4ce44ec$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $f088c3cfa4ce44ec$var$lj(b);
                if (null === a) throw Error($f088c3cfa4ce44ec$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f088c3cfa4ce44ec$var$bh(a, b);
                $f088c3cfa4ce44ec$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f088c3cfa4ce44ec$var$Ki(Error($f088c3cfa4ce44ec$var$p(423)), b);
                        b = $f088c3cfa4ce44ec$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f088c3cfa4ce44ec$var$Ki(Error($f088c3cfa4ce44ec$var$p(424)), b);
                        b = $f088c3cfa4ce44ec$var$mj(a, b, d, c, e);
                        break a;
                    } else for($f088c3cfa4ce44ec$var$yg = $f088c3cfa4ce44ec$var$Lf(b.stateNode.containerInfo.firstChild), $f088c3cfa4ce44ec$var$xg = b, $f088c3cfa4ce44ec$var$I = !0, $f088c3cfa4ce44ec$var$zg = null, c = $f088c3cfa4ce44ec$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f088c3cfa4ce44ec$var$Ig();
                    if (d === e) {
                        b = $f088c3cfa4ce44ec$var$$i(a, b, c);
                        break a;
                    }
                    $f088c3cfa4ce44ec$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f088c3cfa4ce44ec$var$Kh(b), null === a && $f088c3cfa4ce44ec$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f088c3cfa4ce44ec$var$Ef(d, e) ? g = null : null !== f && $f088c3cfa4ce44ec$var$Ef(d, f) && (b.flags |= 32), $f088c3cfa4ce44ec$var$hj(a, b), $f088c3cfa4ce44ec$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $f088c3cfa4ce44ec$var$Eg(b), null;
        case 13:
            return $f088c3cfa4ce44ec$var$pj(a, b, c);
        case 4:
            return $f088c3cfa4ce44ec$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f088c3cfa4ce44ec$var$Bh(b, null, d, c) : $f088c3cfa4ce44ec$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f088c3cfa4ce44ec$var$Lg(d, e), $f088c3cfa4ce44ec$var$Zi(a, b, d, e, c);
        case 7:
            return $f088c3cfa4ce44ec$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f088c3cfa4ce44ec$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f088c3cfa4ce44ec$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f088c3cfa4ce44ec$var$G($f088c3cfa4ce44ec$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f088c3cfa4ce44ec$var$He(f.value, g)) {
                        if (f.children === e.children && !$f088c3cfa4ce44ec$var$Wf.current) {
                            b = $f088c3cfa4ce44ec$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f088c3cfa4ce44ec$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f088c3cfa4ce44ec$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f088c3cfa4ce44ec$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f088c3cfa4ce44ec$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f088c3cfa4ce44ec$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f088c3cfa4ce44ec$var$Tg(b, c), e = $f088c3cfa4ce44ec$var$Vg(e), d = d(e), b.flags |= 1, $f088c3cfa4ce44ec$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f088c3cfa4ce44ec$var$Lg(d, b.pendingProps), e = $f088c3cfa4ce44ec$var$Lg(d.type, e), $f088c3cfa4ce44ec$var$aj(a, b, d, e, c);
        case 15:
            return $f088c3cfa4ce44ec$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f088c3cfa4ce44ec$var$Lg(d, e), $f088c3cfa4ce44ec$var$jj(a, b), b.tag = 1, $f088c3cfa4ce44ec$var$Zf(d) ? (a = !0, $f088c3cfa4ce44ec$var$cg(b)) : a = !1, $f088c3cfa4ce44ec$var$Tg(b, c), $f088c3cfa4ce44ec$var$ph(b, d, e), $f088c3cfa4ce44ec$var$rh(b, d, e, c), $f088c3cfa4ce44ec$var$kj(null, b, d, !0, a, c);
        case 19:
            return $f088c3cfa4ce44ec$var$yj(a, b, c);
        case 22:
            return $f088c3cfa4ce44ec$var$ej(a, b, c);
    }
    throw Error($f088c3cfa4ce44ec$var$p(156, b.tag));
};
function $f088c3cfa4ce44ec$var$Gk(a, b) {
    return $f088c3cfa4ce44ec$var$ac(a, b);
}
function $f088c3cfa4ce44ec$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f088c3cfa4ce44ec$var$Bg(a, b, c, d) {
    return new $f088c3cfa4ce44ec$var$al(a, b, c, d);
}
function $f088c3cfa4ce44ec$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f088c3cfa4ce44ec$var$$k(a) {
    if ("function" === typeof a) return $f088c3cfa4ce44ec$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f088c3cfa4ce44ec$var$Da) return 11;
        if (a === $f088c3cfa4ce44ec$var$Ga) return 14;
    }
    return 2;
}
function $f088c3cfa4ce44ec$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $f088c3cfa4ce44ec$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f088c3cfa4ce44ec$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f088c3cfa4ce44ec$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f088c3cfa4ce44ec$var$ya:
            return $f088c3cfa4ce44ec$var$Ah(c.children, e, f, b);
        case $f088c3cfa4ce44ec$var$za:
            g = 8;
            e |= 8;
            break;
        case $f088c3cfa4ce44ec$var$Aa:
            return a = $f088c3cfa4ce44ec$var$Bg(12, c, b, e | 2), a.elementType = $f088c3cfa4ce44ec$var$Aa, a.lanes = f, a;
        case $f088c3cfa4ce44ec$var$Ea:
            return a = $f088c3cfa4ce44ec$var$Bg(13, c, b, e), a.elementType = $f088c3cfa4ce44ec$var$Ea, a.lanes = f, a;
        case $f088c3cfa4ce44ec$var$Fa:
            return a = $f088c3cfa4ce44ec$var$Bg(19, c, b, e), a.elementType = $f088c3cfa4ce44ec$var$Fa, a.lanes = f, a;
        case $f088c3cfa4ce44ec$var$Ia:
            return $f088c3cfa4ce44ec$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f088c3cfa4ce44ec$var$Ba:
                    g = 10;
                    break a;
                case $f088c3cfa4ce44ec$var$Ca:
                    g = 9;
                    break a;
                case $f088c3cfa4ce44ec$var$Da:
                    g = 11;
                    break a;
                case $f088c3cfa4ce44ec$var$Ga:
                    g = 14;
                    break a;
                case $f088c3cfa4ce44ec$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f088c3cfa4ce44ec$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f088c3cfa4ce44ec$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f088c3cfa4ce44ec$var$Ah(a, b, c, d) {
    a = $f088c3cfa4ce44ec$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f088c3cfa4ce44ec$var$qj(a, b, c, d) {
    a = $f088c3cfa4ce44ec$var$Bg(22, a, d, b);
    a.elementType = $f088c3cfa4ce44ec$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f088c3cfa4ce44ec$var$xh(a, b, c) {
    a = $f088c3cfa4ce44ec$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f088c3cfa4ce44ec$var$zh(a, b, c) {
    b = $f088c3cfa4ce44ec$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f088c3cfa4ce44ec$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f088c3cfa4ce44ec$var$zc(0);
    this.expirationTimes = $f088c3cfa4ce44ec$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f088c3cfa4ce44ec$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f088c3cfa4ce44ec$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $f088c3cfa4ce44ec$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f088c3cfa4ce44ec$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f088c3cfa4ce44ec$var$ah(f);
    return a;
}
function $f088c3cfa4ce44ec$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f088c3cfa4ce44ec$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f088c3cfa4ce44ec$var$el(a) {
    if (!a) return $f088c3cfa4ce44ec$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f088c3cfa4ce44ec$var$Vb(a) !== a || 1 !== a.tag) throw Error($f088c3cfa4ce44ec$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f088c3cfa4ce44ec$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f088c3cfa4ce44ec$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f088c3cfa4ce44ec$var$Zf(c)) return $f088c3cfa4ce44ec$var$bg(a, c, b);
    }
    return b;
}
function $f088c3cfa4ce44ec$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $f088c3cfa4ce44ec$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $f088c3cfa4ce44ec$var$el(null);
    c = a.current;
    d = $f088c3cfa4ce44ec$var$L();
    e = $f088c3cfa4ce44ec$var$lh(c);
    f = $f088c3cfa4ce44ec$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f088c3cfa4ce44ec$var$dh(c, f, e);
    a.current.lanes = e;
    $f088c3cfa4ce44ec$var$Ac(a, e, d);
    $f088c3cfa4ce44ec$var$Ek(a, d);
    return a;
}
function $f088c3cfa4ce44ec$var$gl(a, b, c, d) {
    var e = b.current, f = $f088c3cfa4ce44ec$var$L(), g = $f088c3cfa4ce44ec$var$lh(e);
    c = $f088c3cfa4ce44ec$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f088c3cfa4ce44ec$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f088c3cfa4ce44ec$var$dh(e, b, g);
    null !== a && ($f088c3cfa4ce44ec$var$mh(a, e, g, f), $f088c3cfa4ce44ec$var$eh(a, e, g));
    return g;
}
function $f088c3cfa4ce44ec$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f088c3cfa4ce44ec$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f088c3cfa4ce44ec$var$jl(a, b) {
    $f088c3cfa4ce44ec$var$il(a, b);
    (a = a.alternate) && $f088c3cfa4ce44ec$var$il(a, b);
}
function $f088c3cfa4ce44ec$var$kl() {
    return null;
}
var $f088c3cfa4ce44ec$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f088c3cfa4ce44ec$var$ml(a) {
    this._internalRoot = a;
}
$f088c3cfa4ce44ec$var$nl.prototype.render = $f088c3cfa4ce44ec$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f088c3cfa4ce44ec$var$p(409));
    $f088c3cfa4ce44ec$var$gl(a, b, null, null);
};
$f088c3cfa4ce44ec$var$nl.prototype.unmount = $f088c3cfa4ce44ec$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f088c3cfa4ce44ec$var$Sk(function() {
            $f088c3cfa4ce44ec$var$gl(null, a, null, null);
        });
        b[$f088c3cfa4ce44ec$var$uf] = null;
    }
};
function $f088c3cfa4ce44ec$var$nl(a) {
    this._internalRoot = a;
}
$f088c3cfa4ce44ec$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f088c3cfa4ce44ec$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f088c3cfa4ce44ec$var$Qc.length && 0 !== b && b < $f088c3cfa4ce44ec$var$Qc[c].priority; c++);
        $f088c3cfa4ce44ec$var$Qc.splice(c, 0, a);
        0 === c && $f088c3cfa4ce44ec$var$Vc(a);
    }
};
function $f088c3cfa4ce44ec$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f088c3cfa4ce44ec$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f088c3cfa4ce44ec$var$ql() {}
function $f088c3cfa4ce44ec$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f088c3cfa4ce44ec$var$hl(g);
                f.call(a);
            };
        }
        var g = $f088c3cfa4ce44ec$var$fl(b, d, a, 0, null, !1, !1, "", $f088c3cfa4ce44ec$var$ql);
        a._reactRootContainer = g;
        a[$f088c3cfa4ce44ec$var$uf] = g.current;
        $f088c3cfa4ce44ec$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f088c3cfa4ce44ec$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f088c3cfa4ce44ec$var$hl(k);
            h.call(a);
        };
    }
    var k = $f088c3cfa4ce44ec$var$cl(a, 0, !1, null, null, !1, !1, "", $f088c3cfa4ce44ec$var$ql);
    a._reactRootContainer = k;
    a[$f088c3cfa4ce44ec$var$uf] = k.current;
    $f088c3cfa4ce44ec$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f088c3cfa4ce44ec$var$Sk(function() {
        $f088c3cfa4ce44ec$var$gl(b, k, c, d);
    });
    return k;
}
function $f088c3cfa4ce44ec$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f088c3cfa4ce44ec$var$hl(g);
                h.call(a);
            };
        }
        $f088c3cfa4ce44ec$var$gl(b, g, a, e);
    } else g = $f088c3cfa4ce44ec$var$rl(c, b, a, e, d);
    return $f088c3cfa4ce44ec$var$hl(g);
}
$f088c3cfa4ce44ec$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f088c3cfa4ce44ec$var$tc(b.pendingLanes);
                0 !== c && ($f088c3cfa4ce44ec$var$Cc(b, c | 1), $f088c3cfa4ce44ec$var$Ek(b, $f088c3cfa4ce44ec$var$B()), 0 === ($f088c3cfa4ce44ec$var$K & 6) && ($f088c3cfa4ce44ec$var$Hj = $f088c3cfa4ce44ec$var$B() + 500, $f088c3cfa4ce44ec$var$jg()));
            }
            break;
        case 13:
            $f088c3cfa4ce44ec$var$Sk(function() {
                var b = $f088c3cfa4ce44ec$var$Zg(a, 1);
                if (null !== b) {
                    var c = $f088c3cfa4ce44ec$var$L();
                    $f088c3cfa4ce44ec$var$mh(b, a, 1, c);
                }
            }), $f088c3cfa4ce44ec$var$jl(a, 1);
    }
};
$f088c3cfa4ce44ec$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f088c3cfa4ce44ec$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $f088c3cfa4ce44ec$var$L();
            $f088c3cfa4ce44ec$var$mh(b, a, 134217728, c);
        }
        $f088c3cfa4ce44ec$var$jl(a, 134217728);
    }
};
$f088c3cfa4ce44ec$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f088c3cfa4ce44ec$var$lh(a), c = $f088c3cfa4ce44ec$var$Zg(a, b);
        if (null !== c) {
            var d = $f088c3cfa4ce44ec$var$L();
            $f088c3cfa4ce44ec$var$mh(c, a, b, d);
        }
        $f088c3cfa4ce44ec$var$jl(a, b);
    }
};
$f088c3cfa4ce44ec$var$Hc = function() {
    return $f088c3cfa4ce44ec$var$C;
};
$f088c3cfa4ce44ec$var$Ic = function(a, b) {
    var c = $f088c3cfa4ce44ec$var$C;
    try {
        return $f088c3cfa4ce44ec$var$C = a, b();
    } finally{
        $f088c3cfa4ce44ec$var$C = c;
    }
};
$f088c3cfa4ce44ec$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f088c3cfa4ce44ec$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f088c3cfa4ce44ec$var$Db(d);
                        if (!e) throw Error($f088c3cfa4ce44ec$var$p(90));
                        $f088c3cfa4ce44ec$var$Wa(d);
                        $f088c3cfa4ce44ec$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f088c3cfa4ce44ec$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f088c3cfa4ce44ec$var$fb(a, !!c.multiple, b, !1);
    }
};
$f088c3cfa4ce44ec$var$Gb = $f088c3cfa4ce44ec$var$Rk;
$f088c3cfa4ce44ec$var$Hb = $f088c3cfa4ce44ec$var$Sk;
var $f088c3cfa4ce44ec$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $f088c3cfa4ce44ec$var$Cb,
        $f088c3cfa4ce44ec$var$ue,
        $f088c3cfa4ce44ec$var$Db,
        $f088c3cfa4ce44ec$var$Eb,
        $f088c3cfa4ce44ec$var$Fb,
        $f088c3cfa4ce44ec$var$Rk
    ]
}, $f088c3cfa4ce44ec$var$ul = {
    findFiberByHostInstance: $f088c3cfa4ce44ec$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $f088c3cfa4ce44ec$var$vl = {
    bundleType: $f088c3cfa4ce44ec$var$ul.bundleType,
    version: $f088c3cfa4ce44ec$var$ul.version,
    rendererPackageName: $f088c3cfa4ce44ec$var$ul.rendererPackageName,
    rendererConfig: $f088c3cfa4ce44ec$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f088c3cfa4ce44ec$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f088c3cfa4ce44ec$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f088c3cfa4ce44ec$var$ul.findFiberByHostInstance || $f088c3cfa4ce44ec$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f088c3cfa4ce44ec$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f088c3cfa4ce44ec$var$wl.isDisabled && $f088c3cfa4ce44ec$var$wl.supportsFiber) try {
        $f088c3cfa4ce44ec$var$kc = $f088c3cfa4ce44ec$var$wl.inject($f088c3cfa4ce44ec$var$vl), $f088c3cfa4ce44ec$var$lc = $f088c3cfa4ce44ec$var$wl;
    } catch (a) {}
}
$f088c3cfa4ce44ec$export$ae55be85d98224ed = $f088c3cfa4ce44ec$var$tl;
$f088c3cfa4ce44ec$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f088c3cfa4ce44ec$var$ol(b)) throw Error($f088c3cfa4ce44ec$var$p(200));
    return $f088c3cfa4ce44ec$var$dl(a, b, null, c);
};
$f088c3cfa4ce44ec$export$882461b6382ed46c = function(a, b) {
    if (!$f088c3cfa4ce44ec$var$ol(a)) throw Error($f088c3cfa4ce44ec$var$p(299));
    var c = !1, d = "", e = $f088c3cfa4ce44ec$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f088c3cfa4ce44ec$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$f088c3cfa4ce44ec$var$uf] = b.current;
    $f088c3cfa4ce44ec$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f088c3cfa4ce44ec$var$ml(b);
};
$f088c3cfa4ce44ec$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f088c3cfa4ce44ec$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f088c3cfa4ce44ec$var$p(268, a));
    }
    a = $f088c3cfa4ce44ec$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f088c3cfa4ce44ec$export$cd75ccfd720a3cd4 = function(a) {
    return $f088c3cfa4ce44ec$var$Sk(a);
};
$f088c3cfa4ce44ec$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f088c3cfa4ce44ec$var$pl(b)) throw Error($f088c3cfa4ce44ec$var$p(200));
    return $f088c3cfa4ce44ec$var$sl(null, a, b, !0, c);
};
$f088c3cfa4ce44ec$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f088c3cfa4ce44ec$var$ol(a)) throw Error($f088c3cfa4ce44ec$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f088c3cfa4ce44ec$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f088c3cfa4ce44ec$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f088c3cfa4ce44ec$var$uf] = b.current;
    $f088c3cfa4ce44ec$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f088c3cfa4ce44ec$var$nl(b);
};
$f088c3cfa4ce44ec$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f088c3cfa4ce44ec$var$pl(b)) throw Error($f088c3cfa4ce44ec$var$p(200));
    return $f088c3cfa4ce44ec$var$sl(null, a, b, !1, c);
};
$f088c3cfa4ce44ec$export$502457920280e6be = function(a) {
    if (!$f088c3cfa4ce44ec$var$pl(a)) throw Error($f088c3cfa4ce44ec$var$p(40));
    return a._reactRootContainer ? ($f088c3cfa4ce44ec$var$Sk(function() {
        $f088c3cfa4ce44ec$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f088c3cfa4ce44ec$var$uf] = null;
        });
    }), !0) : !1;
};
$f088c3cfa4ce44ec$export$c78a37762a8d58e1 = $f088c3cfa4ce44ec$var$Rk;
$f088c3cfa4ce44ec$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f088c3cfa4ce44ec$var$pl(c)) throw Error($f088c3cfa4ce44ec$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f088c3cfa4ce44ec$var$p(38));
    return $f088c3cfa4ce44ec$var$sl(a, b, c, !1, d);
};
$f088c3cfa4ce44ec$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("lNe8F", function(module, exports) {
"use strict";

module.exports = (parcelRequire("h58Bn"));

});
parcelRegister("h58Bn", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c6f99375108fe476$export$c4744153514ff05d; }, function (v) { return $c6f99375108fe476$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c6f99375108fe476$export$3e506c1ccc9cc1a7; }, function (v) { return $c6f99375108fe476$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c6f99375108fe476$export$e26fe2ed2fa76875; }, function (v) { return $c6f99375108fe476$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c6f99375108fe476$export$502329bbf4b505b1; }, function (v) { return $c6f99375108fe476$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c6f99375108fe476$export$6e3807111c4874c4; }, function (v) { return $c6f99375108fe476$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c6f99375108fe476$export$c27134553091fb3a; }, function (v) { return $c6f99375108fe476$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c6f99375108fe476$export$33ee1acdc04fd2a2; }, function (v) { return $c6f99375108fe476$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c6f99375108fe476$export$b00a404bbd5edef2; }, function (v) { return $c6f99375108fe476$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c6f99375108fe476$export$8352ce38b91d0c62; }, function (v) { return $c6f99375108fe476$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c6f99375108fe476$export$d66a1c1c77bd778b; }, function (v) { return $c6f99375108fe476$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c6f99375108fe476$export$d3dfb8e4810cb555; }, function (v) { return $c6f99375108fe476$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c6f99375108fe476$export$839f9183b0465a69; }, function (v) { return $c6f99375108fe476$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c6f99375108fe476$export$72fdf0e06517287b; }, function (v) { return $c6f99375108fe476$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c6f99375108fe476$export$4b844e58a3e414b4; }, function (v) { return $c6f99375108fe476$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c6f99375108fe476$export$816d2913ae6b83b1; }, function (v) { return $c6f99375108fe476$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c6f99375108fe476$export$61bcfe829111a1d0; }, function (v) { return $c6f99375108fe476$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c6f99375108fe476$export$7ee8c9beb337bc3f; }, function (v) { return $c6f99375108fe476$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c6f99375108fe476$export$b5836b71941fa3ed; }, function (v) { return $c6f99375108fe476$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c6f99375108fe476$export$cf845f2c119da08a; }, function (v) { return $c6f99375108fe476$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c6f99375108fe476$export$c4744153514ff05d;
var $c6f99375108fe476$export$3e506c1ccc9cc1a7;
var $c6f99375108fe476$export$e26fe2ed2fa76875;
var $c6f99375108fe476$export$502329bbf4b505b1;
var $c6f99375108fe476$export$6e3807111c4874c4;
var $c6f99375108fe476$export$c27134553091fb3a;
var $c6f99375108fe476$export$33ee1acdc04fd2a2;
var $c6f99375108fe476$export$b00a404bbd5edef2;
var $c6f99375108fe476$export$8352ce38b91d0c62;
var $c6f99375108fe476$export$d66a1c1c77bd778b;
var $c6f99375108fe476$export$d3dfb8e4810cb555;
var $c6f99375108fe476$export$839f9183b0465a69;
var $c6f99375108fe476$export$72fdf0e06517287b;
var $c6f99375108fe476$export$4b844e58a3e414b4;
var $c6f99375108fe476$export$816d2913ae6b83b1;
var $c6f99375108fe476$export$61bcfe829111a1d0;
var $c6f99375108fe476$export$7ee8c9beb337bc3f;
var $c6f99375108fe476$export$b5836b71941fa3ed;
var $c6f99375108fe476$export$cf845f2c119da08a;
"use strict";
function $c6f99375108fe476$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $c6f99375108fe476$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c6f99375108fe476$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $c6f99375108fe476$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $c6f99375108fe476$var$g(C, c)) n < e && 0 > $c6f99375108fe476$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $c6f99375108fe476$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $c6f99375108fe476$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c6f99375108fe476$var$l = performance;
    $c6f99375108fe476$export$c4744153514ff05d = function() {
        return $c6f99375108fe476$var$l.now();
    };
} else {
    var $c6f99375108fe476$var$p = Date, $c6f99375108fe476$var$q = $c6f99375108fe476$var$p.now();
    $c6f99375108fe476$export$c4744153514ff05d = function() {
        return $c6f99375108fe476$var$p.now() - $c6f99375108fe476$var$q;
    };
}
var $c6f99375108fe476$var$r = [], $c6f99375108fe476$var$t = [], $c6f99375108fe476$var$u = 1, $c6f99375108fe476$var$v = null, $c6f99375108fe476$var$y = 3, $c6f99375108fe476$var$z = !1, $c6f99375108fe476$var$A = !1, $c6f99375108fe476$var$B = !1, $c6f99375108fe476$var$D = "function" === typeof setTimeout ? setTimeout : null, $c6f99375108fe476$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $c6f99375108fe476$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $c6f99375108fe476$var$G(a) {
    for(var b = $c6f99375108fe476$var$h($c6f99375108fe476$var$t); null !== b;){
        if (null === b.callback) $c6f99375108fe476$var$k($c6f99375108fe476$var$t);
        else if (b.startTime <= a) $c6f99375108fe476$var$k($c6f99375108fe476$var$t), b.sortIndex = b.expirationTime, $c6f99375108fe476$var$f($c6f99375108fe476$var$r, b);
        else break;
        b = $c6f99375108fe476$var$h($c6f99375108fe476$var$t);
    }
}
function $c6f99375108fe476$var$H(a) {
    $c6f99375108fe476$var$B = !1;
    $c6f99375108fe476$var$G(a);
    if (!$c6f99375108fe476$var$A) {
        if (null !== $c6f99375108fe476$var$h($c6f99375108fe476$var$r)) $c6f99375108fe476$var$A = !0, $c6f99375108fe476$var$I($c6f99375108fe476$var$J);
        else {
            var b = $c6f99375108fe476$var$h($c6f99375108fe476$var$t);
            null !== b && $c6f99375108fe476$var$K($c6f99375108fe476$var$H, b.startTime - a);
        }
    }
}
function $c6f99375108fe476$var$J(a, b) {
    $c6f99375108fe476$var$A = !1;
    $c6f99375108fe476$var$B && ($c6f99375108fe476$var$B = !1, $c6f99375108fe476$var$E($c6f99375108fe476$var$L), $c6f99375108fe476$var$L = -1);
    $c6f99375108fe476$var$z = !0;
    var c = $c6f99375108fe476$var$y;
    try {
        $c6f99375108fe476$var$G(b);
        for($c6f99375108fe476$var$v = $c6f99375108fe476$var$h($c6f99375108fe476$var$r); null !== $c6f99375108fe476$var$v && (!($c6f99375108fe476$var$v.expirationTime > b) || a && !$c6f99375108fe476$var$M());){
            var d = $c6f99375108fe476$var$v.callback;
            if ("function" === typeof d) {
                $c6f99375108fe476$var$v.callback = null;
                $c6f99375108fe476$var$y = $c6f99375108fe476$var$v.priorityLevel;
                var e = d($c6f99375108fe476$var$v.expirationTime <= b);
                b = $c6f99375108fe476$export$c4744153514ff05d();
                "function" === typeof e ? $c6f99375108fe476$var$v.callback = e : $c6f99375108fe476$var$v === $c6f99375108fe476$var$h($c6f99375108fe476$var$r) && $c6f99375108fe476$var$k($c6f99375108fe476$var$r);
                $c6f99375108fe476$var$G(b);
            } else $c6f99375108fe476$var$k($c6f99375108fe476$var$r);
            $c6f99375108fe476$var$v = $c6f99375108fe476$var$h($c6f99375108fe476$var$r);
        }
        if (null !== $c6f99375108fe476$var$v) var w = !0;
        else {
            var m = $c6f99375108fe476$var$h($c6f99375108fe476$var$t);
            null !== m && $c6f99375108fe476$var$K($c6f99375108fe476$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $c6f99375108fe476$var$v = null, $c6f99375108fe476$var$y = c, $c6f99375108fe476$var$z = !1;
    }
}
var $c6f99375108fe476$var$N = !1, $c6f99375108fe476$var$O = null, $c6f99375108fe476$var$L = -1, $c6f99375108fe476$var$P = 5, $c6f99375108fe476$var$Q = -1;
function $c6f99375108fe476$var$M() {
    return $c6f99375108fe476$export$c4744153514ff05d() - $c6f99375108fe476$var$Q < $c6f99375108fe476$var$P ? !1 : !0;
}
function $c6f99375108fe476$var$R() {
    if (null !== $c6f99375108fe476$var$O) {
        var a = $c6f99375108fe476$export$c4744153514ff05d();
        $c6f99375108fe476$var$Q = a;
        var b = !0;
        try {
            b = $c6f99375108fe476$var$O(!0, a);
        } finally{
            b ? $c6f99375108fe476$var$S() : ($c6f99375108fe476$var$N = !1, $c6f99375108fe476$var$O = null);
        }
    } else $c6f99375108fe476$var$N = !1;
}
var $c6f99375108fe476$var$S;
if ("function" === typeof $c6f99375108fe476$var$F) $c6f99375108fe476$var$S = function() {
    $c6f99375108fe476$var$F($c6f99375108fe476$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c6f99375108fe476$var$T = new MessageChannel, $c6f99375108fe476$var$U = $c6f99375108fe476$var$T.port2;
    $c6f99375108fe476$var$T.port1.onmessage = $c6f99375108fe476$var$R;
    $c6f99375108fe476$var$S = function() {
        $c6f99375108fe476$var$U.postMessage(null);
    };
} else $c6f99375108fe476$var$S = function() {
    $c6f99375108fe476$var$D($c6f99375108fe476$var$R, 0);
};
function $c6f99375108fe476$var$I(a) {
    $c6f99375108fe476$var$O = a;
    $c6f99375108fe476$var$N || ($c6f99375108fe476$var$N = !0, $c6f99375108fe476$var$S());
}
function $c6f99375108fe476$var$K(a, b) {
    $c6f99375108fe476$var$L = $c6f99375108fe476$var$D(function() {
        a($c6f99375108fe476$export$c4744153514ff05d());
    }, b);
}
$c6f99375108fe476$export$3e506c1ccc9cc1a7 = 5;
$c6f99375108fe476$export$e26fe2ed2fa76875 = 1;
$c6f99375108fe476$export$502329bbf4b505b1 = 4;
$c6f99375108fe476$export$6e3807111c4874c4 = 3;
$c6f99375108fe476$export$c27134553091fb3a = null;
$c6f99375108fe476$export$33ee1acdc04fd2a2 = 2;
$c6f99375108fe476$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c6f99375108fe476$export$8352ce38b91d0c62 = function() {
    $c6f99375108fe476$var$A || $c6f99375108fe476$var$z || ($c6f99375108fe476$var$A = !0, $c6f99375108fe476$var$I($c6f99375108fe476$var$J));
};
$c6f99375108fe476$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c6f99375108fe476$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$c6f99375108fe476$export$d3dfb8e4810cb555 = function() {
    return $c6f99375108fe476$var$y;
};
$c6f99375108fe476$export$839f9183b0465a69 = function() {
    return $c6f99375108fe476$var$h($c6f99375108fe476$var$r);
};
$c6f99375108fe476$export$72fdf0e06517287b = function(a) {
    switch($c6f99375108fe476$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c6f99375108fe476$var$y;
    }
    var c = $c6f99375108fe476$var$y;
    $c6f99375108fe476$var$y = b;
    try {
        return a();
    } finally{
        $c6f99375108fe476$var$y = c;
    }
};
$c6f99375108fe476$export$4b844e58a3e414b4 = function() {};
$c6f99375108fe476$export$816d2913ae6b83b1 = function() {};
$c6f99375108fe476$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c6f99375108fe476$var$y;
    $c6f99375108fe476$var$y = a;
    try {
        return b();
    } finally{
        $c6f99375108fe476$var$y = c;
    }
};
$c6f99375108fe476$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c6f99375108fe476$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $c6f99375108fe476$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $c6f99375108fe476$var$f($c6f99375108fe476$var$t, a), null === $c6f99375108fe476$var$h($c6f99375108fe476$var$r) && a === $c6f99375108fe476$var$h($c6f99375108fe476$var$t) && ($c6f99375108fe476$var$B ? ($c6f99375108fe476$var$E($c6f99375108fe476$var$L), $c6f99375108fe476$var$L = -1) : $c6f99375108fe476$var$B = !0, $c6f99375108fe476$var$K($c6f99375108fe476$var$H, c - d))) : (a.sortIndex = e, $c6f99375108fe476$var$f($c6f99375108fe476$var$r, a), $c6f99375108fe476$var$A || $c6f99375108fe476$var$z || ($c6f99375108fe476$var$A = !0, $c6f99375108fe476$var$I($c6f99375108fe476$var$J)));
    return a;
};
$c6f99375108fe476$export$b5836b71941fa3ed = $c6f99375108fe476$var$M;
$c6f99375108fe476$export$cf845f2c119da08a = function(a) {
    var b = $c6f99375108fe476$var$y;
    return function() {
        var c = $c6f99375108fe476$var$y;
        $c6f99375108fe476$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c6f99375108fe476$var$y = c;
        }
    };
};

});



parcelRegister("JZlia", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $08a3c9693226ad5b$export$bf730a2d8bf68b42; }, function (v) { return $08a3c9693226ad5b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $08a3c9693226ad5b$export$bf730a2d8bf68b42;
"use strict";

var $jzmb2 = parcelRequire("jzmb2");
function $08a3c9693226ad5b$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $08a3c9693226ad5b$var$p = "function" === typeof Object.is ? Object.is : $08a3c9693226ad5b$var$n, $08a3c9693226ad5b$var$q = $jzmb2.useSyncExternalStore, $08a3c9693226ad5b$var$r = $jzmb2.useRef, $08a3c9693226ad5b$var$t = $jzmb2.useEffect, $08a3c9693226ad5b$var$u = $jzmb2.useMemo, $08a3c9693226ad5b$var$v = $jzmb2.useDebugValue;
$08a3c9693226ad5b$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $08a3c9693226ad5b$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $08a3c9693226ad5b$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($08a3c9693226ad5b$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $08a3c9693226ad5b$var$q(a, c[0], c[1]);
    $08a3c9693226ad5b$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $08a3c9693226ad5b$var$v(d);
    return d;
};

});

parcelRegister("1XB36", function(module, exports) {

var $4OZ1r = parcelRequire("4OZ1r");
module.exports = $4OZ1r("cDcGl").then(()=>parcelRequire("eZnrM"));

});
parcelRegister("4OZ1r", function(module, exports) {
"use strict";

function $382b2ab45371da79$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6Fatn")).resolve(id));
}
module.exports = $382b2ab45371da79$var$load;

});



var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");
var $808d048e85732009$exports = {};

$parcel$export($808d048e85732009$exports, "createRoot", function () { return $808d048e85732009$export$882461b6382ed46c; }, function (v) { return $808d048e85732009$export$882461b6382ed46c = v; });
$parcel$export($808d048e85732009$exports, "hydrateRoot", function () { return $808d048e85732009$export$757ceba2d55c277e; }, function (v) { return $808d048e85732009$export$757ceba2d55c277e = v; });
var $808d048e85732009$export$882461b6382ed46c;
var $808d048e85732009$export$757ceba2d55c277e;
"use strict";
var $59b566e1f881b9b6$exports = {};
"use strict";
function $59b566e1f881b9b6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($59b566e1f881b9b6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$59b566e1f881b9b6$var$checkDCE();

$59b566e1f881b9b6$exports = (parcelRequire("kEmcy"));


var $808d048e85732009$var$i;
$808d048e85732009$export$882461b6382ed46c = $59b566e1f881b9b6$exports.createRoot;
$808d048e85732009$export$757ceba2d55c277e = $59b566e1f881b9b6$exports.hydrateRoot;



var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");
/**
 * React Router DOM v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jzmb2 = parcelRequire("jzmb2");

/**
 * @remix-run/router v1.15.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a380c983429df55f$var$_extends() {
    $a380c983429df55f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a380c983429df55f$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a380c983429df55f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a380c983429df55f$export$e19cd5f9376f8cee || ($a380c983429df55f$export$e19cd5f9376f8cee = {}));
const $a380c983429df55f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a380c983429df55f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a380c983429df55f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a380c983429df55f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a380c983429df55f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a380c983429df55f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a380c983429df55f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a380c983429df55f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a380c983429df55f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a380c983429df55f$export$fe53371bee54353d(to);
    }
    return $a380c983429df55f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a380c983429df55f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a380c983429df55f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a380c983429df55f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a380c983429df55f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a380c983429df55f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a380c983429df55f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a380c983429df55f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a380c983429df55f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a380c983429df55f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a380c983429df55f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a380c983429df55f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a380c983429df55f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a380c983429df55f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a380c983429df55f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a380c983429df55f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a380c983429df55f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a380c983429df55f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a380c983429df55f$export$e19cd5f9376f8cee.Push;
        let location = $a380c983429df55f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a380c983429df55f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a380c983429df55f$export$e19cd5f9376f8cee.Replace;
        let location = $a380c983429df55f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a380c983429df55f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a380c983429df55f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a380c983429df55f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a380c983429df55f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a380c983429df55f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a380c983429df55f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a380c983429df55f$var$ResultType || ($a380c983429df55f$var$ResultType = {}));
const $a380c983429df55f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a380c983429df55f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a380c983429df55f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a380c983429df55f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a380c983429df55f$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($a380c983429df55f$var$isIndexRoute(route)) {
            let indexRoute = $a380c983429df55f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a380c983429df55f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a380c983429df55f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $a380c983429df55f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a380c983429df55f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a380c983429df55f$var$flattenRoutes(routes);
    $a380c983429df55f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $a380c983429df55f$var$decodePath(pathname);
        matches = $a380c983429df55f$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $a380c983429df55f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a380c983429df55f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a380c983429df55f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a380c983429df55f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a380c983429df55f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $a380c983429df55f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a380c983429df55f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a380c983429df55f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a380c983429df55f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a380c983429df55f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a380c983429df55f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a380c983429df55f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a380c983429df55f$var$paramRe = /^:[\w-]+$/;
const $a380c983429df55f$var$dynamicSegmentValue = 3;
const $a380c983429df55f$var$indexRouteValue = 2;
const $a380c983429df55f$var$emptySegmentValue = 1;
const $a380c983429df55f$var$staticSegmentValue = 10;
const $a380c983429df55f$var$splatPenalty = -2;
const $a380c983429df55f$var$isSplat = (s)=>s === "*";
function $a380c983429df55f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a380c983429df55f$var$isSplat)) initialScore += $a380c983429df55f$var$splatPenalty;
    if (index) initialScore += $a380c983429df55f$var$indexRouteValue;
    return segments.filter((s)=>!$a380c983429df55f$var$isSplat(s)).reduce((score, segment)=>score + ($a380c983429df55f$var$paramRe.test(segment) ? $a380c983429df55f$var$dynamicSegmentValue : segment === "" ? $a380c983429df55f$var$emptySegmentValue : $a380c983429df55f$var$staticSegmentValue), initialScore);
}
function $a380c983429df55f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a380c983429df55f$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a380c983429df55f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a380c983429df55f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a380c983429df55f$export$a5c6d149b50c1d86($a380c983429df55f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a380c983429df55f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $a380c983429df55f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a380c983429df55f$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a380c983429df55f$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $a380c983429df55f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a380c983429df55f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a380c983429df55f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a380c983429df55f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a380c983429df55f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a380c983429df55f$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a380c983429df55f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $a380c983429df55f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a380c983429df55f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a380c983429df55f$var$normalizeSearch(search),
        hash: $a380c983429df55f$var$normalizeHash(hash)
    };
}
function $a380c983429df55f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a380c983429df55f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a380c983429df55f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a380c983429df55f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a380c983429df55f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a380c983429df55f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a380c983429df55f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a380c983429df55f$var$_extends({}, toArg);
        $a380c983429df55f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a380c983429df55f$var$getInvalidPathError("?", "pathname", "search", to));
        $a380c983429df55f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a380c983429df55f$var$getInvalidPathError("#", "pathname", "hash", to));
        $a380c983429df55f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a380c983429df55f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a380c983429df55f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a380c983429df55f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a380c983429df55f$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a380c983429df55f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a380c983429df55f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a380c983429df55f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $a380c983429df55f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a380c983429df55f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a380c983429df55f$export$42a99a7a4bc0e76a extends Error {
}
class $a380c983429df55f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a380c983429df55f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a380c983429df55f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a380c983429df55f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a380c983429df55f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a380c983429df55f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a380c983429df55f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a380c983429df55f$var$unwrapTrackedPromise(value) {
    if (!$a380c983429df55f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $a380c983429df55f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a380c983429df55f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a380c983429df55f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a380c983429df55f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a380c983429df55f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a380c983429df55f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a380c983429df55f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a380c983429df55f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a380c983429df55f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a380c983429df55f$var$validMutationMethods = new Set($a380c983429df55f$var$validMutationMethodsArr);
const $a380c983429df55f$var$validRequestMethodsArr = [
    "get",
    ...$a380c983429df55f$var$validMutationMethodsArr
];
const $a380c983429df55f$var$validRequestMethods = new Set($a380c983429df55f$var$validRequestMethodsArr);
const $a380c983429df55f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a380c983429df55f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a380c983429df55f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a380c983429df55f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a380c983429df55f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a380c983429df55f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a380c983429df55f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a380c983429df55f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a380c983429df55f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a380c983429df55f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a380c983429df55f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a380c983429df55f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $a380c983429df55f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a380c983429df55f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a380c983429df55f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a380c983429df55f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a380c983429df55f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $a380c983429df55f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a380c983429df55f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a380c983429df55f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a380c983429df55f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a380c983429df55f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a380c983429df55f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a380c983429df55f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a380c983429df55f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a380c983429df55f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a380c983429df55f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a380c983429df55f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a380c983429df55f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a380c983429df55f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a380c983429df55f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a380c983429df55f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a380c983429df55f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a380c983429df55f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a380c983429df55f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a380c983429df55f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a380c983429df55f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a380c983429df55f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a380c983429df55f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a380c983429df55f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a380c983429df55f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a380c983429df55f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a380c983429df55f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $a380c983429df55f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $a380c983429df55f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a380c983429df55f$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $a380c983429df55f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a380c983429df55f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a380c983429df55f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$a380c983429df55f$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $a380c983429df55f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $a380c983429df55f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a380c983429df55f$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a380c983429df55f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $a380c983429df55f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a380c983429df55f$var$ResultType.error,
            error: $a380c983429df55f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $a380c983429df55f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a380c983429df55f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a380c983429df55f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a380c983429df55f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $a380c983429df55f$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($a380c983429df55f$var$isDeferredResult(result)) throw $a380c983429df55f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a380c983429df55f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a380c983429df55f$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a380c983429df55f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a380c983429df55f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $a380c983429df55f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($a380c983429df55f$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a380c983429df55f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a380c983429df55f$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a380c983429df55f$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a380c983429df55f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a380c983429df55f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $a380c983429df55f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a380c983429df55f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a380c983429df55f$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a380c983429df55f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $a380c983429df55f$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a380c983429df55f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $a380c983429df55f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $a380c983429df55f$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a380c983429df55f$var$isRedirectResult(actionResult) || $a380c983429df55f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a380c983429df55f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a380c983429df55f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a380c983429df55f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a380c983429df55f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a380c983429df55f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a380c983429df55f$var$isDeferredResult(actionResult)) throw $a380c983429df55f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a380c983429df55f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a380c983429df55f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a380c983429df55f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a380c983429df55f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a380c983429df55f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a380c983429df55f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a380c983429df55f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a380c983429df55f$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a380c983429df55f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a380c983429df55f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a380c983429df55f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a380c983429df55f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $a380c983429df55f$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $a380c983429df55f$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a380c983429df55f$var$isDeferredResult(result)) result = await $a380c983429df55f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a380c983429df55f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a380c983429df55f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a380c983429df55f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a380c983429df55f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a380c983429df55f$export$3e9cee6b33872309(!$a380c983429df55f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a380c983429df55f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $a380c983429df55f$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $a380c983429df55f$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a380c983429df55f$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a380c983429df55f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $a380c983429df55f$export$e19cd5f9376f8cee.Replace : $a380c983429df55f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a380c983429df55f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a380c983429df55f$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $a380c983429df55f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a380c983429df55f$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a380c983429df55f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a380c983429df55f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $a380c983429df55f$var$callLoaderOrAction("loader", $a380c983429df55f$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $a380c983429df55f$var$ResultType.error,
                        error: $a380c983429df55f$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $a380c983429df55f$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $a380c983429df55f$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a380c983429df55f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $a380c983429df55f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $a380c983429df55f$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a380c983429df55f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a380c983429df55f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a380c983429df55f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a380c983429df55f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a380c983429df55f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a380c983429df55f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a380c983429df55f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a380c983429df55f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a380c983429df55f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a380c983429df55f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a380c983429df55f$export$4d0306f8f6a4585b = Symbol("deferred");
function $a380c983429df55f$export$3336b097a6fbc59a(routes, opts) {
    $a380c983429df55f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a380c983429df55f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a380c983429df55f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a380c983429df55f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a380c983429df55f$var$createLocation("", $a380c983429df55f$export$fe53371bee54353d(url), null, "default");
        let matches = $a380c983429df55f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a380c983429df55f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a380c983429df55f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a380c983429df55f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a380c983429df55f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a380c983429df55f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($a380c983429df55f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a380c983429df55f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a380c983429df55f$var$createLocation("", $a380c983429df55f$export$fe53371bee54353d(url), null, "default");
        let matches = $a380c983429df55f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a380c983429df55f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a380c983429df55f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a380c983429df55f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a380c983429df55f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a380c983429df55f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a380c983429df55f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($a380c983429df55f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a380c983429df55f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $a380c983429df55f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a380c983429df55f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a380c983429df55f$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $a380c983429df55f$var$isResponse(result) ? result : $a380c983429df55f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($a380c983429df55f$var$isQueryRouteResponse(e)) {
                if (e.type === $a380c983429df55f$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a380c983429df55f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a380c983429df55f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a380c983429df55f$var$ResultType.error,
                error: error
            };
        } else {
            result = await $a380c983429df55f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $a380c983429df55f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a380c983429df55f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($a380c983429df55f$var$isDeferredResult(result)) {
            let error = $a380c983429df55f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a380c983429df55f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a380c983429df55f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($a380c983429df55f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a380c983429df55f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $a380c983429df55f$var$_extends({}, context, {
                statusCode: $a380c983429df55f$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $a380c983429df55f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $a380c983429df55f$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $a380c983429df55f$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a380c983429df55f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $a380c983429df55f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a380c983429df55f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $a380c983429df55f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a380c983429df55f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a380c983429df55f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a380c983429df55f$export$fec11da027c70692(routes, context, error) {
    let newContext = $a380c983429df55f$var$_extends({}, context, {
        statusCode: $a380c983429df55f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a380c983429df55f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a380c983429df55f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a380c983429df55f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a380c983429df55f$export$cae722b0cc860f13(to ? to : ".", $a380c983429df55f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a380c983429df55f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$a380c983429df55f$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a380c983429df55f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a380c983429df55f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a380c983429df55f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a380c983429df55f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a380c983429df55f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a380c983429df55f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a380c983429df55f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a380c983429df55f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a380c983429df55f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a380c983429df55f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a380c983429df55f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a380c983429df55f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a380c983429df55f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a380c983429df55f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a380c983429df55f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a380c983429df55f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a380c983429df55f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a380c983429df55f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a380c983429df55f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $a380c983429df55f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $a380c983429df55f$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $a380c983429df55f$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($a380c983429df55f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a380c983429df55f$var$shouldRevalidateLoader(match, $a380c983429df55f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a380c983429df55f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a380c983429df55f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a380c983429df55f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a380c983429df55f$var$shouldRevalidateLoader(fetcherMatch, $a380c983429df55f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a380c983429df55f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a380c983429df55f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a380c983429df55f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a380c983429df55f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a380c983429df55f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a380c983429df55f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$a380c983429df55f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a380c983429df55f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $a380c983429df55f$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $a380c983429df55f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $a380c983429df55f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a380c983429df55f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a380c983429df55f$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a380c983429df55f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a380c983429df55f$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $a380c983429df55f$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($a380c983429df55f$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($a380c983429df55f$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $a380c983429df55f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$a380c983429df55f$var$ABSOLUTE_URL_REGEX.test(location)) location = $a380c983429df55f$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $a380c983429df55f$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $a380c983429df55f$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $a380c983429df55f$var$ResultType.error ? $a380c983429df55f$var$ResultType.error : $a380c983429df55f$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a380c983429df55f$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $a380c983429df55f$var$ResultType.error) return {
            type: resultType,
            error: new $a380c983429df55f$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $a380c983429df55f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $a380c983429df55f$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($a380c983429df55f$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $a380c983429df55f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $a380c983429df55f$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a380c983429df55f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a380c983429df55f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a380c983429df55f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a380c983429df55f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a380c983429df55f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a380c983429df55f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a380c983429df55f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $a380c983429df55f$export$3e9cee6b33872309(!$a380c983429df55f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a380c983429df55f$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $a380c983429df55f$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a380c983429df55f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($a380c983429df55f$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a380c983429df55f$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a380c983429df55f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $a380c983429df55f$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($a380c983429df55f$var$isErrorResult(result)) {
            let boundaryMatch = $a380c983429df55f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a380c983429df55f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a380c983429df55f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a380c983429df55f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a380c983429df55f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a380c983429df55f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a380c983429df55f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a380c983429df55f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a380c983429df55f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a380c983429df55f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a380c983429df55f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a380c983429df55f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $a380c983429df55f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a380c983429df55f$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($a380c983429df55f$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $a380c983429df55f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(path) : path;
    return $a380c983429df55f$export$fe53371bee54353d($a380c983429df55f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a380c983429df55f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a380c983429df55f$var$isDeferredResult(result) {
    return result.type === $a380c983429df55f$var$ResultType.deferred;
}
function $a380c983429df55f$var$isErrorResult(result) {
    return result.type === $a380c983429df55f$var$ResultType.error;
}
function $a380c983429df55f$var$isRedirectResult(result) {
    return (result && result.type) === $a380c983429df55f$var$ResultType.redirect;
}
function $a380c983429df55f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a380c983429df55f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a380c983429df55f$var$isRedirectResponse(result) {
    if (!$a380c983429df55f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a380c983429df55f$var$isQueryRouteResponse(obj) {
    return obj && $a380c983429df55f$var$isResponse(obj.response) && (obj.type === $a380c983429df55f$var$ResultType.data || obj.type === $a380c983429df55f$var$ResultType.error);
}
function $a380c983429df55f$var$isValidMethod(method) {
    return $a380c983429df55f$var$validRequestMethods.has(method.toLowerCase());
}
function $a380c983429df55f$var$isMutationMethod(method) {
    return $a380c983429df55f$var$validMutationMethods.has(method.toLowerCase());
}
async function $a380c983429df55f$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a380c983429df55f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a380c983429df55f$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $a380c983429df55f$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $a380c983429df55f$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $a380c983429df55f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a380c983429df55f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a380c983429df55f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a380c983429df55f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a380c983429df55f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a380c983429df55f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a380c983429df55f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a380c983429df55f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a380c983429df55f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a380c983429df55f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a380c983429df55f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a380c983429df55f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a380c983429df55f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a380c983429df55f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a380c983429df55f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a380c983429df55f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a380c983429df55f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a380c983429df55f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a380c983429df55f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a380c983429df55f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jzmb2 = parcelRequire("jzmb2");

function $545ec7bc5bb917bf$var$_extends() {
    $545ec7bc5bb917bf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $545ec7bc5bb917bf$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $545ec7bc5bb917bf$export$3add0d5dce533e2e = /*#__PURE__*/ $jzmb2.createContext(null);
const $545ec7bc5bb917bf$export$145dfa71566a64dc = /*#__PURE__*/ $jzmb2.createContext(null);
const $545ec7bc5bb917bf$var$AwaitContext = /*#__PURE__*/ $jzmb2.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $545ec7bc5bb917bf$export$26749e8557646306 = /*#__PURE__*/ $jzmb2.createContext(null);
const $545ec7bc5bb917bf$export$c7914228fb69b0f5 = /*#__PURE__*/ $jzmb2.createContext(null);
const $545ec7bc5bb917bf$export$9072aa6dd1f93057 = /*#__PURE__*/ $jzmb2.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $545ec7bc5bb917bf$var$RouteErrorContext = /*#__PURE__*/ $jzmb2.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $545ec7bc5bb917bf$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $545ec7bc5bb917bf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a380c983429df55f$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $545ec7bc5bb917bf$export$9c954a9d03d32f4a() {
    return $jzmb2.useContext($545ec7bc5bb917bf$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $545ec7bc5bb917bf$export$45d76561a5302f2b() {
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return $jzmb2.useContext($545ec7bc5bb917bf$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $545ec7bc5bb917bf$export$1b3f31771c5d07c() {
    return $jzmb2.useContext($545ec7bc5bb917bf$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $545ec7bc5bb917bf$export$6c330e8992e8a295(pattern) {
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $545ec7bc5bb917bf$export$45d76561a5302f2b();
    return $jzmb2.useMemo(()=>(0, $a380c983429df55f$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $545ec7bc5bb917bf$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $545ec7bc5bb917bf$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $jzmb2.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $545ec7bc5bb917bf$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $545ec7bc5bb917bf$var$useNavigateStable() : $545ec7bc5bb917bf$var$useNavigateUnstable();
}
function $545ec7bc5bb917bf$var$useNavigateUnstable() {
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let dataRouterContext = $jzmb2.useContext($545ec7bc5bb917bf$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306);
    let { matches: matches } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $545ec7bc5bb917bf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a380c983429df55f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $jzmb2.useRef(false);
    $545ec7bc5bb917bf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jzmb2.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a380c983429df55f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a380c983429df55f$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $545ec7bc5bb917bf$var$OutletContext = /*#__PURE__*/ $jzmb2.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $545ec7bc5bb917bf$export$4138103a3ae699cc() {
    return $jzmb2.useContext($545ec7bc5bb917bf$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $545ec7bc5bb917bf$export$a3be3530d8e40d0b(context) {
    let outlet = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $545ec7bc5bb917bf$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $545ec7bc5bb917bf$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306);
    let { matches: matches } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $545ec7bc5bb917bf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a380c983429df55f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $jzmb2.useMemo(()=>(0, $a380c983429df55f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $545ec7bc5bb917bf$export$5d3fca4a98652595(routes, locationArg) {
    return $545ec7bc5bb917bf$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $545ec7bc5bb917bf$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306);
    let { matches: parentMatches } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $545ec7bc5bb917bf$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a380c983429df55f$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $a380c983429df55f$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $545ec7bc5bb917bf$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a380c983429df55f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a380c983429df55f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $545ec7bc5bb917bf$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a380c983429df55f$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $545ec7bc5bb917bf$var$DefaultErrorComponent() {
    let error = $545ec7bc5bb917bf$export$ed527bf60f6e05f2();
    let message = (0, $a380c983429df55f$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $jzmb2.createElement($jzmb2.Fragment, null, /*#__PURE__*/ $jzmb2.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $jzmb2.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $jzmb2.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $545ec7bc5bb917bf$var$defaultErrorElement = /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$DefaultErrorComponent, null);
class $545ec7bc5bb917bf$var$RenderErrorBoundary extends $jzmb2.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $545ec7bc5bb917bf$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $jzmb2.useContext($545ec7bc5bb917bf$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $545ec7bc5bb917bf$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $545ec7bc5bb917bf$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $545ec7bc5bb917bf$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $jzmb2.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $545ec7bc5bb917bf$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($545ec7bc5bb917bf$var$DataRouterHook || {});
var $545ec7bc5bb917bf$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($545ec7bc5bb917bf$var$DataRouterStateHook || {});
function $545ec7bc5bb917bf$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $545ec7bc5bb917bf$var$useDataRouterContext(hookName) {
    let ctx = $jzmb2.useContext($545ec7bc5bb917bf$export$3add0d5dce533e2e);
    !ctx && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return ctx;
}
function $545ec7bc5bb917bf$var$useDataRouterState(hookName) {
    let state = $jzmb2.useContext($545ec7bc5bb917bf$export$145dfa71566a64dc);
    !state && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return state;
}
function $545ec7bc5bb917bf$var$useRouteContext(hookName) {
    let route = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    !route && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $545ec7bc5bb917bf$var$useCurrentRouteId(hookName) {
    let route = $545ec7bc5bb917bf$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $545ec7bc5bb917bf$export$5fc8298006ad9e58() {
    return $545ec7bc5bb917bf$var$useCurrentRouteId($545ec7bc5bb917bf$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $545ec7bc5bb917bf$export$d0fd4b7106de2769() {
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $545ec7bc5bb917bf$export$600dc272ed516c15() {
    let dataRouterContext = $545ec7bc5bb917bf$var$useDataRouterContext($545ec7bc5bb917bf$var$DataRouterHook.UseRevalidator);
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseRevalidator);
    return $jzmb2.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $545ec7bc5bb917bf$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseMatches);
    return $jzmb2.useMemo(()=>matches.map((m)=>(0, $a380c983429df55f$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $545ec7bc5bb917bf$export$1448a5050d252c4d() {
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseLoaderData);
    let routeId = $545ec7bc5bb917bf$var$useCurrentRouteId($545ec7bc5bb917bf$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $545ec7bc5bb917bf$export$fd5d37484eab868d(routeId) {
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $545ec7bc5bb917bf$export$fdc00f3f26066d5e() {
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseActionData);
    let routeId = $545ec7bc5bb917bf$var$useCurrentRouteId($545ec7bc5bb917bf$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $545ec7bc5bb917bf$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $jzmb2.useContext($545ec7bc5bb917bf$var$RouteErrorContext);
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseRouteError);
    let routeId = $545ec7bc5bb917bf$var$useCurrentRouteId($545ec7bc5bb917bf$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $545ec7bc5bb917bf$export$78a72ddb39bdd145() {
    let value = $jzmb2.useContext($545ec7bc5bb917bf$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $545ec7bc5bb917bf$export$17f53340677d5831() {
    let value = $jzmb2.useContext($545ec7bc5bb917bf$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $545ec7bc5bb917bf$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $545ec7bc5bb917bf$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $545ec7bc5bb917bf$var$useDataRouterContext($545ec7bc5bb917bf$var$DataRouterHook.UseBlocker);
    let state = $545ec7bc5bb917bf$var$useDataRouterState($545ec7bc5bb917bf$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $jzmb2.useState("");
    let blockerFunction = $jzmb2.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $545ec7bc5bb917bf$var$_extends({}, currentLocation, {
                pathname: (0, $a380c983429df55f$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $545ec7bc5bb917bf$var$_extends({}, nextLocation, {
                pathname: (0, $a380c983429df55f$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $jzmb2.useEffect(()=>{
        let key = String(++$545ec7bc5bb917bf$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $jzmb2.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a380c983429df55f$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $545ec7bc5bb917bf$var$useNavigateStable() {
    let { router: router } = $545ec7bc5bb917bf$var$useDataRouterContext($545ec7bc5bb917bf$var$DataRouterHook.UseNavigateStable);
    let id = $545ec7bc5bb917bf$var$useCurrentRouteId($545ec7bc5bb917bf$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $jzmb2.useRef(false);
    $545ec7bc5bb917bf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jzmb2.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $545ec7bc5bb917bf$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $545ec7bc5bb917bf$var$alreadyWarned = {};
function $545ec7bc5bb917bf$var$warningOnce(key, cond, message) {
    if (!cond && !$545ec7bc5bb917bf$var$alreadyWarned[key]) $545ec7bc5bb917bf$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $545ec7bc5bb917bf$var$START_TRANSITION = "startTransition";
const $545ec7bc5bb917bf$var$startTransitionImpl = $jzmb2[$545ec7bc5bb917bf$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $545ec7bc5bb917bf$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jzmb2.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jzmb2.useCallback((newState)=>{
        if (v7_startTransition && $545ec7bc5bb917bf$var$startTransitionImpl) $545ec7bc5bb917bf$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jzmb2.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jzmb2.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jzmb2.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jzmb2.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jzmb2.createElement($jzmb2.Fragment, null, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $545ec7bc5bb917bf$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $545ec7bc5bb917bf$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $545ec7bc5bb917bf$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $jzmb2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a380c983429df55f$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jzmb2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jzmb2.useCallback((newState)=>{
        v7_startTransition && $545ec7bc5bb917bf$var$startTransitionImpl ? $545ec7bc5bb917bf$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jzmb2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $545ec7bc5bb917bf$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $jzmb2.useContext($545ec7bc5bb917bf$export$26749e8557646306);
    let { matches: matches } = $jzmb2.useContext($545ec7bc5bb917bf$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $545ec7bc5bb917bf$export$45d76561a5302f2b();
    let navigate = $545ec7bc5bb917bf$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a380c983429df55f$export$cae722b0cc860f13)(to, (0, $a380c983429df55f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $jzmb2.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $545ec7bc5bb917bf$export$910ae8079b2c2852(props) {
    return $545ec7bc5bb917bf$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $545ec7bc5bb917bf$export$e7b0ac011bb776c6(_props) {
    (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $545ec7bc5bb917bf$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a380c983429df55f$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$545ec7bc5bb917bf$export$9c954a9d03d32f4a() && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jzmb2.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $545ec7bc5bb917bf$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a380c983429df55f$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $jzmb2.useMemo(()=>{
        let trailingPathname = (0, $a380c983429df55f$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $545ec7bc5bb917bf$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $545ec7bc5bb917bf$export$5d3fca4a98652595($545ec7bc5bb917bf$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $545ec7bc5bb917bf$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$ResolveAwait, null, children));
}
var $545ec7bc5bb917bf$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($545ec7bc5bb917bf$var$AwaitRenderStatus || {});
const $545ec7bc5bb917bf$var$neverSettledPromise = new Promise(()=>{});
class $545ec7bc5bb917bf$var$AwaitErrorBoundary extends $jzmb2.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $545ec7bc5bb917bf$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $545ec7bc5bb917bf$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $545ec7bc5bb917bf$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $545ec7bc5bb917bf$var$AwaitRenderStatus.error : promise._data !== undefined ? $545ec7bc5bb917bf$var$AwaitRenderStatus.success : $545ec7bc5bb917bf$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $545ec7bc5bb917bf$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $545ec7bc5bb917bf$var$AwaitRenderStatus.error && promise._error instanceof (0, $a380c983429df55f$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $545ec7bc5bb917bf$var$neverSettledPromise;
        if (status === $545ec7bc5bb917bf$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $545ec7bc5bb917bf$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $545ec7bc5bb917bf$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $jzmb2.createElement($545ec7bc5bb917bf$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $545ec7bc5bb917bf$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $545ec7bc5bb917bf$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $jzmb2.createElement($jzmb2.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $545ec7bc5bb917bf$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $jzmb2.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $jzmb2.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jzmb2.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $545ec7bc5bb917bf$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $545ec7bc5bb917bf$export$e7b0ac011bb776c6) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $545ec7bc5bb917bf$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $545ec7bc5bb917bf$export$daf73786167a7f72(matches) {
    return $545ec7bc5bb917bf$var$_renderMatches(matches);
}
function $545ec7bc5bb917bf$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $jzmb2.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $jzmb2.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $jzmb2.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $545ec7bc5bb917bf$export$f30f7e456d254e83(routes, opts) {
    return (0, $a380c983429df55f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $545ec7bc5bb917bf$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a380c983429df55f$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $545ec7bc5bb917bf$export$52b333d321859367
    }).initialize();
}



function $d210e937315889a3$var$_extends() {
    $d210e937315889a3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d210e937315889a3$var$_extends.apply(this, arguments);
}
function $d210e937315889a3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d210e937315889a3$var$defaultMethod = "get";
const $d210e937315889a3$var$defaultEncType = "application/x-www-form-urlencoded";
function $d210e937315889a3$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d210e937315889a3$var$isButtonElement(object) {
    return $d210e937315889a3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d210e937315889a3$var$isFormElement(object) {
    return $d210e937315889a3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d210e937315889a3$var$isInputElement(object) {
    return $d210e937315889a3$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d210e937315889a3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d210e937315889a3$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d210e937315889a3$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d210e937315889a3$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d210e937315889a3$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d210e937315889a3$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d210e937315889a3$var$_formDataSupportsSubmitter = null;
function $d210e937315889a3$var$isFormDataSubmitterSupported() {
    if ($d210e937315889a3$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d210e937315889a3$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d210e937315889a3$var$_formDataSupportsSubmitter = true;
    }
    return $d210e937315889a3$var$_formDataSupportsSubmitter;
}
const $d210e937315889a3$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d210e937315889a3$var$getFormEncType(encType) {
    if (encType != null && !$d210e937315889a3$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d210e937315889a3$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d210e937315889a3$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a380c983429df55f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $d210e937315889a3$var$defaultMethod;
        encType = $d210e937315889a3$var$getFormEncType(target.getAttribute("enctype")) || $d210e937315889a3$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d210e937315889a3$var$isButtonElement(target) || $d210e937315889a3$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a380c983429df55f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d210e937315889a3$var$defaultMethod;
        encType = $d210e937315889a3$var$getFormEncType(target.getAttribute("formenctype")) || $d210e937315889a3$var$getFormEncType(form.getAttribute("enctype")) || $d210e937315889a3$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d210e937315889a3$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d210e937315889a3$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d210e937315889a3$var$defaultMethod;
        action = null;
        encType = $d210e937315889a3$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d210e937315889a3$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $d210e937315889a3$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $d210e937315889a3$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $d210e937315889a3$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $d210e937315889a3$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $d210e937315889a3$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a380c983429df55f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d210e937315889a3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a380c983429df55f$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d210e937315889a3$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $545ec7bc5bb917bf$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d210e937315889a3$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a380c983429df55f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d210e937315889a3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a380c983429df55f$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d210e937315889a3$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $545ec7bc5bb917bf$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d210e937315889a3$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d210e937315889a3$var$_extends({}, state, {
        errors: $d210e937315889a3$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d210e937315889a3$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a380c983429df55f$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d210e937315889a3$export$7ad602f0e94e62d1 = /*#__PURE__*/ $jzmb2.createContext({
    isTransitioning: false
});
const $d210e937315889a3$export$148fd98d095596d4 = /*#__PURE__*/ $jzmb2.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d210e937315889a3$var$START_TRANSITION = "startTransition";
const $d210e937315889a3$var$startTransitionImpl = $jzmb2[$d210e937315889a3$var$START_TRANSITION];
const $d210e937315889a3$var$FLUSH_SYNC = "flushSync";
const $d210e937315889a3$var$flushSyncImpl = $59b566e1f881b9b6$exports[$d210e937315889a3$var$FLUSH_SYNC];
const $d210e937315889a3$var$USE_ID = "useId";
const $d210e937315889a3$var$useIdImpl = $jzmb2[$d210e937315889a3$var$USE_ID];
function $d210e937315889a3$var$startTransitionSafe(cb) {
    if ($d210e937315889a3$var$startTransitionImpl) $d210e937315889a3$var$startTransitionImpl(cb);
    else cb();
}
function $d210e937315889a3$var$flushSyncSafe(cb) {
    if ($d210e937315889a3$var$flushSyncImpl) $d210e937315889a3$var$flushSyncImpl(cb);
    else cb();
}
class $d210e937315889a3$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d210e937315889a3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jzmb2.useState(router.state);
    let [pendingState, setPendingState] = $jzmb2.useState();
    let [vtContext, setVtContext] = $jzmb2.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jzmb2.useState();
    let [transition, setTransition] = $jzmb2.useState();
    let [interruption, setInterruption] = $jzmb2.useState();
    let fetcherData = $jzmb2.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $jzmb2.useCallback((cb)=>{
        if (v7_startTransition) $d210e937315889a3$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $jzmb2.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d210e937315889a3$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d210e937315889a3$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d210e937315889a3$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d210e937315889a3$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d210e937315889a3$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jzmb2.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $jzmb2.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d210e937315889a3$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $jzmb2.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $jzmb2.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $jzmb2.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $jzmb2.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jzmb2.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jzmb2.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jzmb2.createElement($jzmb2.Fragment, null, /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $jzmb2.createElement($d210e937315889a3$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $jzmb2.createElement($d210e937315889a3$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jzmb2.createElement($d210e937315889a3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $d210e937315889a3$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $545ec7bc5bb917bf$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d210e937315889a3$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $jzmb2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a380c983429df55f$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jzmb2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jzmb2.useCallback((newState)=>{
        v7_startTransition && $d210e937315889a3$var$startTransitionImpl ? $d210e937315889a3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jzmb2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d210e937315889a3$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $jzmb2.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a380c983429df55f$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jzmb2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jzmb2.useCallback((newState)=>{
        v7_startTransition && $d210e937315889a3$var$startTransitionImpl ? $d210e937315889a3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jzmb2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d210e937315889a3$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $jzmb2.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jzmb2.useCallback((newState)=>{
        v7_startTransition && $d210e937315889a3$var$startTransitionImpl ? $d210e937315889a3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jzmb2.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jzmb2.createElement((0, $545ec7bc5bb917bf$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d210e937315889a3$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d210e937315889a3$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d210e937315889a3$export$a6c7ac8248d6e38a = /*#__PURE__*/ $jzmb2.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $d210e937315889a3$var$_objectWithoutPropertiesLoose(_ref7, $d210e937315889a3$var$_excluded);
    let { basename: basename } = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d210e937315889a3$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d210e937315889a3$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a380c983429df55f$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $545ec7bc5bb917bf$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $d210e937315889a3$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $jzmb2.createElement("a", $d210e937315889a3$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d210e937315889a3$export$b0d92dbee9b5b60d = /*#__PURE__*/ $jzmb2.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $d210e937315889a3$var$_objectWithoutPropertiesLoose(_ref8, $d210e937315889a3$var$_excluded2);
    let path = (0, $545ec7bc5bb917bf$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)();
    let routerState = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d210e937315889a3$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a380c983429df55f$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $jzmb2.createElement($d210e937315889a3$export$a6c7ac8248d6e38a, $d210e937315889a3$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d210e937315889a3$export$a7fed597f4b8afd8 = /*#__PURE__*/ $jzmb2.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d210e937315889a3$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $d210e937315889a3$var$_objectWithoutPropertiesLoose(_ref9, $d210e937315889a3$var$_excluded3);
    let submit = $d210e937315889a3$export$47c85c6e3a081d3();
    let formAction = $d210e937315889a3$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $jzmb2.createElement("form", $d210e937315889a3$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d210e937315889a3$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $d210e937315889a3$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d210e937315889a3$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d210e937315889a3$var$DataRouterHook || ($d210e937315889a3$var$DataRouterHook = {}));
var $d210e937315889a3$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d210e937315889a3$var$DataRouterStateHook || ($d210e937315889a3$var$DataRouterStateHook = {}));
// Internal hooks
function $d210e937315889a3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d210e937315889a3$var$useDataRouterContext(hookName) {
    let ctx = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$3add0d5dce533e2e));
    !ctx && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d210e937315889a3$var$useDataRouterState(hookName) {
    let state = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$145dfa71566a64dc));
    !state && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d210e937315889a3$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $545ec7bc5bb917bf$export$9770f232ac06a008)();
    let location = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)();
    let path = (0, $545ec7bc5bb917bf$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $jzmb2.useCallback((event)=>{
        if ($d210e937315889a3$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a380c983429df55f$export$fe53371bee54353d)(location) === (0, $a380c983429df55f$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d210e937315889a3$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $jzmb2.useRef($d210e937315889a3$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jzmb2.useRef(false);
    let location = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)();
    let searchParams = $jzmb2.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d210e937315889a3$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $545ec7bc5bb917bf$export$9770f232ac06a008)();
    let setSearchParams = $jzmb2.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d210e937315889a3$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d210e937315889a3$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d210e937315889a3$var$fetcherId = 0;
let $d210e937315889a3$var$getUniqueFetcherId = ()=>"__" + String(++$d210e937315889a3$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d210e937315889a3$export$47c85c6e3a081d3() {
    let { router: router } = $d210e937315889a3$var$useDataRouterContext($d210e937315889a3$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$26749e8557646306));
    let currentRouteId = (0, $545ec7bc5bb917bf$export$5fc8298006ad9e58)();
    return $jzmb2.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d210e937315889a3$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d210e937315889a3$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d210e937315889a3$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d210e937315889a3$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$26749e8557646306));
    let routeContext = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$9072aa6dd1f93057));
    !routeContext && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d210e937315889a3$var$_extends({}, (0, $545ec7bc5bb917bf$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a380c983429df55f$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a380c983429df55f$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d210e937315889a3$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d210e937315889a3$var$useDataRouterContext($d210e937315889a3$var$DataRouterHook.UseFetcher);
    let state = $d210e937315889a3$var$useDataRouterState($d210e937315889a3$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $jzmb2.useContext($d210e937315889a3$export$148fd98d095596d4);
    let route = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    !route && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d210e937315889a3$var$useIdImpl ? $d210e937315889a3$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $jzmb2.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d210e937315889a3$var$getUniqueFetcherId());
    // Registration/cleanup
    $jzmb2.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $jzmb2.useCallback((href, opts)=>{
        !routeId && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d210e937315889a3$export$47c85c6e3a081d3();
    let submit = $jzmb2.useCallback((target, opts)=>{
        submitImpl(target, $d210e937315889a3$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $jzmb2.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $jzmb2.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $jzmb2.createElement($d210e937315889a3$export$a7fed597f4b8afd8, $d210e937315889a3$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a380c983429df55f$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $jzmb2.useMemo(()=>$d210e937315889a3$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d210e937315889a3$export$fa996778a3a31087() {
    let state = $d210e937315889a3$var$useDataRouterState($d210e937315889a3$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $d210e937315889a3$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d210e937315889a3$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d210e937315889a3$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d210e937315889a3$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d210e937315889a3$var$useDataRouterContext($d210e937315889a3$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d210e937315889a3$var$useDataRouterState($d210e937315889a3$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $jzmb2.useContext((0, $545ec7bc5bb917bf$export$26749e8557646306));
    let location = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)();
    let matches = (0, $545ec7bc5bb917bf$export$2378eb7f5ff86053)();
    let navigation = (0, $545ec7bc5bb917bf$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $jzmb2.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d210e937315889a3$var$usePageHide($jzmb2.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d210e937315889a3$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d210e937315889a3$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d210e937315889a3$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jzmb2.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d210e937315889a3$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d210e937315889a3$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jzmb2.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d210e937315889a3$var$_extends({}, location, {
                    pathname: (0, $a380c983429df55f$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d210e937315889a3$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jzmb2.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d210e937315889a3$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jzmb2.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d210e937315889a3$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jzmb2.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d210e937315889a3$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $545ec7bc5bb917bf$export$b273b3273281a049)(when);
    $jzmb2.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jzmb2.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d210e937315889a3$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $jzmb2.useContext($d210e937315889a3$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a380c983429df55f$export$3e9cee6b33872309)(false);
    let { basename: basename } = $d210e937315889a3$var$useDataRouterContext($d210e937315889a3$var$DataRouterHook.useViewTransitionState);
    let path = (0, $545ec7bc5bb917bf$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a380c983429df55f$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a380c983429df55f$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a380c983429df55f$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a380c983429df55f$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $jzmb2 = parcelRequire("jzmb2");
const $c41a90b8b24590b3$var$useOnlineStatus = ()=>{
    const [status, setStatus] = (0, $jzmb2.useState)(true);
    (0, $jzmb2.useEffect)(()=>{
        window.addEventListener("online", ()=>{
            setStatus(true);
        });
        window.addEventListener("offline", ()=>{
            setStatus(false);
        });
    }, []);
    return status;
};
var $c41a90b8b24590b3$export$2e2bcd8739ae039 = $c41a90b8b24590b3$var$useOnlineStatus;



var $jzmb2 = parcelRequire("jzmb2");
const $ff6d97cdc0613e88$var$UserContext = /*#__PURE__*/ (0, $jzmb2.createContext)({
    myName: "Default"
});
var $ff6d97cdc0613e88$export$2e2bcd8739ae039 = $ff6d97cdc0613e88$var$UserContext;



var $jzmb2 = parcelRequire("jzmb2");
var $54fcf6ca529f9554$exports = {};
"use strict";

$54fcf6ca529f9554$exports = (parcelRequire("JZlia"));


var $13a78b650353eebe$var$__defProp = Object.defineProperty;
var $13a78b650353eebe$var$__defProps = Object.defineProperties;
var $13a78b650353eebe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $13a78b650353eebe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $13a78b650353eebe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $13a78b650353eebe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $13a78b650353eebe$var$__defNormalProp = (obj, key, value)=>key in obj ? $13a78b650353eebe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $13a78b650353eebe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($13a78b650353eebe$var$__hasOwnProp.call(b, prop)) $13a78b650353eebe$var$__defNormalProp(a, prop, b[prop]);
    if ($13a78b650353eebe$var$__getOwnPropSymbols) {
        for (var prop of $13a78b650353eebe$var$__getOwnPropSymbols(b))if ($13a78b650353eebe$var$__propIsEnum.call(b, prop)) $13a78b650353eebe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $13a78b650353eebe$var$__spreadProps = (a, b)=>$13a78b650353eebe$var$__defProps(a, $13a78b650353eebe$var$__getOwnPropDescs(b));
var $13a78b650353eebe$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($13a78b650353eebe$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $13a78b650353eebe$var$__getOwnPropSymbols) {
        for (var prop of $13a78b650353eebe$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $13a78b650353eebe$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $13a78b650353eebe$var$React = // prettier-ignore
// @ts-ignore
"default" in $jzmb2 ? $jzmb2["default"] : $jzmb2;
// src/components/Context.ts
var $13a78b650353eebe$var$ContextKey = Symbol.for(`react-redux-context`);
var $13a78b650353eebe$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $13a78b650353eebe$var$getContext() {
    var _a;
    if (!$13a78b650353eebe$var$React.createContext) return {};
    const contextMap = (_a = $13a78b650353eebe$var$gT[$13a78b650353eebe$var$ContextKey]) != null ? _a : $13a78b650353eebe$var$gT[$13a78b650353eebe$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($13a78b650353eebe$var$React.createContext);
    if (!realContext) {
        realContext = $13a78b650353eebe$var$React.createContext(null);
        contextMap.set($13a78b650353eebe$var$React.createContext, realContext);
    }
    return realContext;
}
var $13a78b650353eebe$export$cc80c08dc91f1c00 = /* @__PURE__ */ $13a78b650353eebe$var$getContext();
// src/utils/useSyncExternalStore.ts
var $13a78b650353eebe$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $13a78b650353eebe$var$createReduxContextHook(context = $13a78b650353eebe$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $13a78b650353eebe$var$React.useContext(context);
        return contextValue;
    };
}
var $13a78b650353eebe$var$useReduxContext = /* @__PURE__ */ $13a78b650353eebe$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $13a78b650353eebe$var$useSyncExternalStoreWithSelector = $13a78b650353eebe$var$notInitialized;
var $13a78b650353eebe$var$initializeUseSelector = (fn)=>{
    $13a78b650353eebe$var$useSyncExternalStoreWithSelector = fn;
};
var $13a78b650353eebe$var$refEquality = (a, b)=>a === b;
function $13a78b650353eebe$export$2b53f90d2bd1cbfb(context = $13a78b650353eebe$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $13a78b650353eebe$export$cc80c08dc91f1c00 ? $13a78b650353eebe$var$useReduxContext : $13a78b650353eebe$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $13a78b650353eebe$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $13a78b650353eebe$var$React.useRef(true);
        const wrappedSelector = $13a78b650353eebe$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $13a78b650353eebe$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $13a78b650353eebe$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $13a78b650353eebe$export$2105062e25df4afe = /* @__PURE__ */ $13a78b650353eebe$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $13a78b650353eebe$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $13a78b650353eebe$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $13a78b650353eebe$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $13a78b650353eebe$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $13a78b650353eebe$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $13a78b650353eebe$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $13a78b650353eebe$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $13a78b650353eebe$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $13a78b650353eebe$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $13a78b650353eebe$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $13a78b650353eebe$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $13a78b650353eebe$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $13a78b650353eebe$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $13a78b650353eebe$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $13a78b650353eebe$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $13a78b650353eebe$var$ForwardRef = $13a78b650353eebe$var$REACT_FORWARD_REF_TYPE;
var $13a78b650353eebe$var$Memo = $13a78b650353eebe$var$REACT_MEMO_TYPE;
function $13a78b650353eebe$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $13a78b650353eebe$var$REACT_FRAGMENT_TYPE || type === $13a78b650353eebe$var$REACT_PROFILER_TYPE || type === $13a78b650353eebe$var$REACT_STRICT_MODE_TYPE || type === $13a78b650353eebe$var$REACT_SUSPENSE_TYPE || type === $13a78b650353eebe$var$REACT_SUSPENSE_LIST_TYPE || type === $13a78b650353eebe$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $13a78b650353eebe$var$REACT_LAZY_TYPE || type.$$typeof === $13a78b650353eebe$var$REACT_MEMO_TYPE || type.$$typeof === $13a78b650353eebe$var$REACT_PROVIDER_TYPE || type.$$typeof === $13a78b650353eebe$var$REACT_CONTEXT_TYPE || type.$$typeof === $13a78b650353eebe$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $13a78b650353eebe$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $13a78b650353eebe$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $13a78b650353eebe$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $13a78b650353eebe$var$REACT_FRAGMENT_TYPE:
                        case $13a78b650353eebe$var$REACT_PROFILER_TYPE:
                        case $13a78b650353eebe$var$REACT_STRICT_MODE_TYPE:
                        case $13a78b650353eebe$var$REACT_SUSPENSE_TYPE:
                        case $13a78b650353eebe$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $13a78b650353eebe$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $13a78b650353eebe$var$REACT_CONTEXT_TYPE:
                                    case $13a78b650353eebe$var$REACT_FORWARD_REF_TYPE:
                                    case $13a78b650353eebe$var$REACT_LAZY_TYPE:
                                    case $13a78b650353eebe$var$REACT_MEMO_TYPE:
                                    case $13a78b650353eebe$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $13a78b650353eebe$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $13a78b650353eebe$var$isContextConsumer(object) {
    return $13a78b650353eebe$var$typeOf(object) === $13a78b650353eebe$var$REACT_CONTEXT_TYPE;
}
function $13a78b650353eebe$var$isMemo(object) {
    return $13a78b650353eebe$var$typeOf(object) === $13a78b650353eebe$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $13a78b650353eebe$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $13a78b650353eebe$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $13a78b650353eebe$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $13a78b650353eebe$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $13a78b650353eebe$var$verify(mapStateToProps, "mapStateToProps");
    $13a78b650353eebe$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $13a78b650353eebe$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $13a78b650353eebe$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $13a78b650353eebe$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $13a78b650353eebe$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $13a78b650353eebe$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $13a78b650353eebe$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $13a78b650353eebe$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $13a78b650353eebe$var$verifyPlainObject(value, displayName, methodName) {
    if (!$13a78b650353eebe$var$isPlainObject(value)) $13a78b650353eebe$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $13a78b650353eebe$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $13a78b650353eebe$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $13a78b650353eebe$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $13a78b650353eebe$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $13a78b650353eebe$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $13a78b650353eebe$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $13a78b650353eebe$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $13a78b650353eebe$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $13a78b650353eebe$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $13a78b650353eebe$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $13a78b650353eebe$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $13a78b650353eebe$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $13a78b650353eebe$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $13a78b650353eebe$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $13a78b650353eebe$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $13a78b650353eebe$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $13a78b650353eebe$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $13a78b650353eebe$var$__spreadValues($13a78b650353eebe$var$__spreadValues($13a78b650353eebe$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $13a78b650353eebe$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $13a78b650353eebe$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$13a78b650353eebe$var$defaultMergeProps : typeof mergeProps === "function" ? $13a78b650353eebe$var$wrapMergePropsFunc(mergeProps) : $13a78b650353eebe$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $13a78b650353eebe$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $13a78b650353eebe$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $13a78b650353eebe$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $13a78b650353eebe$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $13a78b650353eebe$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $13a78b650353eebe$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $13a78b650353eebe$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $13a78b650353eebe$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $13a78b650353eebe$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $13a78b650353eebe$var$useIsomorphicLayoutEffect = $13a78b650353eebe$var$canUseDOM ? $13a78b650353eebe$var$React.useLayoutEffect : $13a78b650353eebe$var$React.useEffect;
// src/utils/shallowEqual.ts
function $13a78b650353eebe$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $13a78b650353eebe$export$d36bdfa510afb180(objA, objB) {
    if ($13a78b650353eebe$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$13a78b650353eebe$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $13a78b650353eebe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $13a78b650353eebe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $13a78b650353eebe$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $13a78b650353eebe$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $13a78b650353eebe$var$TYPE_STATICS = {
    [$13a78b650353eebe$var$ForwardRef]: $13a78b650353eebe$var$FORWARD_REF_STATICS,
    [$13a78b650353eebe$var$Memo]: $13a78b650353eebe$var$MEMO_STATICS
};
function $13a78b650353eebe$var$getStatics(component) {
    if ($13a78b650353eebe$var$isMemo(component)) return $13a78b650353eebe$var$MEMO_STATICS;
    return $13a78b650353eebe$var$TYPE_STATICS[component["$$typeof"]] || $13a78b650353eebe$var$REACT_STATICS;
}
var $13a78b650353eebe$var$defineProperty = Object.defineProperty;
var $13a78b650353eebe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $13a78b650353eebe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $13a78b650353eebe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $13a78b650353eebe$var$getPrototypeOf = Object.getPrototypeOf;
var $13a78b650353eebe$var$objectPrototype = Object.prototype;
function $13a78b650353eebe$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($13a78b650353eebe$var$objectPrototype) {
            const inheritedComponent = $13a78b650353eebe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $13a78b650353eebe$var$objectPrototype) $13a78b650353eebe$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $13a78b650353eebe$var$getOwnPropertyNames(sourceComponent);
        if ($13a78b650353eebe$var$getOwnPropertySymbols) keys = keys.concat($13a78b650353eebe$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $13a78b650353eebe$var$getStatics(targetComponent);
        const sourceStatics = $13a78b650353eebe$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$13a78b650353eebe$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $13a78b650353eebe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $13a78b650353eebe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $13a78b650353eebe$var$useSyncExternalStore = $13a78b650353eebe$var$notInitialized;
var $13a78b650353eebe$var$initializeConnect = (fn)=>{
    $13a78b650353eebe$var$useSyncExternalStore = fn;
};
var $13a78b650353eebe$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $13a78b650353eebe$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $13a78b650353eebe$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $13a78b650353eebe$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $13a78b650353eebe$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $13a78b650353eebe$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $13a78b650353eebe$var$strictEqual(a, b) {
    return a === b;
}
var $13a78b650353eebe$var$hasWarnedAboutDeprecatedPureOption = false;
function $13a78b650353eebe$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $13a78b650353eebe$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $13a78b650353eebe$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $13a78b650353eebe$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $13a78b650353eebe$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $13a78b650353eebe$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $13a78b650353eebe$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $13a78b650353eebe$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $13a78b650353eebe$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $13a78b650353eebe$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $13a78b650353eebe$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $13a78b650353eebe$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $13a78b650353eebe$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $13a78b650353eebe$var$React.useMemo(()=>{
                return $13a78b650353eebe$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $13a78b650353eebe$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $13a78b650353eebe$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $13a78b650353eebe$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $13a78b650353eebe$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $13a78b650353eebe$var$__spreadProps($13a78b650353eebe$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $13a78b650353eebe$var$React.useRef();
            const lastWrapperProps = $13a78b650353eebe$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $13a78b650353eebe$var$React.useRef();
            const renderIsScheduled = $13a78b650353eebe$var$React.useRef(false);
            const isProcessingDispatch = $13a78b650353eebe$var$React.useRef(false);
            const isMounted = $13a78b650353eebe$var$React.useRef(false);
            const latestSubscriptionCallbackError = $13a78b650353eebe$var$React.useRef();
            $13a78b650353eebe$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $13a78b650353eebe$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $13a78b650353eebe$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $13a78b650353eebe$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $13a78b650353eebe$var$useIsomorphicLayoutEffectWithArgs($13a78b650353eebe$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $13a78b650353eebe$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $13a78b650353eebe$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $13a78b650353eebe$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $13a78b650353eebe$var$React.createElement(WrappedComponent, $13a78b650353eebe$var$__spreadProps($13a78b650353eebe$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $13a78b650353eebe$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $13a78b650353eebe$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $13a78b650353eebe$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $13a78b650353eebe$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $13a78b650353eebe$var$React.createElement(Connect, $13a78b650353eebe$var$__spreadProps($13a78b650353eebe$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $13a78b650353eebe$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $13a78b650353eebe$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $13a78b650353eebe$export$64605811ab45167f = $13a78b650353eebe$var$connect;
// src/components/Provider.tsx
function $13a78b650353eebe$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $13a78b650353eebe$var$React.useMemo(()=>{
        const subscription = $13a78b650353eebe$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $13a78b650353eebe$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $13a78b650353eebe$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $13a78b650353eebe$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $13a78b650353eebe$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $13a78b650353eebe$export$2881499e37b75b9a = $13a78b650353eebe$var$Provider;
// src/hooks/useStore.ts
function $13a78b650353eebe$export$671dba69185d0304(context = $13a78b650353eebe$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $13a78b650353eebe$export$cc80c08dc91f1c00 ? $13a78b650353eebe$var$useReduxContext : // @ts-ignore
    $13a78b650353eebe$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $13a78b650353eebe$export$6ccbb43953eebf8 = /* @__PURE__ */ $13a78b650353eebe$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $13a78b650353eebe$export$bc9b55530897c558(context = $13a78b650353eebe$export$cc80c08dc91f1c00) {
    const useStore2 = context === $13a78b650353eebe$export$cc80c08dc91f1c00 ? $13a78b650353eebe$export$6ccbb43953eebf8 : $13a78b650353eebe$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $13a78b650353eebe$export$8ad76b76a4c905f8 = /* @__PURE__ */ $13a78b650353eebe$export$bc9b55530897c558();
// src/exports.ts
var $13a78b650353eebe$export$712ea50be43a7858 = $13a78b650353eebe$var$defaultNoopBatch;
// src/index.ts
$13a78b650353eebe$var$initializeUseSelector((0, $54fcf6ca529f9554$exports.useSyncExternalStoreWithSelector));
$13a78b650353eebe$var$initializeConnect($jzmb2.useSyncExternalStore);


// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $820203a4de2e0aab$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $820203a4de2e0aab$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $820203a4de2e0aab$var$symbol_observable_default = $820203a4de2e0aab$var$$$observable;
// src/utils/actionTypes.ts
var $820203a4de2e0aab$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $820203a4de2e0aab$var$ActionTypes = {
    INIT: `@@redux/INIT${$820203a4de2e0aab$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$820203a4de2e0aab$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$820203a4de2e0aab$var$randomString()}`
};
var $820203a4de2e0aab$export$4219e499db7ca678 = $820203a4de2e0aab$var$ActionTypes;
// src/utils/isPlainObject.ts
function $820203a4de2e0aab$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $820203a4de2e0aab$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($820203a4de2e0aab$var$isDate(val)) return "date";
    if ($820203a4de2e0aab$var$isError(val)) return "error";
    const constructorName = $820203a4de2e0aab$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $820203a4de2e0aab$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $820203a4de2e0aab$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $820203a4de2e0aab$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $820203a4de2e0aab$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $820203a4de2e0aab$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(1));
        return enhancer($820203a4de2e0aab$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$820203a4de2e0aab$export$53b83ca8eaab0383(action)) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $820203a4de2e0aab$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$820203a4de2e0aab$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $820203a4de2e0aab$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$820203a4de2e0aab$var$symbol_observable_default]: observable
    };
    return store;
}
function $820203a4de2e0aab$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $820203a4de2e0aab$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $820203a4de2e0aab$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $820203a4de2e0aab$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $820203a4de2e0aab$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$820203a4de2e0aab$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$820203a4de2e0aab$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $820203a4de2e0aab$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $820203a4de2e0aab$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $820203a4de2e0aab$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $820203a4de2e0aab$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(13));
    });
}
function $820203a4de2e0aab$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $820203a4de2e0aab$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $820203a4de2e0aab$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $820203a4de2e0aab$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $820203a4de2e0aab$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $820203a4de2e0aab$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $820203a4de2e0aab$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $820203a4de2e0aab$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($820203a4de2e0aab$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $820203a4de2e0aab$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $820203a4de2e0aab$export$b956e38827fca970(action) {
    return $820203a4de2e0aab$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $f0300f660fb65742$var$__defProp = Object.defineProperty;
var $f0300f660fb65742$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f0300f660fb65742$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f0300f660fb65742$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f0300f660fb65742$var$__defNormalProp = (obj, key, value)=>key in obj ? $f0300f660fb65742$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f0300f660fb65742$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f0300f660fb65742$var$__hasOwnProp.call(b, prop)) $f0300f660fb65742$var$__defNormalProp(a, prop, b[prop]);
    if ($f0300f660fb65742$var$__getOwnPropSymbols) {
        for (var prop of $f0300f660fb65742$var$__getOwnPropSymbols(b))if ($f0300f660fb65742$var$__propIsEnum.call(b, prop)) $f0300f660fb65742$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $f0300f660fb65742$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $f0300f660fb65742$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $f0300f660fb65742$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $f0300f660fb65742$var$errors = [];
function $f0300f660fb65742$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $f0300f660fb65742$var$getPrototypeOf = Object.getPrototypeOf;
function $f0300f660fb65742$export$541ac630993a4c84(value) {
    return !!value && !!value[$f0300f660fb65742$var$DRAFT_STATE];
}
function $f0300f660fb65742$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $f0300f660fb65742$var$isPlainObject(value) || Array.isArray(value) || !!value[$f0300f660fb65742$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$f0300f660fb65742$export$6ee2082928bcb0ee]) || $f0300f660fb65742$var$isMap(value) || $f0300f660fb65742$var$isSet(value);
}
var $f0300f660fb65742$var$objectCtorString = Object.prototype.constructor.toString();
function $f0300f660fb65742$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $f0300f660fb65742$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $f0300f660fb65742$var$objectCtorString;
}
function $f0300f660fb65742$export$22e8af3f75a010e3(value) {
    if (!$f0300f660fb65742$export$541ac630993a4c84(value)) $f0300f660fb65742$var$die(15, value);
    return value[$f0300f660fb65742$var$DRAFT_STATE].base_;
}
function $f0300f660fb65742$var$each(obj, iter) {
    if ($f0300f660fb65742$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $f0300f660fb65742$var$getArchtype(thing) {
    const state = thing[$f0300f660fb65742$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $f0300f660fb65742$var$isMap(thing) ? 2 /* Map */  : $f0300f660fb65742$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $f0300f660fb65742$var$has(thing, prop) {
    return $f0300f660fb65742$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $f0300f660fb65742$var$get(thing, prop) {
    return $f0300f660fb65742$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $f0300f660fb65742$var$set(thing, propOrOldValue, value) {
    const t = $f0300f660fb65742$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $f0300f660fb65742$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f0300f660fb65742$var$isMap(target) {
    return target instanceof Map;
}
function $f0300f660fb65742$var$isSet(target) {
    return target instanceof Set;
}
function $f0300f660fb65742$var$latest(state) {
    return state.copy_ || state.base_;
}
function $f0300f660fb65742$var$shallowCopy(base, strict) {
    if ($f0300f660fb65742$var$isMap(base)) return new Map(base);
    if ($f0300f660fb65742$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $f0300f660fb65742$var$isPlainObject(base)) {
        if (!$f0300f660fb65742$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $f0300f660fb65742$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$f0300f660fb65742$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($f0300f660fb65742$var$getPrototypeOf(base), descriptors);
}
function $f0300f660fb65742$export$792f3d81ea979f55(obj, deep = false) {
    if ($f0300f660fb65742$var$isFrozen(obj) || $f0300f660fb65742$export$541ac630993a4c84(obj) || !$f0300f660fb65742$export$16e3aed3edb85946(obj)) return obj;
    if ($f0300f660fb65742$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $f0300f660fb65742$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$f0300f660fb65742$export$792f3d81ea979f55(value, true));
    return obj;
}
function $f0300f660fb65742$var$dontMutateFrozenCollections() {
    $f0300f660fb65742$var$die(2);
}
function $f0300f660fb65742$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $f0300f660fb65742$var$plugins = {};
function $f0300f660fb65742$var$getPlugin(pluginKey) {
    const plugin = $f0300f660fb65742$var$plugins[pluginKey];
    if (!plugin) $f0300f660fb65742$var$die(0, pluginKey);
    return plugin;
}
function $f0300f660fb65742$var$loadPlugin(pluginKey, implementation) {
    if (!$f0300f660fb65742$var$plugins[pluginKey]) $f0300f660fb65742$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $f0300f660fb65742$var$currentScope;
function $f0300f660fb65742$var$getCurrentScope() {
    return $f0300f660fb65742$var$currentScope;
}
function $f0300f660fb65742$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $f0300f660fb65742$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $f0300f660fb65742$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $f0300f660fb65742$var$revokeScope(scope) {
    $f0300f660fb65742$var$leaveScope(scope);
    scope.drafts_.forEach($f0300f660fb65742$var$revokeDraft);
    scope.drafts_ = null;
}
function $f0300f660fb65742$var$leaveScope(scope) {
    if (scope === $f0300f660fb65742$var$currentScope) $f0300f660fb65742$var$currentScope = scope.parent_;
}
function $f0300f660fb65742$var$enterScope(immer2) {
    return $f0300f660fb65742$var$currentScope = $f0300f660fb65742$var$createScope($f0300f660fb65742$var$currentScope, immer2);
}
function $f0300f660fb65742$var$revokeDraft(draft) {
    const state = draft[$f0300f660fb65742$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $f0300f660fb65742$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$f0300f660fb65742$var$DRAFT_STATE].modified_) {
            $f0300f660fb65742$var$revokeScope(scope);
            $f0300f660fb65742$var$die(4);
        }
        if ($f0300f660fb65742$export$16e3aed3edb85946(result)) {
            result = $f0300f660fb65742$var$finalize(scope, result);
            if (!scope.parent_) $f0300f660fb65742$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $f0300f660fb65742$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$f0300f660fb65742$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $f0300f660fb65742$var$finalize(scope, baseDraft, []);
    $f0300f660fb65742$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $f0300f660fb65742$export$45b790e32b2810ee ? result : void 0;
}
function $f0300f660fb65742$var$finalize(rootScope, value, path) {
    if ($f0300f660fb65742$var$isFrozen(value)) return value;
    const state = value[$f0300f660fb65742$var$DRAFT_STATE];
    if (!state) {
        $f0300f660fb65742$var$each(value, (key, childValue)=>$f0300f660fb65742$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $f0300f660fb65742$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $f0300f660fb65742$var$each(resultEach, (key, childValue)=>$f0300f660fb65742$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $f0300f660fb65742$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $f0300f660fb65742$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $f0300f660fb65742$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($f0300f660fb65742$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$f0300f660fb65742$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $f0300f660fb65742$var$finalize(rootScope, childValue, path);
        $f0300f660fb65742$var$set(targetObject, prop, res);
        if ($f0300f660fb65742$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($f0300f660fb65742$export$16e3aed3edb85946(childValue) && !$f0300f660fb65742$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $f0300f660fb65742$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $f0300f660fb65742$var$maybeFreeze(rootScope, childValue);
    }
}
function $f0300f660fb65742$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $f0300f660fb65742$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $f0300f660fb65742$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $f0300f660fb65742$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $f0300f660fb65742$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $f0300f660fb65742$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $f0300f660fb65742$var$objectTraps = {
    get (state, prop) {
        if (prop === $f0300f660fb65742$var$DRAFT_STATE) return state;
        const source = $f0300f660fb65742$var$latest(state);
        if (!$f0300f660fb65742$var$has(source, prop)) return $f0300f660fb65742$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$f0300f660fb65742$export$16e3aed3edb85946(value)) return value;
        if (value === $f0300f660fb65742$var$peek(state.base_, prop)) {
            $f0300f660fb65742$var$prepareCopy(state);
            return state.copy_[prop] = $f0300f660fb65742$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $f0300f660fb65742$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($f0300f660fb65742$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $f0300f660fb65742$var$getDescriptorFromProto($f0300f660fb65742$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $f0300f660fb65742$var$peek($f0300f660fb65742$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$f0300f660fb65742$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($f0300f660fb65742$var$is(value, current2) && (value !== void 0 || $f0300f660fb65742$var$has(state.base_, prop))) return true;
            $f0300f660fb65742$var$prepareCopy(state);
            $f0300f660fb65742$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($f0300f660fb65742$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $f0300f660fb65742$var$prepareCopy(state);
            $f0300f660fb65742$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $f0300f660fb65742$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $f0300f660fb65742$var$die(11);
    },
    getPrototypeOf (state) {
        return $f0300f660fb65742$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $f0300f660fb65742$var$die(12);
    }
};
var $f0300f660fb65742$var$arrayTraps = {};
$f0300f660fb65742$var$each($f0300f660fb65742$var$objectTraps, (key, fn)=>{
    $f0300f660fb65742$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$f0300f660fb65742$var$arrayTraps.deleteProperty = function(state, prop) {
    return $f0300f660fb65742$var$arrayTraps.set.call(this, state, prop, void 0);
};
$f0300f660fb65742$var$arrayTraps.set = function(state, prop, value) {
    return $f0300f660fb65742$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $f0300f660fb65742$var$peek(draft, prop) {
    const state = draft[$f0300f660fb65742$var$DRAFT_STATE];
    const source = state ? $f0300f660fb65742$var$latest(state) : draft;
    return source[prop];
}
function $f0300f660fb65742$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $f0300f660fb65742$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $f0300f660fb65742$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $f0300f660fb65742$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $f0300f660fb65742$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $f0300f660fb65742$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $f0300f660fb65742$var$markChanged(state.parent_);
    }
}
function $f0300f660fb65742$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $f0300f660fb65742$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $f0300f660fb65742$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $f0300f660fb65742$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $f0300f660fb65742$var$die(7);
            let result;
            if ($f0300f660fb65742$export$16e3aed3edb85946(base)) {
                const scope = $f0300f660fb65742$var$enterScope(this);
                const proxy = $f0300f660fb65742$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $f0300f660fb65742$var$revokeScope(scope);
                    else $f0300f660fb65742$var$leaveScope(scope);
                }
                $f0300f660fb65742$var$usePatchesInScope(scope, patchListener);
                return $f0300f660fb65742$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $f0300f660fb65742$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $f0300f660fb65742$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $f0300f660fb65742$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $f0300f660fb65742$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$f0300f660fb65742$export$16e3aed3edb85946(base)) $f0300f660fb65742$var$die(8);
        if ($f0300f660fb65742$export$541ac630993a4c84(base)) base = $f0300f660fb65742$export$97aac956da55dae9(base);
        const scope = $f0300f660fb65742$var$enterScope(this);
        const proxy = $f0300f660fb65742$var$createProxy(base, void 0);
        proxy[$f0300f660fb65742$var$DRAFT_STATE].isManual_ = true;
        $f0300f660fb65742$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$f0300f660fb65742$var$DRAFT_STATE];
        if (!state || !state.isManual_) $f0300f660fb65742$var$die(9);
        const { scope_: scope } = state;
        $f0300f660fb65742$var$usePatchesInScope(scope, patchListener);
        return $f0300f660fb65742$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $f0300f660fb65742$var$getPlugin("Patches").applyPatches_;
        if ($f0300f660fb65742$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $f0300f660fb65742$var$createProxy(value, parent) {
    const draft = $f0300f660fb65742$var$isMap(value) ? $f0300f660fb65742$var$getPlugin("MapSet").proxyMap_(value, parent) : $f0300f660fb65742$var$isSet(value) ? $f0300f660fb65742$var$getPlugin("MapSet").proxySet_(value, parent) : $f0300f660fb65742$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $f0300f660fb65742$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $f0300f660fb65742$export$97aac956da55dae9(value) {
    if (!$f0300f660fb65742$export$541ac630993a4c84(value)) $f0300f660fb65742$var$die(10, value);
    return $f0300f660fb65742$var$currentImpl(value);
}
function $f0300f660fb65742$var$currentImpl(value) {
    if (!$f0300f660fb65742$export$16e3aed3edb85946(value) || $f0300f660fb65742$var$isFrozen(value)) return value;
    const state = value[$f0300f660fb65742$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $f0300f660fb65742$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $f0300f660fb65742$var$shallowCopy(value, true);
    $f0300f660fb65742$var$each(copy, (key, childValue)=>{
        $f0300f660fb65742$var$set(copy, key, $f0300f660fb65742$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $f0300f660fb65742$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $f0300f660fb65742$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $f0300f660fb65742$var$get(base_, key);
            const value = $f0300f660fb65742$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $f0300f660fb65742$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $f0300f660fb65742$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $f0300f660fb65742$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $f0300f660fb65742$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $f0300f660fb65742$var$die(errorOffset + 3);
                base = $f0300f660fb65742$var$get(base, p);
                if (typeof base !== "object") $f0300f660fb65742$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $f0300f660fb65742$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $f0300f660fb65742$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $f0300f660fb65742$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$f0300f660fb65742$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($f0300f660fb65742$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($f0300f660fb65742$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($f0300f660fb65742$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($f0300f660fb65742$var$has(obj, $f0300f660fb65742$export$6ee2082928bcb0ee)) cloned[$f0300f660fb65742$export$6ee2082928bcb0ee] = obj[$f0300f660fb65742$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($f0300f660fb65742$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $f0300f660fb65742$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $f0300f660fb65742$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$f0300f660fb65742$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f0300f660fb65742$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $f0300f660fb65742$var$latest(this[$f0300f660fb65742$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $f0300f660fb65742$var$latest(this[$f0300f660fb65742$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$f0300f660fb65742$var$latest(state).has(key) || $f0300f660fb65742$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $f0300f660fb65742$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $f0300f660fb65742$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f0300f660fb65742$var$latest(state).size) {
                prepareMapCopy(state);
                $f0300f660fb65742$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $f0300f660fb65742$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            $f0300f660fb65742$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $f0300f660fb65742$var$latest(state).get(key);
            if (state.finalized_ || !$f0300f660fb65742$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $f0300f660fb65742$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $f0300f660fb65742$var$latest(this[$f0300f660fb65742$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($f0300f660fb65742$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$f0300f660fb65742$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f0300f660fb65742$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $f0300f660fb65742$var$latest(this[$f0300f660fb65742$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $f0300f660fb65742$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $f0300f660fb65742$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f0300f660fb65742$var$latest(state).size) {
                prepareSetCopy(state);
                $f0300f660fb65742$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$f0300f660fb65742$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($f0300f660fb65742$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($f0300f660fb65742$export$16e3aed3edb85946(value)) {
                    const draft = $f0300f660fb65742$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $f0300f660fb65742$var$die(3, JSON.stringify($f0300f660fb65742$var$latest(state)));
    }
    $f0300f660fb65742$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $f0300f660fb65742$var$immer = new $f0300f660fb65742$export$aaadc6ff0f822719();
var $f0300f660fb65742$export$b46cabe22e78bc00 = $f0300f660fb65742$var$immer.produce;
var $f0300f660fb65742$export$4da66d41c9492c78 = $f0300f660fb65742$var$immer.produceWithPatches.bind($f0300f660fb65742$var$immer);
var $f0300f660fb65742$export$573f26f60825c493 = $f0300f660fb65742$var$immer.setAutoFreeze.bind($f0300f660fb65742$var$immer);
var $f0300f660fb65742$export$333ce65961cbe047 = $f0300f660fb65742$var$immer.setUseStrictShallowCopy.bind($f0300f660fb65742$var$immer);
var $f0300f660fb65742$export$a8b8e03e6bbe5473 = $f0300f660fb65742$var$immer.applyPatches.bind($f0300f660fb65742$var$immer);
var $f0300f660fb65742$export$3c3214997190395f = $f0300f660fb65742$var$immer.createDraft.bind($f0300f660fb65742$var$immer);
var $f0300f660fb65742$export$c60f5e69c521b528 = $f0300f660fb65742$var$immer.finishDraft.bind($f0300f660fb65742$var$immer);
function $f0300f660fb65742$export$c05b21e3257751e5(value) {
    return value;
}
function $f0300f660fb65742$export$20f911b3f8cf0b74(value) {
    return value;
}


var $22031c64eaefa6d8$var$__defProp = Object.defineProperty;
var $22031c64eaefa6d8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $22031c64eaefa6d8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $22031c64eaefa6d8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $22031c64eaefa6d8$var$__defNormalProp = (obj, key, value)=>key in obj ? $22031c64eaefa6d8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $22031c64eaefa6d8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($22031c64eaefa6d8$var$__hasOwnProp.call(b, prop)) $22031c64eaefa6d8$var$__defNormalProp(a, prop, b[prop]);
    if ($22031c64eaefa6d8$var$__getOwnPropSymbols) {
        for (var prop of $22031c64eaefa6d8$var$__getOwnPropSymbols(b))if ($22031c64eaefa6d8$var$__propIsEnum.call(b, prop)) $22031c64eaefa6d8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $22031c64eaefa6d8$var$__publicField = (obj, key, value)=>{
    $22031c64eaefa6d8$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $22031c64eaefa6d8$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $22031c64eaefa6d8$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $22031c64eaefa6d8$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $22031c64eaefa6d8$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($22031c64eaefa6d8$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $22031c64eaefa6d8$var$NOT_FOUND = "NOT_FOUND";
function $22031c64eaefa6d8$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $22031c64eaefa6d8$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $22031c64eaefa6d8$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $22031c64eaefa6d8$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $22031c64eaefa6d8$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $22031c64eaefa6d8$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $22031c64eaefa6d8$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $22031c64eaefa6d8$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $22031c64eaefa6d8$var$__spreadValues($22031c64eaefa6d8$var$__spreadValues({}, $22031c64eaefa6d8$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $22031c64eaefa6d8$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $22031c64eaefa6d8$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $22031c64eaefa6d8$var$$REVISION = 0;
var $22031c64eaefa6d8$var$CURRENT_TRACKER = null;
var $22031c64eaefa6d8$var$Cell = class {
    constructor(initialValue, isEqual = $22031c64eaefa6d8$var$tripleEq){
        $22031c64eaefa6d8$var$__publicField(this, "revision", $22031c64eaefa6d8$var$$REVISION);
        $22031c64eaefa6d8$var$__publicField(this, "_value");
        $22031c64eaefa6d8$var$__publicField(this, "_lastValue");
        $22031c64eaefa6d8$var$__publicField(this, "_isEqual", $22031c64eaefa6d8$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $22031c64eaefa6d8$var$CURRENT_TRACKER == null || $22031c64eaefa6d8$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$22031c64eaefa6d8$var$$REVISION;
    }
};
function $22031c64eaefa6d8$var$tripleEq(a, b) {
    return a === b;
}
var $22031c64eaefa6d8$var$TrackingCache = class {
    constructor(fn){
        $22031c64eaefa6d8$var$__publicField(this, "_cachedValue");
        $22031c64eaefa6d8$var$__publicField(this, "_cachedRevision", -1);
        $22031c64eaefa6d8$var$__publicField(this, "_deps", []);
        $22031c64eaefa6d8$var$__publicField(this, "hits", 0);
        $22031c64eaefa6d8$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $22031c64eaefa6d8$var$CURRENT_TRACKER;
            $22031c64eaefa6d8$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $22031c64eaefa6d8$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $22031c64eaefa6d8$var$CURRENT_TRACKER == null || $22031c64eaefa6d8$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $22031c64eaefa6d8$var$getValue(cell) {
    if (!(cell instanceof $22031c64eaefa6d8$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $22031c64eaefa6d8$var$setValue(storage, value) {
    if (!(storage instanceof $22031c64eaefa6d8$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $22031c64eaefa6d8$var$createCell(initialValue, isEqual = $22031c64eaefa6d8$var$tripleEq) {
    return new $22031c64eaefa6d8$var$Cell(initialValue, isEqual);
}
function $22031c64eaefa6d8$var$createCache(fn) {
    $22031c64eaefa6d8$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $22031c64eaefa6d8$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $22031c64eaefa6d8$var$neverEq = (a, b)=>false;
function $22031c64eaefa6d8$var$createTag() {
    return $22031c64eaefa6d8$var$createCell(null, $22031c64eaefa6d8$var$neverEq);
}
function $22031c64eaefa6d8$var$dirtyTag(tag, value) {
    $22031c64eaefa6d8$var$setValue(tag, value);
}
var $22031c64eaefa6d8$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $22031c64eaefa6d8$var$createTag();
    $22031c64eaefa6d8$var$getValue(tag);
};
var $22031c64eaefa6d8$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $22031c64eaefa6d8$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $22031c64eaefa6d8$var$REDUX_PROXY_LABEL = Symbol();
var $22031c64eaefa6d8$var$nextId = 0;
var $22031c64eaefa6d8$var$proto = Object.getPrototypeOf({});
var $22031c64eaefa6d8$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $22031c64eaefa6d8$var$__publicField(this, "proxy", new Proxy(this, $22031c64eaefa6d8$var$objectProxyHandler));
        $22031c64eaefa6d8$var$__publicField(this, "tag", $22031c64eaefa6d8$var$createTag());
        $22031c64eaefa6d8$var$__publicField(this, "tags", {});
        $22031c64eaefa6d8$var$__publicField(this, "children", {});
        $22031c64eaefa6d8$var$__publicField(this, "collectionTag", null);
        $22031c64eaefa6d8$var$__publicField(this, "id", $22031c64eaefa6d8$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $22031c64eaefa6d8$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $22031c64eaefa6d8$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $22031c64eaefa6d8$var$createNode(childValue);
                if (childNode.tag) $22031c64eaefa6d8$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $22031c64eaefa6d8$var$createTag();
                    tag.value = childValue;
                }
                $22031c64eaefa6d8$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $22031c64eaefa6d8$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $22031c64eaefa6d8$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $22031c64eaefa6d8$var$__publicField(this, "proxy", new Proxy([
            this
        ], $22031c64eaefa6d8$var$arrayProxyHandler));
        $22031c64eaefa6d8$var$__publicField(this, "tag", $22031c64eaefa6d8$var$createTag());
        $22031c64eaefa6d8$var$__publicField(this, "tags", {});
        $22031c64eaefa6d8$var$__publicField(this, "children", {});
        $22031c64eaefa6d8$var$__publicField(this, "collectionTag", null);
        $22031c64eaefa6d8$var$__publicField(this, "id", $22031c64eaefa6d8$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $22031c64eaefa6d8$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $22031c64eaefa6d8$var$consumeCollection(node);
        return $22031c64eaefa6d8$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $22031c64eaefa6d8$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $22031c64eaefa6d8$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $22031c64eaefa6d8$var$objectProxyHandler.has(node, prop);
    }
};
function $22031c64eaefa6d8$var$createNode(value) {
    if (Array.isArray(value)) return new $22031c64eaefa6d8$var$ArrayTreeNode(value);
    return new $22031c64eaefa6d8$var$ObjectTreeNode(value);
}
function $22031c64eaefa6d8$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $22031c64eaefa6d8$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $22031c64eaefa6d8$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $22031c64eaefa6d8$var$dirtyCollection(node);
            $22031c64eaefa6d8$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $22031c64eaefa6d8$var$updateNode(childNode, newChildValue);
        else {
            $22031c64eaefa6d8$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $22031c64eaefa6d8$var$deleteNode(node) {
    if (node.tag) $22031c64eaefa6d8$var$dirtyTag(node.tag, null);
    $22031c64eaefa6d8$var$dirtyCollection(node);
    for(const key in node.tags)$22031c64eaefa6d8$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$22031c64eaefa6d8$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $22031c64eaefa6d8$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $22031c64eaefa6d8$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $22031c64eaefa6d8$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $22031c64eaefa6d8$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $22031c64eaefa6d8$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $22031c64eaefa6d8$export$3f025202a230c6dd = (a, b)=>a === b;
function $22031c64eaefa6d8$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $22031c64eaefa6d8$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $22031c64eaefa6d8$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $22031c64eaefa6d8$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $22031c64eaefa6d8$var$createSingletonCache(comparator) : $22031c64eaefa6d8$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $22031c64eaefa6d8$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $22031c64eaefa6d8$export$c8f9cf88d9fdee55(func) {
    const node = $22031c64eaefa6d8$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $22031c64eaefa6d8$var$createCacheKeyComparator($22031c64eaefa6d8$export$3f025202a230c6dd);
    const cache = $22031c64eaefa6d8$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $22031c64eaefa6d8$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $22031c64eaefa6d8$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $22031c64eaefa6d8$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $22031c64eaefa6d8$var$StrongRef;
var $22031c64eaefa6d8$var$UNTERMINATED = 0;
var $22031c64eaefa6d8$var$TERMINATED = 1;
function $22031c64eaefa6d8$var$createCacheNode() {
    return {
        s: $22031c64eaefa6d8$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $22031c64eaefa6d8$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $22031c64eaefa6d8$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $22031c64eaefa6d8$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $22031c64eaefa6d8$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $22031c64eaefa6d8$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $22031c64eaefa6d8$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $22031c64eaefa6d8$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $22031c64eaefa6d8$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $22031c64eaefa6d8$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $22031c64eaefa6d8$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $22031c64eaefa6d8$var$__spreadValues($22031c64eaefa6d8$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $22031c64eaefa6d8$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $22031c64eaefa6d8$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $22031c64eaefa6d8$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $22031c64eaefa6d8$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $22031c64eaefa6d8$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $22031c64eaefa6d8$export$595d22ed68ca2841 = /* @__PURE__ */ $22031c64eaefa6d8$export$5943f4447f6ef248($22031c64eaefa6d8$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $22031c64eaefa6d8$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $22031c64eaefa6d8$export$595d22ed68ca2841)=>{
    $22031c64eaefa6d8$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$22031c64eaefa6d8$export$75979cfcd91bf38f
});


// src/index.ts
function $001998338996f6f4$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $001998338996f6f4$export$dd164f5517779f15 = $001998338996f6f4$var$createThunkMiddleware();
var $001998338996f6f4$export$16d06542a1949d9e = $001998338996f6f4$var$createThunkMiddleware;


var $57927d29a90ead81$exports = {};
// shim for using process in browser
var $57927d29a90ead81$var$process = $57927d29a90ead81$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $57927d29a90ead81$var$cachedSetTimeout;
var $57927d29a90ead81$var$cachedClearTimeout;
function $57927d29a90ead81$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $57927d29a90ead81$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $57927d29a90ead81$var$cachedSetTimeout = setTimeout;
        else $57927d29a90ead81$var$cachedSetTimeout = $57927d29a90ead81$var$defaultSetTimout;
    } catch (e) {
        $57927d29a90ead81$var$cachedSetTimeout = $57927d29a90ead81$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $57927d29a90ead81$var$cachedClearTimeout = clearTimeout;
        else $57927d29a90ead81$var$cachedClearTimeout = $57927d29a90ead81$var$defaultClearTimeout;
    } catch (e) {
        $57927d29a90ead81$var$cachedClearTimeout = $57927d29a90ead81$var$defaultClearTimeout;
    }
})();
function $57927d29a90ead81$var$runTimeout(fun) {
    if ($57927d29a90ead81$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($57927d29a90ead81$var$cachedSetTimeout === $57927d29a90ead81$var$defaultSetTimout || !$57927d29a90ead81$var$cachedSetTimeout) && setTimeout) {
        $57927d29a90ead81$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $57927d29a90ead81$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $57927d29a90ead81$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $57927d29a90ead81$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $57927d29a90ead81$var$runClearTimeout(marker) {
    if ($57927d29a90ead81$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($57927d29a90ead81$var$cachedClearTimeout === $57927d29a90ead81$var$defaultClearTimeout || !$57927d29a90ead81$var$cachedClearTimeout) && clearTimeout) {
        $57927d29a90ead81$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $57927d29a90ead81$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $57927d29a90ead81$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $57927d29a90ead81$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $57927d29a90ead81$var$queue = [];
var $57927d29a90ead81$var$draining = false;
var $57927d29a90ead81$var$currentQueue;
var $57927d29a90ead81$var$queueIndex = -1;
function $57927d29a90ead81$var$cleanUpNextTick() {
    if (!$57927d29a90ead81$var$draining || !$57927d29a90ead81$var$currentQueue) return;
    $57927d29a90ead81$var$draining = false;
    if ($57927d29a90ead81$var$currentQueue.length) $57927d29a90ead81$var$queue = $57927d29a90ead81$var$currentQueue.concat($57927d29a90ead81$var$queue);
    else $57927d29a90ead81$var$queueIndex = -1;
    if ($57927d29a90ead81$var$queue.length) $57927d29a90ead81$var$drainQueue();
}
function $57927d29a90ead81$var$drainQueue() {
    if ($57927d29a90ead81$var$draining) return;
    var timeout = $57927d29a90ead81$var$runTimeout($57927d29a90ead81$var$cleanUpNextTick);
    $57927d29a90ead81$var$draining = true;
    var len = $57927d29a90ead81$var$queue.length;
    while(len){
        $57927d29a90ead81$var$currentQueue = $57927d29a90ead81$var$queue;
        $57927d29a90ead81$var$queue = [];
        while(++$57927d29a90ead81$var$queueIndex < len)if ($57927d29a90ead81$var$currentQueue) $57927d29a90ead81$var$currentQueue[$57927d29a90ead81$var$queueIndex].run();
        $57927d29a90ead81$var$queueIndex = -1;
        len = $57927d29a90ead81$var$queue.length;
    }
    $57927d29a90ead81$var$currentQueue = null;
    $57927d29a90ead81$var$draining = false;
    $57927d29a90ead81$var$runClearTimeout(timeout);
}
$57927d29a90ead81$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $57927d29a90ead81$var$queue.push(new $57927d29a90ead81$var$Item(fun, args));
    if ($57927d29a90ead81$var$queue.length === 1 && !$57927d29a90ead81$var$draining) $57927d29a90ead81$var$runTimeout($57927d29a90ead81$var$drainQueue);
};
// v8 likes predictible objects
function $57927d29a90ead81$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$57927d29a90ead81$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$57927d29a90ead81$var$process.title = "browser";
$57927d29a90ead81$var$process.browser = true;
$57927d29a90ead81$var$process.env = {};
$57927d29a90ead81$var$process.argv = [];
$57927d29a90ead81$var$process.version = ""; // empty string to avoid regexp issues
$57927d29a90ead81$var$process.versions = {};
function $57927d29a90ead81$var$noop() {}
$57927d29a90ead81$var$process.on = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.addListener = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.once = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.off = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.removeListener = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.removeAllListeners = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.emit = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.prependListener = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.prependOnceListener = $57927d29a90ead81$var$noop;
$57927d29a90ead81$var$process.listeners = function(name) {
    return [];
};
$57927d29a90ead81$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$57927d29a90ead81$var$process.cwd = function() {
    return "/";
};
$57927d29a90ead81$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$57927d29a90ead81$var$process.umask = function() {
    return 0;
};


var $b6edb054d04e55c6$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $22031c64eaefa6d8$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $f0300f660fb65742$export$541ac630993a4c84)(value) ? (0, $f0300f660fb65742$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $b6edb054d04e55c6$export$a5d3c27355e35910 = $b6edb054d04e55c6$export$aab6de9e3dbb1473((0, $22031c64eaefa6d8$export$8402dc26d96f6902));
var $b6edb054d04e55c6$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $820203a4de2e0aab$export$f672e0b6f7222cd7;
    return (0, $820203a4de2e0aab$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $b6edb054d04e55c6$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $b6edb054d04e55c6$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $b6edb054d04e55c6$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $820203a4de2e0aab$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $b6edb054d04e55c6$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $b6edb054d04e55c6$var$hasMatchFunction(action);
}
function $b6edb054d04e55c6$export$ebd532f9034651f3(action) {
    return (0, $820203a4de2e0aab$export$b956e38827fca970)(action) && Object.keys(action).every($b6edb054d04e55c6$var$isValidKey);
}
function $b6edb054d04e55c6$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $b6edb054d04e55c6$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $b6edb054d04e55c6$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $b6edb054d04e55c6$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $b6edb054d04e55c6$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $b6edb054d04e55c6$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $b6edb054d04e55c6$var$freezeDraftable(val) {
    return (0, $f0300f660fb65742$export$16e3aed3edb85946)(val) ? (0, $f0300f660fb65742$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $b6edb054d04e55c6$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $b6edb054d04e55c6$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $b6edb054d04e55c6$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $b6edb054d04e55c6$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $b6edb054d04e55c6$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $b6edb054d04e55c6$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $b6edb054d04e55c6$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $b6edb054d04e55c6$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $b6edb054d04e55c6$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $b6edb054d04e55c6$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $b6edb054d04e55c6$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $820203a4de2e0aab$export$53b83ca8eaab0383)(val);
}
function $b6edb054d04e55c6$export$ada5dca0b571bc7(value, path = "", isSerializable = $b6edb054d04e55c6$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $b6edb054d04e55c6$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $b6edb054d04e55c6$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $b6edb054d04e55c6$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$b6edb054d04e55c6$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $b6edb054d04e55c6$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $b6edb054d04e55c6$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $b6edb054d04e55c6$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $b6edb054d04e55c6$export$1908877435b1d5e9();
        if (thunk) {
            if ($b6edb054d04e55c6$var$isBoolean(thunk)) middlewareArray.push((0, $001998338996f6f4$export$dd164f5517779f15));
            else middlewareArray.push((0, $001998338996f6f4$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $b6edb054d04e55c6$export$8fb31c0f05df007b = "RTK_autoBatch";
var $b6edb054d04e55c6$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$b6edb054d04e55c6$export$8fb31c0f05df007b]: true
            }
        });
var $b6edb054d04e55c6$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $b6edb054d04e55c6$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $b6edb054d04e55c6$var$createQueueWithTimer(10);
var $b6edb054d04e55c6$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $b6edb054d04e55c6$var$rAF : options.type === "callback" ? options.queueNotification : $b6edb054d04e55c6$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$b6edb054d04e55c6$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $b6edb054d04e55c6$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $b6edb054d04e55c6$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($b6edb054d04e55c6$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $b6edb054d04e55c6$var$IS_PRODUCTION = true;
function $b6edb054d04e55c6$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $b6edb054d04e55c6$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $820203a4de2e0aab$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $820203a4de2e0aab$export$66e4520cdb265d18)(reducer);
    else throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(1));
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$b6edb054d04e55c6$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(4));
    let finalCompose = (0, $820203a4de2e0aab$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $b6edb054d04e55c6$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$b6edb054d04e55c6$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $820203a4de2e0aab$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $b6edb054d04e55c6$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(6));
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(7));
    if (!$b6edb054d04e55c6$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $820203a4de2e0aab$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $b6edb054d04e55c6$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $b6edb054d04e55c6$var$isStateFunction(x) {
    return typeof x === "function";
}
function $b6edb054d04e55c6$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $b6edb054d04e55c6$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($b6edb054d04e55c6$var$isStateFunction(initialState)) getInitialState = ()=>$b6edb054d04e55c6$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $b6edb054d04e55c6$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $f0300f660fb65742$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $f0300f660fb65742$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $f0300f660fb65742$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $b6edb054d04e55c6$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $b6edb054d04e55c6$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $b6edb054d04e55c6$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $b6edb054d04e55c6$var$matches = (matcher, action)=>{
    if ($b6edb054d04e55c6$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $b6edb054d04e55c6$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$b6edb054d04e55c6$var$matches(matcher, action));
    };
}
function $b6edb054d04e55c6$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$b6edb054d04e55c6$var$matches(matcher, action));
    };
}
function $b6edb054d04e55c6$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $b6edb054d04e55c6$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $b6edb054d04e55c6$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$b6edb054d04e55c6$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$b6edb054d04e55c6$var$isAsyncThunkArray(asyncThunks)) return $b6edb054d04e55c6$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $b6edb054d04e55c6$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $b6edb054d04e55c6$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$b6edb054d04e55c6$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$b6edb054d04e55c6$var$isAsyncThunkArray(asyncThunks)) return $b6edb054d04e55c6$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $b6edb054d04e55c6$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $b6edb054d04e55c6$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $b6edb054d04e55c6$export$9dd1fb32974da385($b6edb054d04e55c6$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$b6edb054d04e55c6$var$isAsyncThunkArray(asyncThunks)) return $b6edb054d04e55c6$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $b6edb054d04e55c6$export$9dd1fb32974da385($b6edb054d04e55c6$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $b6edb054d04e55c6$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$b6edb054d04e55c6$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$b6edb054d04e55c6$var$isAsyncThunkArray(asyncThunks)) return $b6edb054d04e55c6$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $b6edb054d04e55c6$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $b6edb054d04e55c6$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$b6edb054d04e55c6$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$b6edb054d04e55c6$var$isAsyncThunkArray(asyncThunks)) return $b6edb054d04e55c6$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $b6edb054d04e55c6$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $b6edb054d04e55c6$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $b6edb054d04e55c6$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $b6edb054d04e55c6$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $b6edb054d04e55c6$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $b6edb054d04e55c6$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $b6edb054d04e55c6$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $b6edb054d04e55c6$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $b6edb054d04e55c6$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $b6edb054d04e55c6$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $b6edb054d04e55c6$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $b6edb054d04e55c6$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($b6edb054d04e55c6$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $b6edb054d04e55c6$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $b6edb054d04e55c6$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $b6edb054d04e55c6$var$RejectWithValue) throw result;
                                if (result instanceof $b6edb054d04e55c6$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $b6edb054d04e55c6$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($b6edb054d04e55c6$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $b6edb054d04e55c6$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $b6edb054d04e55c6$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $b6edb054d04e55c6$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $b6edb054d04e55c6$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $b6edb054d04e55c6$export$343355ed40c51c46 = {
    [$b6edb054d04e55c6$var$asyncThunkSymbol]: $b6edb054d04e55c6$export$6abd22dc03e5063f
};
var $b6edb054d04e55c6$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($b6edb054d04e55c6$export$23a094319a4b586 || {});
function $b6edb054d04e55c6$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $b6edb054d04e55c6$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$b6edb054d04e55c6$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(11));
        typeof $57927d29a90ead81$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($b6edb054d04e55c6$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $b6edb054d04e55c6$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($b6edb054d04e55c6$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $b6edb054d04e55c6$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $b6edb054d04e55c6$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $b6edb054d04e55c6$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $b6edb054d04e55c6$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $b6edb054d04e55c6$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $b6edb054d04e55c6$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $b6edb054d04e55c6$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $b6edb054d04e55c6$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $b6edb054d04e55c6$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $b6edb054d04e55c6$export$affdea4146de9cf5();
function $b6edb054d04e55c6$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $b6edb054d04e55c6$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$b6edb054d04e55c6$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $b6edb054d04e55c6$export$309c7a02b0b0bc62(type, prepareCallback) : $b6edb054d04e55c6$export$309c7a02b0b0bc62(type));
}
function $b6edb054d04e55c6$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $b6edb054d04e55c6$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $b6edb054d04e55c6$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $b6edb054d04e55c6$var$noop,
        pending: pending || $b6edb054d04e55c6$var$noop,
        rejected: rejected || $b6edb054d04e55c6$var$noop,
        settled: settled || $b6edb054d04e55c6$var$noop
    });
}
function $b6edb054d04e55c6$var$noop() {}
// src/entities/entity_state.ts
function $b6edb054d04e55c6$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $b6edb054d04e55c6$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($b6edb054d04e55c6$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $b6edb054d04e55c6$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $b6edb054d04e55c6$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $b6edb054d04e55c6$var$isDraftTyped = (0, $f0300f660fb65742$export$541ac630993a4c84);
function $b6edb054d04e55c6$var$createSingleArgumentStateOperator(mutator) {
    const operator = $b6edb054d04e55c6$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $b6edb054d04e55c6$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $b6edb054d04e55c6$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($b6edb054d04e55c6$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $f0300f660fb65742$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $b6edb054d04e55c6$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $b6edb054d04e55c6$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $b6edb054d04e55c6$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $b6edb054d04e55c6$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $b6edb054d04e55c6$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $b6edb054d04e55c6$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $b6edb054d04e55c6$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $b6edb054d04e55c6$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$b6edb054d04e55c6$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $b6edb054d04e55c6$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $b6edb054d04e55c6$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $b6edb054d04e55c6$var$createStateOperator(addOneMutably),
        addMany: $b6edb054d04e55c6$var$createStateOperator(addManyMutably),
        setOne: $b6edb054d04e55c6$var$createStateOperator(setOneMutably),
        setMany: $b6edb054d04e55c6$var$createStateOperator(setManyMutably),
        setAll: $b6edb054d04e55c6$var$createStateOperator(setAllMutably),
        updateOne: $b6edb054d04e55c6$var$createStateOperator(updateOneMutably),
        updateMany: $b6edb054d04e55c6$var$createStateOperator(updateManyMutably),
        upsertOne: $b6edb054d04e55c6$var$createStateOperator(upsertOneMutably),
        upsertMany: $b6edb054d04e55c6$var$createStateOperator(upsertManyMutably),
        removeOne: $b6edb054d04e55c6$var$createStateOperator(removeOneMutably),
        removeMany: $b6edb054d04e55c6$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $b6edb054d04e55c6$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $b6edb054d04e55c6$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($b6edb054d04e55c6$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $b6edb054d04e55c6$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $b6edb054d04e55c6$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $b6edb054d04e55c6$var$createStateOperator(addOneMutably),
        updateOne: $b6edb054d04e55c6$var$createStateOperator(updateOneMutably),
        upsertOne: $b6edb054d04e55c6$var$createStateOperator(upsertOneMutably),
        setOne: $b6edb054d04e55c6$var$createStateOperator(setOneMutably),
        setMany: $b6edb054d04e55c6$var$createStateOperator(setManyMutably),
        setAll: $b6edb054d04e55c6$var$createStateOperator(setAllMutably),
        addMany: $b6edb054d04e55c6$var$createStateOperator(addManyMutably),
        updateMany: $b6edb054d04e55c6$var$createStateOperator(updateManyMutably),
        upsertMany: $b6edb054d04e55c6$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $b6edb054d04e55c6$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $b6edb054d04e55c6$var$createSortedStateAdapter(selectId, sortComparer) : $b6edb054d04e55c6$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $b6edb054d04e55c6$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $b6edb054d04e55c6$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $b6edb054d04e55c6$var$task = "task";
var $b6edb054d04e55c6$var$listener = "listener";
var $b6edb054d04e55c6$var$completed = "completed";
var $b6edb054d04e55c6$var$cancelled = "cancelled";
var $b6edb054d04e55c6$var$taskCancelled = `task-${$b6edb054d04e55c6$var$cancelled}`;
var $b6edb054d04e55c6$var$taskCompleted = `task-${$b6edb054d04e55c6$var$completed}`;
var $b6edb054d04e55c6$var$listenerCancelled = `${$b6edb054d04e55c6$var$listener}-${$b6edb054d04e55c6$var$cancelled}`;
var $b6edb054d04e55c6$var$listenerCompleted = `${$b6edb054d04e55c6$var$listener}-${$b6edb054d04e55c6$var$completed}`;
var $b6edb054d04e55c6$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$b6edb054d04e55c6$var$task} ${$b6edb054d04e55c6$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $b6edb054d04e55c6$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(32));
};
var $b6edb054d04e55c6$var$noop2 = ()=>{};
var $b6edb054d04e55c6$var$catchRejection = (promise, onError = $b6edb054d04e55c6$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $b6edb054d04e55c6$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $b6edb054d04e55c6$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $b6edb054d04e55c6$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $b6edb054d04e55c6$export$cb1bdac908fed7f(reason);
    }
};
function $b6edb054d04e55c6$var$raceWithSignal(signal, promise) {
    let cleanup = $b6edb054d04e55c6$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $b6edb054d04e55c6$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $b6edb054d04e55c6$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $b6edb054d04e55c6$var$noop2;
    });
}
var $b6edb054d04e55c6$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $b6edb054d04e55c6$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $b6edb054d04e55c6$var$createPause = (signal)=>{
    return (promise)=>{
        return $b6edb054d04e55c6$var$catchRejection($b6edb054d04e55c6$var$raceWithSignal(signal, promise).then((output)=>{
            $b6edb054d04e55c6$var$validateActive(signal);
            return output;
        }));
    };
};
var $b6edb054d04e55c6$var$createDelay = (signal)=>{
    const pause = $b6edb054d04e55c6$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $b6edb054d04e55c6$var$assign } = Object;
var $b6edb054d04e55c6$var$INTERNAL_NIL_TOKEN = {};
var $b6edb054d04e55c6$var$alm = "listenerMiddleware";
var $b6edb054d04e55c6$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$b6edb054d04e55c6$var$addAbortSignalListener(parentAbortSignal, ()=>$b6edb054d04e55c6$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $b6edb054d04e55c6$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $b6edb054d04e55c6$var$runTask(async ()=>{
            $b6edb054d04e55c6$var$validateActive(parentAbortSignal);
            $b6edb054d04e55c6$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $b6edb054d04e55c6$var$createPause(childAbortController.signal),
                delay: $b6edb054d04e55c6$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $b6edb054d04e55c6$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$b6edb054d04e55c6$var$abortControllerWithReason(childAbortController, $b6edb054d04e55c6$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($b6edb054d04e55c6$var$noop2));
        return {
            result: $b6edb054d04e55c6$var$createPause(parentAbortSignal)(result),
            cancel () {
                $b6edb054d04e55c6$var$abortControllerWithReason(childAbortController, $b6edb054d04e55c6$var$taskCancelled);
            }
        };
    };
};
var $b6edb054d04e55c6$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $b6edb054d04e55c6$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $b6edb054d04e55c6$var$raceWithSignal(signal, Promise.race(promises));
            $b6edb054d04e55c6$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$b6edb054d04e55c6$var$catchRejection(take(predicate, timeout));
};
var $b6edb054d04e55c6$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $b6edb054d04e55c6$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(21));
    $b6edb054d04e55c6$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $b6edb054d04e55c6$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $b6edb054d04e55c6$var$getListenerEntryPropsFrom(options);
    const id = $b6edb054d04e55c6$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$b6edb054d04e55c6$var$createListenerEntry
});
var $b6edb054d04e55c6$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $b6edb054d04e55c6$var$abortControllerWithReason(controller, $b6edb054d04e55c6$var$listenerCancelled);
    });
};
var $b6edb054d04e55c6$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($b6edb054d04e55c6$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $b6edb054d04e55c6$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $b6edb054d04e55c6$export$f03a6b845d3fb58b = Object.assign($b6edb054d04e55c6$export$309c7a02b0b0bc62(`${$b6edb054d04e55c6$var$alm}/add`), {
    withTypes: ()=>$b6edb054d04e55c6$export$f03a6b845d3fb58b
});
var $b6edb054d04e55c6$export$b1b8022855fb2b71 = $b6edb054d04e55c6$export$309c7a02b0b0bc62(`${$b6edb054d04e55c6$var$alm}/removeAll`);
var $b6edb054d04e55c6$export$b03e9483f936dccb = Object.assign($b6edb054d04e55c6$export$309c7a02b0b0bc62(`${$b6edb054d04e55c6$var$alm}/remove`), {
    withTypes: ()=>$b6edb054d04e55c6$export$b03e9483f936dccb
});
var $b6edb054d04e55c6$var$defaultErrorHandler = (...args)=>{
    console.error(`${$b6edb054d04e55c6$var$alm}/error`, ...args);
};
var $b6edb054d04e55c6$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $b6edb054d04e55c6$var$defaultErrorHandler } = middlewareOptions;
    $b6edb054d04e55c6$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $b6edb054d04e55c6$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $b6edb054d04e55c6$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $b6edb054d04e55c6$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $b6edb054d04e55c6$var$getListenerEntryPropsFrom(options);
        const entry = $b6edb054d04e55c6$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $b6edb054d04e55c6$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $b6edb054d04e55c6$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $b6edb054d04e55c6$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $b6edb054d04e55c6$var$createDelay(internalTaskController.signal),
                pause: $b6edb054d04e55c6$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $b6edb054d04e55c6$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $b6edb054d04e55c6$var$abortControllerWithReason(controller, $b6edb054d04e55c6$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $b6edb054d04e55c6$var$abortControllerWithReason(internalTaskController, $b6edb054d04e55c6$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $b6edb054d04e55c6$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $b6edb054d04e55c6$export$cb1bdac908fed7f)) $b6edb054d04e55c6$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $b6edb054d04e55c6$var$abortControllerWithReason(internalTaskController, $b6edb054d04e55c6$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $b6edb054d04e55c6$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $820203a4de2e0aab$export$b956e38827fca970)(action)) return next(action);
                if ($b6edb054d04e55c6$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($b6edb054d04e55c6$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($b6edb054d04e55c6$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $b6edb054d04e55c6$var$INTERNAL_NIL_TOKEN) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $b6edb054d04e55c6$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $b6edb054d04e55c6$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $b6edb054d04e55c6$var$createMiddlewareEntry = (middleware)=>({
        id: $b6edb054d04e55c6$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $b6edb054d04e55c6$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $b6edb054d04e55c6$export$4bb1606a79445586 = ()=>{
    const instanceId = $b6edb054d04e55c6$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($b6edb054d04e55c6$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $b6edb054d04e55c6$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $b6edb054d04e55c6$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$b6edb054d04e55c6$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $820203a4de2e0aab$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $b6edb054d04e55c6$export$9dd1fb32974da385(withMiddleware, $b6edb054d04e55c6$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $b6edb054d04e55c6$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $b6edb054d04e55c6$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$b6edb054d04e55c6$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $b6edb054d04e55c6$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $b6edb054d04e55c6$var$isStateProxy = (value)=>!!value && !!value[$b6edb054d04e55c6$var$ORIGINAL_STATE];
var $b6edb054d04e55c6$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $b6edb054d04e55c6$var$createStateProxy = (state, reducerMap)=>$b6edb054d04e55c6$var$emplace($b6edb054d04e55c6$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $b6edb054d04e55c6$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $b6edb054d04e55c6$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $b6edb054d04e55c6$var$original = (state)=>{
    if (!$b6edb054d04e55c6$var$isStateProxy(state)) throw new Error($b6edb054d04e55c6$export$378fa86b259c0280(25));
    return state[$b6edb054d04e55c6$var$ORIGINAL_STATE];
};
var $b6edb054d04e55c6$var$noopReducer = (state = {})=>state;
function $b6edb054d04e55c6$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($b6edb054d04e55c6$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $820203a4de2e0aab$export$66e4520cdb265d18)(reducerMap) : $b6edb054d04e55c6$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $57927d29a90ead81$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($b6edb054d04e55c6$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $b6edb054d04e55c6$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $b6edb054d04e55c6$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $6f1d62e9ba514404$var$themeSlice = (0, $b6edb054d04e55c6$export$4d8d9bd83c24ae8b)({
    name: "themeChanger",
    initialState: {
        theme: "dark"
    },
    reducers: {
        toogleTheme: (state, action)=>{
            if (state.theme === "light") state.theme = "dark";
            else state.theme = "light";
        }
    }
});
var $6f1d62e9ba514404$export$2e2bcd8739ae039 = $6f1d62e9ba514404$var$themeSlice.reducer;
const { toogleTheme: $6f1d62e9ba514404$export$9443a770e75d2a08 } = $6f1d62e9ba514404$var$themeSlice.actions;


const $3e8f8bb6c362ab6e$export$bcede3532aa4b7f7 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $3e8f8bb6c362ab6e$export$4cb72355748c04dd = "https://ucarecdn.com/a5921077-2612-4458-b16e-c37a80402d5a/-/preview/999x952/";
const $3e8f8bb6c362ab6e$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.4089123&lng=77.3177894&restaurantId=";
const $3e8f8bb6c362ab6e$export$1087355e69a7a68 = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.4089123&lng=77.3177894";
const $3e8f8bb6c362ab6e$export$f89a830e1c49df8f = "https://img.icons8.com/fluency/96/vegetarian-food-symbol.png";
const $3e8f8bb6c362ab6e$export$ecdeacdb356c62b = "https://www.pngkey.com/png/detail/245-2459071_non-veg-icon-non-veg-symbol-png.png";
const $3e8f8bb6c362ab6e$export$f30cb9bc4f736419 = "https://ucarecdn.com/3e2bf550-142d-4d38-9d87-9b10260a9878/2682848_day_forecast_sun_sunny_weather_icon.png";
const $3e8f8bb6c362ab6e$export$3e936a8db52a10a0 = "https://ucarecdn.com/481c8102-6fa2-4cbe-8f2a-5a3e2123ca37/8726101_moon_icon.png"; /* 
    fetch('https://proxy.cors.sh/https://acme.com', {
  headers: {
  'x-cors-api-key': 'temp_1d89d97e9a7fea79a5794d20f4d66a87'
  }
})
    */ 


// Import the functions you need from the SDKs you need

var $hAhso = parcelRequire("hAhso");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
const $0ca209b9dac42ea9$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $0ca209b9dac42ea9$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $0ca209b9dac42ea9$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $0ca209b9dac42ea9$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $0ca209b9dac42ea9$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ca209b9dac42ea9$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $0ca209b9dac42ea9$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $0ca209b9dac42ea9$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($0ca209b9dac42ea9$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $0ca209b9dac42ea9$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $0ca209b9dac42ea9$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $0ca209b9dac42ea9$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $0ca209b9dac42ea9$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $0ca209b9dac42ea9$var$stringToByteArray$1(str);
    return $0ca209b9dac42ea9$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $0ca209b9dac42ea9$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $0ca209b9dac42ea9$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $0ca209b9dac42ea9$export$c62426fdd000a97e = function(str) {
    try {
        return $0ca209b9dac42ea9$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $0ca209b9dac42ea9$export$6c40052bed430212(value) {
    return $0ca209b9dac42ea9$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $0ca209b9dac42ea9$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$0ca209b9dac42ea9$var$isValidKey(prop)) continue;
        target[prop] = $0ca209b9dac42ea9$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $0ca209b9dac42ea9$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $0ca209b9dac42ea9$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ca209b9dac42ea9$var$getDefaultsFromGlobal = ()=>$0ca209b9dac42ea9$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $0ca209b9dac42ea9$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $57927d29a90ead81$exports === "undefined" || typeof $57927d29a90ead81$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $0ca209b9dac42ea9$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $0ca209b9dac42ea9$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $0ca209b9dac42ea9$export$212bb2fc580a90a8 = ()=>{
    try {
        return $0ca209b9dac42ea9$var$getDefaultsFromGlobal() || $0ca209b9dac42ea9$var$getDefaultsFromEnvVariable() || $0ca209b9dac42ea9$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $0ca209b9dac42ea9$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $0ca209b9dac42ea9$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $0ca209b9dac42ea9$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $0ca209b9dac42ea9$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $0ca209b9dac42ea9$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $0ca209b9dac42ea9$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $0ca209b9dac42ea9$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $0ca209b9dac42ea9$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0ca209b9dac42ea9$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0ca209b9dac42ea9$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $0ca209b9dac42ea9$export$4b5284a3025a455(JSON.stringify(header)),
        $0ca209b9dac42ea9$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $0ca209b9dac42ea9$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $0ca209b9dac42ea9$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($0ca209b9dac42ea9$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $0ca209b9dac42ea9$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $0ca209b9dac42ea9$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $0ca209b9dac42ea9$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $0ca209b9dac42ea9$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $0ca209b9dac42ea9$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $0ca209b9dac42ea9$export$f2f6a8999f8ebd30() {
    return $0ca209b9dac42ea9$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $0ca209b9dac42ea9$export$7e7b1a9668aaed8() {
    const ua = $0ca209b9dac42ea9$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $0ca209b9dac42ea9$export$202944b2d2824246() {
    return $0ca209b9dac42ea9$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $0ca209b9dac42ea9$export$5d1d834fbbf8bab7() {
    return $0ca209b9dac42ea9$export$588c7fdda06fbb0a.NODE_CLIENT === true || $0ca209b9dac42ea9$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $0ca209b9dac42ea9$export$95df08bae54cb4df() {
    return !$0ca209b9dac42ea9$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $0ca209b9dac42ea9$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $0ca209b9dac42ea9$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $0ca209b9dac42ea9$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $0ca209b9dac42ea9$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $0ca209b9dac42ea9$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $0ca209b9dac42ea9$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0ca209b9dac42ea9$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $0ca209b9dac42ea9$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $0ca209b9dac42ea9$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $0ca209b9dac42ea9$var$replaceTemplate(template, data) {
    return template.replace($0ca209b9dac42ea9$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $0ca209b9dac42ea9$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $0ca209b9dac42ea9$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $0ca209b9dac42ea9$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $0ca209b9dac42ea9$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $0ca209b9dac42ea9$export$c5a53ce6a17cf18d($0ca209b9dac42ea9$export$c62426fdd000a97e(parts[0]) || "");
        claims = $0ca209b9dac42ea9$export$c5a53ce6a17cf18d($0ca209b9dac42ea9$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $0ca209b9dac42ea9$export$5f870fcca7ae6a88 = function(token) {
    const claims = $0ca209b9dac42ea9$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $0ca209b9dac42ea9$export$701c661ec91095f2 = function(token) {
    const claims = $0ca209b9dac42ea9$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $0ca209b9dac42ea9$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $0ca209b9dac42ea9$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $0ca209b9dac42ea9$export$fc970ed23da99565 = function(token) {
    const claims = $0ca209b9dac42ea9$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0ca209b9dac42ea9$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $0ca209b9dac42ea9$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $0ca209b9dac42ea9$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $0ca209b9dac42ea9$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $0ca209b9dac42ea9$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($0ca209b9dac42ea9$var$isObject(aProp) && $0ca209b9dac42ea9$var$isObject(bProp)) {
            if (!$0ca209b9dac42ea9$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $0ca209b9dac42ea9$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $0ca209b9dac42ea9$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $0ca209b9dac42ea9$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $0ca209b9dac42ea9$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $0ca209b9dac42ea9$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $0ca209b9dac42ea9$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $0ca209b9dac42ea9$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $0ca209b9dac42ea9$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $0ca209b9dac42ea9$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $0ca209b9dac42ea9$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($0ca209b9dac42ea9$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $0ca209b9dac42ea9$var$noop;
        if (observer.error === undefined) observer.error = $0ca209b9dac42ea9$var$noop;
        if (observer.complete === undefined) observer.complete = $0ca209b9dac42ea9$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0ca209b9dac42ea9$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $0ca209b9dac42ea9$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $0ca209b9dac42ea9$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $0ca209b9dac42ea9$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $0ca209b9dac42ea9$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $0ca209b9dac42ea9$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($0ca209b9dac42ea9$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $0ca209b9dac42ea9$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($0ca209b9dac42ea9$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $0ca209b9dac42ea9$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($0ca209b9dac42ea9$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $0ca209b9dac42ea9$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $0ca209b9dac42ea9$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $0ca209b9dac42ea9$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $0ca209b9dac42ea9$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $0ca209b9dac42ea9$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $0ca209b9dac42ea9$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $0ca209b9dac42ea9$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $0ca209b9dac42ea9$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $0ca209b9dac42ea9$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $0ca209b9dac42ea9$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $0ca209b9dac42ea9$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $0ca209b9dac42ea9$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($0ca209b9dac42ea9$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $0ca209b9dac42ea9$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $0ca209b9dac42ea9$var$indicator(i);
}
function $0ca209b9dac42ea9$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0ca209b9dac42ea9$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $bd83337a38fbc7ce$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $bd83337a38fbc7ce$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $0ca209b9dac42ea9$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($bd83337a38fbc7ce$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $bd83337a38fbc7ce$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $bd83337a38fbc7ce$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $bd83337a38fbc7ce$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $bd83337a38fbc7ce$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $bd83337a38fbc7ce$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $bd83337a38fbc7ce$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $824298205172e14b$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $824298205172e14b$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($824298205172e14b$export$243e62d78d3b544d || ($824298205172e14b$export$243e62d78d3b544d = {}));
const $824298205172e14b$var$levelStringToEnum = {
    "debug": $824298205172e14b$export$243e62d78d3b544d.DEBUG,
    "verbose": $824298205172e14b$export$243e62d78d3b544d.VERBOSE,
    "info": $824298205172e14b$export$243e62d78d3b544d.INFO,
    "warn": $824298205172e14b$export$243e62d78d3b544d.WARN,
    "error": $824298205172e14b$export$243e62d78d3b544d.ERROR,
    "silent": $824298205172e14b$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $824298205172e14b$var$defaultLogLevel = $824298205172e14b$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $824298205172e14b$var$ConsoleMethod = {
    [$824298205172e14b$export$243e62d78d3b544d.DEBUG]: "log",
    [$824298205172e14b$export$243e62d78d3b544d.VERBOSE]: "log",
    [$824298205172e14b$export$243e62d78d3b544d.INFO]: "info",
    [$824298205172e14b$export$243e62d78d3b544d.WARN]: "warn",
    [$824298205172e14b$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $824298205172e14b$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $824298205172e14b$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $824298205172e14b$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $824298205172e14b$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $824298205172e14b$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $824298205172e14b$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $824298205172e14b$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $824298205172e14b$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $824298205172e14b$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $824298205172e14b$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $824298205172e14b$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $824298205172e14b$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $824298205172e14b$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $824298205172e14b$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $824298205172e14b$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $824298205172e14b$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $824298205172e14b$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $824298205172e14b$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $824298205172e14b$export$c622e99c0ce7b1c9(level) {
    $824298205172e14b$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $824298205172e14b$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $824298205172e14b$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $824298205172e14b$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $824298205172e14b$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $d1a1bf9ba0ae5116$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $d1a1bf9ba0ae5116$var$idbProxyableTypes;
let $d1a1bf9ba0ae5116$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $d1a1bf9ba0ae5116$var$getIdbProxyableTypes() {
    return $d1a1bf9ba0ae5116$var$idbProxyableTypes || ($d1a1bf9ba0ae5116$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $d1a1bf9ba0ae5116$var$getCursorAdvanceMethods() {
    return $d1a1bf9ba0ae5116$var$cursorAdvanceMethods || ($d1a1bf9ba0ae5116$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $d1a1bf9ba0ae5116$var$cursorRequestMap = new WeakMap();
const $d1a1bf9ba0ae5116$var$transactionDoneMap = new WeakMap();
const $d1a1bf9ba0ae5116$var$transactionStoreNamesMap = new WeakMap();
const $d1a1bf9ba0ae5116$var$transformCache = new WeakMap();
const $d1a1bf9ba0ae5116$export$407448d2b89b1813 = new WeakMap();
function $d1a1bf9ba0ae5116$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($d1a1bf9ba0ae5116$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $d1a1bf9ba0ae5116$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $d1a1bf9ba0ae5116$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $d1a1bf9ba0ae5116$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($d1a1bf9ba0ae5116$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $d1a1bf9ba0ae5116$var$transactionDoneMap.set(tx, done);
}
let $d1a1bf9ba0ae5116$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $d1a1bf9ba0ae5116$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $d1a1bf9ba0ae5116$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $d1a1bf9ba0ae5116$export$43caf9889c228507(callback) {
    $d1a1bf9ba0ae5116$var$idbProxyTraps = callback($d1a1bf9ba0ae5116$var$idbProxyTraps);
}
function $d1a1bf9ba0ae5116$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($d1a1bf9ba0ae5116$export$3b14a55fb2447963(this), storeNames, ...args);
        $d1a1bf9ba0ae5116$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($d1a1bf9ba0ae5116$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($d1a1bf9ba0ae5116$export$3b14a55fb2447963(this), args);
        return $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b($d1a1bf9ba0ae5116$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b(func.apply($d1a1bf9ba0ae5116$export$3b14a55fb2447963(this), args));
    };
}
function $d1a1bf9ba0ae5116$var$transformCachableValue(value) {
    if (typeof value === "function") return $d1a1bf9ba0ae5116$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $d1a1bf9ba0ae5116$var$cacheDonePromiseForTransaction(value);
    if ($d1a1bf9ba0ae5116$export$23f2a1d2818174ef(value, $d1a1bf9ba0ae5116$var$getIdbProxyableTypes())) return new Proxy(value, $d1a1bf9ba0ae5116$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $d1a1bf9ba0ae5116$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($d1a1bf9ba0ae5116$var$transformCache.has(value)) return $d1a1bf9ba0ae5116$var$transformCache.get(value);
    const newValue = $d1a1bf9ba0ae5116$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $d1a1bf9ba0ae5116$var$transformCache.set(value, newValue);
        $d1a1bf9ba0ae5116$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $d1a1bf9ba0ae5116$export$3b14a55fb2447963 = (value)=>$d1a1bf9ba0ae5116$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $2797533eeb51470a$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $2797533eeb51470a$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $d1a1bf9ba0ae5116$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $2797533eeb51470a$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $2797533eeb51470a$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $2797533eeb51470a$var$cachedMethods = new Map();
function $2797533eeb51470a$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($2797533eeb51470a$var$cachedMethods.get(prop)) return $2797533eeb51470a$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $2797533eeb51470a$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $2797533eeb51470a$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $2797533eeb51470a$var$cachedMethods.set(prop, method);
    return method;
}
(0, $d1a1bf9ba0ae5116$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$2797533eeb51470a$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$2797533eeb51470a$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494b068b89b4758a$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($494b068b89b4758a$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $494b068b89b4758a$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $494b068b89b4758a$var$name$o = "@firebase/app";
const $494b068b89b4758a$var$version$1 = "0.9.23";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494b068b89b4758a$var$logger = new (0, $824298205172e14b$export$efa9a398d6368992)("@firebase/app");
const $494b068b89b4758a$var$name$n = "@firebase/app-compat";
const $494b068b89b4758a$var$name$m = "@firebase/analytics-compat";
const $494b068b89b4758a$var$name$l = "@firebase/analytics";
const $494b068b89b4758a$var$name$k = "@firebase/app-check-compat";
const $494b068b89b4758a$var$name$j = "@firebase/app-check";
const $494b068b89b4758a$var$name$i = "@firebase/auth";
const $494b068b89b4758a$var$name$h = "@firebase/auth-compat";
const $494b068b89b4758a$var$name$g = "@firebase/database";
const $494b068b89b4758a$var$name$f = "@firebase/database-compat";
const $494b068b89b4758a$var$name$e = "@firebase/functions";
const $494b068b89b4758a$var$name$d = "@firebase/functions-compat";
const $494b068b89b4758a$var$name$c = "@firebase/installations";
const $494b068b89b4758a$var$name$b = "@firebase/installations-compat";
const $494b068b89b4758a$var$name$a = "@firebase/messaging";
const $494b068b89b4758a$var$name$9 = "@firebase/messaging-compat";
const $494b068b89b4758a$var$name$8 = "@firebase/performance";
const $494b068b89b4758a$var$name$7 = "@firebase/performance-compat";
const $494b068b89b4758a$var$name$6 = "@firebase/remote-config";
const $494b068b89b4758a$var$name$5 = "@firebase/remote-config-compat";
const $494b068b89b4758a$var$name$4 = "@firebase/storage";
const $494b068b89b4758a$var$name$3 = "@firebase/storage-compat";
const $494b068b89b4758a$var$name$2 = "@firebase/firestore";
const $494b068b89b4758a$var$name$1 = "@firebase/firestore-compat";
const $494b068b89b4758a$var$name = "firebase";
const $494b068b89b4758a$var$version = "10.6.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $494b068b89b4758a$export$9f30fa0c10967f7f = "[DEFAULT]";
const $494b068b89b4758a$var$PLATFORM_LOG_STRING = {
    [$494b068b89b4758a$var$name$o]: "fire-core",
    [$494b068b89b4758a$var$name$n]: "fire-core-compat",
    [$494b068b89b4758a$var$name$l]: "fire-analytics",
    [$494b068b89b4758a$var$name$m]: "fire-analytics-compat",
    [$494b068b89b4758a$var$name$j]: "fire-app-check",
    [$494b068b89b4758a$var$name$k]: "fire-app-check-compat",
    [$494b068b89b4758a$var$name$i]: "fire-auth",
    [$494b068b89b4758a$var$name$h]: "fire-auth-compat",
    [$494b068b89b4758a$var$name$g]: "fire-rtdb",
    [$494b068b89b4758a$var$name$f]: "fire-rtdb-compat",
    [$494b068b89b4758a$var$name$e]: "fire-fn",
    [$494b068b89b4758a$var$name$d]: "fire-fn-compat",
    [$494b068b89b4758a$var$name$c]: "fire-iid",
    [$494b068b89b4758a$var$name$b]: "fire-iid-compat",
    [$494b068b89b4758a$var$name$a]: "fire-fcm",
    [$494b068b89b4758a$var$name$9]: "fire-fcm-compat",
    [$494b068b89b4758a$var$name$8]: "fire-perf",
    [$494b068b89b4758a$var$name$7]: "fire-perf-compat",
    [$494b068b89b4758a$var$name$6]: "fire-rc",
    [$494b068b89b4758a$var$name$5]: "fire-rc-compat",
    [$494b068b89b4758a$var$name$4]: "fire-gcs",
    [$494b068b89b4758a$var$name$3]: "fire-gcs-compat",
    [$494b068b89b4758a$var$name$2]: "fire-fst",
    [$494b068b89b4758a$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$494b068b89b4758a$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $494b068b89b4758a$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $494b068b89b4758a$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $494b068b89b4758a$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $494b068b89b4758a$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $494b068b89b4758a$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $494b068b89b4758a$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($494b068b89b4758a$export$9566bce3835c0f28.has(componentName)) {
        $494b068b89b4758a$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $494b068b89b4758a$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $494b068b89b4758a$export$b4e3c36c855b14b5.values())$494b068b89b4758a$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $494b068b89b4758a$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $494b068b89b4758a$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $494b068b89b4758a$export$9f30fa0c10967f7f) {
    $494b068b89b4758a$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $494b068b89b4758a$export$3685d89b9c3cdfaf() {
    $494b068b89b4758a$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494b068b89b4758a$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $494b068b89b4758a$var$ERROR_FACTORY = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)("app", "Firebase", $494b068b89b4758a$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $494b068b89b4758a$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $494b068b89b4758a$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $494b068b89b4758a$export$31499a9cd224b78c = $494b068b89b4758a$var$version;
function $494b068b89b4758a$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $494b068b89b4758a$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $494b068b89b4758a$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $0ca209b9dac42ea9$export$3dfb6827a9f89756)());
    if (!options) throw $494b068b89b4758a$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $494b068b89b4758a$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $0ca209b9dac42ea9$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $0ca209b9dac42ea9$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $494b068b89b4758a$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $bd83337a38fbc7ce$export$436a80eea5d5c0c5)(name);
    for (const component of $494b068b89b4758a$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $494b068b89b4758a$var$FirebaseAppImpl(options, config, container);
    $494b068b89b4758a$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $494b068b89b4758a$export$f9962582c9e66d99(name = $494b068b89b4758a$export$9f30fa0c10967f7f) {
    const app = $494b068b89b4758a$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $494b068b89b4758a$export$9f30fa0c10967f7f && (0, $0ca209b9dac42ea9$export$3dfb6827a9f89756)()) return $494b068b89b4758a$export$c55cfd413944906d();
    if (!app) throw $494b068b89b4758a$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $494b068b89b4758a$export$68ddedf7d44b3bdf() {
    return Array.from($494b068b89b4758a$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $494b068b89b4758a$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($494b068b89b4758a$export$b4e3c36c855b14b5.has(name)) {
        $494b068b89b4758a$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $494b068b89b4758a$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $494b068b89b4758a$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $494b068b89b4758a$var$logger.warn(warning.join(" "));
        return;
    }
    $494b068b89b4758a$export$c930050e7bb63965(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $494b068b89b4758a$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $494b068b89b4758a$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $824298205172e14b$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $494b068b89b4758a$export$c622e99c0ce7b1c9(logLevel) {
    (0, $824298205172e14b$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494b068b89b4758a$var$DB_NAME = "firebase-heartbeat-database";
const $494b068b89b4758a$var$DB_VERSION = 1;
const $494b068b89b4758a$var$STORE_NAME = "firebase-heartbeat-store";
let $494b068b89b4758a$var$dbPromise = null;
function $494b068b89b4758a$var$getDbPromise() {
    if (!$494b068b89b4758a$var$dbPromise) $494b068b89b4758a$var$dbPromise = (0, $2797533eeb51470a$export$ca0ed41b1a2af7e)($494b068b89b4758a$var$DB_NAME, $494b068b89b4758a$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($494b068b89b4758a$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $494b068b89b4758a$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $494b068b89b4758a$var$dbPromise;
}
async function $494b068b89b4758a$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $494b068b89b4758a$var$getDbPromise();
        const result = await db.transaction($494b068b89b4758a$var$STORE_NAME).objectStore($494b068b89b4758a$var$STORE_NAME).get($494b068b89b4758a$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56)) $494b068b89b4758a$var$logger.warn(e.message);
        else {
            const idbGetError = $494b068b89b4758a$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $494b068b89b4758a$var$logger.warn(idbGetError.message);
        }
    }
}
async function $494b068b89b4758a$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $494b068b89b4758a$var$getDbPromise();
        const tx = db.transaction($494b068b89b4758a$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($494b068b89b4758a$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $494b068b89b4758a$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56)) $494b068b89b4758a$var$logger.warn(e.message);
        else {
            const idbGetError = $494b068b89b4758a$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $494b068b89b4758a$var$logger.warn(idbGetError.message);
        }
    }
}
function $494b068b89b4758a$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $494b068b89b4758a$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $494b068b89b4758a$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $494b068b89b4758a$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $494b068b89b4758a$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a;
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $494b068b89b4758a$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $494b068b89b4758a$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $494b068b89b4758a$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $494b068b89b4758a$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $0ca209b9dac42ea9$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $494b068b89b4758a$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $494b068b89b4758a$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $494b068b89b4758a$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($494b068b89b4758a$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($494b068b89b4758a$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $494b068b89b4758a$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $0ca209b9dac42ea9$export$3865db50535c2055)()) return false;
        else return (0, $0ca209b9dac42ea9$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $494b068b89b4758a$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $494b068b89b4758a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $494b068b89b4758a$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $494b068b89b4758a$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $0ca209b9dac42ea9$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $494b068b89b4758a$var$registerCoreComponents(variant) {
    $494b068b89b4758a$export$c930050e7bb63965(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("platform-logger", (container)=>new $494b068b89b4758a$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $494b068b89b4758a$export$c930050e7bb63965(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("heartbeat", (container)=>new $494b068b89b4758a$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $494b068b89b4758a$export$d29d5299a7137abc($494b068b89b4758a$var$name$o, $494b068b89b4758a$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $494b068b89b4758a$export$d29d5299a7137abc($494b068b89b4758a$var$name$o, $494b068b89b4758a$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $494b068b89b4758a$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $494b068b89b4758a$var$registerCoreComponents("");


var $d1b101eb037d1a53$var$name = "firebase";
var $d1b101eb037d1a53$var$version = "10.6.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $494b068b89b4758a$export$d29d5299a7137abc)($d1b101eb037d1a53$var$name, $d1b101eb037d1a53$var$version, "app");





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a30250e776d41ddb$var$extendStatics = function(d, b) {
    $a30250e776d41ddb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a30250e776d41ddb$var$extendStatics(d, b);
};
function $a30250e776d41ddb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a30250e776d41ddb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a30250e776d41ddb$export$18ce0697a983be9b = function() {
    $a30250e776d41ddb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a30250e776d41ddb$export$18ce0697a983be9b.apply(this, arguments);
};
function $a30250e776d41ddb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a30250e776d41ddb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a30250e776d41ddb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a30250e776d41ddb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a30250e776d41ddb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a30250e776d41ddb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a30250e776d41ddb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a30250e776d41ddb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a30250e776d41ddb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a30250e776d41ddb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a30250e776d41ddb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a30250e776d41ddb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a30250e776d41ddb$export$45d3717a4c69092e(o, m, p);
}
function $a30250e776d41ddb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a30250e776d41ddb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a30250e776d41ddb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a30250e776d41ddb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a30250e776d41ddb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a30250e776d41ddb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a30250e776d41ddb$export$10c90e4f7922046c(v) {
    return this instanceof $a30250e776d41ddb$export$10c90e4f7922046c ? (this.v = v, this) : new $a30250e776d41ddb$export$10c90e4f7922046c(v);
}
function $a30250e776d41ddb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a30250e776d41ddb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a30250e776d41ddb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a30250e776d41ddb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a30250e776d41ddb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a30250e776d41ddb$export$19a8beecd37a4c45 === "function" ? $a30250e776d41ddb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a30250e776d41ddb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a30250e776d41ddb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a30250e776d41ddb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a30250e776d41ddb$export$45d3717a4c69092e(result, mod, k);
    }
    $a30250e776d41ddb$var$__setModuleDefault(result, mod);
    return result;
}
function $a30250e776d41ddb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a30250e776d41ddb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a30250e776d41ddb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a30250e776d41ddb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a30250e776d41ddb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a30250e776d41ddb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a30250e776d41ddb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a30250e776d41ddb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a30250e776d41ddb$export$2e2bcd8739ae039 = {
    __extends: $a30250e776d41ddb$export$a8ba968b8961cb8a,
    __assign: $a30250e776d41ddb$export$18ce0697a983be9b,
    __rest: $a30250e776d41ddb$export$3c9a16f847548506,
    __decorate: $a30250e776d41ddb$export$29e00dfd3077644b,
    __param: $a30250e776d41ddb$export$d5ad3fd78186038f,
    __metadata: $a30250e776d41ddb$export$f1db080c865becb9,
    __awaiter: $a30250e776d41ddb$export$1050f835b63b671e,
    __generator: $a30250e776d41ddb$export$67ebef60e6f28a6,
    __createBinding: $a30250e776d41ddb$export$45d3717a4c69092e,
    __exportStar: $a30250e776d41ddb$export$f33643c0debef087,
    __values: $a30250e776d41ddb$export$19a8beecd37a4c45,
    __read: $a30250e776d41ddb$export$8d051b38c9118094,
    __spread: $a30250e776d41ddb$export$afc72e2116322959,
    __spreadArrays: $a30250e776d41ddb$export$6388937ca91ccae8,
    __spreadArray: $a30250e776d41ddb$export$1216008129fb82ed,
    __await: $a30250e776d41ddb$export$10c90e4f7922046c,
    __asyncGenerator: $a30250e776d41ddb$export$e427f37a30a4de9b,
    __asyncDelegator: $a30250e776d41ddb$export$bbd80228419bb833,
    __asyncValues: $a30250e776d41ddb$export$e3b29a3d6162315f,
    __makeTemplateObject: $a30250e776d41ddb$export$4fb47efe1390b86f,
    __importStar: $a30250e776d41ddb$export$c21735bcef00d192,
    __importDefault: $a30250e776d41ddb$export$da59b14a69baef04,
    __classPrivateFieldGet: $a30250e776d41ddb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a30250e776d41ddb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a30250e776d41ddb$export$81fdc39f203e4e04,
    __addDisposableResource: $a30250e776d41ddb$export$88ac25d8e944e405,
    __disposeResources: $a30250e776d41ddb$export$8f076105dc360e92
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $1d3138fe302b21d0$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $1d3138fe302b21d0$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $1d3138fe302b21d0$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $1d3138fe302b21d0$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $1d3138fe302b21d0$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $1d3138fe302b21d0$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $1d3138fe302b21d0$export$2329c99376c9d0a4 = $1d3138fe302b21d0$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $1d3138fe302b21d0$export$7f8ddf7c7c20b3cd = $1d3138fe302b21d0$var$_prodErrorMap;
const $1d3138fe302b21d0$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)("auth", "Firebase", $1d3138fe302b21d0$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $1d3138fe302b21d0$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$logClient = new (0, $824298205172e14b$export$efa9a398d6368992)("@firebase/auth");
function $1d3138fe302b21d0$var$_logWarn(msg, ...args) {
    if ($1d3138fe302b21d0$var$logClient.logLevel <= (0, $824298205172e14b$export$243e62d78d3b544d).WARN) $1d3138fe302b21d0$var$logClient.warn(`Auth (${(0, $494b068b89b4758a$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $1d3138fe302b21d0$var$_logError(msg, ...args) {
    if ($1d3138fe302b21d0$var$logClient.logLevel <= (0, $824298205172e14b$export$243e62d78d3b544d).ERROR) $1d3138fe302b21d0$var$logClient.error(`Auth (${(0, $494b068b89b4758a$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $1d3138fe302b21d0$var$createErrorInternal(authOrCode, ...rest);
}
function $1d3138fe302b21d0$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $1d3138fe302b21d0$var$createErrorInternal(authOrCode, ...rest);
}
function $1d3138fe302b21d0$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $1d3138fe302b21d0$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $1d3138fe302b21d0$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $1d3138fe302b21d0$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $1d3138fe302b21d0$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $1d3138fe302b21d0$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $1d3138fe302b21d0$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $1d3138fe302b21d0$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $1d3138fe302b21d0$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $1d3138fe302b21d0$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $1d3138fe302b21d0$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $1d3138fe302b21d0$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $1d3138fe302b21d0$var$_isHttpOrHttps() {
    return $1d3138fe302b21d0$var$_getCurrentScheme() === "http:" || $1d3138fe302b21d0$var$_getCurrentScheme() === "https:";
}
function $1d3138fe302b21d0$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $1d3138fe302b21d0$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($1d3138fe302b21d0$var$_isHttpOrHttps() || (0, $0ca209b9dac42ea9$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $1d3138fe302b21d0$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $1d3138fe302b21d0$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $1d3138fe302b21d0$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $0ca209b9dac42ea9$export$872f8323f01d7ae0)() || (0, $0ca209b9dac42ea9$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$1d3138fe302b21d0$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_emulatorUrl(config, path) {
    $1d3138fe302b21d0$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $1d3138fe302b21d0$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $1d3138fe302b21d0$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $1d3138fe302b21d0$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $1d3138fe302b21d0$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$DEFAULT_API_TIMEOUT_MS = new $1d3138fe302b21d0$var$Delay(30000, 60000);
function $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $1d3138fe302b21d0$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $1d3138fe302b21d0$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $0ca209b9dac42ea9$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $1d3138fe302b21d0$export$2ed0fc6709e59212.fetch()($1d3138fe302b21d0$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $1d3138fe302b21d0$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $1d3138fe302b21d0$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $1d3138fe302b21d0$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $1d3138fe302b21d0$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $1d3138fe302b21d0$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $1d3138fe302b21d0$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $1d3138fe302b21d0$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $1d3138fe302b21d0$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $1d3138fe302b21d0$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $1d3138fe302b21d0$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $1d3138fe302b21d0$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $1d3138fe302b21d0$var$_emulatorUrl(auth.config, base);
}
function $1d3138fe302b21d0$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $1d3138fe302b21d0$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($1d3138fe302b21d0$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $1d3138fe302b21d0$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $1d3138fe302b21d0$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $1d3138fe302b21d0$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $1d3138fe302b21d0$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $1d3138fe302b21d0$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $1d3138fe302b21d0$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$getRecaptchaParams(auth) {
    return (await $1d3138fe302b21d0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $1d3138fe302b21d0$var$getRecaptchaConfig(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$deleteAccount(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $1d3138fe302b21d0$var$deleteLinkedAccounts(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $1d3138fe302b21d0$var$getAccountInfo(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $1d3138fe302b21d0$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $1d3138fe302b21d0$var$_parseToken(token);
    $1d3138fe302b21d0$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $1d3138fe302b21d0$var$utcTimestampToDateString($1d3138fe302b21d0$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $1d3138fe302b21d0$var$utcTimestampToDateString($1d3138fe302b21d0$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $1d3138fe302b21d0$var$utcTimestampToDateString($1d3138fe302b21d0$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $1d3138fe302b21d0$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $1d3138fe302b21d0$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $1d3138fe302b21d0$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $0ca209b9dac42ea9$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $1d3138fe302b21d0$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $1d3138fe302b21d0$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $1d3138fe302b21d0$var$_tokenExpiresIn(token) {
    const parsedToken = $1d3138fe302b21d0$var$_parseToken(token);
    $1d3138fe302b21d0$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56) && $1d3138fe302b21d0$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $1d3138fe302b21d0$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $1d3138fe302b21d0$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $1d3138fe302b21d0$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $1d3138fe302b21d0$var$_logoutIfInvalidated(user, $1d3138fe302b21d0$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $1d3138fe302b21d0$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $1d3138fe302b21d0$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $1d3138fe302b21d0$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $1d3138fe302b21d0$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$d24c54395ce0c509(user) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    await $1d3138fe302b21d0$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $1d3138fe302b21d0$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $1d3138fe302b21d0$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $a30250e776d41ddb$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$requestStsToken(auth, refreshToken) {
    const response = await $1d3138fe302b21d0$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $0ca209b9dac42ea9$export$ac4103b836844853)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $1d3138fe302b21d0$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $1d3138fe302b21d0$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $1d3138fe302b21d0$var$revokeToken(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $1d3138fe302b21d0$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $1d3138fe302b21d0$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $1d3138fe302b21d0$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $1d3138fe302b21d0$var$StsTokenManager();
        if (refreshToken) {
            $1d3138fe302b21d0$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $1d3138fe302b21d0$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $1d3138fe302b21d0$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $1d3138fe302b21d0$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $1d3138fe302b21d0$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$assertStringOrUndefined(assertion, appName) {
    $1d3138fe302b21d0$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $1d3138fe302b21d0$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $a30250e776d41ddb$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $1d3138fe302b21d0$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $1d3138fe302b21d0$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $1d3138fe302b21d0$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $1d3138fe302b21d0$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $1d3138fe302b21d0$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $1d3138fe302b21d0$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $1d3138fe302b21d0$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $1d3138fe302b21d0$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $1d3138fe302b21d0$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $1d3138fe302b21d0$var$_logoutIfInvalidated(this, $1d3138fe302b21d0$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $1d3138fe302b21d0$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $1d3138fe302b21d0$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $1d3138fe302b21d0$var$assertStringOrUndefined(displayName, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(email, auth.name);
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $1d3138fe302b21d0$var$assertStringOrUndefined(phoneNumber, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(photoURL, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(tenantId, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(createdAt, auth.name);
        $1d3138fe302b21d0$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $1d3138fe302b21d0$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $1d3138fe302b21d0$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $1d3138fe302b21d0$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $1d3138fe302b21d0$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$instanceCache = new Map();
function $1d3138fe302b21d0$export$158acd800e1ef08b(cls) {
    $1d3138fe302b21d0$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $1d3138fe302b21d0$var$instanceCache.get(cls);
    if (instance) {
        $1d3138fe302b21d0$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $1d3138fe302b21d0$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$1d3138fe302b21d0$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $1d3138fe302b21d0$export$3a6d5c9ae78a2c08 = $1d3138fe302b21d0$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $1d3138fe302b21d0$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $1d3138fe302b21d0$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $1d3138fe302b21d0$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $1d3138fe302b21d0$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $1d3138fe302b21d0$var$PersistenceUserManager($1d3138fe302b21d0$export$158acd800e1ef08b($1d3138fe302b21d0$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $1d3138fe302b21d0$export$158acd800e1ef08b($1d3138fe302b21d0$export$3a6d5c9ae78a2c08);
        const key = $1d3138fe302b21d0$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $1d3138fe302b21d0$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $1d3138fe302b21d0$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $1d3138fe302b21d0$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $1d3138fe302b21d0$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($1d3138fe302b21d0$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($1d3138fe302b21d0$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($1d3138fe302b21d0$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($1d3138fe302b21d0$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($1d3138fe302b21d0$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $1d3138fe302b21d0$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($1d3138fe302b21d0$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $1d3138fe302b21d0$var$_isFirefox(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $1d3138fe302b21d0$var$_isSafari(userAgent = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $1d3138fe302b21d0$var$_isChromeIOS(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $1d3138fe302b21d0$var$_isIEMobile(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $1d3138fe302b21d0$export$92108d983e8ee699(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $1d3138fe302b21d0$var$_isBlackBerry(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $1d3138fe302b21d0$var$_isWebOS(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $1d3138fe302b21d0$export$d66dc83d8cfc8dd(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $1d3138fe302b21d0$export$91c6e00c14e7e6fd(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $1d3138fe302b21d0$var$_isIOSStandalone(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    var _a;
    return $1d3138fe302b21d0$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $1d3138fe302b21d0$var$_isIE10() {
    return (0, $0ca209b9dac42ea9$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $1d3138fe302b21d0$var$_isMobileBrowser(ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $1d3138fe302b21d0$export$d66dc83d8cfc8dd(ua) || $1d3138fe302b21d0$export$92108d983e8ee699(ua) || $1d3138fe302b21d0$var$_isWebOS(ua) || $1d3138fe302b21d0$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $1d3138fe302b21d0$var$_isIEMobile(ua);
}
function $1d3138fe302b21d0$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $1d3138fe302b21d0$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $1d3138fe302b21d0$var$_getBrowserName((0, $0ca209b9dac42ea9$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$1d3138fe302b21d0$var$_getBrowserName((0, $0ca209b9dac42ea9$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $494b068b89b4758a$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $1d3138fe302b21d0$var$_getPasswordPolicy(auth, request = {}) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $1d3138fe302b21d0$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $1d3138fe302b21d0$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $1d3138fe302b21d0$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $1d3138fe302b21d0$var$Subscription(this);
        this.idTokenSubscription = new $1d3138fe302b21d0$var$Subscription(this);
        this.beforeStateQueue = new $1d3138fe302b21d0$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $1d3138fe302b21d0$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $1d3138fe302b21d0$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $1d3138fe302b21d0$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $1d3138fe302b21d0$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $1d3138fe302b21d0$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $1d3138fe302b21d0$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $1d3138fe302b21d0$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $1d3138fe302b21d0$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($1d3138fe302b21d0$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $1d3138fe302b21d0$var$_getPasswordPolicy(this);
        const passwordPolicy = new $1d3138fe302b21d0$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $1d3138fe302b21d0$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $1d3138fe302b21d0$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $1d3138fe302b21d0$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $1d3138fe302b21d0$var$PersistenceUserManager.create(this, [
                $1d3138fe302b21d0$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $1d3138fe302b21d0$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $1d3138fe302b21d0$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $1d3138fe302b21d0$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $1d3138fe302b21d0$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $0ca209b9dac42ea9$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $1d3138fe302b21d0$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $1d3138fe302b21d0$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $1d3138fe302b21d0$var$getScriptParentElement().appendChild(el);
    });
}
function $1d3138fe302b21d0$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $1d3138fe302b21d0$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
const $1d3138fe302b21d0$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $1d3138fe302b21d0$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $1d3138fe302b21d0$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $1d3138fe302b21d0$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $1d3138fe302b21d0$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $1d3138fe302b21d0$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $1d3138fe302b21d0$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($1d3138fe302b21d0$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($1d3138fe302b21d0$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $1d3138fe302b21d0$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    $1d3138fe302b21d0$var$_loadJS($1d3138fe302b21d0$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $1d3138fe302b21d0$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $1d3138fe302b21d0$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $1d3138fe302b21d0$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $1d3138fe302b21d0$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $1d3138fe302b21d0$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $1d3138fe302b21d0$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const response = await $1d3138fe302b21d0$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $1d3138fe302b21d0$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $1d3138fe302b21d0$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $1d3138fe302b21d0$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $0ca209b9dac42ea9$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $1d3138fe302b21d0$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($1d3138fe302b21d0$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $1d3138fe302b21d0$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    $1d3138fe302b21d0$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $1d3138fe302b21d0$var$extractProtocol(url);
    const { host: host, port: port } = $1d3138fe302b21d0$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $1d3138fe302b21d0$var$emitEmulatorWarning();
}
function $1d3138fe302b21d0$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $1d3138fe302b21d0$var$extractHostAndPort(url) {
    const protocol = $1d3138fe302b21d0$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $1d3138fe302b21d0$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $1d3138fe302b21d0$var$parsePort(port)
        };
    }
}
function $1d3138fe302b21d0$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $1d3138fe302b21d0$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $1d3138fe302b21d0$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $1d3138fe302b21d0$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $1d3138fe302b21d0$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $1d3138fe302b21d0$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $1d3138fe302b21d0$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$resetPassword(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$updateEmailPassword(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $1d3138fe302b21d0$var$linkEmailPassword(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $1d3138fe302b21d0$var$applyActionCode$1(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$signInWithPassword(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$sendOobCode(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$sendEmailVerification$1(auth, request) {
    return $1d3138fe302b21d0$var$sendOobCode(auth, request);
}
async function $1d3138fe302b21d0$var$sendPasswordResetEmail$1(auth, request) {
    return $1d3138fe302b21d0$var$sendOobCode(auth, request);
}
async function $1d3138fe302b21d0$var$sendSignInLinkToEmail$1(auth, request) {
    return $1d3138fe302b21d0$var$sendOobCode(auth, request);
}
async function $1d3138fe302b21d0$var$verifyAndChangeEmail(auth, request) {
    return $1d3138fe302b21d0$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$signInWithEmailLink$1(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$signInWithEmailLinkForLinking(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $1d3138fe302b21d0$export$3a1a48c8f6ef640e extends $1d3138fe302b21d0$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $1d3138fe302b21d0$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $1d3138fe302b21d0$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $1d3138fe302b21d0$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $1d3138fe302b21d0$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $1d3138fe302b21d0$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $1d3138fe302b21d0$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $1d3138fe302b21d0$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $1d3138fe302b21d0$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$signInWithIdp(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $1d3138fe302b21d0$export$a07804094c3ecf2d extends $1d3138fe302b21d0$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $1d3138fe302b21d0$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $1d3138fe302b21d0$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $a30250e776d41ddb$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $1d3138fe302b21d0$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $1d3138fe302b21d0$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $0ca209b9dac42ea9$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$sendPhoneVerificationCode(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$signInWithPhoneNumber$1(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
async function $1d3138fe302b21d0$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $1d3138fe302b21d0$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $1d3138fe302b21d0$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $1d3138fe302b21d0$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, apiRequest), $1d3138fe302b21d0$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $1d3138fe302b21d0$export$3722cfe417b6ed86 extends $1d3138fe302b21d0$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $1d3138fe302b21d0$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $1d3138fe302b21d0$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $1d3138fe302b21d0$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $1d3138fe302b21d0$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $1d3138fe302b21d0$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $1d3138fe302b21d0$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $1d3138fe302b21d0$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $1d3138fe302b21d0$var$parseDeepLink(url) {
    const link = (0, $0ca209b9dac42ea9$export$c1271ca4c8a70741)((0, $0ca209b9dac42ea9$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $0ca209b9dac42ea9$export$c1271ca4c8a70741)((0, $0ca209b9dac42ea9$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $0ca209b9dac42ea9$export$c1271ca4c8a70741)((0, $0ca209b9dac42ea9$export$1a8408415472d8ed)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $0ca209b9dac42ea9$export$c1271ca4c8a70741)((0, $0ca209b9dac42ea9$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $1d3138fe302b21d0$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $0ca209b9dac42ea9$export$c1271ca4c8a70741)((0, $0ca209b9dac42ea9$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $1d3138fe302b21d0$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $1d3138fe302b21d0$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $1d3138fe302b21d0$var$parseDeepLink(link);
        try {
            return new $1d3138fe302b21d0$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $1d3138fe302b21d0$export$3b513254972cfc9c(link) {
    return $1d3138fe302b21d0$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $1d3138fe302b21d0$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $1d3138fe302b21d0$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $1d3138fe302b21d0$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $1d3138fe302b21d0$export$f38c853ae54ed474.parseLink(emailLink);
        $1d3138fe302b21d0$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $1d3138fe302b21d0$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $1d3138fe302b21d0$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $1d3138fe302b21d0$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $1d3138fe302b21d0$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $1d3138fe302b21d0$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $1d3138fe302b21d0$var$BaseOAuthProvider extends $1d3138fe302b21d0$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $1d3138fe302b21d0$export$dc98b0b04f4c7758 extends $1d3138fe302b21d0$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $1d3138fe302b21d0$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $1d3138fe302b21d0$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $1d3138fe302b21d0$export$71cec2538cb2c617 extends $1d3138fe302b21d0$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams({
            providerId: $1d3138fe302b21d0$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $1d3138fe302b21d0$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $1d3138fe302b21d0$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $1d3138fe302b21d0$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $1d3138fe302b21d0$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $1d3138fe302b21d0$export$78acf4525d8a74c4 extends $1d3138fe302b21d0$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams({
            providerId: $1d3138fe302b21d0$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $1d3138fe302b21d0$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $1d3138fe302b21d0$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $1d3138fe302b21d0$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $1d3138fe302b21d0$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $1d3138fe302b21d0$export$8743009a87fcb00f extends $1d3138fe302b21d0$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams({
            providerId: $1d3138fe302b21d0$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $1d3138fe302b21d0$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $1d3138fe302b21d0$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $1d3138fe302b21d0$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $1d3138fe302b21d0$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $1d3138fe302b21d0$export$f96d196f7728bb5 extends $1d3138fe302b21d0$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $1d3138fe302b21d0$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $1d3138fe302b21d0$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $1d3138fe302b21d0$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $1d3138fe302b21d0$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $1d3138fe302b21d0$export$71511d61b312f219 extends $1d3138fe302b21d0$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $1d3138fe302b21d0$export$890c4ad488842ce7(providerId.startsWith($1d3138fe302b21d0$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $1d3138fe302b21d0$export$f96d196f7728bb5.fromJSON(json);
        $1d3138fe302b21d0$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $1d3138fe302b21d0$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $1d3138fe302b21d0$export$3d8c2f653ac9d0b9 extends $1d3138fe302b21d0$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $1d3138fe302b21d0$export$a07804094c3ecf2d._fromParams({
            providerId: $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $1d3138fe302b21d0$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$signUp(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $1d3138fe302b21d0$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $1d3138fe302b21d0$var$providerIdForResponse(idTokenResponse);
        const userCred = new $1d3138fe302b21d0$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $1d3138fe302b21d0$var$providerIdForResponse(response);
        return new $1d3138fe302b21d0$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $1d3138fe302b21d0$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$34aec0b863436764(auth) {
    var _a;
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $1d3138fe302b21d0$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $1d3138fe302b21d0$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $1d3138fe302b21d0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$MultiFactorError extends (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $1d3138fe302b21d0$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $1d3138fe302b21d0$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $1d3138fe302b21d0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $1d3138fe302b21d0$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $1d3138fe302b21d0$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    await $1d3138fe302b21d0$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $1d3138fe302b21d0$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $1d3138fe302b21d0$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $1d3138fe302b21d0$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $1d3138fe302b21d0$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $1d3138fe302b21d0$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $1d3138fe302b21d0$var$_assertLinkedStatus(expected, user, provider) {
    await $1d3138fe302b21d0$var$_reloadWithoutSaving(user);
    const providerIds = $1d3138fe302b21d0$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $1d3138fe302b21d0$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $1d3138fe302b21d0$var$_logoutIfInvalidated(user, $1d3138fe302b21d0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $1d3138fe302b21d0$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $1d3138fe302b21d0$var$_parseToken(response.idToken);
        $1d3138fe302b21d0$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $1d3138fe302b21d0$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $1d3138fe302b21d0$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $1d3138fe302b21d0$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $1d3138fe302b21d0$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$3c2fa207a37baaea(auth, credential) {
    return $1d3138fe302b21d0$var$_signInWithCredential($1d3138fe302b21d0$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    await $1d3138fe302b21d0$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $1d3138fe302b21d0$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$6559d589eb85fbb6(user, credential) {
    return $1d3138fe302b21d0$var$_reauthenticate((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$signInWithCustomToken$1(auth, request) {
    return $1d3138fe302b21d0$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$efca4cbe5dd06740(auth, customToken) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const response = await $1d3138fe302b21d0$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $1d3138fe302b21d0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $1d3138fe302b21d0$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $1d3138fe302b21d0$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $1d3138fe302b21d0$var$PhoneMultiFactorInfoImpl extends $1d3138fe302b21d0$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $1d3138fe302b21d0$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $1d3138fe302b21d0$var$TotpMultiFactorInfoImpl extends $1d3138fe302b21d0$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $1d3138fe302b21d0$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $1d3138fe302b21d0$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $1d3138fe302b21d0$var$recachePasswordPolicy(auth) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $1d3138fe302b21d0$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $1d3138fe302b21d0$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $1d3138fe302b21d0$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $1d3138fe302b21d0$var$resetPassword((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $1d3138fe302b21d0$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$a93c5207d687da10(auth, oobCode) {
    await $1d3138fe302b21d0$var$applyActionCode$1((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth);
    const response = await $1d3138fe302b21d0$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $1d3138fe302b21d0$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $1d3138fe302b21d0$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $1d3138fe302b21d0$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $1d3138fe302b21d0$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $1d3138fe302b21d0$var$MultiFactorInfoImpl._fromServerResponse($1d3138fe302b21d0$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $1d3138fe302b21d0$export$c3950d9923825c02((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$7910e0436ed8d1de(auth, email, password) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $1d3138fe302b21d0$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $1d3138fe302b21d0$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $1d3138fe302b21d0$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $1d3138fe302b21d0$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $1d3138fe302b21d0$export$555508cbc6add439(auth, email, password) {
    return $1d3138fe302b21d0$export$3c2fa207a37baaea((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth), $1d3138fe302b21d0$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $1d3138fe302b21d0$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $1d3138fe302b21d0$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $1d3138fe302b21d0$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $1d3138fe302b21d0$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $1d3138fe302b21d0$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $1d3138fe302b21d0$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$f787f51d84a910ad(auth, email, emailLink) {
    const authModular = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth);
    const credential = $1d3138fe302b21d0$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $1d3138fe302b21d0$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $1d3138fe302b21d0$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $1d3138fe302b21d0$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$createAuthUri(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $1d3138fe302b21d0$var$_isHttpOrHttps() ? $1d3138fe302b21d0$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $1d3138fe302b21d0$var$createAuthUri((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $1d3138fe302b21d0$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $1d3138fe302b21d0$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $1d3138fe302b21d0$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $1d3138fe302b21d0$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$var$updateProfile$1(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $1d3138fe302b21d0$var$_logoutIfInvalidated(userInternal, $1d3138fe302b21d0$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $1d3138fe302b21d0$export$ab83b03e4111b1d0(user, newEmail) {
    return $1d3138fe302b21d0$var$updateEmailOrPassword((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $1d3138fe302b21d0$export$1a82df3d29112e01(user, newPassword) {
    return $1d3138fe302b21d0$var$updateEmailOrPassword((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $1d3138fe302b21d0$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $1d3138fe302b21d0$var$_logoutIfInvalidated(user, $1d3138fe302b21d0$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $1d3138fe302b21d0$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $1d3138fe302b21d0$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $1d3138fe302b21d0$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $1d3138fe302b21d0$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $1d3138fe302b21d0$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $1d3138fe302b21d0$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $1d3138fe302b21d0$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $1d3138fe302b21d0$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $1d3138fe302b21d0$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $1d3138fe302b21d0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $1d3138fe302b21d0$var$FederatedAdditionalUserInfoWithUsername extends $1d3138fe302b21d0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $1d3138fe302b21d0$var$FacebookAdditionalUserInfo extends $1d3138fe302b21d0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $1d3138fe302b21d0$var$GithubAdditionalUserInfo extends $1d3138fe302b21d0$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $1d3138fe302b21d0$var$GoogleAdditionalUserInfo extends $1d3138fe302b21d0$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $1d3138fe302b21d0$var$TwitterAdditionalUserInfo extends $1d3138fe302b21d0$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $1d3138fe302b21d0$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $1d3138fe302b21d0$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $1d3138fe302b21d0$export$9e5f44173e64f162(auth, persistence) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $1d3138fe302b21d0$export$625550452a3fa3ec(auth) {
    return $1d3138fe302b21d0$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$90a7f3efeed30595(auth, password) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $1d3138fe302b21d0$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $1d3138fe302b21d0$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $1d3138fe302b21d0$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $1d3138fe302b21d0$export$df995fae86a55f06(auth) {
    (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $1d3138fe302b21d0$export$ef35774e6d314e91(auth, user) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $1d3138fe302b21d0$export$e7094788287c5e9b(auth) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $1d3138fe302b21d0$export$96f57966bedc81b4(auth, token) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$a9c23c6ac3fc3eca(user) {
    return (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $1d3138fe302b21d0$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $1d3138fe302b21d0$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $1d3138fe302b21d0$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $1d3138fe302b21d0$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $1d3138fe302b21d0$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$1d3138fe302b21d0$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $1d3138fe302b21d0$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $1d3138fe302b21d0$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $1d3138fe302b21d0$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $1d3138fe302b21d0$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $1d3138fe302b21d0$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $1d3138fe302b21d0$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $1d3138fe302b21d0$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $1d3138fe302b21d0$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $1d3138fe302b21d0$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$startEnrollPhoneMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$finalizeEnrollPhoneMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$startEnrollTotpMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$finalizeEnrollTotpMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$withdrawMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
class $1d3138fe302b21d0$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$1d3138fe302b21d0$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $1d3138fe302b21d0$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $1d3138fe302b21d0$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $1d3138fe302b21d0$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $1d3138fe302b21d0$var$_logoutIfInvalidated(this.user, $1d3138fe302b21d0$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $1d3138fe302b21d0$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $1d3138fe302b21d0$export$493d36ec626b6698(user) {
    const userModular = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    if (!$1d3138fe302b21d0$var$multiFactorUserCache.has(userModular)) $1d3138fe302b21d0$var$multiFactorUserCache.set(userModular, $1d3138fe302b21d0$var$MultiFactorUserImpl._fromUser(userModular));
    return $1d3138fe302b21d0$var$multiFactorUserCache.get(userModular);
}
const $1d3138fe302b21d0$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $1d3138fe302b21d0$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($1d3138fe302b21d0$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($1d3138fe302b21d0$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)();
    return $1d3138fe302b21d0$var$_isSafari(ua) || $1d3138fe302b21d0$export$d66dc83d8cfc8dd(ua);
}
// The polling period in case events are not supported
const $1d3138fe302b21d0$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $1d3138fe302b21d0$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $1d3138fe302b21d0$var$BrowserLocalPersistence extends $1d3138fe302b21d0$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $1d3138fe302b21d0$var$_iframeCannotSyncWebStorage() && $1d3138fe302b21d0$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $1d3138fe302b21d0$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($1d3138fe302b21d0$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $1d3138fe302b21d0$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $1d3138fe302b21d0$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$1d3138fe302b21d0$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $1d3138fe302b21d0$export$8b22cf2602fb60ce = $1d3138fe302b21d0$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$BrowserSessionPersistence extends $1d3138fe302b21d0$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$1d3138fe302b21d0$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $1d3138fe302b21d0$export$407448d2b89b1813 = $1d3138fe302b21d0$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $1d3138fe302b21d0$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $1d3138fe302b21d0$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $1d3138fe302b21d0$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $1d3138fe302b21d0$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$1d3138fe302b21d0$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $1d3138fe302b21d0$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $1d3138fe302b21d0$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $1d3138fe302b21d0$var$_window() {
    return window;
}
function $1d3138fe302b21d0$var$_setWindowLocation(url) {
    $1d3138fe302b21d0$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$_isWorker() {
    return typeof $1d3138fe302b21d0$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $1d3138fe302b21d0$var$_window()["importScripts"] === "function";
}
async function $1d3138fe302b21d0$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $1d3138fe302b21d0$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $1d3138fe302b21d0$var$_getWorkerGlobalScope() {
    return $1d3138fe302b21d0$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$DB_NAME = "firebaseLocalStorageDb";
const $1d3138fe302b21d0$var$DB_VERSION = 1;
const $1d3138fe302b21d0$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $1d3138fe302b21d0$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $1d3138fe302b21d0$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $1d3138fe302b21d0$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $1d3138fe302b21d0$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($1d3138fe302b21d0$var$DB_OBJECTSTORE_NAME);
}
function $1d3138fe302b21d0$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($1d3138fe302b21d0$var$DB_NAME);
    return new $1d3138fe302b21d0$var$DBPromise(request).toPromise();
}
function $1d3138fe302b21d0$var$_openDatabase() {
    const request = indexedDB.open($1d3138fe302b21d0$var$DB_NAME, $1d3138fe302b21d0$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($1d3138fe302b21d0$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $1d3138fe302b21d0$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($1d3138fe302b21d0$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $1d3138fe302b21d0$var$_deleteDatabase();
                resolve(await $1d3138fe302b21d0$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $1d3138fe302b21d0$var$_putObject(db, key, value) {
    const request = $1d3138fe302b21d0$var$getObjectStore(db, true).put({
        [$1d3138fe302b21d0$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $1d3138fe302b21d0$var$DBPromise(request).toPromise();
}
async function $1d3138fe302b21d0$var$getObject(db, key) {
    const request = $1d3138fe302b21d0$var$getObjectStore(db, false).get(key);
    const data = await new $1d3138fe302b21d0$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $1d3138fe302b21d0$var$_deleteObject(db, key) {
    const request = $1d3138fe302b21d0$var$getObjectStore(db, true).delete(key);
    return new $1d3138fe302b21d0$var$DBPromise(request).toPromise();
}
const $1d3138fe302b21d0$var$_POLLING_INTERVAL_MS = 800;
const $1d3138fe302b21d0$var$_TRANSACTION_RETRY_COUNT = 3;
class $1d3138fe302b21d0$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $1d3138fe302b21d0$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $1d3138fe302b21d0$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $1d3138fe302b21d0$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $1d3138fe302b21d0$var$Receiver._getInstance($1d3138fe302b21d0$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $1d3138fe302b21d0$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $1d3138fe302b21d0$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $1d3138fe302b21d0$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $1d3138fe302b21d0$var$_openDatabase();
            await $1d3138fe302b21d0$var$_putObject(db, $1d3138fe302b21d0$var$STORAGE_AVAILABLE_KEY, "1");
            await $1d3138fe302b21d0$var$_deleteObject(db, $1d3138fe302b21d0$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$1d3138fe302b21d0$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$1d3138fe302b21d0$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$1d3138fe302b21d0$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $1d3138fe302b21d0$var$getObjectStore(db, false).getAll();
            return new $1d3138fe302b21d0$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $1d3138fe302b21d0$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$1d3138fe302b21d0$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $1d3138fe302b21d0$export$23f2a1d2818174ef = $1d3138fe302b21d0$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$startSignInPhoneMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$finalizeSignInPhoneMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
function $1d3138fe302b21d0$var$finalizeSignInTotpMfa(auth, request) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $1d3138fe302b21d0$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$_SOLVE_TIME_MS = 500;
const $1d3138fe302b21d0$var$_EXPIRATION_TIME_MS = 60000;
const $1d3138fe302b21d0$var$_WIDGET_ID_START = 1000000000000;
class $1d3138fe302b21d0$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $1d3138fe302b21d0$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $1d3138fe302b21d0$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $1d3138fe302b21d0$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $1d3138fe302b21d0$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $1d3138fe302b21d0$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $1d3138fe302b21d0$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $1d3138fe302b21d0$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $1d3138fe302b21d0$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $1d3138fe302b21d0$var$_EXPIRATION_TIME_MS);
        }, $1d3138fe302b21d0$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $1d3138fe302b21d0$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $1d3138fe302b21d0$var$_JSLOAD_CALLBACK = $1d3138fe302b21d0$var$_generateCallbackName("rcb");
const $1d3138fe302b21d0$var$NETWORK_TIMEOUT_DELAY = new $1d3138fe302b21d0$var$Delay(30000, 60000);
const $1d3138fe302b21d0$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $1d3138fe302b21d0$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $1d3138fe302b21d0$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $1d3138fe302b21d0$export$890c4ad488842ce7($1d3138fe302b21d0$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $1d3138fe302b21d0$var$isV2($1d3138fe302b21d0$var$_window().grecaptcha)) return Promise.resolve($1d3138fe302b21d0$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $1d3138fe302b21d0$var$_window().setTimeout(()=>{
                reject($1d3138fe302b21d0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $1d3138fe302b21d0$var$NETWORK_TIMEOUT_DELAY.get());
            $1d3138fe302b21d0$var$_window()[$1d3138fe302b21d0$var$_JSLOAD_CALLBACK] = ()=>{
                $1d3138fe302b21d0$var$_window().clearTimeout(networkTimeout);
                delete $1d3138fe302b21d0$var$_window()[$1d3138fe302b21d0$var$_JSLOAD_CALLBACK];
                const recaptcha = $1d3138fe302b21d0$var$_window().grecaptcha;
                if (!recaptcha || !$1d3138fe302b21d0$var$isV2(recaptcha)) {
                    reject($1d3138fe302b21d0$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$1d3138fe302b21d0$var$RECAPTCHA_BASE}?${(0, $0ca209b9dac42ea9$export$ac4103b836844853)({
                onload: $1d3138fe302b21d0$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $1d3138fe302b21d0$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($1d3138fe302b21d0$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $1d3138fe302b21d0$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $1d3138fe302b21d0$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $1d3138fe302b21d0$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $1d3138fe302b21d0$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $1d3138fe302b21d0$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $1d3138fe302b21d0$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $1d3138fe302b21d0$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $1d3138fe302b21d0$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $1d3138fe302b21d0$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $1d3138fe302b21d0$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $1d3138fe302b21d0$var$MockReCaptchaLoaderImpl() : new $1d3138fe302b21d0$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $1d3138fe302b21d0$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $1d3138fe302b21d0$export$890c4ad488842ce7($1d3138fe302b21d0$var$_isHttpOrHttps() && !$1d3138fe302b21d0$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $1d3138fe302b21d0$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $1d3138fe302b21d0$var$getRecaptchaParams(this.auth);
        $1d3138fe302b21d0$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $1d3138fe302b21d0$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $1d3138fe302b21d0$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const verificationId = await $1d3138fe302b21d0$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(appVerifier));
    return new $1d3138fe302b21d0$var$ConfirmationResultImpl(verificationId, (cred)=>$1d3138fe302b21d0$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    await $1d3138fe302b21d0$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $1d3138fe302b21d0$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(appVerifier));
    return new $1d3138fe302b21d0$var$ConfirmationResultImpl(verificationId, (cred)=>$1d3138fe302b21d0$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    const verificationId = await $1d3138fe302b21d0$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(appVerifier));
    return new $1d3138fe302b21d0$var$ConfirmationResultImpl(verificationId, (cred)=>$1d3138fe302b21d0$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $1d3138fe302b21d0$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $1d3138fe302b21d0$export$890c4ad488842ce7(verifier.type === $1d3138fe302b21d0$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $1d3138fe302b21d0$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $1d3138fe302b21d0$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $1d3138fe302b21d0$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $1d3138fe302b21d0$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $1d3138fe302b21d0$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $1d3138fe302b21d0$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$3b14a55fb2447963(user, credential) {
    await $1d3138fe302b21d0$var$_link$1((0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $1d3138fe302b21d0$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $1d3138fe302b21d0$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $1d3138fe302b21d0$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $1d3138fe302b21d0$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $1d3138fe302b21d0$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $1d3138fe302b21d0$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $1d3138fe302b21d0$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $1d3138fe302b21d0$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $1d3138fe302b21d0$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $1d3138fe302b21d0$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $1d3138fe302b21d0$export$158acd800e1ef08b(resolverOverride);
    $1d3138fe302b21d0$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$IdpCredential extends $1d3138fe302b21d0$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $1d3138fe302b21d0$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $1d3138fe302b21d0$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $1d3138fe302b21d0$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $1d3138fe302b21d0$var$_signIn(params) {
    return $1d3138fe302b21d0$var$_signInWithCredential(params.auth, new $1d3138fe302b21d0$var$IdpCredential(params), params.bypassAuthState);
}
function $1d3138fe302b21d0$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $1d3138fe302b21d0$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $1d3138fe302b21d0$var$_reauthenticate(user, new $1d3138fe302b21d0$var$IdpCredential(params), params.bypassAuthState);
}
async function $1d3138fe302b21d0$var$_link(params) {
    const { auth: auth, user: user } = params;
    $1d3138fe302b21d0$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $1d3138fe302b21d0$var$_link$1(user, new $1d3138fe302b21d0$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $1d3138fe302b21d0$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $1d3138fe302b21d0$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $1d3138fe302b21d0$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $1d3138fe302b21d0$var$_reauth;
            default:
                $1d3138fe302b21d0$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $1d3138fe302b21d0$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $1d3138fe302b21d0$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $1d3138fe302b21d0$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    $1d3138fe302b21d0$var$_assertInstanceOf(auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(authInternal, resolver);
    const action = new $1d3138fe302b21d0$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    $1d3138fe302b21d0$var$_assertInstanceOf(userInternal.auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $1d3138fe302b21d0$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    $1d3138fe302b21d0$var$_assertInstanceOf(userInternal.auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $1d3138fe302b21d0$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $1d3138fe302b21d0$var$PopupOperation extends $1d3138fe302b21d0$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($1d3138fe302b21d0$var$PopupOperation.currentPopupAction) $1d3138fe302b21d0$var$PopupOperation.currentPopupAction.cancel();
        $1d3138fe302b21d0$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $1d3138fe302b21d0$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $1d3138fe302b21d0$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $1d3138fe302b21d0$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($1d3138fe302b21d0$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($1d3138fe302b21d0$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $1d3138fe302b21d0$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($1d3138fe302b21d0$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $1d3138fe302b21d0$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$1d3138fe302b21d0$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $1d3138fe302b21d0$var$redirectOutcomeMap = new Map();
class $1d3138fe302b21d0$var$RedirectAction extends $1d3138fe302b21d0$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $1d3138fe302b21d0$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $1d3138fe302b21d0$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $1d3138fe302b21d0$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $1d3138fe302b21d0$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $1d3138fe302b21d0$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $1d3138fe302b21d0$var$pendingRedirectKey(auth);
    const persistence = $1d3138fe302b21d0$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $1d3138fe302b21d0$var$_setPendingRedirectStatus(resolver, auth) {
    return $1d3138fe302b21d0$var$resolverPersistence(resolver)._set($1d3138fe302b21d0$var$pendingRedirectKey(auth), "true");
}
function $1d3138fe302b21d0$export$b9a6b53f9be3734() {
    $1d3138fe302b21d0$var$redirectOutcomeMap.clear();
}
function $1d3138fe302b21d0$export$a33b77bbdbb8366c(auth, result) {
    $1d3138fe302b21d0$var$redirectOutcomeMap.set(auth._key(), result);
}
function $1d3138fe302b21d0$var$resolverPersistence(resolver) {
    return $1d3138fe302b21d0$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $1d3138fe302b21d0$var$pendingRedirectKey(auth) {
    return $1d3138fe302b21d0$export$cf2f7c5792f80b46($1d3138fe302b21d0$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $1d3138fe302b21d0$export$2d1720544b23b823(auth, provider, resolver) {
    return $1d3138fe302b21d0$var$_signInWithRedirect(auth, provider, resolver);
}
async function $1d3138fe302b21d0$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    $1d3138fe302b21d0$var$_assertInstanceOf(auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(authInternal, resolver);
    await $1d3138fe302b21d0$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $1d3138fe302b21d0$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $1d3138fe302b21d0$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $1d3138fe302b21d0$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    $1d3138fe302b21d0$var$_assertInstanceOf(userInternal.auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(userInternal.auth, resolver);
    await $1d3138fe302b21d0$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $1d3138fe302b21d0$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $1d3138fe302b21d0$export$39b482c5e57630a8(user, provider, resolver) {
    return $1d3138fe302b21d0$var$_linkWithRedirect(user, provider, resolver);
}
async function $1d3138fe302b21d0$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(user);
    $1d3138fe302b21d0$var$_assertInstanceOf(userInternal.auth, provider, $1d3138fe302b21d0$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $1d3138fe302b21d0$var$_withDefaultResolver(userInternal.auth, resolver);
    await $1d3138fe302b21d0$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $1d3138fe302b21d0$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $1d3138fe302b21d0$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $1d3138fe302b21d0$export$35e795649ee09318(auth, resolver) {
    await $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $1d3138fe302b21d0$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $1d3138fe302b21d0$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $1d3138fe302b21d0$export$a05254e7c3aeba6e(auth);
    const resolver = $1d3138fe302b21d0$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $1d3138fe302b21d0$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $1d3138fe302b21d0$var$prepareUserForRedirect(user) {
    const eventId = $1d3138fe302b21d0$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $1d3138fe302b21d0$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $1d3138fe302b21d0$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$1d3138fe302b21d0$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$1d3138fe302b21d0$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($1d3138fe302b21d0$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $1d3138fe302b21d0$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($1d3138fe302b21d0$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($1d3138fe302b21d0$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $1d3138fe302b21d0$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $1d3138fe302b21d0$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $1d3138fe302b21d0$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $1d3138fe302b21d0$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1d3138fe302b21d0$export$3d12bd131bb975d1(auth, request = {}) {
    return $1d3138fe302b21d0$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $1d3138fe302b21d0$var$HTTP_REGEX = /^https?/;
async function $1d3138fe302b21d0$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $1d3138fe302b21d0$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($1d3138fe302b21d0$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $1d3138fe302b21d0$var$matchDomain(expected) {
    const currentUrl = $1d3138fe302b21d0$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$1d3138fe302b21d0$var$HTTP_REGEX.test(protocol)) return false;
    if ($1d3138fe302b21d0$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$NETWORK_TIMEOUT = new $1d3138fe302b21d0$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $1d3138fe302b21d0$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $1d3138fe302b21d0$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $1d3138fe302b21d0$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $1d3138fe302b21d0$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $1d3138fe302b21d0$var$resetUnloadedGapiModules();
                    reject($1d3138fe302b21d0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $1d3138fe302b21d0$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $1d3138fe302b21d0$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $1d3138fe302b21d0$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $1d3138fe302b21d0$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $1d3138fe302b21d0$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($1d3138fe302b21d0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $1d3138fe302b21d0$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $1d3138fe302b21d0$var$cachedGApiLoader = null;
        throw error;
    });
}
let $1d3138fe302b21d0$var$cachedGApiLoader = null;
function $1d3138fe302b21d0$var$_loadGapi(auth) {
    $1d3138fe302b21d0$var$cachedGApiLoader = $1d3138fe302b21d0$var$cachedGApiLoader || $1d3138fe302b21d0$var$loadGapi(auth);
    return $1d3138fe302b21d0$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$PING_TIMEOUT = new $1d3138fe302b21d0$var$Delay(5000, 15000);
const $1d3138fe302b21d0$var$IFRAME_PATH = "__/auth/iframe";
const $1d3138fe302b21d0$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $1d3138fe302b21d0$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $1d3138fe302b21d0$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $1d3138fe302b21d0$var$getIframeUrl(auth) {
    const config = auth.config;
    $1d3138fe302b21d0$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $1d3138fe302b21d0$var$_emulatorUrl(config, $1d3138fe302b21d0$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$1d3138fe302b21d0$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $494b068b89b4758a$export$31499a9cd224b78c)
    };
    const eid = $1d3138fe302b21d0$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $0ca209b9dac42ea9$export$ac4103b836844853)(params).slice(1)}`;
}
async function $1d3138fe302b21d0$var$_openIframe(auth) {
    const context = await $1d3138fe302b21d0$var$_loadGapi(auth);
    const gapi1 = $1d3138fe302b21d0$var$_window().gapi;
    $1d3138fe302b21d0$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $1d3138fe302b21d0$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $1d3138fe302b21d0$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $1d3138fe302b21d0$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $1d3138fe302b21d0$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $1d3138fe302b21d0$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $1d3138fe302b21d0$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $1d3138fe302b21d0$var$DEFAULT_WIDTH = 500;
const $1d3138fe302b21d0$var$DEFAULT_HEIGHT = 600;
const $1d3138fe302b21d0$var$TARGET_BLANK = "_blank";
const $1d3138fe302b21d0$var$FIREFOX_EMPTY_URL = "http://localhost";
class $1d3138fe302b21d0$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $1d3138fe302b21d0$var$_open(auth, url, name, width = $1d3138fe302b21d0$var$DEFAULT_WIDTH, height = $1d3138fe302b21d0$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $1d3138fe302b21d0$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $0ca209b9dac42ea9$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $1d3138fe302b21d0$var$_isChromeIOS(ua) ? $1d3138fe302b21d0$var$TARGET_BLANK : name;
    if ($1d3138fe302b21d0$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $1d3138fe302b21d0$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($1d3138fe302b21d0$var$_isIOSStandalone(ua) && target !== "_self") {
        $1d3138fe302b21d0$var$openAsNewWindowIOS(url || "", target);
        return new $1d3138fe302b21d0$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $1d3138fe302b21d0$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $1d3138fe302b21d0$export$c03999cb2f36933f(newWin);
}
function $1d3138fe302b21d0$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $1d3138fe302b21d0$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $1d3138fe302b21d0$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $1d3138fe302b21d0$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $1d3138fe302b21d0$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $1d3138fe302b21d0$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $1d3138fe302b21d0$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $494b068b89b4758a$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $1d3138fe302b21d0$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $0ca209b9dac42ea9$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $1d3138fe302b21d0$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$1d3138fe302b21d0$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$1d3138fe302b21d0$var$getHandlerBase(auth)}?${(0, $0ca209b9dac42ea9$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $1d3138fe302b21d0$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$1d3138fe302b21d0$var$WIDGET_PATH}`;
    return $1d3138fe302b21d0$var$_emulatorUrl(config, $1d3138fe302b21d0$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $1d3138fe302b21d0$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $1d3138fe302b21d0$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $1d3138fe302b21d0$export$407448d2b89b1813;
        this._completeRedirectFn = $1d3138fe302b21d0$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $1d3138fe302b21d0$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $1d3138fe302b21d0$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $1d3138fe302b21d0$export$28f7fcd39efa255(auth, provider, authType, $1d3138fe302b21d0$var$_getCurrentUrl(), eventId);
        return $1d3138fe302b21d0$var$_open(auth, url, $1d3138fe302b21d0$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $1d3138fe302b21d0$export$28f7fcd39efa255(auth, provider, authType, $1d3138fe302b21d0$var$_getCurrentUrl(), eventId);
        $1d3138fe302b21d0$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $1d3138fe302b21d0$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $1d3138fe302b21d0$var$_openIframe(auth);
        const manager = new $1d3138fe302b21d0$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $1d3138fe302b21d0$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($1d3138fe302b21d0$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $1d3138fe302b21d0$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$1d3138fe302b21d0$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $1d3138fe302b21d0$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $1d3138fe302b21d0$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $1d3138fe302b21d0$var$_isMobileBrowser() || $1d3138fe302b21d0$var$_isSafari() || $1d3138fe302b21d0$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $1d3138fe302b21d0$export$342063e11d6c3cad = $1d3138fe302b21d0$var$BrowserPopupRedirectResolver;
class $1d3138fe302b21d0$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $1d3138fe302b21d0$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $1d3138fe302b21d0$var$PhoneMultiFactorAssertionImpl extends $1d3138fe302b21d0$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $1d3138fe302b21d0$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $1d3138fe302b21d0$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $1d3138fe302b21d0$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $1d3138fe302b21d0$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $1d3138fe302b21d0$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $1d3138fe302b21d0$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $1d3138fe302b21d0$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $1d3138fe302b21d0$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $1d3138fe302b21d0$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $1d3138fe302b21d0$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $1d3138fe302b21d0$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $1d3138fe302b21d0$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $1d3138fe302b21d0$var$TotpMultiFactorAssertionImpl extends $1d3138fe302b21d0$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $1d3138fe302b21d0$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $1d3138fe302b21d0$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $1d3138fe302b21d0$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $1d3138fe302b21d0$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $1d3138fe302b21d0$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $1d3138fe302b21d0$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($1d3138fe302b21d0$var$_isEmptyString(accountName) || $1d3138fe302b21d0$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($1d3138fe302b21d0$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($1d3138fe302b21d0$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $1d3138fe302b21d0$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $1d3138fe302b21d0$var$name = "@firebase/auth";
var $1d3138fe302b21d0$var$version = "1.4.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d3138fe302b21d0$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $1d3138fe302b21d0$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d3138fe302b21d0$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $1d3138fe302b21d0$var$registerAuth(clientPlatform) {
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $1d3138fe302b21d0$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $1d3138fe302b21d0$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $1d3138fe302b21d0$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $1d3138fe302b21d0$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $1d3138fe302b21d0$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $1d3138fe302b21d0$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $494b068b89b4758a$export$d29d5299a7137abc)($1d3138fe302b21d0$var$name, $1d3138fe302b21d0$var$version, $1d3138fe302b21d0$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $494b068b89b4758a$export$d29d5299a7137abc)($1d3138fe302b21d0$var$name, $1d3138fe302b21d0$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d3138fe302b21d0$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $1d3138fe302b21d0$var$authIdTokenMaxAge = (0, $0ca209b9dac42ea9$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $1d3138fe302b21d0$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $1d3138fe302b21d0$var$lastPostedIdToken = null;
const $1d3138fe302b21d0$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $1d3138fe302b21d0$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($1d3138fe302b21d0$var$lastPostedIdToken === idToken) return;
        $1d3138fe302b21d0$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $1d3138fe302b21d0$export$ae1af26003f05816(app = (0, $494b068b89b4758a$export$f9962582c9e66d99)()) {
    const provider = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $1d3138fe302b21d0$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $1d3138fe302b21d0$export$342063e11d6c3cad,
        persistence: [
            $1d3138fe302b21d0$export$23f2a1d2818174ef,
            $1d3138fe302b21d0$export$8b22cf2602fb60ce,
            $1d3138fe302b21d0$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $0ca209b9dac42ea9$export$5539a1a3afe87d6)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        const mintCookie = $1d3138fe302b21d0$var$mintCookieFactory(authTokenSyncUrl);
        $1d3138fe302b21d0$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $1d3138fe302b21d0$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $0ca209b9dac42ea9$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $1d3138fe302b21d0$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
$1d3138fe302b21d0$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );


















const $6e93f29bdef04086$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $6e93f29bdef04086$var$idbProxyableTypes;
let $6e93f29bdef04086$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $6e93f29bdef04086$var$getIdbProxyableTypes() {
    return $6e93f29bdef04086$var$idbProxyableTypes || ($6e93f29bdef04086$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $6e93f29bdef04086$var$getCursorAdvanceMethods() {
    return $6e93f29bdef04086$var$cursorAdvanceMethods || ($6e93f29bdef04086$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $6e93f29bdef04086$var$cursorRequestMap = new WeakMap();
const $6e93f29bdef04086$var$transactionDoneMap = new WeakMap();
const $6e93f29bdef04086$var$transactionStoreNamesMap = new WeakMap();
const $6e93f29bdef04086$var$transformCache = new WeakMap();
const $6e93f29bdef04086$export$407448d2b89b1813 = new WeakMap();
function $6e93f29bdef04086$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($6e93f29bdef04086$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $6e93f29bdef04086$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $6e93f29bdef04086$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $6e93f29bdef04086$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($6e93f29bdef04086$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $6e93f29bdef04086$var$transactionDoneMap.set(tx, done);
}
let $6e93f29bdef04086$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $6e93f29bdef04086$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $6e93f29bdef04086$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $6e93f29bdef04086$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $6e93f29bdef04086$export$43caf9889c228507(callback) {
    $6e93f29bdef04086$var$idbProxyTraps = callback($6e93f29bdef04086$var$idbProxyTraps);
}
function $6e93f29bdef04086$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($6e93f29bdef04086$export$3b14a55fb2447963(this), storeNames, ...args);
        $6e93f29bdef04086$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $6e93f29bdef04086$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($6e93f29bdef04086$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($6e93f29bdef04086$export$3b14a55fb2447963(this), args);
        return $6e93f29bdef04086$export$efccba1c4a2ef57b($6e93f29bdef04086$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $6e93f29bdef04086$export$efccba1c4a2ef57b(func.apply($6e93f29bdef04086$export$3b14a55fb2447963(this), args));
    };
}
function $6e93f29bdef04086$var$transformCachableValue(value) {
    if (typeof value === "function") return $6e93f29bdef04086$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $6e93f29bdef04086$var$cacheDonePromiseForTransaction(value);
    if ($6e93f29bdef04086$export$23f2a1d2818174ef(value, $6e93f29bdef04086$var$getIdbProxyableTypes())) return new Proxy(value, $6e93f29bdef04086$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $6e93f29bdef04086$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $6e93f29bdef04086$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($6e93f29bdef04086$var$transformCache.has(value)) return $6e93f29bdef04086$var$transformCache.get(value);
    const newValue = $6e93f29bdef04086$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $6e93f29bdef04086$var$transformCache.set(value, newValue);
        $6e93f29bdef04086$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $6e93f29bdef04086$export$3b14a55fb2447963 = (value)=>$6e93f29bdef04086$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $3a63bb1d70fa76b9$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $6e93f29bdef04086$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $6e93f29bdef04086$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $6e93f29bdef04086$export$efccba1c4a2ef57b)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $3a63bb1d70fa76b9$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $6e93f29bdef04086$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $3a63bb1d70fa76b9$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $3a63bb1d70fa76b9$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $3a63bb1d70fa76b9$var$cachedMethods = new Map();
function $3a63bb1d70fa76b9$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($3a63bb1d70fa76b9$var$cachedMethods.get(prop)) return $3a63bb1d70fa76b9$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $3a63bb1d70fa76b9$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $3a63bb1d70fa76b9$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $3a63bb1d70fa76b9$var$cachedMethods.set(prop, method);
    return method;
}
(0, $6e93f29bdef04086$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$3a63bb1d70fa76b9$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$3a63bb1d70fa76b9$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


const $48df29119ce51fd3$var$name = "@firebase/installations";
const $48df29119ce51fd3$var$version = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$PENDING_TIMEOUT_MS = 10000;
const $48df29119ce51fd3$var$PACKAGE_VERSION = `w:${$48df29119ce51fd3$var$version}`;
const $48df29119ce51fd3$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $48df29119ce51fd3$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $48df29119ce51fd3$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $48df29119ce51fd3$var$SERVICE = "installations";
const $48df29119ce51fd3$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $48df29119ce51fd3$var$ERROR_FACTORY = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)($48df29119ce51fd3$var$SERVICE, $48df29119ce51fd3$var$SERVICE_NAME, $48df29119ce51fd3$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $48df29119ce51fd3$var$isServerError(error) {
    return error instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $48df29119ce51fd3$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$48df29119ce51fd3$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $48df29119ce51fd3$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $48df29119ce51fd3$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $48df29119ce51fd3$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $48df29119ce51fd3$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $48df29119ce51fd3$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $48df29119ce51fd3$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $48df29119ce51fd3$var$getHeaders(appConfig);
    headers.append("Authorization", $48df29119ce51fd3$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $48df29119ce51fd3$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $48df29119ce51fd3$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $48df29119ce51fd3$var$getAuthorizationHeader(refreshToken) {
    return `${$48df29119ce51fd3$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $48df29119ce51fd3$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $48df29119ce51fd3$var$getInstallationsEndpoint(appConfig);
    const headers = $48df29119ce51fd3$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $48df29119ce51fd3$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $48df29119ce51fd3$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $48df29119ce51fd3$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $48df29119ce51fd3$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $48df29119ce51fd3$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $48df29119ce51fd3$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $48df29119ce51fd3$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $48df29119ce51fd3$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $48df29119ce51fd3$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $48df29119ce51fd3$var$encode(fidByteArray);
        return $48df29119ce51fd3$var$VALID_FID_PATTERN.test(fid) ? fid : $48df29119ce51fd3$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $48df29119ce51fd3$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $48df29119ce51fd3$var$encode(fidByteArray) {
    const b64String = $48df29119ce51fd3$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $48df29119ce51fd3$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $48df29119ce51fd3$var$fidChanged(appConfig, fid) {
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    $48df29119ce51fd3$var$callFidChangeCallbacks(key, fid);
    $48df29119ce51fd3$var$broadcastFidChange(key, fid);
}
function $48df29119ce51fd3$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $48df29119ce51fd3$var$getBroadcastChannel();
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    let callbackSet = $48df29119ce51fd3$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $48df29119ce51fd3$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $48df29119ce51fd3$var$removeCallback(appConfig, callback) {
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    const callbackSet = $48df29119ce51fd3$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $48df29119ce51fd3$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $48df29119ce51fd3$var$closeBroadcastChannel();
}
function $48df29119ce51fd3$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $48df29119ce51fd3$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $48df29119ce51fd3$var$broadcastFidChange(key, fid) {
    const channel = $48df29119ce51fd3$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $48df29119ce51fd3$var$closeBroadcastChannel();
}
let $48df29119ce51fd3$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $48df29119ce51fd3$var$getBroadcastChannel() {
    if (!$48df29119ce51fd3$var$broadcastChannel && "BroadcastChannel" in self) {
        $48df29119ce51fd3$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $48df29119ce51fd3$var$broadcastChannel.onmessage = (e)=>{
            $48df29119ce51fd3$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $48df29119ce51fd3$var$broadcastChannel;
}
function $48df29119ce51fd3$var$closeBroadcastChannel() {
    if ($48df29119ce51fd3$var$fidChangeCallbacks.size === 0 && $48df29119ce51fd3$var$broadcastChannel) {
        $48df29119ce51fd3$var$broadcastChannel.close();
        $48df29119ce51fd3$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$DATABASE_NAME = "firebase-installations-database";
const $48df29119ce51fd3$var$DATABASE_VERSION = 1;
const $48df29119ce51fd3$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $48df29119ce51fd3$var$dbPromise = null;
function $48df29119ce51fd3$var$getDbPromise() {
    if (!$48df29119ce51fd3$var$dbPromise) $48df29119ce51fd3$var$dbPromise = (0, $3a63bb1d70fa76b9$export$ca0ed41b1a2af7e)($48df29119ce51fd3$var$DATABASE_NAME, $48df29119ce51fd3$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($48df29119ce51fd3$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $48df29119ce51fd3$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $48df29119ce51fd3$var$set(appConfig, value) {
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    const db = await $48df29119ce51fd3$var$getDbPromise();
    const tx = db.transaction($48df29119ce51fd3$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($48df29119ce51fd3$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $48df29119ce51fd3$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $48df29119ce51fd3$var$remove(appConfig) {
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    const db = await $48df29119ce51fd3$var$getDbPromise();
    const tx = db.transaction($48df29119ce51fd3$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($48df29119ce51fd3$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $48df29119ce51fd3$var$update(appConfig, updateFn) {
    const key = $48df29119ce51fd3$var$getKey(appConfig);
    const db = await $48df29119ce51fd3$var$getDbPromise();
    const tx = db.transaction($48df29119ce51fd3$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($48df29119ce51fd3$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $48df29119ce51fd3$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $48df29119ce51fd3$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $48df29119ce51fd3$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $48df29119ce51fd3$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $48df29119ce51fd3$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $48df29119ce51fd3$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $48df29119ce51fd3$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $48df29119ce51fd3$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $48df29119ce51fd3$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $48df29119ce51fd3$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($48df29119ce51fd3$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $48df29119ce51fd3$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $48df29119ce51fd3$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $48df29119ce51fd3$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $48df29119ce51fd3$var$createInstallationRequest(installations, installationEntry);
        return $48df29119ce51fd3$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($48df29119ce51fd3$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $48df29119ce51fd3$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $48df29119ce51fd3$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $48df29119ce51fd3$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $48df29119ce51fd3$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $48df29119ce51fd3$var$sleep(100);
        entry = await $48df29119ce51fd3$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $48df29119ce51fd3$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $48df29119ce51fd3$var$updateInstallationRequest(appConfig) {
    return $48df29119ce51fd3$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $48df29119ce51fd3$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $48df29119ce51fd3$var$clearTimedOutRequest(oldEntry);
    });
}
function $48df29119ce51fd3$var$clearTimedOutRequest(entry) {
    if ($48df29119ce51fd3$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $48df29119ce51fd3$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $48df29119ce51fd3$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $48df29119ce51fd3$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $48df29119ce51fd3$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $48df29119ce51fd3$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $48df29119ce51fd3$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $48df29119ce51fd3$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $48df29119ce51fd3$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $48df29119ce51fd3$var$getErrorFromResponse("Generate Auth Token", response);
}
function $48df29119ce51fd3$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$48df29119ce51fd3$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $48df29119ce51fd3$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $48df29119ce51fd3$var$update(installations.appConfig, (oldEntry)=>{
        if (!$48df29119ce51fd3$var$isEntryRegistered(oldEntry)) throw $48df29119ce51fd3$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $48df29119ce51fd3$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $48df29119ce51fd3$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $48df29119ce51fd3$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $48df29119ce51fd3$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $48df29119ce51fd3$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $48df29119ce51fd3$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $48df29119ce51fd3$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $48df29119ce51fd3$var$sleep(100);
        entry = await $48df29119ce51fd3$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $48df29119ce51fd3$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $48df29119ce51fd3$var$updateAuthTokenRequest(appConfig) {
    return $48df29119ce51fd3$var$update(appConfig, (oldEntry)=>{
        if (!$48df29119ce51fd3$var$isEntryRegistered(oldEntry)) throw $48df29119ce51fd3$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($48df29119ce51fd3$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $48df29119ce51fd3$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $48df29119ce51fd3$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $48df29119ce51fd3$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($48df29119ce51fd3$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $48df29119ce51fd3$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $48df29119ce51fd3$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $48df29119ce51fd3$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $48df29119ce51fd3$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$48df29119ce51fd3$var$isAuthTokenExpired(authToken);
}
function $48df29119ce51fd3$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $48df29119ce51fd3$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $48df29119ce51fd3$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $48df29119ce51fd3$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $48df29119ce51fd3$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $48df29119ce51fd3$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $48df29119ce51fd3$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $48df29119ce51fd3$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $48df29119ce51fd3$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $48df29119ce51fd3$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $48df29119ce51fd3$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $48df29119ce51fd3$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $48df29119ce51fd3$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $48df29119ce51fd3$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $48df29119ce51fd3$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $48df29119ce51fd3$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $48df29119ce51fd3$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $48df29119ce51fd3$var$getErrorFromResponse("Delete Installation", response);
}
function $48df29119ce51fd3$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$48df29119ce51fd3$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $48df29119ce51fd3$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $48df29119ce51fd3$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $48df29119ce51fd3$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $48df29119ce51fd3$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $48df29119ce51fd3$var$deleteInstallationRequest(appConfig, entry);
                await $48df29119ce51fd3$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $48df29119ce51fd3$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $48df29119ce51fd3$var$addCallback(appConfig, callback);
    return ()=>{
        $48df29119ce51fd3$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $48df29119ce51fd3$export$9bfc115e43431ff5(app = (0, $494b068b89b4758a$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $48df29119ce51fd3$var$extractAppConfig(app) {
    if (!app || !app.options) throw $48df29119ce51fd3$var$getMissingValueError("App Configuration");
    if (!app.name) throw $48df29119ce51fd3$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $48df29119ce51fd3$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $48df29119ce51fd3$var$getMissingValueError(valueName) {
    return $48df29119ce51fd3$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48df29119ce51fd3$var$INSTALLATIONS_NAME = "installations";
const $48df29119ce51fd3$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $48df29119ce51fd3$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $48df29119ce51fd3$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $48df29119ce51fd3$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, $48df29119ce51fd3$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$48df29119ce51fd3$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$48df29119ce51fd3$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $48df29119ce51fd3$var$registerInstallations() {
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)($48df29119ce51fd3$var$INSTALLATIONS_NAME, $48df29119ce51fd3$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)($48df29119ce51fd3$var$INSTALLATIONS_NAME_INTERNAL, $48df29119ce51fd3$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * Firebase Installations
 *
 * @packageDocumentation
 */ $48df29119ce51fd3$var$registerInstallations();
(0, $494b068b89b4758a$export$d29d5299a7137abc)($48df29119ce51fd3$var$name, $48df29119ce51fd3$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $494b068b89b4758a$export$d29d5299a7137abc)($48df29119ce51fd3$var$name, $48df29119ce51fd3$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $fc37f0c1cdb19715$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
const $fc37f0c1cdb19715$var$GA_FID_KEY = "firebase_id";
const $fc37f0c1cdb19715$var$ORIGIN_KEY = "origin";
const $fc37f0c1cdb19715$var$FETCH_TIMEOUT_MILLIS = 60000;
const $fc37f0c1cdb19715$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
const $fc37f0c1cdb19715$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc37f0c1cdb19715$var$logger = new (0, $824298205172e14b$export$efa9a398d6368992)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fc37f0c1cdb19715$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: "Firebase Analytics Interop Component failed to instantiate: {$reason}",
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: "Trusted Types detected an invalid gtag resource: {$gtagURL}."
};
const $fc37f0c1cdb19715$var$ERROR_FACTORY = new (0, $0ca209b9dac42ea9$export$3fa6e1b18a3b2d40)("analytics", "Analytics", $fc37f0c1cdb19715$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $fc37f0c1cdb19715$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($fc37f0c1cdb19715$var$GTAG_URL)) {
        const err = $fc37f0c1cdb19715$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $fc37f0c1cdb19715$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $fc37f0c1cdb19715$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $fc37f0c1cdb19715$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $fc37f0c1cdb19715$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $fc37f0c1cdb19715$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $fc37f0c1cdb19715$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$fc37f0c1cdb19715$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $fc37f0c1cdb19715$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $fc37f0c1cdb19715$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $fc37f0c1cdb19715$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $fc37f0c1cdb19715$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $fc37f0c1cdb19715$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams["send_to"]) {
            let gaSendToList = gtagParams["send_to"];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $fc37f0c1cdb19715$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $fc37f0c1cdb19715$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $fc37f0c1cdb19715$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $fc37f0c1cdb19715$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $fc37f0c1cdb19715$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , "update", gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $fc37f0c1cdb19715$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $fc37f0c1cdb19715$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $fc37f0c1cdb19715$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $fc37f0c1cdb19715$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName("script");
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($fc37f0c1cdb19715$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $fc37f0c1cdb19715$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $fc37f0c1cdb19715$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $fc37f0c1cdb19715$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $fc37f0c1cdb19715$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $fc37f0c1cdb19715$var$defaultRetryData = new $fc37f0c1cdb19715$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $fc37f0c1cdb19715$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $fc37f0c1cdb19715$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: "GET",
        headers: $fc37f0c1cdb19715$var$getHeaders(apiKey)
    };
    const appUrl = $fc37f0c1cdb19715$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = "";
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $fc37f0c1cdb19715$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $fc37f0c1cdb19715$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $fc37f0c1cdb19715$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $fc37f0c1cdb19715$var$FETCH_TIMEOUT_MILLIS);
    return $fc37f0c1cdb19715$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $fc37f0c1cdb19715$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $fc37f0c1cdb19715$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $fc37f0c1cdb19715$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $fc37f0c1cdb19715$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $fc37f0c1cdb19715$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$fc37f0c1cdb19715$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $fc37f0c1cdb19715$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $0ca209b9dac42ea9$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $fc37f0c1cdb19715$var$LONG_RETRY_FACTOR) : (0, $0ca209b9dac42ea9$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $fc37f0c1cdb19715$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $fc37f0c1cdb19715$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $fc37f0c1cdb19715$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($fc37f0c1cdb19715$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $fc37f0c1cdb19715$var$isRetriableError(e) {
    if (!(e instanceof (0, $0ca209b9dac42ea9$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $fc37f0c1cdb19715$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $fc37f0c1cdb19715$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $fc37f0c1cdb19715$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            "send_to": measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $fc37f0c1cdb19715$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "screen_name": screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "screen_name": screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $fc37f0c1cdb19715$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "user_id": id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_id": id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $fc37f0c1cdb19715$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_properties": properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $fc37f0c1cdb19715$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", (clientId)=>{
            if (!clientId) reject($fc37f0c1cdb19715$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $fc37f0c1cdb19715$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $fc37f0c1cdb19715$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $fc37f0c1cdb19715$var$_setConsentDefaultForInit(consentSettings) {
    $fc37f0c1cdb19715$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $fc37f0c1cdb19715$var$_setDefaultEventParametersForInit(customParams) {
    $fc37f0c1cdb19715$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fc37f0c1cdb19715$var$validateIndexedDB() {
    if (!(0, $0ca209b9dac42ea9$export$3865db50535c2055)()) {
        $fc37f0c1cdb19715$var$logger.warn($fc37f0c1cdb19715$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: "IndexedDB is not available in this environment."
        }).message);
        return false;
    } else try {
        await (0, $0ca209b9dac42ea9$export$a8a3018f3d187a4d)();
    } catch (e) {
        $fc37f0c1cdb19715$var$logger.warn($fc37f0c1cdb19715$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $fc37f0c1cdb19715$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $fc37f0c1cdb19715$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $fc37f0c1cdb19715$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $fc37f0c1cdb19715$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$fc37f0c1cdb19715$var$findGtagScriptOnPage(dataLayerName)) $fc37f0c1cdb19715$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($fc37f0c1cdb19715$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $fc37f0c1cdb19715$var$defaultConsentSettingsForInit);
        $fc37f0c1cdb19715$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore("js", new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$fc37f0c1cdb19715$var$ORIGIN_KEY] = "firebase";
    configProperties.update = true;
    if (fid != null) configProperties[$fc37f0c1cdb19715$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($fc37f0c1cdb19715$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $fc37f0c1cdb19715$var$defaultEventParametersForInit);
        $fc37f0c1cdb19715$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $fc37f0c1cdb19715$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $fc37f0c1cdb19715$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $fc37f0c1cdb19715$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $fc37f0c1cdb19715$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $fc37f0c1cdb19715$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $fc37f0c1cdb19715$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $fc37f0c1cdb19715$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $fc37f0c1cdb19715$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $fc37f0c1cdb19715$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $fc37f0c1cdb19715$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $fc37f0c1cdb19715$export$a5a6e0b888b2c992(options) {
    if ($fc37f0c1cdb19715$var$globalInitDone) throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $fc37f0c1cdb19715$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $fc37f0c1cdb19715$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $fc37f0c1cdb19715$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $0ca209b9dac42ea9$export$caa8774a9107a58e)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $0ca209b9dac42ea9$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(" ");
        const err = $fc37f0c1cdb19715$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $fc37f0c1cdb19715$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $fc37f0c1cdb19715$var$factory(app, installations, options) {
    $fc37f0c1cdb19715$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $fc37f0c1cdb19715$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($fc37f0c1cdb19715$var$initializationPromisesMap[appId] != null) throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$fc37f0c1cdb19715$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $fc37f0c1cdb19715$var$getOrCreateDataLayer($fc37f0c1cdb19715$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $fc37f0c1cdb19715$var$wrapOrCreateGtag($fc37f0c1cdb19715$var$initializationPromisesMap, $fc37f0c1cdb19715$var$dynamicConfigPromisesList, $fc37f0c1cdb19715$var$measurementIdToAppId, $fc37f0c1cdb19715$var$dataLayerName, $fc37f0c1cdb19715$var$gtagName);
        $fc37f0c1cdb19715$var$wrappedGtagFunction = wrappedGtag;
        $fc37f0c1cdb19715$var$gtagCoreFunction = gtagCore;
        $fc37f0c1cdb19715$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $fc37f0c1cdb19715$var$initializationPromisesMap[appId] = $fc37f0c1cdb19715$var$_initializeAnalytics(app, $fc37f0c1cdb19715$var$dynamicConfigPromisesList, $fc37f0c1cdb19715$var$measurementIdToAppId, installations, $fc37f0c1cdb19715$var$gtagCoreFunction, $fc37f0c1cdb19715$var$dataLayerName, options);
    const analyticsInstance = new $fc37f0c1cdb19715$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $fc37f0c1cdb19715$export$b0297573c90085aa(app = (0, $494b068b89b4758a$export$f9962582c9e66d99)()) {
    app = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, $fc37f0c1cdb19715$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $fc37f0c1cdb19715$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $fc37f0c1cdb19715$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $494b068b89b4758a$export$fa0d6da0f5838f50)(app, $fc37f0c1cdb19715$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $0ca209b9dac42ea9$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $fc37f0c1cdb19715$export$48c17662a6902497() {
    if ((0, $0ca209b9dac42ea9$export$caa8774a9107a58e)()) return false;
    if (!(0, $0ca209b9dac42ea9$export$f172b7eb6cf60599)()) return false;
    if (!(0, $0ca209b9dac42ea9$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $0ca209b9dac42ea9$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $fc37f0c1cdb19715$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    $fc37f0c1cdb19715$var$setCurrentScreen$1($fc37f0c1cdb19715$var$wrappedGtagFunction, $fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $fc37f0c1cdb19715$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    return $fc37f0c1cdb19715$var$internalGetGoogleAnalyticsClientId($fc37f0c1cdb19715$var$wrappedGtagFunction, $fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $fc37f0c1cdb19715$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    $fc37f0c1cdb19715$var$setUserId$1($fc37f0c1cdb19715$var$wrappedGtagFunction, $fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $fc37f0c1cdb19715$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    $fc37f0c1cdb19715$var$setUserProperties$1($fc37f0c1cdb19715$var$wrappedGtagFunction, $fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $fc37f0c1cdb19715$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    $fc37f0c1cdb19715$var$setAnalyticsCollectionEnabled$1($fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $fc37f0c1cdb19715$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($fc37f0c1cdb19715$var$wrappedGtagFunction) $fc37f0c1cdb19715$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $fc37f0c1cdb19715$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $fc37f0c1cdb19715$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $0ca209b9dac42ea9$export$4befe9b5fa509a1b)(analyticsInstance);
    $fc37f0c1cdb19715$var$logEvent$1($fc37f0c1cdb19715$var$wrappedGtagFunction, $fc37f0c1cdb19715$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$fc37f0c1cdb19715$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $fc37f0c1cdb19715$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($fc37f0c1cdb19715$var$wrappedGtagFunction) $fc37f0c1cdb19715$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $fc37f0c1cdb19715$var$_setConsentDefaultForInit(consentSettings);
}
const $fc37f0c1cdb19715$var$name = "@firebase/analytics";
const $fc37f0c1cdb19715$var$version = "0.10.0";
/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */ function $fc37f0c1cdb19715$var$registerAnalytics() {
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)($fc37f0c1cdb19715$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app").getImmediate();
        const installations = container.getProvider("installations-internal").getImmediate();
        return $fc37f0c1cdb19715$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $494b068b89b4758a$export$c930050e7bb63965)(new (0, $bd83337a38fbc7ce$export$16fa2f45be04daa8)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $494b068b89b4758a$export$d29d5299a7137abc)($fc37f0c1cdb19715$var$name, $fc37f0c1cdb19715$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $494b068b89b4758a$export$d29d5299a7137abc)($fc37f0c1cdb19715$var$name, $fc37f0c1cdb19715$var$version, "esm2017");
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($fc37f0c1cdb19715$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$fc37f0c1cdb19715$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $fc37f0c1cdb19715$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$fc37f0c1cdb19715$var$registerAnalytics();





var $jzmb2 = parcelRequire("jzmb2");
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const $5741cae07859eab0$var$firebaseConfig = {
    apiKey: "AIzaSyCU1XAzRdEH0q3sWWcjhGtyXGRrXB6TLC4",
    authDomain: "food-app-7a3c9.firebaseapp.com",
    projectId: "food-app-7a3c9",
    storageBucket: "food-app-7a3c9.appspot.com",
    messagingSenderId: "869864697008",
    appId: "1:869864697008:web:48997b5ac88fe1f2261f75",
    measurementId: "G-KV70J01DLJ"
};
const $5741cae07859eab0$export$729c8b7179294ba = (0, $494b068b89b4758a$export$c55cfd413944906d)($5741cae07859eab0$var$firebaseConfig);
const $5741cae07859eab0$var$analytics = (0, $fc37f0c1cdb19715$export$b0297573c90085aa)($5741cae07859eab0$export$729c8b7179294ba);
const $5741cae07859eab0$var$auth = (0, $1d3138fe302b21d0$export$ae1af26003f05816)($5741cae07859eab0$export$729c8b7179294ba);
const $5741cae07859eab0$var$googleProvider = new (0, $1d3138fe302b21d0$export$78acf4525d8a74c4)();
const $5741cae07859eab0$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $jzmb2.createContext)();
const $5741cae07859eab0$export$87091915187a1a85 = (props)=>{
    return /*#__PURE__*/ (0, $hAhso.jsx)($5741cae07859eab0$export$a0fd8390cfe8ae69.Provider, {
        value: {
            signUp: $5741cae07859eab0$var$signUp,
            signIn: $5741cae07859eab0$var$signIn,
            signInWithGoogle: $5741cae07859eab0$var$signInWithGoogle,
            signout: $5741cae07859eab0$var$signout
        },
        children: props.children
    });
};
//functions
async function $5741cae07859eab0$var$signUp(email, password, name) {
    await (0, $1d3138fe302b21d0$export$7910e0436ed8d1de)($5741cae07859eab0$var$auth, email, password).then((val)=>{
        (0, $1d3138fe302b21d0$export$4a5767248b18ef41)($5741cae07859eab0$var$auth, (user)=>{
            console.log("firebase signup on auth change run");
            if (user) {
                console.log("signup", user, name);
                (0, $1d3138fe302b21d0$export$21579262ef46735b)(user, {
                    displayName: name
                });
            }
        });
    }).catch((err)=>alert(err));
}
async function $5741cae07859eab0$var$signIn(email, password) {
    await (0, $1d3138fe302b21d0$export$555508cbc6add439)($5741cae07859eab0$var$auth, email, password).then((val)=>{
        console.log("signin successfully");
    }).catch((err)=>alert(err));
}
async function $5741cae07859eab0$var$signInWithGoogle() {
    await (0, $1d3138fe302b21d0$export$db3b6bfb95261072)($5741cae07859eab0$var$auth, $5741cae07859eab0$var$googleProvider);
}
async function $5741cae07859eab0$var$signout() {
    (0, $1d3138fe302b21d0$export$e7094788287c5e9b)($5741cae07859eab0$var$auth);
}



let $d3e879c95fd97bd4$var$Header = ()=>{
    console.log("HEADER RENDERED");
    const [btn, setbtn] = (0, $jzmb2.useState)("Login");
    const status = (0, $c41a90b8b24590b3$export$2e2bcd8739ae039)();
    const data = (0, $jzmb2.useContext)((0, $ff6d97cdc0613e88$export$2e2bcd8739ae039));
    // const { dummyData, changeDummyData } = data;
    // let { myName } = dummyData;
    const themeData = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.themeChanger.theme);
    const dispatch = (0, $13a78b650353eebe$export$8ad76b76a4c905f8)();
    // console.log(dummyData);
    let cartItems = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.cart.items); // cartItems = [] (initialstate.items)
    // console.log(cartItems);
    const { pathname: pathname } = (0, $545ec7bc5bb917bf$export$45d76561a5302f2b)(); // gives current route
    const firebase = (0, $jzmb2.useContext)((0, $5741cae07859eab0$export$a0fd8390cfe8ae69));
    const [isUserLoggedIn, setisUserLoggedIn] = (0, $jzmb2.useState)(null);
    const auth = (0, $1d3138fe302b21d0$export$ae1af26003f05816)((0, $5741cae07859eab0$export$729c8b7179294ba));
    function handleThemeClick() {
        console.log(themeData);
        //themeData=="light" ? dispatch(toogleTheme("dark")) : dispatch(toogleTheme("light"));
        if (themeData == "light") {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $6f1d62e9ba514404$export$9443a770e75d2a08)("dark"));
        } else {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $6f1d62e9ba514404$export$9443a770e75d2a08)("light"));
        }
    }
    (0, $jzmb2.useEffect)(()=>{
        console.log("header use effect called");
        (0, $1d3138fe302b21d0$export$4a5767248b18ef41)(auth, (user)=>{
            console.log("header on auth change run");
            if (user != isUserLoggedIn) {
                console.log("header ", user, user?.displayName);
                setisUserLoggedIn(user);
            } else setisUserLoggedIn(null);
        });
    }, []);
    //console.log("isuserloggedin= ",isUserLoggedIn);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "header flex justify-between items-center gap-8 px-4 mb-5   mx-auto py-4",
        id: "header",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                    className: "w-24",
                    src: "https://ucarecdn.com/eac2b467-5e68-451d-8254-56aa57a0b678/-/preview/512x512/"
                })
            }),
            /*#__PURE__*/ (0, $hAhso.jsxs)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                to: pathname == "/header" ? "/" : "/header",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        className: "md:hidden  ",
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                            src: themeData == "dark" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Hamburger_icon_white.svg/1200px-Hamburger_icon_white.svg.png" : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Hamburger_icon.svg/1024px-Hamburger_icon.svg.png",
                            className: "w-6"
                        })
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $hAhso.jsxs)("ul", {
                className: " hidden md:flex items-center gap-8 lg:gap-10 ",
                id: "list",
                children: [
                    isUserLoggedIn?.displayName && /*#__PURE__*/ (0, $hAhso.jsxs)("li", {
                        children: [
                            "Hey, ",
                            isUserLoggedIn?.displayName,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsxs)("li", {
                        children: [
                            "Online Status:",
                            status ? "\u2705" : "\u274C",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/about",
                            children: "About Us"
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/grocery",
                            children: "Grocery"
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $hAhso.jsxs)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            className: "hover:text-[#dd4747]",
                            to: "/cart",
                            children: [
                                /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Shopping_cart_icon.svg/1250px-Shopping_cart_icon.svg.png",
                                    className: "w-8 inline",
                                    alt: "cart"
                                }),
                                /*#__PURE__*/ (0, $hAhso.jsxs)("span", {
                                    className: "font-bold",
                                    children: [
                                        "(",
                                        cartItems.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: isUserLoggedIn?.displayName ? /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                            className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                            onClick: ()=>firebase.signout(),
                            children: "Logout"
                        }) : /*#__PURE__*/ (0, $hAhso.jsxs)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: [
                                /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                    className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                                    children: "Login"
                                }),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                            className: "w-8 ",
                            onClick: handleThemeClick,
                            children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                src: themeData == "light" ? (0, $3e8f8bb6c362ab6e$export$3e936a8db52a10a0) : (0, $3e8f8bb6c362ab6e$export$f30cb9bc4f736419)
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $d3e879c95fd97bd4$export$2e2bcd8739ae039 = $d3e879c95fd97bd4$var$Header;



var $hAhso = parcelRequire("hAhso");

var $hAhso = parcelRequire("hAhso");

let $285ce1d9de3b0754$var$Card = (props)=>{
    // console.log(props);
    const { cloudinaryImageId: cloudinaryImageId, name: name, avgRatingString: avgRatingString, sla: sla, areaName: areaName, cuisines: cuisines } = props?.data?.info;
    //   console.log(isVeg , myData.name);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "card  w-80  p-2 hover:cursor-pointer hover:scale-95 transition  duration-200  ",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                    className: "res-icon rounded-xl w-full h-[250px]  mb-3 object-cover",
                    src: (0, $3e8f8bb6c362ab6e$export$bcede3532aa4b7f7) + cloudinaryImageId,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: "res-name text-xl font-bold  text-ellipsis whitespace-nowrap  overflow-hidden",
                children: name
            }),
            /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                className: "res-rating flex  items-center ",
                children: [
                    /*#__PURE__*/ (0, $hAhso.jsx)("span", {
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                            src: (0, $3e8f8bb6c362ab6e$export$4cb72355748c04dd),
                            className: "w-5 "
                        })
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("span", {
                        className: "rating mr-4 ml-1",
                        children: avgRatingString
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsxs)("span", {
                        className: "  ",
                        children: [
                            " ",
                            sla.slaString
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: "res-cusine text-[#02060c60] dark:text-[#dedede] duration-100 text-ellipsis whitespace-nowrap  overflow-hidden ",
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                className: "res-location text-[#02060c60] dark:text-[#dedede] duration-100 ",
                children: [
                    areaName,
                    " "
                ]
            })
        ]
    });
};
const $285ce1d9de3b0754$export$e707e773b106c157 = (Card)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
            className: "relative ",
            children: [
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "w-10 absolute z-20 m-4 right-0 shadow-lg  ",
                    children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                        src: (0, $3e8f8bb6c362ab6e$export$f89a830e1c49df8f),
                        alt: "veg",
                        className: ""
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)(Card, {
                    ...props
                })
            ]
        });
    };
};
var $285ce1d9de3b0754$export$2e2bcd8739ae039 = $285ce1d9de3b0754$var$Card;



var $jzmb2 = parcelRequire("jzmb2");

var $hAhso = parcelRequire("hAhso");
let $1e8f367942753092$export$809644b82cfe94b1 = ()=>{
    var arrOfCards = [];
    for(let i = 0; i < 16; i++)arrOfCards.push(/*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        class: "w-80 animate-pulse h-[378px]",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                class: "w-full h-64 bg-gray-300 rounded-lg dark:bg-gray-600"
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("h1", {
                class: "w-56 h-2 mt-4 bg-gray-200 rounded-lg dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("p", {
                class: "w-24 h-2 mt-4 bg-gray-200 rounded-lg dark:bg-gray-700"
            })
        ]
    }));
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: " mx-auto p-3 ",
        children: /*#__PURE__*/ (0, $hAhso.jsx)("div", {
            className: "Cardcontainer grid grid-cols-[repeat(auto-fit,_minmax(310px,_1fr))] gap-6 justify-items-center items-center  ",
            children: arrOfCards
        })
    });
};





var $hAhso = parcelRequire("hAhso");
const $632b8205818cb504$var$Offline = ()=>{
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        children: "Oops no internet"
    });
};
var $632b8205818cb504$export$2e2bcd8739ae039 = $632b8205818cb504$var$Offline;



var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");

var $jzmb2 = parcelRequire("jzmb2");

let $5c05fa9443b5f182$export$545a45b8c6148dec = [
    {
        info: {
            id: "570170",
            name: "Gianis - Ice Cream, Shakes & Sundaes",
            cloudinaryImageId: "2365e2117e199c2b9a2cfa643c31b05c",
            locality: "Charmwood Village",
            areaName: "Charmwood Village",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Ice Cream",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.6,
            veg: true,
            parentId: "427371",
            avgRatingString: "4.6",
            totalRatingsString: "100+",
            promoted: true,
            adTrackingId: "cid=11367948~p=3~eid=0000018d-e6da-9519-7de6-c9bc005a035a~srvts=1708975101209~45995",
            sla: {
                deliveryTime: 37,
                lastMileTravel: 3.7,
                serviceability: "SERVICEABLE",
                slaString: "35-40 mins",
                lastMileTravelString: "3.7 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=570170",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "543889",
            name: "Kwality Walls Frozen Dessert and Ice Cream Shop",
            cloudinaryImageId: "erypfb2cluupyteh91id",
            locality: "Sarita Vihar",
            areaName: "Badarpur",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Desserts",
                "Ice Cream",
                "Ice Cream Cakes"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "582",
            avgRatingString: "4.4",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 36,
                lastMileTravel: 4,
                serviceability: "SERVICEABLE",
                slaString: "35-40 mins",
                lastMileTravelString: "4.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:30:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=543889",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655871",
            name: "Big Bowl",
            cloudinaryImageId: "c99751d54e4e1847186c62b3309c1327",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "North Indian",
                "Chinese",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "434792",
            avgRatingString: "4.0",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655871",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "574330",
            name: "NOTO - Ice Creams & Desserts",
            cloudinaryImageId: "81ac87e5c89c16adc867be38ce5a1ba3",
            locality: "Sector 4",
            areaName: "Madangir",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Ice Cream",
                "Desserts"
            ],
            avgRating: 4.3,
            veg: true,
            parentId: "468478",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 33,
                lastMileTravel: 9.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "9.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "brand",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "brand",
                                    fontColor: "#7E808C"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=574330",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "39265",
            name: "KFC",
            cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
            locality: "Crown Interiorz Mall",
            areaName: "Sector 35",
            costForTwo: "\u20B9450 for two",
            cuisines: [
                "Burgers",
                "Biryani",
                "American",
                "Snacks",
                "Fast Food"
            ],
            avgRating: 4.1,
            parentId: "547",
            avgRatingString: "4.1",
            totalRatingsString: "5K+",
            sla: {
                deliveryTime: 49,
                lastMileTravel: 6.2,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "6.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 03:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=39265",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655870",
            name: "Chinese Wok",
            cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "61955",
            avgRatingString: "4.0",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "30-35 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655870",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "736173",
            name: "Olio - The Wood Fired Pizzeria",
            cloudinaryImageId: "7e651e00dbf998af59ae7c5e3296c982",
            locality: "Neelam Bata Chowk",
            areaName: "Sector 31",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Pizzas",
                "Pastas",
                "Fast Food",
                "Snacks",
                "Beverages"
            ],
            avgRating: 4.3,
            parentId: "11633",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 51,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ],
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    description: "",
                                    shortDescription: "options available",
                                    fontColor: "#7E808C"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9179"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=736173",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "342847",
            name: "Aromas Of Biryani",
            cloudinaryImageId: "szsru4s2q7tcm2psvjqy",
            locality: "Huda Market",
            areaName: "Sector 37",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Biryani",
                "Beverages"
            ],
            avgRating: 4.3,
            parentId: "36155",
            avgRatingString: "4.3",
            totalRatingsString: "20+",
            sla: {
                deliveryTime: 51,
                lastMileTravel: 4.9,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "4.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "20% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=342847",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "327586",
            name: "Delights by INOX",
            cloudinaryImageId: "b857fcf611707fedd3773eb02688f925",
            locality: "Interiorz Mall",
            areaName: "Sector 35",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "Fast Food",
                "Biryani"
            ],
            avgRating: 2.5,
            veg: true,
            parentId: "385095",
            avgRatingString: "2.5",
            totalRatingsString: "10+",
            sla: {
                deliveryTime: 54,
                lastMileTravel: 6.3,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "6.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    imageId: "v1695133679/badges/Pure_Veg111.png",
                                    description: "pureveg"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=327586",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "729306",
            name: "Baap Of rolls",
            cloudinaryImageId: "76ec5cd6480589bec2976d76eb68180c",
            locality: "Gautam Budh Nagar",
            areaName: "Badarpur Border",
            costForTwo: "\u20B9300 for two",
            cuisines: [
                "Fast Food",
                "Beverages"
            ],
            avgRating: 3.8,
            parentId: "14310",
            avgRatingString: "3.8",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 47,
                lastMileTravel: 3,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "3.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textExtendedBadges: {},
                    textBased: {},
                    imageBased: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=729306",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "655872",
            name: "The Momo Co.",
            cloudinaryImageId: "9668a5819fcba35364dcff30d5f5cfbb",
            locality: "KALKAJI",
            areaName: "Badarpur Metro Station",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4,
            parentId: "11442",
            avgRatingString: "4.0",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 2.9,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "2.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=655872",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "447688",
            name: "Chicago Pizza",
            cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
            locality: "Green Fields Colony",
            areaName: "Green Fields Colony",
            costForTwo: "\u20B9350 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Beverages"
            ],
            avgRating: 4,
            parentId: "60277",
            avgRatingString: "4.0",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 48,
                lastMileTravel: 7.2,
                serviceability: "SERVICEABLE",
                slaString: "45-50 mins",
                lastMileTravelString: "7.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 04:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=447688",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "622927",
            name: "The Dessert Heaven - Pure Veg",
            cloudinaryImageId: "bca418d5554239d48ac1f8ba84a42d79",
            locality: "Sector 31",
            areaName: "Inder Colony",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Bakery",
                "Desserts",
                "Sweets",
                "Ice Cream"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "350292",
            avgRatingString: "4.4",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 54,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    shortDescription: "options available",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=622927",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "775707",
            name: "RollsKing",
            cloudinaryImageId: "35662624fc589e6ab075b6af6dbb65d1",
            locality: "Greenfields_FBD",
            areaName: "Greenfields_FBD",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "Fast Food",
                "Rolls & Wraps",
                "North Indian",
                "Snacks"
            ],
            avgRating: 4.3,
            parentId: "4697",
            avgRatingString: "4.3",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 3.7,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "3.7 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 05:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            isNewlyOnboarded: true,
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=775707",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "622931",
            name: "Cheesecakes By CakeZone",
            cloudinaryImageId: "76d5f4055f9d5796bc7b72dfba8bd92b",
            locality: "Sector 31",
            areaName: "Inder Colony",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Bakery",
                "Desserts"
            ],
            avgRating: 3.9,
            veg: true,
            parentId: "348057",
            avgRatingString: "3.9",
            totalRatingsString: "50+",
            sla: {
                deliveryTime: 53,
                lastMileTravel: 9.2,
                serviceability: "SERVICEABLE",
                slaString: "50-55 mins",
                lastMileTravelString: "9.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 02:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    imageId: "newg.png",
                                    description: "Gourmet"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B9125 OFF",
                subHeader: "ABOVE \u20B9399",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=622931",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    },
    {
        info: {
            id: "733025",
            name: "The Belgian Waffle Co.",
            cloudinaryImageId: "5116a385bac0548e06c33c08350fbf11",
            locality: "ASHOKA ENCLAVE",
            areaName: "CROWN INTERIOR MALL",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "Waffle",
                "Desserts",
                "Ice Cream"
            ],
            avgRating: 4.6,
            veg: true,
            parentId: "2233",
            avgRatingString: "4.6",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 44,
                lastMileTravel: 7.1,
                serviceability: "SERVICEABLE",
                slaString: "40-45 mins",
                lastMileTravelString: "7.1 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2024-02-27 03:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    textBased: {},
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {},
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {},
        cta: {
            link: "swiggy://menu?restaurant_id=733025",
            text: "RESTAURANT_MENU",
            type: "DEEPLINK"
        }
    }
];
let $5c05fa9443b5f182$export$6f49b4016bfc8d56 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        cards: [
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: [
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            badges: {},
                                            vegOnlyDetails: {
                                                imageId: "AutoVegOnly_qkjowj",
                                                title: "Showing only vegetarian options.",
                                                description: "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            topRatedFilter: {},
                                            kidsCategoryFilter: {
                                                attributes: {
                                                    displayText: "Kids Favourites",
                                                    tooltip: {
                                                        enabled: true,
                                                        displayText: "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                    }
                                                }
                                            },
                                            vegFilter: {
                                                attributes: {
                                                    displayText: "VEG"
                                                }
                                            },
                                            nonvegFilter: {
                                                attributes: {
                                                    displayText: "NONVEG"
                                                }
                                            }
                                        },
                                        relevance: {
                                            type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                            sectionId: "MENU_FILTER_TOGGLE"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                            title: "Top Picks",
                                            carousel: [
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814328",
                                                    creativeId: "TopPicks/24054943B.png",
                                                    title: "Chicken Shawarma",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814329",
                                                    creativeId: "TopPicks/24054946B.png",
                                                    title: "Chicken Momos (8 Pieces)",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Recommended",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "2923 ratings",
                                                                    ratingCountV2: "2923"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211921",
                                                            name: "Creamy Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            imageId: "fb2tuglzzfa6obm7d6cs",
                                                            inStock: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203092",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203106",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "489 ratings",
                                                                    ratingCountV2: "489"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054944",
                                                            name: "Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "50 ml | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                                                            imageId: "ow3qpjqq51rxzcv1klkb",
                                                            inStock: 1,
                                                            price: 26900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203097",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203098",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "492 ratings",
                                                                    ratingCountV2: "492"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "33883619",
                                                            name: "Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203101",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203102",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "371 ratings",
                                                                    ratingCountV2: "371"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "50 ml | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "1454 ratings",
                                                                    ratingCountV2: "1454"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "130267359",
                                                            name: "Cheese Corn Momos ( Newly Added )",
                                                            category: "Momos",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "272cb272dc392196faf2e343425cf6f5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "127592292",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123277941",
                                                            name: "Kurkure Paneer Momos (8 Pieces)",
                                                            category: "Kurkure, Chinese & Indian Fusion",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                            imageId: "734063890947eed2463996c6d4ec3268",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106473894",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123277940",
                                                            name: "Chicken Tangdi Fry (2 Pieces)",
                                                            category: "Kurkure, Chinese & Indian Fusion",
                                                            description: "Crispy ",
                                                            imageId: "0d82c121cd2643716ce05e96f1c4698f",
                                                            inStock: 1,
                                                            price: 21900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054948",
                                                            name: "Mineral Water (1 L)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Bisleri or. Kinley",
                                                            imageId: "e1gzxr4vc6rodmebeofq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 3500,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "102 ratings",
                                                                    ratingCountV2: "102"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ],
                                            type: "CATEGORY_TYPE_RECOMMENDED"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Shawarma",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054943",
                                                            name: "Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh to our beloved customers.",
                                                            imageId: "whobcsb2vwalztixhopi",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203095",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203096",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "2923 ratings",
                                                                    ratingCountV2: "2923"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211921",
                                                            name: "Creamy Chicken Shawarma",
                                                            category: "Shawarma",
                                                            description: "Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add on cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            imageId: "fb2tuglzzfa6obm7d6cs",
                                                            inStock: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203092",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203106",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "489 ratings",
                                                                    ratingCountV2: "489"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054944",
                                                            name: "Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "Medium Spicy | With Bone | 50 ml | Serves 1 | Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and put in a microwave safe bowl and served fresh to our beloved customers.",
                                                            imageId: "ow3qpjqq51rxzcv1klkb",
                                                            inStock: 1,
                                                            price: 26900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203097",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203098",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "492 ratings",
                                                                    ratingCountV2: "492"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211923",
                                                            name: "Creamy Roasted Chicken Shawarma Bowl",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce [50ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender and juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies & add in cream and put in a microwave safe bowl and served fresh.",
                                                            imageId: "a01b7b506c94dab1493011b1cd3335b8",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203099",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203100",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "92 ratings",
                                                                    ratingCountV2: "92"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270735",
                                                            name: "Chicken Shawarma Roll + Roasted Shawarma Bowl ** Save Rs.30 Extra",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            inStock: 1,
                                                            price: 37900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106459174",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "33883619",
                                                            name: "Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and mint sauce | Serves 1 | Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203101",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203102",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and mint sauce",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "371 ratings",
                                                                    ratingCountV2: "371"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "36211924",
                                                            name: "Creamy Paneer Shawarma",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This shawarma is a fusion of lebanese & north indian cuisine. Just try it out & appreciate the chef's skills.",
                                                            imageId: "47876777e4c1f5a567e1a439304600e3",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203105",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "11130951",
                                                                            name: "Extra Spicy Filling",
                                                                            price: 1000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "14486620",
                                                                            name: "Extra Butter Filling",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 2,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "37203104",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.6",
                                                                    ratingCount: "74 ratings",
                                                                    ratingCountV2: "74"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270733",
                                                            name: "Chicken Shawarma [ Super Saver Box ]",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarmas are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo & some veggies and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            price: 26900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395427",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "Box Of 2 [ Save Rs.10 Extra ]",
                                                                                default: 1,
                                                                                id: "97251713",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 3 [ Save Rs.30 Extra ]",
                                                                                price: 12000,
                                                                                id: "97251714",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 4 [ Save Rs.50 Extra ]",
                                                                                price: 24000,
                                                                                id: "97251715",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 5 [ Save Rs.70 Extra ]",
                                                                                price: 36000,
                                                                                id: "97251716",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 10 [ Save Rs.200 Extra ]",
                                                                                price: 93000,
                                                                                id: "97251717",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106459172",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "106465569",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "98089557",
                                                                            name: "Extra Spicy Fillings",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 1,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            nextAvailableAtMessage: "Next available at 4:58 pm, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270734",
                                                            name: "Creamy Chicken Shawarma [ Super Saver Box ]",
                                                            category: "Shawarma",
                                                            description: "Served with mayonnaise and mint sauce. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. Mastering the middle eastern cuisine, our shawarma are made in a traditional rotisserie machine stacked with tender & juicy chicken pieces, being slowly roasted, mixed with rare spices, sauces, mayo, some veggies, cream and stuffed then rolled in a hand tossed soft base and served fresh.",
                                                            price: 30900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395428",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "Box Of 2 [ Save Rs.30 Extra ]",
                                                                                default: 1,
                                                                                id: "97251718",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 3 [ Save Rs.50 Extra ]",
                                                                                price: 14000,
                                                                                id: "97251719",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 4 [ Save Rs.70 Extra ]",
                                                                                price: 28000,
                                                                                id: "97251720",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "Box Of 5 [ Save Rs.100 Extra ]",
                                                                                price: 41000,
                                                                                id: "97251721",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "106465570",
                                                                    groupName: "Add-ons",
                                                                    choices: [
                                                                        {
                                                                            id: "98089557",
                                                                            name: "Extra Spicy Fillings",
                                                                            price: 3000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 1,
                                                                    maxFreeAddons: -1
                                                                },
                                                                {
                                                                    groupId: "106459173",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Momos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054946",
                                                            name: "Chicken Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "rqztsxexf4uhepjpwfm6",
                                                            inStock: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203107",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "1454 ratings",
                                                                    ratingCountV2: "1454"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054945",
                                                            name: "Paneer Momos (8 Pieces)",
                                                            category: "Momos",
                                                            description: "Medium Spicy | Comes with Served with mayonnaise and red chilli sauce | 50 ml | Serves 1 | Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and soft paneer pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "oifv5eatmljnshmmyjpd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 13900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "37203108",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with Served with mayonnaise and red chilli sauce",
                                                                portionSize: "50 ml"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "472 ratings",
                                                                    ratingCountV2: "472"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "130267359",
                                                            name: "Cheese Corn Momos ( Newly Added )",
                                                            category: "Momos",
                                                            description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos qsr chain in ncr. Mastering the tibetan cuisine, our momos are made with tender and juicy chicken pieces, being slowly steamed, mixed with rare spices, sauces & little bit of onions and stuffed in a hand tossed base, shaped to perfection and served fresh to our beloved customers.",
                                                            imageId: "272cb272dc392196faf2e343425cf6f5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            addons: [
                                                                {
                                                                    groupId: "127592292",
                                                                    groupName: "Extras",
                                                                    choices: [
                                                                        {
                                                                            id: "11130952",
                                                                            name: "Extra Mayonnaise Cup (100 ml)",
                                                                            price: 7000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130953",
                                                                            name: "Extra Mint Sauce Cup (100 ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        },
                                                                        {
                                                                            id: "11130954",
                                                                            name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                            price: 6000,
                                                                            inStock: 1,
                                                                            isVeg: 1,
                                                                            isEnabled: 1
                                                                        }
                                                                    ],
                                                                    maxAddons: 3,
                                                                    maxFreeAddons: -1
                                                                }
                                                            ],
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Kurkure, Chinese & Indian Fusion",
                                            categories: [
                                                {
                                                    title: "Kurkure",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270791",
                                                                    name: "Kurkure Chicken Shawarma",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and mint sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering shawarmas since then and has become 2nd largest shawarma chain in north india. This newly added shawarma in our menu is a fusion of lebanese and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot, rolled and served fresh and hot to our beloved customers.",
                                                                    imageId: "3f6b5a81b57213aeb0758590ad62a2e7",
                                                                    inStock: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459176",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "16 ratings",
                                                                            ratingCountV2: "16"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270792",
                                                                    name: "Kurkure Chicken Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    imageId: "f31815d1558ff35607a3a83ce0d9b40a",
                                                                    inStock: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459177",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {
                                                                        text: "Bestseller",
                                                                        textColor: "#ffffff",
                                                                        topBackgroundColor: "#d53d4c",
                                                                        bottomBackgroundColor: "#b02331"
                                                                    },
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    isBestseller: true,
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.5",
                                                                            ratingCount: "37 ratings",
                                                                            ratingCountV2: "37"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123277941",
                                                                    name: "Kurkure Paneer Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and red chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering momos since then and has become top 10 momos chain. This newly added momos in our menu is a fusion of tibetan and north indian cuisine. Inside, it is same authentic uncle chicken taste but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    imageId: "734063890947eed2463996c6d4ec3268",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106473894",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "18 ratings",
                                                                            ratingCountV2: "18"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "130267360",
                                                                    name: "Kurkure Cheese Corn Momos (new Launch)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "127592293",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270790",
                                                                    name: "Kurkure Leg (2 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Served with mayonnaise and chilli sauce [30ml each]. Estd in 2003, uncle chicken has been serving mouth watering dishes since then and has become 2nd largest shawarma chain in north india. This newly added kurkure leg piece in our menu is a fusion of different cuisines. Inside, it's juicy tender chicken but outside, we added a crispy layer specially prepared on the spot and served fresh and hot to our beloved customers.",
                                                                    price: 23900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    addons: [
                                                                        {
                                                                            groupId: "106459175",
                                                                            groupName: "Extras",
                                                                            choices: [
                                                                                {
                                                                                    id: "11130952",
                                                                                    name: "Extra Mayonnaise Cup (100 ml)",
                                                                                    price: 7000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130953",
                                                                                    name: "Extra Mint Sauce Cup (100 ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                },
                                                                                {
                                                                                    id: "11130954",
                                                                                    name: "Extra Red Chilli Sauce Cup (100ml)",
                                                                                    price: 6000,
                                                                                    inStock: 1,
                                                                                    isVeg: 1,
                                                                                    isEnabled: 1
                                                                                }
                                                                            ],
                                                                            maxAddons: 3,
                                                                            maxFreeAddons: -1
                                                                        }
                                                                    ],
                                                                    nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "Chinese",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270794",
                                                                    name: "Chicken Chilli Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270796",
                                                                    name: "Paneer Chilli Momos (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270799",
                                                                    name: "Chicken 65 Dry (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.0",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270801",
                                                                    name: "Chilli Chicken Boneless Thigh (8 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    inStock: 1,
                                                                    price: 32900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.4",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "Fried",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123277940",
                                                                    name: "Chicken Tangdi Fry (2 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Crispy ",
                                                                    imageId: "0d82c121cd2643716ce05e96f1c4698f",
                                                                    inStock: 1,
                                                                    price: 21900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "9 ratings",
                                                                            ratingCountV2: "9"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "123270809",
                                                                    name: "Chicken Lollipop Fry (4 Pieces)",
                                                                    category: "Kurkure, Chinese & Indian Fusion",
                                                                    description: "Crispy",
                                                                    imageId: "59695d3e4cca656d5fdc5f577afcc03c",
                                                                    inStock: 1,
                                                                    price: 21900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "31 ratings",
                                                                            ratingCountV2: "31"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Beverages",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054947",
                                                            name: "Coke (750 Ml)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Served cold",
                                                            imageId: "iry5fu453gvnzexxnwu9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 8900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "394 ratings",
                                                                    ratingCountV2: "394"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "24054948",
                                                            name: "Mineral Water (1 L)",
                                                            category: "Beverages",
                                                            description: "Serves 1 | Bisleri or. Kinley",
                                                            imageId: "e1gzxr4vc6rodmebeofq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 3500,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "102 ratings",
                                                                    ratingCountV2: "102"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Biryani",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490562",
                                                            name: "Chicken Dum Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "ugchcdpg05ivuametha2",
                                                            price: 11900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494729",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Gm | (3 Pcs Wings Or Boneless)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465613",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Gm | (5-6 Pcs Wings Or Boneless Pcs)",
                                                                                price: 12600,
                                                                                id: "14465614",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (9-10 Pcs Wings Or Boneless)",
                                                                                price: 26000,
                                                                                id: "14465615",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "1687 ratings",
                                                                    ratingCountV2: "1687"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490556",
                                                            name: "Chicken Leg Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "vzxgkbawopprfnhddtkk",
                                                            price: 12500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494727",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Grams | (1 Leg Piece + Some Boneless Or Wings)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465607",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Grams | (2 Leg Pieces + Some Boneless Or Wings)",
                                                                                price: 13400,
                                                                                id: "14465608",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (4 Leg Pieces + Some Boneless Or Wings)",
                                                                                price: 27400,
                                                                                id: "14465609",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "1151 ratings",
                                                                    ratingCountV2: "1151"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490555",
                                                            name: "Chicken Thigh Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "fo6gm5nvjqwshcznoyjk",
                                                            price: 13500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494726",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Grams | (1 Thigh Piece + Boneless Or Wings)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465604",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Grams | (2 Thigh Pieces + Some Boneless Or Wings)",
                                                                                price: 14000,
                                                                                id: "14465605",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (4 Thigh Pieces + Some Boneless Or Wings)",
                                                                                price: 34400,
                                                                                id: "14465606",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "517 ratings",
                                                                    ratingCountV2: "517"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "41490560",
                                                            name: "Boneless Chicken Biryani",
                                                            category: "Biryani",
                                                            description: "Medium Spicy | Boneless | Comes with mint curd chutney & spicy tomato chutney | Serves 1 | Served with mint curd chutney & spicy tomato chutney. This biryani is a royal meal for non-vegetarians in the house. Dum cooked and overloaded with tender chicken pieces laid out on a bed of long-grain aromatic boiled rice cooked with flavourful indian and exotic spices in our royal uncle kitchen. Note** dear customers, sometimes chicken pieces are present under the rice when you open the biryani box so don't worry, you are always getting the promised quantity and pieces.",
                                                            imageId: "jlvokk4v2bofhxbzqacs",
                                                            price: 12500,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "4494728",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "300 Gm | (3 Pcs Boneless)",
                                                                                price: 1000,
                                                                                default: 1,
                                                                                id: "14465610",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "600 Gm | (5-6 Pcs Boneless)",
                                                                                price: 13400,
                                                                                id: "14465611",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "1 Kg | (9-10 Pcs Boneless)",
                                                                                price: 29400,
                                                                                id: "14465612",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                accompaniments: "Served with mint curd chutney & spicy tomato chutney",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {
                                                                text: "Bestseller",
                                                                textColor: "#ffffff",
                                                                topBackgroundColor: "#d53d4c",
                                                                bottomBackgroundColor: "#b02331"
                                                            },
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            isBestseller: true,
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "873 ratings",
                                                                    ratingCountV2: "873"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "123270736",
                                                            name: "Boiled Boneless Chicken Breast ( Gym Diet )",
                                                            category: "Biryani",
                                                            description: "It is mainly for fitness enthusiasts and gym goers so please don't expect flavourful taste or aroma of signature spices of uncle chicken. It is boiled along with dum biryani so sometimes a little natural food colour may also be present but rest assured, nothing extra would be present not even salt. Just pure tender chicken breast.",
                                                            imageId: "thjhcqbnjjtlozzbod8u",
                                                            price: 24900,
                                                            variants: {
                                                                variantGroups: [
                                                                    {
                                                                        groupId: "31395429",
                                                                        name: "Quantity",
                                                                        variations: [
                                                                            {
                                                                                name: "200 Gms",
                                                                                default: 1,
                                                                                id: "97251722",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            },
                                                                            {
                                                                                name: "400 Gms [ Save Rs.40 Extra ]",
                                                                                price: 21100,
                                                                                id: "97251723",
                                                                                inStock: 1,
                                                                                isEnabled: 1
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            variantsV2: {},
                                                            nextAvailableAtMessage: "Next available at 12 noon, tomorrow",
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            type: "FSSAI",
                                            imageId: "fssai_final_edss9i",
                                            text: [
                                                "License No. 20818003000369"
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            name: "Uncle Chicken - Shawarma, Biryani & Momos",
                                            area: "Sector 14",
                                            completeAddress: "Shop No. 165, Huda Market Maharishi Parashar Marg, Sector 14 Faridabad, Haryana, 121007"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        isQCLink: false
    },
    tid: "3e45fb63-b7f2-4d01-9691-275ef61e28c5",
    sid: "cj92ea31-6ce9-4e9b-84c5-807d086719a9",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "Z42msBkwELWD-99dLS0tCskhkPNN1qqd2Widzx08"
};
let $5c05fa9443b5f182$export$52daddf863f66fd0 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        pageOffset: {
            nextOffset: "COVCELQ4KICgsd224q7FZDCnEzgE",
            widgetOffset: {
                NewListingView_category_bar_chicletranking_TwoRows: "",
                NewListingView_category_bar_chicletranking_TwoRows_Rendition: "",
                Restaurant_Group_WebView_SEO_PB_Theme: "",
                collectionV5RestaurantListWidget_SimRestoRelevance_food_seo: "10",
                inlineFacetFilter: "",
                restaurantCountWidget: ""
            }
        },
        cards: [
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        header: {
                            title: "What's on your mind?",
                            headerStyling: {
                                padding: {
                                    left: 16,
                                    top: 16,
                                    bottom: 4
                                }
                            }
                        },
                        layout: {
                            rows: 1,
                            columns: 10,
                            horizontalScrollEnabled: true,
                            itemSpacing: 24,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 8,
                                    top: 8,
                                    right: 12,
                                    bottom: 4
                                }
                            },
                            scrollBar: {},
                            widgetTheme: {
                                defaultMode: {
                                    backgroundColour: "#FFFFFF",
                                    theme: "THEME_TYPE_LIGHT"
                                },
                                darkMode: {
                                    theme: "THEME_TYPE_DARK"
                                }
                            }
                        },
                        imageGridCards: {
                            info: [
                                {
                                    id: "762797",
                                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                        text: "Burgers",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for burger",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750580",
                                    imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                        text: "pizzas",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for pizza",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750597",
                                    imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                                        text: "Ice Cream",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for icecream",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750582",
                                    imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                        text: "North Indian",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for north indian",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750223",
                                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                                        text: "Rolls",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for roll",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750592",
                                    imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                        text: "Biryani",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for biryani",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750588",
                                    imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                                        text: "Chinese",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for chinese",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750584",
                                    imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                        text: "South Indian",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for south indian",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749769",
                                    imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                                        text: "Momos",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for momos",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749774",
                                    imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                        text: "Noodles",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for noodles",
                                        altTextCta: "open"
                                    },
                                    entityId: "80464",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "749874",
                                    imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                                        text: "Cakes",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for cakes",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750207",
                                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                                        text: "Pasta",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for pasta",
                                        altTextCta: "open"
                                    },
                                    entityId: "80480",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750217",
                                    imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                                        text: "Pav Bhaji",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for pav bhaji",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750636",
                                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                                        text: "Kebabs",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for kebabs",
                                        altTextCta: "open"
                                    },
                                    entityId: "80452",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750203",
                                    imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                                        text: "Paratha",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for paratha",
                                        altTextCta: "open"
                                    },
                                    entityId: "80476",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750226",
                                    imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                                        text: "Salad",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for salad",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750593",
                                    imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                                        text: "Gulab Jamun",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for gulab jamun",
                                        altTextCta: "open"
                                    },
                                    entityId: "80432",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750209",
                                    imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                                        text: "Pastry",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for Pastry",
                                        altTextCta: "open"
                                    },
                                    entityId: "80358",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750235",
                                    imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                                        text: "Sandwich",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurants curated for sandwich",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                                    frequencyCapping: {}
                                },
                                {
                                    id: "750239",
                                    imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                    action: {
                                        link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                                        text: "Shake",
                                        type: "WEBLINK"
                                    },
                                    entityType: "BANNER",
                                    accessibility: {
                                        altText: "restaurant curated for shakes",
                                        altTextCta: "open"
                                    },
                                    entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                                    frequencyCapping: {}
                                }
                            ],
                            style: {
                                width: {
                                    type: "TYPE_RELATIVE",
                                    value: 0.2941,
                                    reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                },
                                height: {
                                    type: "TYPE_RELATIVE",
                                    value: 1.2444,
                                    reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                }
                            }
                        },
                        id: "whats_on_your_mind",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                                info: [
                                    {
                                        id: "762797",
                                        imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                            text: "Burgers",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for burger",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750580",
                                        imageId: "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83644?collection_id=83644&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                            text: "pizzas",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for pizza",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83644&tags=layout_CCS_Pizza&search_context=pizza",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750597",
                                        imageId: "v1674029851/PC_Creative%20refresh/3D_bau/banners_new/Ice_Creams.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83650?collection_id=83650&tags=layout_CCS_IceCreams&type=rcv2",
                                            text: "Ice Cream",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for icecream",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83650&tags=layout_CCS_IceCreams",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750582",
                                        imageId: "v1675667625/PC_Creative%20refresh/North_Indian_4.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83645?collection_id=83645&search_context=northindian&tags=layout_CCS_NorthIndian&type=rcv2",
                                            text: "North Indian",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for north indian",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83645&tags=layout_CCS_NorthIndian&search_context=northindian",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750223",
                                        imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83670?collection_id=83670&tags=layout_CCS_Rolls&type=rcv2",
                                            text: "Rolls",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for roll",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83670&tags=layout_CCS_Rolls",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750592",
                                        imageId: "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83649?collection_id=83649&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                            text: "Biryani",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for biryani",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83649&tags=layout_CCS_Biryani&search_context=biryani",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750588",
                                        imageId: "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83647?collection_id=83647&tags=layout_CCS_Chinese&type=rcv2",
                                            text: "Chinese",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for chinese",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83647&tags=layout_CCS_Chinese",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750584",
                                        imageId: "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83646?collection_id=83646&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                            text: "South Indian",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for south indian",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83646&tags=layout_CCS_SouthIndian&search_context=southindian",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749769",
                                        imageId: "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80462?collection_id=80462&tags=layout_CCS_Momos&type=rcv2",
                                            text: "Momos",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for momos",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80462&tags=layout_CCS_Momos",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749774",
                                        imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80464?collection_id=80464&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                            text: "Noodles",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for noodles",
                                            altTextCta: "open"
                                        },
                                        entityId: "80464",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "749874",
                                        imageId: "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83656?collection_id=83656&tags=layout_CCS_Cake&type=rcv2",
                                            text: "Cakes",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for cakes",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83656&tags=layout_CCS_Cake",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750207",
                                        imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80480?collection_id=80480&tags=layout_BAU_Contextual%2Cpasta%2Cads_pc_pasta&type=rcv2",
                                            text: "Pasta",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for pasta",
                                            altTextCta: "open"
                                        },
                                        entityId: "80480",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750217",
                                        imageId: "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
                                            text: "Pav Bhaji",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for pav bhaji",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750636",
                                        imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Kebabs.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80452?collection_id=80452&tags=layout_BAU_Contextual%2Ckebab%2Cads_pc_kebab&type=rcv2",
                                            text: "Kebabs",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for kebabs",
                                            altTextCta: "open"
                                        },
                                        entityId: "80452",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750203",
                                        imageId: "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
                                            text: "Paratha",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for paratha",
                                            altTextCta: "open"
                                        },
                                        entityId: "80476",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750226",
                                        imageId: "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80395?collection_id=80395&tags=layout_CCS_Salad&type=rcv2",
                                            text: "Salad",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for salad",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=80395&tags=layout_CCS_Salad",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750593",
                                        imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Gulab_Jamun.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80432?collection_id=80432&tags=layout_BAU_Contextual%2Cgulab_jamun&type=rcv2",
                                            text: "Gulab Jamun",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for gulab jamun",
                                            altTextCta: "open"
                                        },
                                        entityId: "80432",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750209",
                                        imageId: "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/80358?collection_id=80358&tags=layout_BAU_Contextual%2Clayout_ux4&type=rcv2",
                                            text: "Pastry",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for Pastry",
                                            altTextCta: "open"
                                        },
                                        entityId: "80358",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750235",
                                        imageId: "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
                                            text: "Sandwich",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurants curated for sandwich",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
                                        frequencyCapping: {}
                                    },
                                    {
                                        id: "750239",
                                        imageId: "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                                        action: {
                                            link: "https://www.swiggy.com/collections/83674?collection_id=83674&tags=layout_CCS_Shakes&type=rcv2",
                                            text: "Shake",
                                            type: "WEBLINK"
                                        },
                                        entityType: "BANNER",
                                        accessibility: {
                                            altText: "restaurant curated for shakes",
                                            altTextCta: "open"
                                        },
                                        entityId: "swiggy://collectionV2?collection_id=83674&tags=layout_CCS_Shakes",
                                        frequencyCapping: {}
                                    }
                                ],
                                style: {
                                    width: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.2941,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                    },
                                    height: {
                                        type: "TYPE_RELATIVE",
                                        value: 1.2444,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        header: {
                            title: "Top restaurant chains in Faridabad",
                            action: {},
                            headerStyling: {
                                padding: {
                                    left: 16,
                                    top: 28,
                                    bottom: 18
                                }
                            }
                        },
                        layout: {
                            rows: 1,
                            columns: 20,
                            horizontalScrollEnabled: true,
                            itemSpacing: 32,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 16,
                                    right: 12,
                                    bottom: 12
                                }
                            },
                            scrollBar: {
                                scrollThumbColor: "#E46D47",
                                scrollTrackColor: "#02060C",
                                width: 54,
                                height: 4,
                                scrollStyling: {
                                    padding: {
                                        top: 6,
                                        bottom: 24
                                    }
                                }
                            },
                            widgetTheme: {
                                defaultMode: {
                                    backgroundColour: "#1B3028",
                                    theme: "THEME_TYPE_DARK"
                                },
                                darkMode: {
                                    backgroundColour: "#1B3028",
                                    theme: "THEME_TYPE_DARK"
                                }
                            }
                        },
                        id: "top_brands_for_you",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                restaurants: [
                                    {
                                        info: {
                                            id: "21986",
                                            name: "Dark Brown",
                                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Italian-American",
                                                "Continental",
                                                "Burgers",
                                                "Pizzas",
                                                "Pastas",
                                                "Chinese",
                                                "Beverages",
                                                "Salads",
                                                "Asian",
                                                "Healthy Food",
                                                "Fast Food",
                                                "Chaat",
                                                "Snacks",
                                                "Desserts",
                                                "American",
                                                "Italian",
                                                "Momos",
                                                "Rolls & Wraps",
                                                "Cafe"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "16162",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "253728",
                                            name: "McDonald's",
                                            cloudinaryImageId: "535fc9f9c135f7982317bbb6a64a1ffc",
                                            locality: "Crown Plaza Mall",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "American"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "630",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 29,
                                                lastMileTravel: 1.7,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.7 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:15:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "50% OFF",
                                                subHeader: "UPTO \u20B980"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/mcdonalds-crown-plaza-mall-sector-15-faridabad-253728",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "207998",
                                            name: "Burger King",
                                            cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
                                            locality: "Eldeco Station 1 Mall",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Burgers",
                                                "American"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "166",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 05:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/burger-king-eldeco-station-1-mall-sector-12-faridabad-207998",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "28805",
                                            name: "Domino's Pizza",
                                            cloudinaryImageId: "d0450ce1a6ba19ea60cd724471ed54a8",
                                            locality: "Town Park",
                                            areaName: "Sector 16",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Pastas",
                                                "Desserts"
                                            ],
                                            avgRating: 3.9,
                                            parentId: "2456",
                                            avgRatingString: "3.9",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 30,
                                                lastMileTravel: 0.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "30 mins",
                                                lastMileTravelString: "0.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:55:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Pizza.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "30% OFF",
                                                subHeader: "UPTO \u20B975"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dominos-pizza-town-park-sector-16-faridabad-28805",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "356223",
                                            name: "KFC",
                                            cloudinaryImageId: "f01666ac73626461d7455d9c24005cd4",
                                            locality: "Sector-79",
                                            areaName: "Omaxe World Street",
                                            costForTwo: "\u20B9450 for two",
                                            cuisines: [
                                                "Burgers",
                                                "Biryani",
                                                "American",
                                                "Snacks",
                                                "Fast Food"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "547",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Burger.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/kfc-sector-79-omaxe-world-street-faridabad-356223",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "349817",
                                            name: "Pizza Hut",
                                            cloudinaryImageId: "2b4f62d606d1b2bfba9ba9e5386fabb7",
                                            locality: "Sector-79",
                                            areaName: "Omaxe World Street",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Pizzas"
                                            ],
                                            avgRating: 3.7,
                                            parentId: "721",
                                            avgRatingString: "3.7",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 36,
                                                lastMileTravel: 5.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "35-40 mins",
                                                lastMileTravelString: "5.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "20% OFF",
                                                subHeader: "UPTO \u20B950"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/pizza-hut-sector-79-omaxe-world-street-faridabad-349817",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "518208",
                                            name: "Nirula's",
                                            cloudinaryImageId: "a66fa8f5befa65947d9e20f29a863ce0",
                                            locality: "Sector-15 Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Ice Cream",
                                                "Pizzas",
                                                "Fast Food"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "1738",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 19,
                                                lastMileTravel: 2.1,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "2.1 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:30:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            aggregatedDiscountInfoV2: {},
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/nirulas-market-sector-15-faridabad-518208",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "374000",
                                            name: "The Brooklyn Creamery - Healthy Ice Cream",
                                            cloudinaryImageId: "b1b35780a9b1dfeb26d680506d494eaa",
                                            locality: "Sector 16A",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Desserts",
                                                "Ice Cream",
                                                "Healthy Food"
                                            ],
                                            avgRating: 4.3,
                                            veg: true,
                                            parentId: "236673",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 17,
                                                lastMileTravel: 1,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "1.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "brand",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "brand"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/the-brooklyn-creamery-healthy-ice-cream-sector-16a-sector-19-faridabad-374000",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "206561",
                                            name: "House of Chow",
                                            cloudinaryImageId: "6e97ac8f5c89213610309ef1940afa05",
                                            locality: "Town Park",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9300 for two",
                                            cuisines: [
                                                "Pan-Asian",
                                                "Chinese",
                                                "Thai",
                                                "Oriental"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "9064",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 28,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "C",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/house-of-chow-town-park-sector-12-faridabad-206561",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "56999",
                                            name: "La Pino'z Pizza",
                                            cloudinaryImageId: "mzb8tq7ccskyvadm9mt2",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 3.8,
                                            parentId: "4961",
                                            avgRatingString: "3.8",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 03:45:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9199"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/la-pinoz-pizza-shopping-centre-market-sector-15-faridabad-56999",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "170934",
                                            name: "Wow! Momo",
                                            cloudinaryImageId: "64fd45fd9f44c1737bc446e470bed666",
                                            locality: "Sector 15",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9300 for two",
                                            cuisines: [
                                                "Tibetan",
                                                "Healthy Food",
                                                "Asian",
                                                "Chinese",
                                                "Snacks",
                                                "Continental",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 3.9,
                                            parentId: "1776",
                                            avgRatingString: "3.9",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 24,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 02:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Chinese.png",
                                                        description: "Delivery!"
                                                    },
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Momos.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Chinese.png"
                                                                }
                                                            },
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Momos.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B999"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/wow-momo-sector-15-faridabad-170934",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "337231",
                                            name: "Biryani Blues",
                                            cloudinaryImageId: "97377e54937c079fe269d744aa66274a",
                                            locality: "Sector 79",
                                            areaName: "Sector 79",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Biryani",
                                                "Hyderabadi",
                                                "Lucknowi",
                                                "Kebabs"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "13813",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 29,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 04:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "50% OFF",
                                                subHeader: "UPTO \u20B995"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/biryani-blues-sector-79-faridabad-337231",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "156075",
                                            name: "The Good Bowl",
                                            cloudinaryImageId: "6e04be27387483a7c00444f8e8241108",
                                            locality: "Kapori colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Pastas",
                                                "Punjabi",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "7918",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 26,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9110"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/the-good-bowl-kapori-colony-sector-19-faridabad-156075",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39278",
                                            name: "Faasos - Wraps, Rolls & Shawarma",
                                            cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Kebabs",
                                                "Fast Food",
                                                "Snacks",
                                                "American",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "21809",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9129"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/faasos-wraps-rolls-and-shawarma-kapori-colony-sector-19-faridabad-39278",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39279",
                                            name: "Behrouz Biryani",
                                            cloudinaryImageId: "a4ffed13eb197c6df43dfe1c756560e5",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Kebabs",
                                                "Mughlai",
                                                "Beverages",
                                                "Desserts"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "1803",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 24,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Biryani.png",
                                                        description: "Delivery!"
                                                    },
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Biryani.png"
                                                                }
                                                            },
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9199",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/behrouz-biryani-kapori-colony-sector-19-faridabad-39279",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "62981",
                                            name: "LunchBox - Meals and Thalis",
                                            cloudinaryImageId: "4edcfc66d91018d69894941ebb3c8d16",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9200 for two",
                                            cuisines: [
                                                "Biryani",
                                                "North Indian",
                                                "Punjabi",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4,
                                            parentId: "4925",
                                            avgRatingString: "4.0",
                                            totalRatingsString: "5K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9159"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-kapori-colony-sector-19-faridabad-62981",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39280",
                                            name: "Oven Story Pizza - Standout Toppings",
                                            cloudinaryImageId: "b39e4312ae2e9f65c3b58faaed83f488",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "3534",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 30,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "26-35 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9125 OFF",
                                                subHeader: "ABOVE \u20B9199",
                                                discountTag: "FLAT DEAL"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-kapori-colony-sector-19-faridabad-39280",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "263954",
                                            name: "Chai Point",
                                            cloudinaryImageId: "znobbbace3njt7oxau2f",
                                            locality: "Adb Pwd Colony",
                                            areaName: "Sector 16",
                                            costForTwo: "\u20B9150 for two",
                                            cuisines: [
                                                "Bakery",
                                                "Beverages",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "South Indian",
                                                "Punjabi",
                                                "Chaat",
                                                "Indian",
                                                "American",
                                                "Fast Food",
                                                "Desserts",
                                                "Cafe",
                                                "Healthy Food",
                                                "Home Food",
                                                "North Indian"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "1607",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 23,
                                                lastMileTravel: 0.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-25 mins",
                                                lastMileTravelString: "0.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-11 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chai-point-adb-pwd-colony-sector-16-faridabad-263954",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "353657",
                                            name: "Chaayos Chai+Snacks=Relax",
                                            cloudinaryImageId: "cace805a6ba74137571d0f7ac92302b1",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Bakery",
                                                "Beverages",
                                                "Chaat",
                                                "Desserts",
                                                "Home Food",
                                                "Italian",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "Sweets"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "281782",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 20,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-20 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-11 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chaayos-chai-snacks-relax-shopping-centre-market-sector-15-faridabad-353657",
                                            type: "WEBLINK"
                                        }
                                    },
                                    {
                                        info: {
                                            id: "39281",
                                            name: "Firangi Bake",
                                            cloudinaryImageId: "rbvv4z3539ntnlrfcwhs",
                                            locality: "Kapori Colony",
                                            areaName: "Sector 19",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Mexican",
                                                "Healthy Food",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            avgRating: 4.1,
                                            parentId: "3952",
                                            avgRatingString: "4.1",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.3 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9199"
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {},
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/firangi-bake-kapori-colony-sector-19-faridabad-39281",
                                            type: "WEBLINK"
                                        }
                                    }
                                ],
                                theme: "Restaurant_Group_WebView_SEO_PB_Theme",
                                widgetType: "WIDGET_TYPE_POPULAR_BRANDS",
                                style: {
                                    width: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.41111112,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                                    },
                                    height: {
                                        type: "TYPE_RELATIVE",
                                        value: 0.7027027,
                                        reference: "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    },
                                    layoutAlignment: "LAYOUT_ALIGNMENT_LEFT"
                                },
                                collectionId: "84124"
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
                        title: "Restaurants with online food delivery in Faridabad",
                        id: "popular_restaurants_title"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
                        sortConfigs: [
                            {
                                key: "relevance",
                                title: "Relevance (Default)",
                                selected: true,
                                defaultSelection: true
                            },
                            {
                                key: "deliveryTimeAsc",
                                title: "Delivery Time"
                            },
                            {
                                key: "modelBasedRatingDesc",
                                title: "Rating"
                            },
                            {
                                key: "costForTwoAsc",
                                title: "Cost: Low to High"
                            },
                            {
                                key: "costForTwoDesc",
                                title: "Cost: High to Low"
                            }
                        ],
                        restaurantCount: 490,
                        facetList: [
                            {
                                label: "Delivery Time",
                                id: "deliveryTime",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Fast Delivery",
                                        id: "deliveryTimefacetquery1",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Cuisines",
                                id: "catalog_cuisines",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Afghani",
                                        id: "query_afghani",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "American",
                                        id: "query_american",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Andhra",
                                        id: "query_andhra",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Arabian",
                                        id: "query_arabian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Asian",
                                        id: "query_asian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Awadhi",
                                        id: "query_awadhi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bakery",
                                        id: "query_bakery",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bangladeshi",
                                        id: "query_bangladeshi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Barbecue",
                                        id: "query_barbecue",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Bengali",
                                        id: "query_bengali",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Beverages",
                                        id: "query_beverages",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Biryani",
                                        id: "query_biryani",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "British",
                                        id: "query_british",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Burgers",
                                        id: "query_burgers",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Burmese",
                                        id: "query_burmese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Cafe",
                                        id: "query_cafe",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Cakes and Pastries",
                                        id: "query_cakes_and_pastries",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chaat",
                                        id: "query_chaat",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chettinad",
                                        id: "query_chettinad",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Chinese",
                                        id: "query_chinese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Coastal",
                                        id: "query_coastal",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Confectionery",
                                        id: "query_confectionery",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Continental",
                                        id: "query_continental",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Desserts",
                                        id: "query_desserts",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "European",
                                        id: "query_european",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Fast Food",
                                        id: "query_fast_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "French",
                                        id: "query_french",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Grill",
                                        id: "query_grill",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Healthy Food",
                                        id: "query_healthy_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Home Food",
                                        id: "query_home_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Hyderabadi",
                                        id: "query_hyderabadi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ice Cream",
                                        id: "query_ice_cream",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ice Cream Cakes",
                                        id: "query_ice_cream_cakes",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Indian",
                                        id: "query_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Italian",
                                        id: "query_italian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Italian-American",
                                        id: "query_italian-american",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Japanese",
                                        id: "query_japanese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Juices",
                                        id: "query_juices",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Kebabs",
                                        id: "query_kebabs",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Keto",
                                        id: "query_keto",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Lebanese",
                                        id: "query_lebanese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Lucknowi",
                                        id: "query_lucknowi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Maharashtrian",
                                        id: "query_maharashtrian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Meat",
                                        id: "query_meat",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Mexican",
                                        id: "query_mexican",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Momos",
                                        id: "query_momos",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Mughlai",
                                        id: "query_mughlai",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Navratri Special",
                                        id: "query_navratri_special",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Nepalese",
                                        id: "query_nepalese",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "North Eastern",
                                        id: "query_north_eastern",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "North Indian",
                                        id: "query_north_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Oriental",
                                        id: "query_oriental",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Paan",
                                        id: "query_paan",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pan-Asian",
                                        id: "query_pan-asian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pastas",
                                        id: "query_pastas",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Pizzas",
                                        id: "query_pizzas",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Punjabi",
                                        id: "query_punjabi",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Rolls & Wraps",
                                        id: "query_rolls_&_wraps",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Salads",
                                        id: "query_salads",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Seafood",
                                        id: "query_seafood",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Snacks",
                                        id: "query_snacks",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "South Indian",
                                        id: "query_south_indian",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Street Food",
                                        id: "query_street_food",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Sweets",
                                        id: "query_sweets",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Tandoor",
                                        id: "query_tandoor",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Thai",
                                        id: "query_thai",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Thalis",
                                        id: "query_thalis",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Tibetan",
                                        id: "query_tibetan",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Waffle",
                                        id: "query_waffle",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "rolls",
                                        id: "query_rolls",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                canSearch: true,
                                subLabel: "Filter by cuisine",
                                openFilter: true
                            },
                            {
                                label: "Explore",
                                id: "explore",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "New on Swiggy",
                                        id: "newfacetquery1",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD"
                            },
                            {
                                label: "Ratings",
                                id: "rating",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Ratings 4.5+",
                                        id: "ratingfacetquery3",
                                        analytics: {}
                                    },
                                    {
                                        label: "Ratings 4.0+",
                                        id: "ratingfacetquery4",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Ratings 3.5+",
                                        id: "ratingfacetquery5",
                                        analytics: {}
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Veg/Non-Veg",
                                id: "isVeg",
                                selection: "SELECT_TYPE_SINGLESELECT",
                                facetInfo: [
                                    {
                                        label: "Pure Veg",
                                        id: "isVegfacetquery2",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Non Veg",
                                        id: "isVegfacetquery3",
                                        analytics: {}
                                    }
                                ],
                                viewType: "VIEW_TYPE_FLATTENED",
                                subLabel: "Filter by"
                            },
                            {
                                label: "Offers",
                                id: "restaurantOfferMultiTd",
                                selection: "SELECT_TYPE_SINGLESELECT",
                                facetInfo: [
                                    {
                                        label: "Offers",
                                        id: "restaurantOfferMultiTdfacetquery3",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_FLATTENED",
                                subLabel: "Restaurants with"
                            },
                            {
                                label: "Cost for two",
                                id: "costForTwo",
                                selection: "SELECT_TYPE_MULTISELECT",
                                facetInfo: [
                                    {
                                        label: "Rs. 300-Rs. 600",
                                        id: "costForTwofacetquery3",
                                        analytics: {},
                                        openFilter: true
                                    },
                                    {
                                        label: "Greater than Rs. 600",
                                        id: "costForTwofacetquery4",
                                        analytics: {}
                                    },
                                    {
                                        label: "Less than Rs. 300",
                                        id: "costForTwofacetquery5",
                                        analytics: {},
                                        openFilter: true
                                    }
                                ],
                                viewType: "VIEW_TYPE_HALF_CARD",
                                subLabel: "Filter by"
                            }
                        ]
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        layout: {
                            columns: 4
                        },
                        id: "restaurant_grid_listing",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                restaurants: [
                                    {
                                        info: {
                                            id: "576302",
                                            name: "Chinese Wok",
                                            cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
                                            locality: "Block E",
                                            areaName: "Sector 86",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Chinese",
                                                "Asian",
                                                "Tibetan",
                                                "Desserts"
                                            ],
                                            avgRating: 4,
                                            parentId: "61955",
                                            avgRatingString: "4.0",
                                            totalRatingsString: "500+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "5.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "Rxawards/_CATEGORY-Chinese.png",
                                                        description: "Delivery!"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Delivery!",
                                                                    imageId: "Rxawards/_CATEGORY-Chinese.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chinese-wok-block-e-sector-86-faridabad-576302",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "483332",
                                            name: "BOX8 - Desi Meals",
                                            cloudinaryImageId: "69a061b7e0f951cef2b4947946f94ec6",
                                            locality: "KC Road",
                                            areaName: "Badkal Lake",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Biryani",
                                                "Thalis",
                                                "Home Food"
                                            ],
                                            avgRating: 4.4,
                                            parentId: "10655",
                                            avgRatingString: "4.4",
                                            totalRatingsString: "500+",
                                            sla: {
                                                deliveryTime: 20,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "15-25 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9179"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/box8-desi-meals-kc-road-badkal-lake-faridabad-483332",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "447688",
                                            name: "Chicago Pizza",
                                            cloudinaryImageId: "z7vplkcpx1l3bfivhtqb",
                                            locality: "Green Fields Colony",
                                            areaName: "Green Fields Colony",
                                            costForTwo: "\u20B9350 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Beverages"
                                            ],
                                            avgRating: 3.8,
                                            parentId: "60277",
                                            avgRatingString: "3.8",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 42,
                                                lastMileTravel: 7.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "40-45 mins",
                                                lastMileTravelString: "7.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-04 23:59:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/chicago-pizza-green-fields-colony-faridabad-447688",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "21986",
                                            name: "Dark Brown",
                                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                                            locality: "Shopping Centre Market",
                                            areaName: "Sector 15",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Italian-American",
                                                "Continental",
                                                "Burgers",
                                                "Pizzas",
                                                "Pastas",
                                                "Chinese",
                                                "Beverages",
                                                "Salads",
                                                "Asian",
                                                "Healthy Food",
                                                "Fast Food",
                                                "Chaat",
                                                "Snacks",
                                                "Desserts",
                                                "American",
                                                "Italian",
                                                "Momos",
                                                "Rolls & Wraps",
                                                "Cafe"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "16162",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "10K+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 1.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "1.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/dark-brown-shopping-centre-market-sector-15-faridabad-21986",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "160794",
                                            name: "Jujube Asian Cookhouse",
                                            cloudinaryImageId: "aec4411704260f0a4e0749b44c0b6eeb",
                                            locality: "Sector 15",
                                            areaName: "Sector 16_FBD",
                                            costForTwo: "\u20B9500 for two",
                                            cuisines: [
                                                "Asian"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "15279",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 2,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "60% OFF",
                                                subHeader: "UPTO \u20B9120"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/jujube-asian-cookhouse-sector-15-sector-16-fbd-faridabad-160794",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "255729",
                                            name: "Silbuttah - The Indian Story By Berco's",
                                            cloudinaryImageId: "db6d3861e995a9ac4f7e461ddaed1b9f",
                                            locality: "Sector 12",
                                            areaName: "Sector 12",
                                            costForTwo: "\u20B9400 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Mughlai",
                                                "Kebabs"
                                            ],
                                            avgRating: 4.2,
                                            parentId: "459398",
                                            avgRatingString: "4.2",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 27,
                                                lastMileTravel: 3,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "3.0 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 00:00:00",
                                                opened: true
                                            },
                                            badges: {
                                                imageBadges: [
                                                    {
                                                        imageId: "newg.png",
                                                        description: "Gourmet"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "Gourmet",
                                                                    imageId: "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "40% OFF",
                                                subHeader: "UPTO \u20B980"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/silbuttah-the-indian-story-by-bercos-sector-12-faridabad-255729",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "328851",
                                            name: "HR-51",
                                            cloudinaryImageId: "cf2chuvk0swv15ypwasv",
                                            locality: "Friends Colony",
                                            areaName: "Sector 14",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Chinese",
                                                "Snacks"
                                            ],
                                            avgRating: 3.7,
                                            parentId: "13822",
                                            avgRatingString: "3.7",
                                            totalRatingsString: "1K+",
                                            sla: {
                                                deliveryTime: 28,
                                                lastMileTravel: 2.8,
                                                serviceability: "SERVICEABLE",
                                                slaString: "25-30 mins",
                                                lastMileTravelString: "2.8 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 03:00:00",
                                                opened: true
                                            },
                                            badges: {},
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {}
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "\u20B9100 OFF",
                                                subHeader: "ABOVE \u20B9249",
                                                discountTag: "FLAT DEAL",
                                                discountCalloutInfo: {
                                                    message: "Free Delivery",
                                                    logoCtx: {
                                                        logo: "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/hr-51-friends-colony-sector-14-faridabad-328851",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "622189",
                                            name: "MOJO Pizza - 2X Toppings",
                                            cloudinaryImageId: "59b64f9bb67234987652437f21d379c2",
                                            locality: "K C Road",
                                            areaName: "New Industrial Township",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "Pizzas",
                                                "Italian",
                                                "Fast Food",
                                                "Desserts"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "11329",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 25,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "20-30 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9169"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/mojo-pizza-2x-toppings-k-c-road-new-industrial-township-faridabad-622189",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        info: {
                                            id: "483340",
                                            name: "NH1 Bowls - Highway To North",
                                            cloudinaryImageId: "94654fdf308764cd0faf83dba35bcdc3",
                                            locality: "KC Road",
                                            areaName: "Badkal Lake",
                                            costForTwo: "\u20B9250 for two",
                                            cuisines: [
                                                "North Indian",
                                                "Punjabi",
                                                "Home Food"
                                            ],
                                            avgRating: 4.3,
                                            parentId: "22452",
                                            avgRatingString: "4.3",
                                            totalRatingsString: "100+",
                                            sla: {
                                                deliveryTime: 19,
                                                lastMileTravel: 4.5,
                                                serviceability: "SERVICEABLE",
                                                slaString: "14-24 mins",
                                                lastMileTravelString: "4.5 km",
                                                iconType: "ICON_TYPE_EMPTY"
                                            },
                                            availability: {
                                                nextCloseTime: "2024-04-05 01:45:00",
                                                opened: true
                                            },
                                            badges: {
                                                textExtendedBadges: [
                                                    {
                                                        iconId: "guiltfree/GF_Logo_android_3x",
                                                        shortDescription: "options available",
                                                        fontColor: "#7E808C"
                                                    }
                                                ]
                                            },
                                            isOpen: true,
                                            type: "F",
                                            badgesV2: {
                                                entityBadges: {
                                                    imageBased: {},
                                                    textBased: {},
                                                    textExtendedBadges: {
                                                        badgeObject: [
                                                            {
                                                                attributes: {
                                                                    description: "",
                                                                    fontColor: "#7E808C",
                                                                    iconId: "guiltfree/GF_Logo_android_3x",
                                                                    shortDescription: "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            aggregatedDiscountInfoV3: {
                                                header: "ITEMS",
                                                subHeader: "AT \u20B9159"
                                            },
                                            orderabilityCommunication: {
                                                title: {},
                                                subTitle: {},
                                                message: {},
                                                customIcon: {}
                                            },
                                            differentiatedUi: {
                                                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                differentiatedUiMediaDetails: {
                                                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                                                    lottie: {},
                                                    video: {}
                                                }
                                            },
                                            reviewsSummary: {},
                                            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            restaurantOfferPresentationInfo: {}
                                        },
                                        analytics: {
                                            context: "seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e"
                                        },
                                        cta: {
                                            link: "https://www.swiggy.com/restaurants/nh1-bowls-highway-to-north-kc-road-badkal-lake-faridabad-483340",
                                            text: "RESTAURANT_MENU",
                                            type: "WEBLINK"
                                        },
                                        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    }
                                ],
                                theme: "SeoRestaurantListingGridWidget"
                            }
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
                        message: "Show More",
                        id: "show_more_button"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Best Places to Eat Across Cities",
                        brands: [
                            {
                                text: "Best Restaurants in Bangalore",
                                link: "https://www.swiggy.com/city/bangalore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Pune",
                                link: "https://www.swiggy.com/city/pune/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mumbai",
                                link: "https://www.swiggy.com/city/mumbai/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Delhi",
                                link: "https://www.swiggy.com/city/delhi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Hyderabad",
                                link: "https://www.swiggy.com/city/hyderabad/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Kolkata",
                                link: "https://www.swiggy.com/city/kolkata/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Chennai",
                                link: "https://www.swiggy.com/city/chennai/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Chandigarh",
                                link: "https://www.swiggy.com/city/chandigarh/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ahmedabad",
                                link: "https://www.swiggy.com/city/ahmedabad/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Jaipur",
                                link: "https://www.swiggy.com/city/jaipur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Nagpur",
                                link: "https://www.swiggy.com/city/nagpur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Bhubaneswar",
                                link: "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Kochi",
                                link: "https://www.swiggy.com/city/kochi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Surat",
                                link: "https://www.swiggy.com/city/surat/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Dehradun",
                                link: "https://www.swiggy.com/city/dehradun/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ludhiana",
                                link: "https://www.swiggy.com/city/ludhiana/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Patna",
                                link: "https://www.swiggy.com/city/patna/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mangaluru",
                                link: "https://www.swiggy.com/city/mangaluru/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Bhopal",
                                link: "https://www.swiggy.com/city/bhopal/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Gurgaon",
                                link: "https://www.swiggy.com/city/gurgaon/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Coimbatore",
                                link: "https://www.swiggy.com/city/coimbatore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Agra",
                                link: "https://www.swiggy.com/city/agra/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Noida",
                                link: "https://www.swiggy.com/city/noida/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vijayawada",
                                link: "https://www.swiggy.com/city/vijayawada/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Guwahati",
                                link: "https://www.swiggy.com/city/guwahati/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Mysore",
                                link: "https://www.swiggy.com/city/mysore/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Pondicherry",
                                link: "https://www.swiggy.com/city/pondicherry/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Thiruvananthapuram",
                                link: "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Ranchi",
                                link: "https://www.swiggy.com/city/ranchi/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vizag",
                                link: "https://www.swiggy.com/city/vizag/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Udaipur",
                                link: "https://www.swiggy.com/city/udaipur/best-restaurants"
                            },
                            {
                                text: "Best Restaurants in Vadodara",
                                link: "https://www.swiggy.com/city/vadodara/best-restaurants"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Best Cuisines Near Me",
                        brands: [
                            {
                                text: "Chinese Restaurant Near Me",
                                link: "https://www.swiggy.com/chinese-restaurants-near-me"
                            },
                            {
                                text: "South Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/south-indian-restaurants-near-me"
                            },
                            {
                                text: "Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/indian-restaurants-near-me"
                            },
                            {
                                text: "Kerala Restaurant Near Me",
                                link: "https://www.swiggy.com/kerala-restaurants-near-me"
                            },
                            {
                                text: "Korean Restaurant Near Me",
                                link: "https://www.swiggy.com/korean-restaurants-near-me"
                            },
                            {
                                text: "North Indian Restaurant Near Me",
                                link: "https://www.swiggy.com/north-indian-restaurants-near-me"
                            },
                            {
                                text: "Seafood Restaurant Near Me",
                                link: "https://www.swiggy.com/seafood-restaurants-near-me"
                            },
                            {
                                text: "Bengali Restaurant Near Me",
                                link: "https://www.swiggy.com/bengali-restaurants-near-me"
                            },
                            {
                                text: "Punjabi Restaurant Near Me",
                                link: "https://www.swiggy.com/punjabi-restaurants-near-me"
                            },
                            {
                                text: "Italian Restaurant Near Me",
                                link: "https://www.swiggy.com/italian-restaurants-near-me"
                            },
                            {
                                text: "Andhra Restaurant Near Me",
                                link: "https://www.swiggy.com/andhra-restaurants-near-me"
                            },
                            {
                                text: "Biryani Restaurant Near Me",
                                link: "https://www.swiggy.com/biryani-restaurants-near-me"
                            },
                            {
                                text: "Japanese Restaurant Near Me",
                                link: "https://www.swiggy.com/japanese-restaurants-near-me"
                            },
                            {
                                text: "Arabian Restaurant Near Me",
                                link: "https://www.swiggy.com/arabian-restaurants-near-me"
                            },
                            {
                                text: "Fast Food Restaurant Near Me",
                                link: "https://www.swiggy.com/fast-food-restaurants-near-me"
                            },
                            {
                                text: "Jain Restaurant Near Me",
                                link: "https://www.swiggy.com/jain-restaurants-near-me"
                            },
                            {
                                text: "Gujarati Restaurant Near Me",
                                link: "https://www.swiggy.com/gujarati-restaurants-near-me"
                            },
                            {
                                text: "Thai Restaurant Near Me",
                                link: "https://www.swiggy.com/thai-restaurants-near-me"
                            },
                            {
                                text: "Pizzas Restaurant Near Me",
                                link: "https://www.swiggy.com/pizzas-restaurants-near-me"
                            },
                            {
                                text: "Asian Restaurant Near Me",
                                link: "https://www.swiggy.com/asian-restaurants-near-me"
                            },
                            {
                                text: "Cafe Restaurant Near Me",
                                link: "https://www.swiggy.com/cafe-restaurants-near-me"
                            },
                            {
                                text: "Continental Restaurant Near Me",
                                link: "https://www.swiggy.com/continental-restaurants-near-me"
                            },
                            {
                                text: "Mexican Restaurant Near Me",
                                link: "https://www.swiggy.com/mexican-restaurants-near-me"
                            },
                            {
                                text: "Mughlai Restaurant Near Me",
                                link: "https://www.swiggy.com/mughlai-restaurants-near-me"
                            },
                            {
                                text: "Sushi Restaurant Near Me",
                                link: "https://www.swiggy.com/sushi-restaurants-near-me"
                            },
                            {
                                text: "Mangalorean Restaurant Near Me",
                                link: "https://www.swiggy.com/mangalorean-restaurants-near-me"
                            },
                            {
                                text: "Tibetan Restaurant Near Me",
                                link: "https://www.swiggy.com/tibetan-restaurants-near-me"
                            },
                            {
                                text: "Barbecue Restaurant Near Me",
                                link: "https://www.swiggy.com/barbecue-restaurants-near-me"
                            },
                            {
                                text: "Maharashtrian Restaurant Near Me",
                                link: "https://www.swiggy.com/maharashtrian-restaurants-near-me"
                            },
                            {
                                text: "Nepalese Restaurant Near Me",
                                link: "https://www.swiggy.com/nepalese-restaurants-near-me"
                            },
                            {
                                text: "Rajasthani Restaurant Near Me",
                                link: "https://www.swiggy.com/rajasthani-restaurants-near-me"
                            },
                            {
                                text: "Turkish Restaurant Near Me",
                                link: "https://www.swiggy.com/turkish-restaurants-near-me"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        title: "Explore Every Restaurants Near Me",
                        brands: [
                            {
                                text: "Explore Restaurants Near Me",
                                link: "https://www.swiggy.com/restaurants-near-me"
                            },
                            {
                                text: "Explore Top Rated Restaurants Near Me",
                                link: "https://www.swiggy.com/best-restaurants-near-me"
                            }
                        ],
                        id: "restaurant_near_me_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
                        title: "For better experience,download the Swiggy app now",
                        androidAppImage: "portal/m/play_store.png",
                        androidAppLink: "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                        iosAppImage: "portal/m/app_store.png",
                        iosAppLink: "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
                        id: "app_install_links"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
                        cities: [
                            {
                                text: "Bangalore",
                                link: "https://www.swiggy.com/city/bangalore"
                            },
                            {
                                text: "Gurgaon",
                                link: "https://www.swiggy.com/city/gurgaon"
                            },
                            {
                                text: "Hyderabad",
                                link: "https://www.swiggy.com/city/hyderabad"
                            },
                            {
                                text: "Delhi",
                                link: "https://www.swiggy.com/city/delhi"
                            },
                            {
                                text: "Mumbai",
                                link: "https://www.swiggy.com/city/mumbai"
                            },
                            {
                                text: "Pune",
                                link: "https://www.swiggy.com/city/pune"
                            },
                            {
                                text: "Kolkata",
                                link: "https://www.swiggy.com/city/kolkata"
                            },
                            {
                                text: "Chennai",
                                link: "https://www.swiggy.com/city/chennai"
                            },
                            {
                                text: "Ahmedabad",
                                link: "https://www.swiggy.com/city/ahmedabad"
                            },
                            {
                                text: "Chandigarh",
                                link: "https://www.swiggy.com/city/chandigarh"
                            },
                            {
                                text: "Jaipur",
                                link: "https://www.swiggy.com/city/jaipur"
                            },
                            {
                                text: "Kochi",
                                link: "https://www.swiggy.com/city/kochi"
                            },
                            {
                                text: "Coimbatore",
                                link: "https://www.swiggy.com/city/coimbatore"
                            },
                            {
                                text: "Lucknow",
                                link: "https://www.swiggy.com/city/lucknow"
                            },
                            {
                                text: "Nagpur",
                                link: "https://www.swiggy.com/city/nagpur"
                            },
                            {
                                text: "Vadodara",
                                link: "https://www.swiggy.com/city/vadodara"
                            },
                            {
                                text: "Indore",
                                link: "https://www.swiggy.com/city/indore"
                            },
                            {
                                text: "Guwahati",
                                link: "https://www.swiggy.com/city/guwahati"
                            },
                            {
                                text: "Vizag",
                                link: "https://www.swiggy.com/city/vizag"
                            },
                            {
                                text: "Surat",
                                link: "https://www.swiggy.com/city/surat"
                            },
                            {
                                text: "Dehradun",
                                link: "https://www.swiggy.com/city/dehradun"
                            },
                            {
                                text: "Noida",
                                link: "https://www.swiggy.com/city/noida"
                            },
                            {
                                text: "Ludhiana",
                                link: "https://www.swiggy.com/city/ludhiana"
                            },
                            {
                                text: "Trichy",
                                link: "https://www.swiggy.com/city/trichy"
                            },
                            {
                                text: "Vijayawada",
                                link: "https://www.swiggy.com/city/vijayawada"
                            },
                            {
                                text: "Kanpur",
                                link: "https://www.swiggy.com/city/kanpur"
                            },
                            {
                                text: "Mysore",
                                link: "https://www.swiggy.com/city/mysore"
                            },
                            {
                                text: "Nashik",
                                link: "https://www.swiggy.com/city/nashik"
                            },
                            {
                                text: "Udaipur",
                                link: "https://www.swiggy.com/city/udaipur"
                            },
                            {
                                text: "Pondicherry",
                                link: "https://www.swiggy.com/city/pondicherry"
                            },
                            {
                                text: "Agra",
                                link: "https://www.swiggy.com/city/agra"
                            },
                            {
                                text: "Aurangabad",
                                link: "https://www.swiggy.com/city/aurangabad"
                            },
                            {
                                text: "Jalandhar",
                                link: "https://www.swiggy.com/city/jalandhar"
                            },
                            {
                                text: "Kota",
                                link: "https://www.swiggy.com/city/kota"
                            },
                            {
                                text: "Madurai",
                                link: "https://www.swiggy.com/city/madurai"
                            },
                            {
                                text: "Allahabad",
                                link: "https://www.swiggy.com/city/allahabad"
                            },
                            {
                                text: "Manipal",
                                link: "https://www.swiggy.com/city/manipal"
                            },
                            {
                                text: "Amritsar",
                                link: "https://www.swiggy.com/city/amritsar"
                            },
                            {
                                text: "Bareilly",
                                link: "https://www.swiggy.com/city/bareilly"
                            },
                            {
                                text: "Meerut",
                                link: "https://www.swiggy.com/city/meerut"
                            },
                            {
                                text: "Bhopal",
                                link: "https://www.swiggy.com/city/bhopal"
                            },
                            {
                                text: "Ooty",
                                link: "https://www.swiggy.com/city/ooty"
                            },
                            {
                                text: "Bhubaneswar",
                                link: "https://www.swiggy.com/city/bhubaneswar"
                            },
                            {
                                text: "Raipur",
                                link: "https://www.swiggy.com/city/raipur"
                            },
                            {
                                text: "Bikaner",
                                link: "https://www.swiggy.com/city/bikaner"
                            },
                            {
                                text: "Rajkot",
                                link: "https://www.swiggy.com/city/rajkot"
                            },
                            {
                                text: "Kozhikode",
                                link: "https://www.swiggy.com/city/kozhikode"
                            },
                            {
                                text: "Central Goa",
                                link: "https://www.swiggy.com/city/central-goa"
                            },
                            {
                                text: "Sirsa",
                                link: "https://www.swiggy.com/city/sirsa"
                            },
                            {
                                text: "Gwalior",
                                link: "https://www.swiggy.com/city/gwalior"
                            },
                            {
                                text: "Thrissur",
                                link: "https://www.swiggy.com/city/thrissur"
                            },
                            {
                                text: "Kharagpur",
                                link: "https://www.swiggy.com/city/kharagpur"
                            },
                            {
                                text: "Tirupati",
                                link: "https://www.swiggy.com/city/tirupati"
                            },
                            {
                                text: "Tirupur",
                                link: "https://www.swiggy.com/city/tirupur"
                            },
                            {
                                text: "Vellore",
                                link: "https://www.swiggy.com/city/vellore"
                            },
                            {
                                text: "Thiruvananthapuram",
                                link: "https://www.swiggy.com/city/thiruvananthapuram"
                            },
                            {
                                text: "Warangal",
                                link: "https://www.swiggy.com/city/warangal"
                            },
                            {
                                text: "Varanasi",
                                link: "https://www.swiggy.com/city/varanasi"
                            },
                            {
                                text: "Mangaluru",
                                link: "https://www.swiggy.com/city/mangaluru"
                            },
                            {
                                text: "Patna",
                                link: "https://www.swiggy.com/city/patna"
                            },
                            {
                                text: "Ranchi",
                                link: "https://www.swiggy.com/city/ranchi"
                            },
                            {
                                text: "Faridabad",
                                link: "https://www.swiggy.com/city/faridabad"
                            },
                            {
                                text: "Guntur",
                                link: "https://www.swiggy.com/city/guntur"
                            },
                            {
                                text: "Ujjain",
                                link: "https://www.swiggy.com/city/ujjain"
                            },
                            {
                                text: "Patiala",
                                link: "https://www.swiggy.com/city/patiala"
                            },
                            {
                                text: "Karnal",
                                link: "https://www.swiggy.com/city/karnal"
                            },
                            {
                                text: "Kakinada",
                                link: "https://www.swiggy.com/city/kakinada"
                            },
                            {
                                text: "Rajahmundry",
                                link: "https://www.swiggy.com/city/rajahmundry"
                            },
                            {
                                text: "Bilaspur",
                                link: "https://www.swiggy.com/city/bilaspur"
                            },
                            {
                                text: "Bhilai",
                                link: "https://www.swiggy.com/city/bhilai"
                            },
                            {
                                text: "Anand",
                                link: "https://www.swiggy.com/city/anand"
                            },
                            {
                                text: "Bhavnagar",
                                link: "https://www.swiggy.com/city/bhavnagar"
                            },
                            {
                                text: "Jammu",
                                link: "https://www.swiggy.com/city/jammu"
                            },
                            {
                                text: "Muktsar",
                                link: "https://www.swiggy.com/city/muktsar"
                            },
                            {
                                text: "Panipat",
                                link: "https://www.swiggy.com/city/panipat"
                            },
                            {
                                text: "Dhanbad",
                                link: "https://www.swiggy.com/city/dhanbad"
                            },
                            {
                                text: "Hubli",
                                link: "https://www.swiggy.com/city/hubli"
                            },
                            {
                                text: "Belgaum",
                                link: "https://www.swiggy.com/city/belgaum"
                            },
                            {
                                text: "Jabalpur",
                                link: "https://www.swiggy.com/city/jabalpur"
                            },
                            {
                                text: "Kolhapur",
                                link: "https://www.swiggy.com/city/kolhapur"
                            },
                            {
                                text: "Solapur",
                                link: "https://www.swiggy.com/city/solapur"
                            },
                            {
                                text: "Shillong",
                                link: "https://www.swiggy.com/city/shillong"
                            },
                            {
                                text: "Cuttack",
                                link: "https://www.swiggy.com/city/cuttack"
                            },
                            {
                                text: "Aligarh",
                                link: "https://www.swiggy.com/city/aligarh"
                            },
                            {
                                text: "Salem",
                                link: "https://www.swiggy.com/city/salem"
                            },
                            {
                                text: "Jodhpur",
                                link: "https://www.swiggy.com/city/jodhpur"
                            },
                            {
                                text: "Ajmer",
                                link: "https://www.swiggy.com/city/ajmer"
                            },
                            {
                                text: "Jhansi",
                                link: "https://www.swiggy.com/city/jhansi"
                            },
                            {
                                text: "Gorakhpur",
                                link: "https://www.swiggy.com/city/gorakhpur"
                            },
                            {
                                text: "Thanjavur",
                                link: "https://www.swiggy.com/city/thanjavur"
                            },
                            {
                                text: "Erode",
                                link: "https://www.swiggy.com/city/erode"
                            },
                            {
                                text: "Nellore",
                                link: "https://www.swiggy.com/city/nellore"
                            },
                            {
                                text: "Rourkela",
                                link: "https://www.swiggy.com/city/rourkela"
                            },
                            {
                                text: "Anantapur",
                                link: "https://www.swiggy.com/city/anantapur"
                            },
                            {
                                text: "Kurnool",
                                link: "https://www.swiggy.com/city/kurnool"
                            },
                            {
                                text: "Ahmednagar",
                                link: "https://www.swiggy.com/city/ahmednagar"
                            },
                            {
                                text: "Phagwara",
                                link: "https://www.swiggy.com/city/phagwara"
                            },
                            {
                                text: "Ambala",
                                link: "https://www.swiggy.com/city/ambala"
                            },
                            {
                                text: "Ballari",
                                link: "https://www.swiggy.com/city/ballari"
                            },
                            {
                                text: "Saharanpur",
                                link: "https://www.swiggy.com/city/saharanpur"
                            },
                            {
                                text: "Tirunelveli",
                                link: "https://www.swiggy.com/city/tirunelveli"
                            },
                            {
                                text: "Bathinda",
                                link: "https://www.swiggy.com/city/bathinda"
                            },
                            {
                                text: "Mathura",
                                link: "https://www.swiggy.com/city/mathura"
                            },
                            {
                                text: "Haridwar",
                                link: "https://www.swiggy.com/city/haridwar"
                            },
                            {
                                text: "Ratnagiri",
                                link: "https://www.swiggy.com/city/ratnagiri"
                            },
                            {
                                text: "Sangli",
                                link: "https://www.swiggy.com/city/sangli"
                            },
                            {
                                text: "Amravati",
                                link: "https://www.swiggy.com/city/amravati"
                            },
                            {
                                text: "Rishikesh",
                                link: "https://www.swiggy.com/city/rishikesh"
                            },
                            {
                                text: "Nagercoil",
                                link: "https://www.swiggy.com/city/nagercoil"
                            },
                            {
                                text: "KanyaKumari",
                                link: "https://www.swiggy.com/city/kanyakumari"
                            },
                            {
                                text: "Kadapa",
                                link: "https://www.swiggy.com/city/kadapa"
                            },
                            {
                                text: "Nizamabad",
                                link: "https://www.swiggy.com/city/nizamabad"
                            },
                            {
                                text: "Shivamogga",
                                link: "https://www.swiggy.com/city/shivamogga"
                            },
                            {
                                text: "Davanagere",
                                link: "https://www.swiggy.com/city/davanagere"
                            },
                            {
                                text: "Roorkee",
                                link: "https://www.swiggy.com/city/roorkee"
                            },
                            {
                                text: "Nanded",
                                link: "https://www.swiggy.com/city/nanded"
                            },
                            {
                                text: "Rewa",
                                link: "https://www.swiggy.com/city/rewa"
                            },
                            {
                                text: "Satna",
                                link: "https://www.swiggy.com/city/satna"
                            },
                            {
                                text: "Muzaffarpur",
                                link: "https://www.swiggy.com/city/muzaffarpur"
                            },
                            {
                                text: "Valsad",
                                link: "https://www.swiggy.com/city/valsad"
                            },
                            {
                                text: "Vapi",
                                link: "https://www.swiggy.com/city/vapi"
                            },
                            {
                                text: "Chhapra",
                                link: "https://www.swiggy.com/city/chhapra"
                            },
                            {
                                text: "Dharamshala",
                                link: "https://www.swiggy.com/city/dharamshala"
                            },
                            {
                                text: "Kollam",
                                link: "https://www.swiggy.com/city/kollam"
                            },
                            {
                                text: "Silchar",
                                link: "https://www.swiggy.com/city/silchar"
                            },
                            {
                                text: "Alappuzha",
                                link: "https://www.swiggy.com/city/alappuzha"
                            },
                            {
                                text: "Sonipat",
                                link: "https://www.swiggy.com/city/sonipat"
                            },
                            {
                                text: "Rohtak",
                                link: "https://www.swiggy.com/city/rohtak"
                            },
                            {
                                text: "Mehsana",
                                link: "https://www.swiggy.com/city/mehsana"
                            },
                            {
                                text: "Kullu",
                                link: "https://www.swiggy.com/city/kullu"
                            },
                            {
                                text: "Dhule",
                                link: "https://www.swiggy.com/city/dhule"
                            },
                            {
                                text: "Dharwad",
                                link: "https://www.swiggy.com/city/dharwad"
                            },
                            {
                                text: "Latur",
                                link: "https://www.swiggy.com/city/latur"
                            },
                            {
                                text: "Vizianagaram",
                                link: "https://www.swiggy.com/city/vizianagaram"
                            },
                            {
                                text: "Khammam",
                                link: "https://www.swiggy.com/city/khammam"
                            },
                            {
                                text: "Hampi",
                                link: "https://www.swiggy.com/city/hampi"
                            },
                            {
                                text: "Nainital",
                                link: "https://www.swiggy.com/city/nainital"
                            },
                            {
                                text: "Akola",
                                link: "https://www.swiggy.com/city/akola"
                            },
                            {
                                text: "Kalaburagi",
                                link: "https://www.swiggy.com/city/kalaburagi"
                            },
                            {
                                text: "Gaya",
                                link: "https://www.swiggy.com/city/gaya"
                            },
                            {
                                text: "Muzaffarnagar",
                                link: "https://www.swiggy.com/city/muzaffarnagar"
                            },
                            {
                                text: "Dewas",
                                link: "https://www.swiggy.com/city/dewas"
                            },
                            {
                                text: "Korba",
                                link: "https://www.swiggy.com/city/korba"
                            },
                            {
                                text: "Mussoorie",
                                link: "https://www.swiggy.com/city/mussoorie"
                            },
                            {
                                text: "Jalgaon",
                                link: "https://www.swiggy.com/city/jalgaon"
                            },
                            {
                                text: "Yamuna Nagar",
                                link: "https://www.swiggy.com/city/yamuna-nagar"
                            },
                            {
                                text: "Bhagalpur",
                                link: "https://www.swiggy.com/city/bhagalpur"
                            },
                            {
                                text: "Hapur",
                                link: "https://www.swiggy.com/city/hapur"
                            },
                            {
                                text: "Morena",
                                link: "https://www.swiggy.com/city/morena"
                            },
                            {
                                text: "Hassan",
                                link: "https://www.swiggy.com/city/hassan"
                            },
                            {
                                text: "Hisar",
                                link: "https://www.swiggy.com/city/hisar"
                            },
                            {
                                text: "Godhra",
                                link: "https://www.swiggy.com/city/godhra"
                            },
                            {
                                text: "Kolar ",
                                link: "https://www.swiggy.com/city/kolar"
                            },
                            {
                                text: "Rampur",
                                link: "https://www.swiggy.com/city/rampur"
                            },
                            {
                                text: "Sitapur",
                                link: "https://www.swiggy.com/city/sitapur"
                            },
                            {
                                text: "Etawah",
                                link: "https://www.swiggy.com/city/etawah"
                            },
                            {
                                text: "Porbandar",
                                link: "https://www.swiggy.com/city/porbandar"
                            },
                            {
                                text: "Nadiad",
                                link: "https://www.swiggy.com/city/nadiad"
                            },
                            {
                                text: "Sagar",
                                link: "https://www.swiggy.com/city/sagar"
                            },
                            {
                                text: "Morbi",
                                link: "https://www.swiggy.com/city/morbi"
                            },
                            {
                                text: "Chhindwara",
                                link: "https://www.swiggy.com/city/chhindwara"
                            },
                            {
                                text: "Tumakuru",
                                link: "https://www.swiggy.com/city/tumakuru"
                            },
                            {
                                text: "Singrauli",
                                link: "https://www.swiggy.com/city/singrauli"
                            },
                            {
                                text: "Thoothukudi",
                                link: "https://www.swiggy.com/city/thoothukudi"
                            },
                            {
                                text: "Katni",
                                link: "https://www.swiggy.com/city/katni"
                            },
                            {
                                text: "Khandwa",
                                link: "https://www.swiggy.com/city/khandwa"
                            },
                            {
                                text: "Eluru",
                                link: "https://www.swiggy.com/city/eluru"
                            },
                            {
                                text: "Malappuram",
                                link: "https://www.swiggy.com/city/malappuram"
                            },
                            {
                                text: "Dibrugarh",
                                link: "https://www.swiggy.com/city/dibrugarh"
                            },
                            {
                                text: "Deoghar",
                                link: "https://www.swiggy.com/city/deoghar"
                            },
                            {
                                text: "Khanna",
                                link: "https://www.swiggy.com/city/khanna"
                            },
                            {
                                text: "Bidar",
                                link: "https://www.swiggy.com/city/bidar"
                            },
                            {
                                text: "Madikeri",
                                link: "https://www.swiggy.com/city/madikeri"
                            },
                            {
                                text: "Haldwani",
                                link: "https://www.swiggy.com/city/haldwani"
                            },
                            {
                                text: "Farrukhabad",
                                link: "https://www.swiggy.com/city/farrukhabad"
                            },
                            {
                                text: "Malegaon",
                                link: "https://www.swiggy.com/city/malegaon"
                            },
                            {
                                text: "Dindigul",
                                link: "https://www.swiggy.com/city/dindigul"
                            },
                            {
                                text: "Shahjahanpur",
                                link: "https://www.swiggy.com/city/shahjahanpur"
                            },
                            {
                                text: "Beed",
                                link: "https://www.swiggy.com/city/beed"
                            },
                            {
                                text: "Junagadh",
                                link: "https://www.swiggy.com/city/junagadh"
                            },
                            {
                                text: "Asansol",
                                link: "https://www.swiggy.com/city/asansol"
                            },
                            {
                                text: "Beawar",
                                link: "https://www.swiggy.com/city/beawar"
                            },
                            {
                                text: "Kishangarh",
                                link: "https://www.swiggy.com/city/kishangarh"
                            },
                            {
                                text: "Parbhani",
                                link: "https://www.swiggy.com/city/parbhani"
                            },
                            {
                                text: "Gondia",
                                link: "https://www.swiggy.com/city/gondia"
                            },
                            {
                                text: "Ichalkaranji",
                                link: "https://www.swiggy.com/city/ichalkaranji"
                            },
                            {
                                text: "Jalna",
                                link: "https://www.swiggy.com/city/jalna"
                            },
                            {
                                text: "Yavatmal",
                                link: "https://www.swiggy.com/city/yavatmal"
                            },
                            {
                                text: "Shivpuri",
                                link: "https://www.swiggy.com/city/shivpuri"
                            },
                            {
                                text: "Moga",
                                link: "https://www.swiggy.com/city/moga"
                            },
                            {
                                text: "Abohar",
                                link: "https://www.swiggy.com/city/abohar"
                            },
                            {
                                text: "Adoni",
                                link: "https://www.swiggy.com/city/adoni"
                            },
                            {
                                text: "Madanapalle",
                                link: "https://www.swiggy.com/city/madanapalle"
                            },
                            {
                                text: "Tiruvannamalai",
                                link: "https://www.swiggy.com/city/tiruvannamalai"
                            },
                            {
                                text: "Satara",
                                link: "https://www.swiggy.com/city/satara"
                            },
                            {
                                text: "Ambur",
                                link: "https://www.swiggy.com/city/ambur"
                            },
                            {
                                text: "Karimnagar",
                                link: "https://www.swiggy.com/city/karimnagar"
                            },
                            {
                                text: "Ratlam",
                                link: "https://www.swiggy.com/city/ratlam"
                            },
                            {
                                text: "Moradabad",
                                link: "https://www.swiggy.com/city/moradabad"
                            },
                            {
                                text: "Machilipatnam",
                                link: "https://www.swiggy.com/city/machilipatnam"
                            },
                            {
                                text: "Ongole",
                                link: "https://www.swiggy.com/city/ongole"
                            },
                            {
                                text: "Kottayam",
                                link: "https://www.swiggy.com/city/kottayam"
                            },
                            {
                                text: "Darbhanga",
                                link: "https://www.swiggy.com/city/darbhanga"
                            },
                            {
                                text: "Kurukshetra",
                                link: "https://www.swiggy.com/city/kurukshetra"
                            },
                            {
                                text: "Unnao",
                                link: "https://www.swiggy.com/city/unnao"
                            },
                            {
                                text: "Bulandshahr",
                                link: "https://www.swiggy.com/city/bulandshahr"
                            },
                            {
                                text: "Durgapur",
                                link: "https://www.swiggy.com/city/durgapur"
                            },
                            {
                                text: "Siliguri",
                                link: "https://www.swiggy.com/city/siliguri"
                            },
                            {
                                text: "Pali",
                                link: "https://www.swiggy.com/city/pali"
                            },
                            {
                                text: "Tadepalligudem",
                                link: "https://www.swiggy.com/city/tadepalligudem"
                            },
                            {
                                text: "Ramagundam",
                                link: "https://www.swiggy.com/city/ramagundam"
                            },
                            {
                                text: "Mahbubnagar",
                                link: "https://www.swiggy.com/city/mahbubnagar"
                            },
                            {
                                text: "Bhiwani",
                                link: "https://www.swiggy.com/city/bhiwani"
                            },
                            {
                                text: "Cuddalore",
                                link: "https://www.swiggy.com/city/cuddalore"
                            },
                            {
                                text: "Kaithal",
                                link: "https://www.swiggy.com/city/kaithal"
                            },
                            {
                                text: "Jagtial",
                                link: "https://www.swiggy.com/city/jagtial"
                            },
                            {
                                text: "Palakkad",
                                link: "https://www.swiggy.com/city/palakkad"
                            },
                            {
                                text: "Guna",
                                link: "https://www.swiggy.com/city/guna"
                            },
                            {
                                text: "Kumbakonam",
                                link: "https://www.swiggy.com/city/kumbakonam"
                            },
                            {
                                text: "Maunath Bhanjan",
                                link: "https://www.swiggy.com/city/maunath-bhanjan"
                            },
                            {
                                text: "Baripada",
                                link: "https://www.swiggy.com/city/baripada"
                            },
                            {
                                text: "Orai",
                                link: "https://www.swiggy.com/city/orai"
                            },
                            {
                                text: "Bhadrak",
                                link: "https://www.swiggy.com/city/bhadrak"
                            },
                            {
                                text: "Batala",
                                link: "https://www.swiggy.com/city/batala"
                            },
                            {
                                text: "Firozpur",
                                link: "https://www.swiggy.com/city/firozpur"
                            },
                            {
                                text: "Barnala",
                                link: "https://www.swiggy.com/city/barnala"
                            },
                            {
                                text: "Raigarh",
                                link: "https://www.swiggy.com/city/raigarh"
                            },
                            {
                                text: "Nagaon",
                                link: "https://www.swiggy.com/city/nagaon"
                            },
                            {
                                text: "Mainpuri",
                                link: "https://www.swiggy.com/city/mainpuri"
                            },
                            {
                                text: "Balurghat",
                                link: "https://www.swiggy.com/city/balurghat"
                            },
                            {
                                text: "Giridih",
                                link: "https://www.swiggy.com/city/giridih"
                            },
                            {
                                text: "Ghazipur",
                                link: "https://www.swiggy.com/city/ghazipur"
                            },
                            {
                                text: "Jagdalpur",
                                link: "https://www.swiggy.com/city/jagdalpur"
                            },
                            {
                                text: "Vidisha",
                                link: "https://www.swiggy.com/city/vidisha"
                            },
                            {
                                text: "Dimapur",
                                link: "https://www.swiggy.com/city/dimapur"
                            },
                            {
                                text: "Shikohabad",
                                link: "https://www.swiggy.com/city/shikohabad"
                            },
                            {
                                text: "Imphal",
                                link: "https://www.swiggy.com/city/imphal"
                            },
                            {
                                text: "Lakhimpur",
                                link: "https://www.swiggy.com/city/lakhimpur"
                            },
                            {
                                text: "Rudrapur",
                                link: "https://www.swiggy.com/city/rudrapur"
                            },
                            {
                                text: "Ambikapur",
                                link: "https://www.swiggy.com/city/ambikapur"
                            },
                            {
                                text: "Rae Bareli",
                                link: "https://www.swiggy.com/city/rae-bareli"
                            },
                            {
                                text: "Tinsukia",
                                link: "https://www.swiggy.com/city/tinsukia"
                            },
                            {
                                text: "Rajapalayam",
                                link: "https://www.swiggy.com/city/rajapalayam"
                            },
                            {
                                text: "Rajnandgaon",
                                link: "https://www.swiggy.com/city/rajnandgaon"
                            },
                            {
                                text: "Kashipur",
                                link: "https://www.swiggy.com/city/kashipur"
                            },
                            {
                                text: "Ranibennur",
                                link: "https://www.swiggy.com/city/ranibennur"
                            },
                            {
                                text: "Burhanpur",
                                link: "https://www.swiggy.com/city/burhanpur"
                            },
                            {
                                text: "Bhadravati",
                                link: "https://www.swiggy.com/city/bhadravati"
                            },
                            {
                                text: "Chittoor",
                                link: "https://www.swiggy.com/city/chittoor"
                            },
                            {
                                text: "Pudukkottai",
                                link: "https://www.swiggy.com/city/pudukkottai"
                            },
                            {
                                text: "Hardoi",
                                link: "https://www.swiggy.com/city/hardoi"
                            },
                            {
                                text: "Basti",
                                link: "https://www.swiggy.com/city/basti"
                            },
                            {
                                text: "Karaikkudi",
                                link: "https://www.swiggy.com/city/karaikkudi"
                            },
                            {
                                text: "Lalitpur",
                                link: "https://www.swiggy.com/city/lalitpur"
                            },
                            {
                                text: "Hospet",
                                link: "https://www.swiggy.com/city/hospet"
                            },
                            {
                                text: "Budaun",
                                link: "https://www.swiggy.com/city/budaun"
                            },
                            {
                                text: "Neemuch",
                                link: "https://www.swiggy.com/city/neemuch"
                            },
                            {
                                text: "Pilibhit",
                                link: "https://www.swiggy.com/city/pilibhit"
                            },
                            {
                                text: "Barshi",
                                link: "https://www.swiggy.com/city/barshi"
                            },
                            {
                                text: "Sri Ganganagar",
                                link: "https://www.swiggy.com/city/sri-ganganagar"
                            },
                            {
                                text: "Wardha",
                                link: "https://www.swiggy.com/city/wardha"
                            },
                            {
                                text: "Sehore",
                                link: "https://www.swiggy.com/city/sehore"
                            },
                            {
                                text: "Bhimavaram",
                                link: "https://www.swiggy.com/city/bhimavaram"
                            },
                            {
                                text: "Hanumangarh",
                                link: "https://www.swiggy.com/city/hanumangarh"
                            },
                            {
                                text: "Pathankot",
                                link: "https://www.swiggy.com/city/pathankot"
                            },
                            {
                                text: "Puri",
                                link: "https://www.swiggy.com/city/puri"
                            },
                            {
                                text: "Fatehpur",
                                link: "https://www.swiggy.com/city/fatehpur"
                            },
                            {
                                text: "Surendranagar Dudhrej",
                                link: "https://www.swiggy.com/city/surendranagar-dudhrej"
                            },
                            {
                                text: "Jamnagar",
                                link: "https://www.swiggy.com/city/jamnagar"
                            },
                            {
                                text: "Bhuj",
                                link: "https://www.swiggy.com/city/bhuj"
                            },
                            {
                                text: "Gandhidham",
                                link: "https://www.swiggy.com/city/gandhidham"
                            },
                            {
                                text: "Bharuch",
                                link: "https://www.swiggy.com/city/bharuch"
                            },
                            {
                                text: "Navsari",
                                link: "https://www.swiggy.com/city/navsari"
                            },
                            {
                                text: "Amreli",
                                link: "https://www.swiggy.com/city/amreli"
                            },
                            {
                                text: "Palanpur",
                                link: "https://www.swiggy.com/city/palanpur"
                            },
                            {
                                text: "Bhilwara",
                                link: "https://www.swiggy.com/city/bhilwara"
                            },
                            {
                                text: "Suratgarh",
                                link: "https://www.swiggy.com/city/suratgarh"
                            },
                            {
                                text: "Sikar",
                                link: "https://www.swiggy.com/city/sikar"
                            },
                            {
                                text: "Churu",
                                link: "https://www.swiggy.com/city/churu"
                            },
                            {
                                text: "Alwar",
                                link: "https://www.swiggy.com/city/alwar"
                            },
                            {
                                text: "Bhiwadi",
                                link: "https://www.swiggy.com/city/bhiwadi"
                            },
                            {
                                text: "Bharatpur",
                                link: "https://www.swiggy.com/city/bharatpur"
                            },
                            {
                                text: "Mount Abu",
                                link: "https://www.swiggy.com/city/mount-abu"
                            },
                            {
                                text: "Bundi",
                                link: "https://www.swiggy.com/city/bundi"
                            },
                            {
                                text: "Sawai Madhopur",
                                link: "https://www.swiggy.com/city/sawai-madhopur"
                            },
                            {
                                text: "Purulia",
                                link: "https://www.swiggy.com/city/purulia"
                            },
                            {
                                text: "Bardhaman",
                                link: "https://www.swiggy.com/city/bardhaman"
                            },
                            {
                                text: "Raniganj",
                                link: "https://www.swiggy.com/city/raniganj"
                            },
                            {
                                text: "Darjeeling",
                                link: "https://www.swiggy.com/city/darjeeling"
                            },
                            {
                                text: "Jalpaiguri",
                                link: "https://www.swiggy.com/city/jalpaiguri"
                            },
                            {
                                text: "Chittorgarh",
                                link: "https://www.swiggy.com/city/chittorgarh"
                            },
                            {
                                text: "Dholpur",
                                link: "https://www.swiggy.com/city/dholpur"
                            },
                            {
                                text: "Uluberia",
                                link: "https://www.swiggy.com/city/uluberia"
                            },
                            {
                                text: "Nabadwip",
                                link: "https://www.swiggy.com/city/nabadwip"
                            },
                            {
                                text: "Bongaon",
                                link: "https://www.swiggy.com/city/bongaon"
                            },
                            {
                                text: "Kanchrapara",
                                link: "https://www.swiggy.com/city/kanchrapara"
                            },
                            {
                                text: "Habra",
                                link: "https://www.swiggy.com/city/habra"
                            },
                            {
                                text: "Firozabad",
                                link: "https://www.swiggy.com/city/firozabad"
                            },
                            {
                                text: "Nalgonda",
                                link: "https://www.swiggy.com/city/nalgonda"
                            },
                            {
                                text: "Chandrapur",
                                link: "https://www.swiggy.com/city/chandrapur"
                            },
                            {
                                text: "Bijapur",
                                link: "https://www.swiggy.com/city/bijapur"
                            },
                            {
                                text: "Bhusawal",
                                link: "https://www.swiggy.com/city/bhusawal"
                            },
                            {
                                text: "Raichur",
                                link: "https://www.swiggy.com/city/raichur"
                            },
                            {
                                text: "Bahraich",
                                link: "https://www.swiggy.com/city/bahraich"
                            },
                            {
                                text: "Azamgarh",
                                link: "https://www.swiggy.com/city/azamgarh"
                            },
                            {
                                text: "Bahadurgarh",
                                link: "https://www.swiggy.com/city/bahadurgarh"
                            },
                            {
                                text: "Jind",
                                link: "https://www.swiggy.com/city/jind"
                            },
                            {
                                text: "Rewari",
                                link: "https://www.swiggy.com/city/rewari"
                            },
                            {
                                text: "Palwal",
                                link: "https://www.swiggy.com/city/palwal"
                            },
                            {
                                text: "Hathras",
                                link: "https://www.swiggy.com/city/hathras"
                            },
                            {
                                text: "Sambalpur",
                                link: "https://www.swiggy.com/city/sambalpur"
                            },
                            {
                                text: "Banda",
                                link: "https://www.swiggy.com/city/banda"
                            },
                            {
                                text: "Hoshiarpur",
                                link: "https://www.swiggy.com/city/hoshiarpur"
                            },
                            {
                                text: "Faridkot",
                                link: "https://www.swiggy.com/city/faridkot"
                            },
                            {
                                text: "Mandsaur",
                                link: "https://www.swiggy.com/city/mandsaur"
                            },
                            {
                                text: "Suryapet",
                                link: "https://www.swiggy.com/city/suryapet"
                            },
                            {
                                text: "Adilabad",
                                link: "https://www.swiggy.com/city/adilabad"
                            },
                            {
                                text: "Narasaraopet",
                                link: "https://www.swiggy.com/city/narasaraopet"
                            },
                            {
                                text: "Faizabad",
                                link: "https://www.swiggy.com/city/faizabad"
                            },
                            {
                                text: "Tadpatri",
                                link: "https://www.swiggy.com/city/tadpatri"
                            },
                            {
                                text: "Gonda",
                                link: "https://www.swiggy.com/city/gonda"
                            },
                            {
                                text: "Mughalsarai",
                                link: "https://www.swiggy.com/city/mughalsarai"
                            },
                            {
                                text: "Medinipur",
                                link: "https://www.swiggy.com/city/medinipur"
                            },
                            {
                                text: "Nagda",
                                link: "https://www.swiggy.com/city/nagda"
                            },
                            {
                                text: "Raiganj",
                                link: "https://www.swiggy.com/city/raiganj"
                            },
                            {
                                text: "Deoria City",
                                link: "https://www.swiggy.com/city/deoria-city"
                            },
                            {
                                text: "Sultanpur",
                                link: "https://www.swiggy.com/city/sultanpur"
                            },
                            {
                                text: "Shamli",
                                link: "https://www.swiggy.com/city/shamli"
                            },
                            {
                                text: "Krishnanagar",
                                link: "https://www.swiggy.com/city/krishnanagar"
                            },
                            {
                                text: "Ballia",
                                link: "https://www.swiggy.com/city/ballia"
                            },
                            {
                                text: "Guntakal",
                                link: "https://www.swiggy.com/city/guntakal"
                            },
                            {
                                text: "Miryalaguda",
                                link: "https://www.swiggy.com/city/miryalaguda"
                            },
                            {
                                text: "Etah",
                                link: "https://www.swiggy.com/city/etah"
                            },
                            {
                                text: "Berhampore",
                                link: "https://www.swiggy.com/city/berhampore"
                            },
                            {
                                text: "Gudivada",
                                link: "https://www.swiggy.com/city/gudivada"
                            },
                            {
                                text: "Haldia",
                                link: "https://www.swiggy.com/city/haldia"
                            },
                            {
                                text: "Santipur",
                                link: "https://www.swiggy.com/city/santipur"
                            },
                            {
                                text: "Basirhat",
                                link: "https://www.swiggy.com/city/basirhat"
                            },
                            {
                                text: "Udgir",
                                link: "https://www.swiggy.com/city/udgir"
                            },
                            {
                                text: "Proddatur",
                                link: "https://www.swiggy.com/city/proddatur"
                            },
                            {
                                text: "Nagapattinam",
                                link: "https://www.swiggy.com/city/nagapattinam"
                            },
                            {
                                text: "Chikmagalur",
                                link: "https://www.swiggy.com/city/chikmagalur"
                            },
                            {
                                text: "Chandausi",
                                link: "https://www.swiggy.com/city/chandausi"
                            },
                            {
                                text: "Bhind",
                                link: "https://www.swiggy.com/city/bhind"
                            },
                            {
                                text: "Mandya",
                                link: "https://www.swiggy.com/city/mandya"
                            },
                            {
                                text: "Bagalkot",
                                link: "https://www.swiggy.com/city/bagalkot"
                            },
                            {
                                text: "Nandurbar",
                                link: "https://www.swiggy.com/city/nandurbar"
                            },
                            {
                                text: "Chitradurga",
                                link: "https://www.swiggy.com/city/chitradurga"
                            },
                            {
                                text: "Osmanabad",
                                link: "https://www.swiggy.com/city/osmanabad"
                            },
                            {
                                text: "Modinagar",
                                link: "https://www.swiggy.com/city/modinagar"
                            },
                            {
                                text: "Gadag-Betigeri",
                                link: "https://www.swiggy.com/city/gadag-betigeri"
                            },
                            {
                                text: "Hoshangabad",
                                link: "https://www.swiggy.com/city/hoshangabad"
                            },
                            {
                                text: "Jaunpur",
                                link: "https://www.swiggy.com/city/jaunpur"
                            },
                            {
                                text: "Port Blair",
                                link: "https://www.swiggy.com/city/port-blair"
                            },
                            {
                                text: "Jorhat",
                                link: "https://www.swiggy.com/city/jorhat"
                            },
                            {
                                text: "Nandyal",
                                link: "https://www.swiggy.com/city/nandyal"
                            },
                            {
                                text: "Biharsharif",
                                link: "https://www.swiggy.com/city/biharsharif"
                            },
                            {
                                text: "Buxar",
                                link: "https://www.swiggy.com/city/buxar"
                            },
                            {
                                text: "Siwan",
                                link: "https://www.swiggy.com/city/siwan"
                            },
                            {
                                text: "Dehri",
                                link: "https://www.swiggy.com/city/dehri"
                            },
                            {
                                text: "Bettiah",
                                link: "https://www.swiggy.com/city/bettiah"
                            },
                            {
                                text: "Kishanganj",
                                link: "https://www.swiggy.com/city/kishanganj"
                            },
                            {
                                text: "Saharsa",
                                link: "https://www.swiggy.com/city/saharsa"
                            },
                            {
                                text: "Hajipur",
                                link: "https://www.swiggy.com/city/hajipur"
                            },
                            {
                                text: "Motihari",
                                link: "https://www.swiggy.com/city/motihari"
                            },
                            {
                                text: "Sasaram",
                                link: "https://www.swiggy.com/city/sasaram"
                            },
                            {
                                text: "Munger",
                                link: "https://www.swiggy.com/city/munger"
                            },
                            {
                                text: "Katihar",
                                link: "https://www.swiggy.com/city/katihar"
                            },
                            {
                                text: "Arrah",
                                link: "https://www.swiggy.com/city/arrah"
                            },
                            {
                                text: "Srikakulam",
                                link: "https://www.swiggy.com/city/srikakulam"
                            },
                            {
                                text: "Begusarai",
                                link: "https://www.swiggy.com/city/begusarai"
                            },
                            {
                                text: "Neyveli",
                                link: "https://www.swiggy.com/city/neyveli"
                            },
                            {
                                text: "Waidhan",
                                link: "https://www.swiggy.com/city/waidhan"
                            },
                            {
                                text: "Markapur",
                                link: "https://www.swiggy.com/city/markapur"
                            },
                            {
                                text: "Chikkaballapur",
                                link: "https://www.swiggy.com/city/chikkaballapur"
                            },
                            {
                                text: "Bhatkal",
                                link: "https://www.swiggy.com/city/bhatkal"
                            },
                            {
                                text: "Gokak",
                                link: "https://www.swiggy.com/city/gokak"
                            },
                            {
                                text: "Itarsi",
                                link: "https://www.swiggy.com/city/itarsi"
                            },
                            {
                                text: "Dhar",
                                link: "https://www.swiggy.com/city/dhar"
                            },
                            {
                                text: "Chalisgaon",
                                link: "https://www.swiggy.com/city/chalisgaon"
                            },
                            {
                                text: "Thiruvallur",
                                link: "https://www.swiggy.com/city/thiruvallur"
                            },
                            {
                                text: "Namakkal",
                                link: "https://www.swiggy.com/city/namakkal"
                            },
                            {
                                text: "Dharmapuri",
                                link: "https://www.swiggy.com/city/dharmapuri"
                            },
                            {
                                text: "Bhandara",
                                link: "https://www.swiggy.com/city/bhandara"
                            },
                            {
                                text: "Virudhunagar",
                                link: "https://www.swiggy.com/city/virudhunagar"
                            },
                            {
                                text: "Siddipet",
                                link: "https://www.swiggy.com/city/siddipet"
                            },
                            {
                                text: "Gadwal",
                                link: "https://www.swiggy.com/city/gadwal"
                            },
                            {
                                text: "Bodhan-Rural",
                                link: "https://www.swiggy.com/city/bodhan-rural"
                            },
                            {
                                text: "Kamareddy",
                                link: "https://www.swiggy.com/city/kamareddy"
                            },
                            {
                                text: "Jhunjhunu",
                                link: "https://www.swiggy.com/city/jhunjhunu"
                            },
                            {
                                text: "Kapurthala",
                                link: "https://www.swiggy.com/city/kapurthala"
                            },
                            {
                                text: "Sangrur",
                                link: "https://www.swiggy.com/city/sangrur"
                            },
                            {
                                text: "Gurdaspur",
                                link: "https://www.swiggy.com/city/gurdaspur"
                            },
                            {
                                text: "Ramgarh",
                                link: "https://www.swiggy.com/city/ramgarh"
                            },
                            {
                                text: "Bantwal",
                                link: "https://www.swiggy.com/city/bantwal"
                            },
                            {
                                text: "Doddaballapura",
                                link: "https://www.swiggy.com/city/doddaballapura"
                            },
                            {
                                text: "Buldana",
                                link: "https://www.swiggy.com/city/buldana"
                            },
                            {
                                text: "Karad",
                                link: "https://www.swiggy.com/city/karad"
                            },
                            {
                                text: "Krishnagiri",
                                link: "https://www.swiggy.com/city/krishnagiri"
                            },
                            {
                                text: "Tiptur",
                                link: "https://www.swiggy.com/city/tiptur"
                            },
                            {
                                text: "Bhadrachalam",
                                link: "https://www.swiggy.com/city/bhadrachalam"
                            },
                            {
                                text: "Mancherial",
                                link: "https://www.swiggy.com/city/mancherial"
                            },
                            {
                                text: "Balrampur",
                                link: "https://www.swiggy.com/city/balrampur"
                            },
                            {
                                text: "Bharabanki",
                                link: "https://www.swiggy.com/city/bharabanki"
                            },
                            {
                                text: "Malout",
                                link: "https://www.swiggy.com/city/malout"
                            },
                            {
                                text: "Fatehgarh Sahib",
                                link: "https://www.swiggy.com/city/fatehgarh-sahib"
                            },
                            {
                                text: "Ropar",
                                link: "https://www.swiggy.com/city/ropar"
                            },
                            {
                                text: "Nangal",
                                link: "https://www.swiggy.com/city/nangal"
                            },
                            {
                                text: "Narnaul",
                                link: "https://www.swiggy.com/city/narnaul"
                            },
                            {
                                text: "Naraingarh",
                                link: "https://www.swiggy.com/city/naraingarh"
                            },
                            {
                                text: "Himmatnagar",
                                link: "https://www.swiggy.com/city/himmatnagar"
                            },
                            {
                                text: "Dausa",
                                link: "https://www.swiggy.com/city/dausa"
                            },
                            {
                                text: "Jahanabad",
                                link: "https://www.swiggy.com/city/jahanabad"
                            },
                            {
                                text: "Samastipur",
                                link: "https://www.swiggy.com/city/samastipur"
                            },
                            {
                                text: "Purnea",
                                link: "https://www.swiggy.com/city/purnea"
                            },
                            {
                                text: "Berhampur",
                                link: "https://www.swiggy.com/city/berhampur"
                            },
                            {
                                text: "Malda",
                                link: "https://www.swiggy.com/city/malda"
                            },
                            {
                                text: "Tuni",
                                link: "https://www.swiggy.com/city/tuni"
                            },
                            {
                                text: "Puttur",
                                link: "https://www.swiggy.com/city/puttur"
                            },
                            {
                                text: "Rayachoty",
                                link: "https://www.swiggy.com/city/rayachoty"
                            },
                            {
                                text: "Nirmal",
                                link: "https://www.swiggy.com/city/nirmal"
                            },
                            {
                                text: "Mirzapur",
                                link: "https://www.swiggy.com/city/mirzapur"
                            },
                            {
                                text: "Tanuku",
                                link: "https://www.swiggy.com/city/tanuku"
                            },
                            {
                                text: "Dahod",
                                link: "https://www.swiggy.com/city/dahod"
                            },
                            {
                                text: "Barmer",
                                link: "https://www.swiggy.com/city/barmer"
                            },
                            {
                                text: "Gangapur City",
                                link: "https://www.swiggy.com/city/gangapur-city"
                            },
                            {
                                text: "Mandi Gobindgarh",
                                link: "https://www.swiggy.com/city/mandi-gobindgarh"
                            },
                            {
                                text: "Tarn Taran Sahib",
                                link: "https://www.swiggy.com/city/tarn-taran-sahib"
                            },
                            {
                                text: "Nakodar",
                                link: "https://www.swiggy.com/city/nakodar"
                            },
                            {
                                text: "Ankleshwar",
                                link: "https://www.swiggy.com/city/ankleshwar"
                            },
                            {
                                text: "Vyara",
                                link: "https://www.swiggy.com/city/vyara"
                            },
                            {
                                text: "Bardoli",
                                link: "https://www.swiggy.com/city/bardoli"
                            },
                            {
                                text: "Halol",
                                link: "https://www.swiggy.com/city/halol"
                            },
                            {
                                text: "Bijnor",
                                link: "https://www.swiggy.com/city/bijnor"
                            },
                            {
                                text: "Sangamner",
                                link: "https://www.swiggy.com/city/sangamner"
                            },
                            {
                                text: "Baramati",
                                link: "https://www.swiggy.com/city/baramati"
                            },
                            {
                                text: "Betul",
                                link: "https://www.swiggy.com/city/betul"
                            },
                            {
                                text: "Chhatarpur",
                                link: "https://www.swiggy.com/city/chhatarpur"
                            },
                            {
                                text: "Balaghat",
                                link: "https://www.swiggy.com/city/balaghat"
                            },
                            {
                                text: "Sivakasi",
                                link: "https://www.swiggy.com/city/sivakasi"
                            },
                            {
                                text: "Viluppuram",
                                link: "https://www.swiggy.com/city/viluppuram"
                            },
                            {
                                text: "Ramanathapuram",
                                link: "https://www.swiggy.com/city/ramanathapuram"
                            },
                            {
                                text: "Sirsi",
                                link: "https://www.swiggy.com/city/sirsi"
                            },
                            {
                                text: "Theni",
                                link: "https://www.swiggy.com/city/theni"
                            },
                            {
                                text: "Karur",
                                link: "https://www.swiggy.com/city/karur"
                            },
                            {
                                text: "Karwar",
                                link: "https://www.swiggy.com/city/karwar"
                            },
                            {
                                text: "Sindhanur",
                                link: "https://www.swiggy.com/city/sindhanur"
                            },
                            {
                                text: "Kannur",
                                link: "https://www.swiggy.com/city/kannur"
                            },
                            {
                                text: "Noida 1",
                                link: "https://www.swiggy.com/city/noida-1"
                            },
                            {
                                text: "Thiruvalla",
                                link: "https://www.swiggy.com/city/thiruvalla"
                            },
                            {
                                text: "Thodupuzha",
                                link: "https://www.swiggy.com/city/thodupuzha"
                            },
                            {
                                text: "Kadiri",
                                link: "https://www.swiggy.com/city/kadiri"
                            },
                            {
                                text: "Kavali",
                                link: "https://www.swiggy.com/city/kavali"
                            },
                            {
                                text: "Tezpur",
                                link: "https://www.swiggy.com/city/tezpur"
                            },
                            {
                                text: "Kayamkulam",
                                link: "https://www.swiggy.com/city/kayamkulam"
                            },
                            {
                                text: "Kottarakkara",
                                link: "https://www.swiggy.com/city/kottarakkara"
                            },
                            {
                                text: "Mandi Dabwali",
                                link: "https://www.swiggy.com/city/mandi-dabwali"
                            },
                            {
                                text: "Fatehabad",
                                link: "https://www.swiggy.com/city/fatehabad"
                            },
                            {
                                text: "Jagraon",
                                link: "https://www.swiggy.com/city/jagraon"
                            },
                            {
                                text: "Mansa",
                                link: "https://www.swiggy.com/city/mansa"
                            },
                            {
                                text: "Pinjore City",
                                link: "https://www.swiggy.com/city/pinjore-city"
                            },
                            {
                                text: "Fazilka",
                                link: "https://www.swiggy.com/city/fazilka"
                            },
                            {
                                text: "Baddi",
                                link: "https://www.swiggy.com/city/baddi"
                            },
                            {
                                text: "Solan",
                                link: "https://www.swiggy.com/city/solan"
                            },
                            {
                                text: "Daltonganj",
                                link: "https://www.swiggy.com/city/daltonganj"
                            },
                            {
                                text: "Balangir",
                                link: "https://www.swiggy.com/city/balangir"
                            },
                            {
                                text: "Kothagudem",
                                link: "https://www.swiggy.com/city/kothagudem"
                            },
                            {
                                text: "Hansi",
                                link: "https://www.swiggy.com/city/hansi"
                            },
                            {
                                text: "Aurangabad_Bihar",
                                link: "https://www.swiggy.com/city/aurangabadbihar"
                            },
                            {
                                text: "Gopalganj",
                                link: "https://www.swiggy.com/city/gopalganj"
                            },
                            {
                                text: "Jharsuguda",
                                link: "https://www.swiggy.com/city/jharsuguda"
                            },
                            {
                                text: "Tohana",
                                link: "https://www.swiggy.com/city/tohana"
                            },
                            {
                                text: "Jhalawar",
                                link: "https://www.swiggy.com/city/jhalawar"
                            },
                            {
                                text: "Sivasagar",
                                link: "https://www.swiggy.com/city/sivasagar"
                            },
                            {
                                text: "Bagdogra",
                                link: "https://www.swiggy.com/city/bagdogra"
                            },
                            {
                                text: "Kendrapada",
                                link: "https://www.swiggy.com/city/kendrapada"
                            },
                            {
                                text: "Mallapuram (Do not Use)",
                                link: "https://www.swiggy.com/city/mallapuram-do-not-use"
                            },
                            {
                                text: "Veraval",
                                link: "https://www.swiggy.com/city/veraval"
                            },
                            {
                                text: "Daman",
                                link: "https://www.swiggy.com/city/daman"
                            },
                            {
                                text: "Chiplun",
                                link: "https://www.swiggy.com/city/chiplun"
                            },
                            {
                                text: "Silvassa",
                                link: "https://www.swiggy.com/city/silvassa"
                            },
                            {
                                text: "Lonavla",
                                link: "https://www.swiggy.com/city/lonavla"
                            },
                            {
                                text: "Bongaigaon",
                                link: "https://www.swiggy.com/city/bongaigaon"
                            },
                            {
                                text: "Golaghat",
                                link: "https://www.swiggy.com/city/golaghat"
                            },
                            {
                                text: "Duliajan",
                                link: "https://www.swiggy.com/city/duliajan"
                            },
                            {
                                text: "Bolpur",
                                link: "https://www.swiggy.com/city/bolpur"
                            },
                            {
                                text: "Madhubani",
                                link: "https://www.swiggy.com/city/madhubani"
                            },
                            {
                                text: "Balasore",
                                link: "https://www.swiggy.com/city/balasore"
                            },
                            {
                                text: "Palampur",
                                link: "https://www.swiggy.com/city/palampur"
                            },
                            {
                                text: "Kotdwar",
                                link: "https://www.swiggy.com/city/kotdwar"
                            },
                            {
                                text: "Koppal",
                                link: "https://www.swiggy.com/city/koppal"
                            },
                            {
                                text: "Chikhli",
                                link: "https://www.swiggy.com/city/chikhli"
                            },
                            {
                                text: "Dahanu",
                                link: "https://www.swiggy.com/city/dahanu"
                            },
                            {
                                text: "Itanagar",
                                link: "https://www.swiggy.com/city/itanagar"
                            },
                            {
                                text: "Rangpo",
                                link: "https://www.swiggy.com/city/rangpo"
                            },
                            {
                                text: "Aizawl",
                                link: "https://www.swiggy.com/city/aizawl"
                            },
                            {
                                text: "Gangtok",
                                link: "https://www.swiggy.com/city/gangtok"
                            },
                            {
                                text: "Mayiladuthurai",
                                link: "https://www.swiggy.com/city/mayiladuthurai"
                            },
                            {
                                text: "Kannauj",
                                link: "https://www.swiggy.com/city/kannauj"
                            },
                            {
                                text: "Cooch Behar",
                                link: "https://www.swiggy.com/city/cooch-behar"
                            },
                            {
                                text: "Palani",
                                link: "https://www.swiggy.com/city/palani"
                            },
                            {
                                text: "Bilimora",
                                link: "https://www.swiggy.com/city/bilimora"
                            },
                            {
                                text: "Boisar",
                                link: "https://www.swiggy.com/city/boisar"
                            },
                            {
                                text: "Kohima",
                                link: "https://www.swiggy.com/city/kohima"
                            },
                            {
                                text: "Naharlagun",
                                link: "https://www.swiggy.com/city/naharlagun"
                            },
                            {
                                text: "Dumka",
                                link: "https://www.swiggy.com/city/dumka"
                            },
                            {
                                text: "Rajsamand",
                                link: "https://www.swiggy.com/city/rajsamand"
                            },
                            {
                                text: "Gauriganj",
                                link: "https://www.swiggy.com/city/gauriganj"
                            },
                            {
                                text: "Bodinayakanur",
                                link: "https://www.swiggy.com/city/bodinayakanur"
                            },
                            {
                                text: "Bhawanipatna",
                                link: "https://www.swiggy.com/city/bhawanipatna"
                            },
                            {
                                text: "Baran",
                                link: "https://www.swiggy.com/city/baran"
                            },
                            {
                                text: "Narsinghpur",
                                link: "https://www.swiggy.com/city/narsinghpur"
                            },
                            {
                                text: "Kovilpatti",
                                link: "https://www.swiggy.com/city/kovilpatti"
                            },
                            {
                                text: "Pusad",
                                link: "https://www.swiggy.com/city/pusad"
                            },
                            {
                                text: "Kendujhar",
                                link: "https://www.swiggy.com/city/kendujhar"
                            },
                            {
                                text: "Manali",
                                link: "https://www.swiggy.com/city/manali"
                            },
                            {
                                text: "Diu",
                                link: "https://www.swiggy.com/city/diu"
                            },
                            {
                                text: "Khamgaon",
                                link: "https://www.swiggy.com/city/khamgaon"
                            },
                            {
                                text: "Ramanagara",
                                link: "https://www.swiggy.com/city/ramanagara"
                            },
                            {
                                text: "Alipurduar",
                                link: "https://www.swiggy.com/city/alipurduar"
                            },
                            {
                                text: "Almora",
                                link: "https://www.swiggy.com/city/almora"
                            },
                            {
                                text: "Jhargram",
                                link: "https://www.swiggy.com/city/jhargram"
                            },
                            {
                                text: "Arambagh",
                                link: "https://www.swiggy.com/city/arambagh"
                            },
                            {
                                text: "Bhadohi",
                                link: "https://www.swiggy.com/city/bhadohi"
                            },
                            {
                                text: "Tenkasi",
                                link: "https://www.swiggy.com/city/tenkasi"
                            },
                            {
                                text: "Srivilliputhur",
                                link: "https://www.swiggy.com/city/srivilliputhur"
                            },
                            {
                                text: "Chidambaram",
                                link: "https://www.swiggy.com/city/chidambaram"
                            },
                            {
                                text: "Rajgarh",
                                link: "https://www.swiggy.com/city/rajgarh"
                            },
                            {
                                text: "Pratapgarh",
                                link: "https://www.swiggy.com/city/pratapgarh"
                            },
                            {
                                text: "Washim",
                                link: "https://www.swiggy.com/city/washim"
                            },
                            {
                                text: "Raghunathpur",
                                link: "https://www.swiggy.com/city/raghunathpur"
                            },
                            {
                                text: "Suri",
                                link: "https://www.swiggy.com/city/suri"
                            },
                            {
                                text: "Kadayanallur",
                                link: "https://www.swiggy.com/city/kadayanallur"
                            },
                            {
                                text: "Thiruvarur",
                                link: "https://www.swiggy.com/city/thiruvarur"
                            },
                            {
                                text: "Ranaghat-WB",
                                link: "https://www.swiggy.com/city/ranaghat-wb"
                            },
                            {
                                text: "Wayanad",
                                link: "https://www.swiggy.com/city/wayanad"
                            },
                            {
                                text: "Perambalur",
                                link: "https://www.swiggy.com/city/perambalur"
                            },
                            {
                                text: "Paramakudi",
                                link: "https://www.swiggy.com/city/paramakudi"
                            },
                            {
                                text: "Bela Pratapgarh",
                                link: "https://www.swiggy.com/city/bela-pratapgarh"
                            },
                            {
                                text: "Mahoba",
                                link: "https://www.swiggy.com/city/mahoba"
                            },
                            {
                                text: "Sitamarhi",
                                link: "https://www.swiggy.com/city/sitamarhi"
                            },
                            {
                                text: "Chakdaha",
                                link: "https://www.swiggy.com/city/chakdaha"
                            },
                            {
                                text: "Khalilabad",
                                link: "https://www.swiggy.com/city/khalilabad"
                            },
                            {
                                text: "Pattukkottai",
                                link: "https://www.swiggy.com/city/pattukkottai"
                            },
                            {
                                text: "Tindivanam",
                                link: "https://www.swiggy.com/city/tindivanam"
                            },
                            {
                                text: "Tiruttani",
                                link: "https://www.swiggy.com/city/tiruttani"
                            },
                            {
                                text: "Gangarampur",
                                link: "https://www.swiggy.com/city/gangarampur"
                            },
                            {
                                text: "Dharapuram",
                                link: "https://www.swiggy.com/city/dharapuram"
                            },
                            {
                                text: "Arakkonam",
                                link: "https://www.swiggy.com/city/arakkonam"
                            },
                            {
                                text: "Sirkali",
                                link: "https://www.swiggy.com/city/sirkali"
                            },
                            {
                                text: "Mettupalayam",
                                link: "https://www.swiggy.com/city/mettupalayam"
                            },
                            {
                                text: "Digboi",
                                link: "https://www.swiggy.com/city/digboi"
                            },
                            {
                                text: "Biswanath Chariali",
                                link: "https://www.swiggy.com/city/biswanath-chariali"
                            },
                            {
                                text: "Nalbari",
                                link: "https://www.swiggy.com/city/nalbari"
                            },
                            {
                                text: "Shirdi city",
                                link: "https://www.swiggy.com/city/shirdi-city"
                            },
                            {
                                text: "Mukerian",
                                link: "https://www.swiggy.com/city/mukerian"
                            },
                            {
                                text: "Hosur",
                                link: "https://www.swiggy.com/city/hosur"
                            },
                            {
                                text: "Palakollu",
                                link: "https://www.swiggy.com/city/palakollu"
                            },
                            {
                                text: "Ravulapalem",
                                link: "https://www.swiggy.com/city/ravulapalem"
                            },
                            {
                                text: "Barh",
                                link: "https://www.swiggy.com/city/barh"
                            },
                            {
                                text: "Palghar",
                                link: "https://www.swiggy.com/city/palghar"
                            },
                            {
                                text: "Kushalnagar",
                                link: "https://www.swiggy.com/city/kushalnagar"
                            },
                            {
                                text: "Dungarpur",
                                link: "https://www.swiggy.com/city/dungarpur"
                            },
                            {
                                text: "Chaibasa",
                                link: "https://www.swiggy.com/city/chaibasa"
                            },
                            {
                                text: "Haveri",
                                link: "https://www.swiggy.com/city/haveri"
                            },
                            {
                                text: "Karaikal",
                                link: "https://www.swiggy.com/city/karaikal"
                            },
                            {
                                text: "Jjajjar",
                                link: "https://www.swiggy.com/city/jjajjar"
                            },
                            {
                                text: "Kokrajhar",
                                link: "https://www.swiggy.com/city/kokrajhar"
                            },
                            {
                                text: "Rangia",
                                link: "https://www.swiggy.com/city/rangia"
                            },
                            {
                                text: "Hamirpur",
                                link: "https://www.swiggy.com/city/hamirpur"
                            },
                            {
                                text: "Una",
                                link: "https://www.swiggy.com/city/una"
                            },
                            {
                                text: "Sulthan Bathery",
                                link: "https://www.swiggy.com/city/sulthan-bathery"
                            },
                            {
                                text: "Rayagada",
                                link: "https://www.swiggy.com/city/rayagada"
                            },
                            {
                                text: "Paradeep",
                                link: "https://www.swiggy.com/city/paradeep"
                            },
                            {
                                text: "Mandapeta",
                                link: "https://www.swiggy.com/city/mandapeta"
                            },
                            {
                                text: "Jamui",
                                link: "https://www.swiggy.com/city/jamui"
                            },
                            {
                                text: "Pilkhuwa",
                                link: "https://www.swiggy.com/city/pilkhuwa"
                            },
                            {
                                text: "Parvathipuram",
                                link: "https://www.swiggy.com/city/parvathipuram"
                            },
                            {
                                text: "Ambajogai",
                                link: "https://www.swiggy.com/city/ambajogai"
                            },
                            {
                                text: "Araria",
                                link: "https://www.swiggy.com/city/araria"
                            },
                            {
                                text: "North Lakhimpur",
                                link: "https://www.swiggy.com/city/north-lakhimpur"
                            },
                            {
                                text: "Rajampet",
                                link: "https://www.swiggy.com/city/rajampet"
                            },
                            {
                                text: "Udumalaipettai",
                                link: "https://www.swiggy.com/city/udumalaipettai"
                            },
                            {
                                text: "Tirupattur",
                                link: "https://www.swiggy.com/city/tirupattur"
                            },
                            {
                                text: "Hojai",
                                link: "https://www.swiggy.com/city/hojai"
                            },
                            {
                                text: "Khagaria",
                                link: "https://www.swiggy.com/city/khagaria"
                            },
                            {
                                text: "Dasuya",
                                link: "https://www.swiggy.com/city/dasuya"
                            },
                            {
                                text: "Gudur",
                                link: "https://www.swiggy.com/city/gudur"
                            },
                            {
                                text: "Sullurpeta",
                                link: "https://www.swiggy.com/city/sullurpeta"
                            },
                            {
                                text: "Piler",
                                link: "https://www.swiggy.com/city/piler"
                            },
                            {
                                text: "SankaranKoil",
                                link: "https://www.swiggy.com/city/sankarankoil"
                            },
                            {
                                text: "Nabha",
                                link: "https://www.swiggy.com/city/nabha"
                            },
                            {
                                text: "LPU - Phagwara",
                                link: "https://www.swiggy.com/city/lpu-phagwara"
                            },
                            {
                                text: "Jangipur",
                                link: "https://www.swiggy.com/city/jangipur"
                            },
                            {
                                text: "Roha",
                                link: "https://www.swiggy.com/city/roha"
                            }
                        ],
                        id: "footer_content"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
                        citySlug: "faridabad",
                        lat: "28.4089123",
                        lng: "77.3177894",
                        userAgent: "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/123.0.0.0 Safari/537.36",
                        gandalfRequest: '{"sortAttribute":"relevance","isFiltered":false,"queryId":"seo-data-b314abe3-f146-4943-ac8e-0eef8fd8b50e","seoParams":{"apiName":"FoodHomePage","brandId":"","seoUrl":"www.swiggy.com","pageType":"FOOD_HOME_PAGE"}}',
                        id: "meta_data",
                        metaInfo: {
                            pageType: "FOOD_HOME_PAGE",
                            pageTitle: "Order Food Online from India's Best Food Delivery Service | Swiggy",
                            pageMetaDescription: "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
                            pageKeywords: "Food delivery, Online food order, Online food dleivery"
                        },
                        screenType: "filteredCollection",
                        seoParams: {
                            apiName: "FoodHomePage",
                            seoUrl: "www.swiggy.com",
                            pageType: "FOOD_HOME_PAGE"
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        cacheExpiryTime: 240,
        nextFetch: 1
    },
    tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
    sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "UwmkelsQ8Duk-9B3iU9InosXfu2k2oHASD-Klhgc"
};
let $5c05fa9443b5f182$export$bc4d6c843416a567 = {
    statusCode: 0,
    data: {
        statusMessage: "done successfully",
        cards: [
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
                        text: "Dark Brown",
                        headerStyling: {
                            textColor: "text_Highest_Emphasis",
                            textVariant: "header_H3_Black"
                        }
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
                        tabs: [
                            {
                                id: "Order Online",
                                title: "Order Online"
                            }
                        ]
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
                        info: {
                            id: "21986",
                            name: "Dark Brown",
                            city: "Faridabad",
                            slugs: {
                                restaurant: "dark-brown-sector-15-sector-15_archive",
                                city: "faridabad"
                            },
                            uniqueId: "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                            cloudinaryImageId: "mzdetw2s1ihmpiegkhyl",
                            locality: "Shopping Centre Market",
                            areaName: "Sector 15",
                            costForTwo: "25000",
                            costForTwoMessage: "\u20B9250 for two",
                            cuisines: [
                                "Italian-American",
                                "Continental"
                            ],
                            avgRating: 4.2,
                            feeDetails: {
                                restaurantId: "21986",
                                fees: [
                                    {
                                        name: "TYPE_DISTANCE",
                                        fee: 4200
                                    },
                                    {
                                        name: "TYPE_TIME"
                                    }
                                ],
                                totalFee: 4200,
                                title: "Delivery Charge",
                                amount: "4200",
                                icon: "v1648635511/Delivery_fee_new_cjxumu"
                            },
                            parentId: "16162",
                            avgRatingString: "4.2",
                            totalRatingsString: "10K+ ratings",
                            sla: {
                                restaurantId: "21986",
                                deliveryTime: 26,
                                minDeliveryTime: 25,
                                maxDeliveryTime: 30,
                                lastMileTravel: 1.8,
                                serviceability: "SERVICEABLE",
                                stressFactor: 1,
                                rainMode: "RAIN_MODE_NONE",
                                longDistance: "LONG_DISTANCE_NOT_LONG_DISTANCE",
                                zoneId: 749,
                                slaString: "25-30 MINS",
                                lastMileTravelString: "1.7 km",
                                iconType: "ICON_TYPE_EMPTY"
                            },
                            availability: {
                                nextCloseTime: "2024-04-05 00:00:00",
                                visibility: true,
                                opened: true,
                                restaurantClosedMeta: {}
                            },
                            aggregatedDiscountInfo: {
                                header: "FLAT100 off",
                                shortDescriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                descriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                visible: true
                            },
                            badges: {},
                            slugString: "dark-brown-sector-15-sector-15_archive",
                            multiOutlet: true,
                            isOpen: true,
                            labels: [
                                {
                                    title: "Timings",
                                    message: "null"
                                },
                                {
                                    title: "Address",
                                    message: "Shop - 144, booth no.163, Huda Market, sec15, faridabad"
                                },
                                {
                                    title: "Cuisines",
                                    message: "Italian-American,Continental"
                                }
                            ],
                            totalRatings: 10000,
                            aggregatedDiscountInfoV2: {
                                header: "FLAT100 off",
                                shortDescriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                descriptionList: [
                                    {
                                        meta: "FLAT100 off  | Use LNBINGE",
                                        discountType: "Flat",
                                        operationType: "RESTAURANT"
                                    },
                                    {
                                        discountType: "Percentage",
                                        operationType: "RESTAURANT"
                                    }
                                ],
                                couponDetailsCta: "View coupon details"
                            },
                            type: "F",
                            nudgeBanners: [
                                {
                                    minValue: 125,
                                    maxValue: 179,
                                    priority: 2,
                                    couponCode: "SAVINGS4ME",
                                    discountInfo: {
                                        discountType: "Percentage",
                                        value: 20
                                    },
                                    logoCtx: {}
                                },
                                {
                                    minValue: 279,
                                    maxValue: 399,
                                    priority: 3,
                                    couponCode: "MDM150",
                                    discountInfo: {
                                        discountType: "Flat",
                                        value: 150
                                    },
                                    lockedMessage: "Add items worth \u20B9<amount> to save \u20B9150 | Code MDM150",
                                    unlockedMessage: "MDM150 Coupon Unlocked! Use it to save \u20B9150",
                                    logoCtx: {}
                                }
                            ],
                            headerBanner: {
                                url: "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/21986"
                            },
                            expectationNotifiers: [
                                {
                                    icon: {
                                        imageId: "v1648635511/Delivery_fee_new_cjxumu"
                                    },
                                    popup: {
                                        cta: {}
                                    },
                                    type: "DISTANCE_FEE_NON_FOOD_LM",
                                    enrichedText: "<b>1.8 km</b> | <del>\u20B942</del> Free Delivery on your order",
                                    halfCardPopup: {
                                        halfCardPopupHeader: {}
                                    }
                                }
                            ],
                            ratingSlab: "RATING_SLAB_5",
                            orderabilityCommunication: {
                                title: {},
                                subTitle: {},
                                message: {},
                                customIcon: {}
                            },
                            cartOrderabilityNudgeBanner: {
                                parameters: {},
                                presentation: {}
                            },
                            latLong: "28.395346190109397,77.32197622453688",
                            backgroundImageOverlayInfo: {}
                        },
                        analytics: {}
                    },
                    relevance: {
                        type: "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
                        sectionId: "POP_UP_CROUTON_MENU"
                    }
                }
            },
            {
                card: {
                    card: {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        layout: {
                            rows: 1,
                            columns: 5,
                            horizontalScrollEnabled: true,
                            itemSpacing: 12,
                            lineSpacing: 10,
                            widgetPadding: {},
                            containerStyle: {
                                containerPadding: {
                                    left: 10,
                                    right: 10,
                                    bottom: 16
                                }
                            },
                            scrollBar: {}
                        },
                        id: "offerCollectionWidget_UX4",
                        gridElements: {
                            infoWithStyle: {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                                offers: [
                                    {
                                        info: {
                                            header: "FLAT \u20B9100 OFF",
                                            offerTag: "LATE NIGHT",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "21b510e6-d1e5-49f2-9a0c-7c8df2376113"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE LNBINGE",
                                            description: "ABOVE \u20B9249",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "20% OFF UPTO \u20B945",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "bec108ac-7985-4c49-a231-2f489c7bfa89"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE SAVINGS4ME",
                                            description: "ABOVE \u20B9179",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "FLAT \u20B9150 OFF",
                                            offerTag: "FLAT DEAL",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "2b0a5844-c1d1-48db-a745-1fc78a37b6e4"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE MDM150",
                                            description: "ABOVE \u20B9399",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "15% OFF UPTO \u20B9150",
                                            offerTagColor: "#E46D47",
                                            logoBottom: "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                                            offerIds: [
                                                "7b012c7c-a7e1-49d7-a84a-2ba6e1224780"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE HSBCMANIA",
                                            description: "ABOVE \u20B9499",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "MARKETING_BANNERS/IMAGES/OFFERS/2024/3/31/5e5be43d-5232-4afc-843d-d828639ae129_HSBC.png",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    },
                                    {
                                        info: {
                                            header: "FLAT \u20B9125 OFF",
                                            offerTag: "FLAT DEAL",
                                            offerTagColor: "#E46D47",
                                            offerIds: [
                                                "84cd7bc1-65e3-4f0a-9280-844a68d9d474"
                                            ],
                                            expiryTime: "1970-01-01T00:00:00Z",
                                            couponCode: "USE FLAT125",
                                            description: "ABOVE \u20B9249",
                                            offerType: "offers",
                                            restId: "21986",
                                            offerLogo: "offers/generic",
                                            descriptionTextColor: "#7302060C"
                                        },
                                        cta: {
                                            type: "OFFER_HALF_CARD"
                                        }
                                    }
                                ],
                                habitMilestoneInfo: {
                                    callout: {}
                                },
                                loyaltyDiscoverPresentationInfo: {
                                    logoCtx: {}
                                }
                            }
                        }
                    }
                }
            },
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: [
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                                            badges: {},
                                            vegOnlyDetails: {
                                                imageId: "AutoVegOnly_qkjowj",
                                                title: "Showing only vegetarian options.",
                                                description: "Tap on the VEG ONLY button to turn off the setting"
                                            },
                                            topRatedFilter: {},
                                            kidsCategoryFilter: {
                                                attributes: {
                                                    displayText: "Kids Favourites",
                                                    tooltip: {
                                                        enabled: true,
                                                        displayText: "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                                                    }
                                                }
                                            },
                                            vegFilter: {
                                                attributes: {
                                                    displayText: "VEG"
                                                }
                                            },
                                            nonvegFilter: {
                                                attributes: {
                                                    displayText: "NONVEG"
                                                }
                                            }
                                        },
                                        relevance: {
                                            type: "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                                            sectionId: "MENU_FILTER_TOGGLE"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                                            title: "Top Picks",
                                            carousel: [
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814238",
                                                    creativeId: "TopPicks/12563599B.png",
                                                    title: "Grilled Veg Paneer Sandwich",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "12563599",
                                                            name: "Grilled Veg Paneer Sandwich",
                                                            category: "Sandwich",
                                                            description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                                                            imageId: "str6dgmj5eya9agsgnvb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814237",
                                                    creativeId: "TopPicks/4077858B.png",
                                                    title: "Davidoff Coffee",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "4077858",
                                                            name: "Davidoff Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814239",
                                                    creativeId: "TopPicks/96805980B.png",
                                                    title: "Hot Brownie With Hot Chocolate",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "96805980",
                                                            name: "Hot Brownie With Hot Chocolate",
                                                            category: "Desserts",
                                                            description: "Serves 1",
                                                            imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814235",
                                                    creativeId: "TopPicks/100949073B.png",
                                                    title: "Mix Sauce Pasta (Penne)",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "100949073",
                                                            name: "Mix Sauce Pasta (Penne)",
                                                            category: "Pastas",
                                                            description: "Serves 1",
                                                            imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    type: "TopCarousel",
                                                    subtype: "image",
                                                    bannerId: "1814236",
                                                    creativeId: "TopPicks/4077862B.png",
                                                    title: "Cold Coffee",
                                                    description: " ",
                                                    fontColor: "#FFFFFF",
                                                    dish: {
                                                        info: {
                                                            id: "4077862",
                                                            name: "Cold Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "thvril6hi8fwrftuuayg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            itemBadge: {},
                                                            badgesV2: {}
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Recommended",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000919",
                                                            name: "Tomato Basil Soup",
                                                            category: "Soups",
                                                            imageId: "7491a231591f7c8ef6299a3846e59f22",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "44 ratings",
                                                                    ratingCountV2: "44"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000922",
                                                            name: "Minestrone Soup",
                                                            category: "Soups",
                                                            imageId: "5d42ac81e15221854bcff2f2728b0756",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000924",
                                                            name: "Broccoli Mushroom Soup",
                                                            category: "Soups",
                                                            imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806071",
                                                            name: "Veg Manchow Soup",
                                                            category: "Soups",
                                                            imageId: "05307aa34e454058947fda4617a93185",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806072",
                                                            name: "Veg Hot & Sour Soup",
                                                            category: "Soups",
                                                            imageId: "cvw4mo9midegdkky6v1a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806080",
                                                            name: "Veg Spring Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                                                            imageId: "uixdrme6e8v6udsill2b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170622",
                                                            name: "Crispy Corn",
                                                            category: "Appetizers",
                                                            imageId: "2c482f34b257753b843846b77bda83ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000929",
                                                            name: "Mozzarella Cheese Stick",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "a5553c3cccf840486b4651bb43d6193c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000931",
                                                            name: "Cottage Cheese Finger",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "8247914a73d640b489ea18fd9da204c2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000933",
                                                            name: "Mac An Cheese Roll",
                                                            category: "Appetizers",
                                                            imageId: "c3c9f192e21cda38a103b730eeabb617",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000938",
                                                            name: "Veg Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "y5wdcgfyq3zvieb9tq7k",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373200",
                                                            name: "Cheesy Chicken Garlic Bread",
                                                            category: "Appetizers",
                                                            imageId: "6ea2115c9beb322d26f55e9434013258",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388291",
                                                            name: "Fish Finger",
                                                            category: "Appetizers",
                                                            imageId: "fr5h5gd3136chq0qmb2k",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388364",
                                                            name: "Chicken Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388366",
                                                            name: "Grilled Chicken Tacos",
                                                            category: "Appetizers",
                                                            imageId: "3459612908fefb04a7b6a474f455117a",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388368",
                                                            name: "Chicken Corn Paper Tacos",
                                                            category: "Appetizers",
                                                            imageId: "c10090e963cebe1ca4fc0030ba692108",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388371",
                                                            name: "Signature Chicken Nachos",
                                                            category: "Appetizers",
                                                            imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806100",
                                                            name: "Chicken & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "70281f65f7a8ac41a197cd571fa242d0",
                                                            inStock: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806103",
                                                            name: "Chicken Special Roll",
                                                            category: "Appetizers",
                                                            imageId: "f818471f535553a4351c1490b80147a4",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021818",
                                                            name: "Veg Noodles",
                                                            category: "Chinese",
                                                            description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                            imageId: "d2dkjmf5h7vil9zzjnoo",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            showImage: true,
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "84 ratings",
                                                                    ratingCountV2: "84"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ],
                                            type: "CATEGORY_TYPE_RECOMMENDED"
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Soups",
                                            categories: [
                                                {
                                                    title: "Soups",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "119531729",
                                                                    name: "Veg Tom Yum Soup",
                                                                    category: "Soups",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 19900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "131044284",
                                                                    name: "Sweet Corn Soup",
                                                                    category: "Soups",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000919",
                                                                    name: "Tomato Basil Soup",
                                                                    category: "Soups",
                                                                    imageId: "7491a231591f7c8ef6299a3846e59f22",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 15000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "44 ratings",
                                                                            ratingCountV2: "44"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000922",
                                                                    name: "Minestrone Soup",
                                                                    category: "Soups",
                                                                    imageId: "5d42ac81e15221854bcff2f2728b0756",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 15000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.7",
                                                                            ratingCount: "19 ratings",
                                                                            ratingCountV2: "19"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "25000924",
                                                                    name: "Broccoli Mushroom Soup",
                                                                    category: "Soups",
                                                                    imageId: "74d5792e3f3cbdbc6da69228f53e394a",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "50 ratings",
                                                                            ratingCountV2: "50"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806071",
                                                                    name: "Veg Manchow Soup",
                                                                    category: "Soups",
                                                                    imageId: "05307aa34e454058947fda4617a93185",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.7",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806072",
                                                                    name: "Veg Hot & Sour Soup",
                                                                    category: "Soups",
                                                                    imageId: "cvw4mo9midegdkky6v1a",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.9",
                                                                            ratingCount: "4 ratings",
                                                                            ratingCountV2: "4"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Appetizers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044959",
                                                            name: "Chicken Spring Roll",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 32100,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000927",
                                                            name: "Corn & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806080",
                                                            name: "Veg Spring Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1 | Deep-fried, stuffed rolls packed with seasoned assorted veggies.",
                                                            imageId: "uixdrme6e8v6udsill2b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170622",
                                                            name: "Crispy Corn",
                                                            category: "Appetizers",
                                                            imageId: "2c482f34b257753b843846b77bda83ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67996521",
                                                            name: "Paneer Kulcha",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000929",
                                                            name: "Mozzarella Cheese Stick",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "a5553c3cccf840486b4651bb43d6193c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000931",
                                                            name: "Cottage Cheese Finger",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "8247914a73d640b489ea18fd9da204c2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000933",
                                                            name: "Mac An Cheese Roll",
                                                            category: "Appetizers",
                                                            imageId: "c3c9f192e21cda38a103b730eeabb617",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000938",
                                                            name: "Veg Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "y5wdcgfyq3zvieb9tq7k",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676683",
                                                            name: "Chicken Cheese Finger",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373200",
                                                            name: "Cheesy Chicken Garlic Bread",
                                                            category: "Appetizers",
                                                            imageId: "6ea2115c9beb322d26f55e9434013258",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373205",
                                                            name: "Chicken Cheese Fries",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59141394",
                                                            name: "Dynamite Chicken",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "pfoied7sjl36bcui9gnv",
                                                            inStock: 1,
                                                            price: 56000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388285",
                                                            name: "Caucasian Spice Fish & Chips",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 72000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388291",
                                                            name: "Fish Finger",
                                                            category: "Appetizers",
                                                            imageId: "fr5h5gd3136chq0qmb2k",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388363",
                                                            name: "Moroccan Chicken",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388364",
                                                            name: "Chicken Quesadilla",
                                                            category: "Appetizers",
                                                            imageId: "3de7c0cd4d3a33f610dfb59cc0330fba",
                                                            inStock: 1,
                                                            price: 60000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388366",
                                                            name: "Grilled Chicken Tacos",
                                                            category: "Appetizers",
                                                            imageId: "3459612908fefb04a7b6a474f455117a",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388368",
                                                            name: "Chicken Corn Paper Tacos",
                                                            category: "Appetizers",
                                                            imageId: "c10090e963cebe1ca4fc0030ba692108",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388371",
                                                            name: "Signature Chicken Nachos",
                                                            category: "Appetizers",
                                                            imageId: "132354fc2cfdd5bcfcaad7ccd29c6731",
                                                            inStock: 1,
                                                            price: 54900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388372",
                                                            name: "Twist Cone Fish",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 72000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806098",
                                                            name: "Chicken Kulcha ",
                                                            category: "Appetizers",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806100",
                                                            name: "Chicken & Cheese Roll",
                                                            category: "Appetizers",
                                                            description: "Serves 1",
                                                            imageId: "70281f65f7a8ac41a197cd571fa242d0",
                                                            inStock: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806103",
                                                            name: "Chicken Special Roll",
                                                            category: "Appetizers",
                                                            imageId: "f818471f535553a4351c1490b80147a4",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Chinese",
                                            categories: [
                                                {
                                                    title: "Chinese",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "119533395",
                                                                    name: "Singapori Veg Noodle",
                                                                    category: "Chinese",
                                                                    imageId: "343db05cc4b92f3a6163b7d9e1a081db",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.7",
                                                                            ratingCount: "18 ratings",
                                                                            ratingCountV2: "18"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021818",
                                                                    name: "Veg Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                                    imageId: "d2dkjmf5h7vil9zzjnoo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "84 ratings",
                                                                            ratingCountV2: "84"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021823",
                                                                    name: "Chilli Potato",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "lw8unhoxkntfp5ikqbc6",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "113 ratings",
                                                                            ratingCountV2: "113"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "60883673",
                                                                    name: "Schezwan Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "hu6hvqbmdsyfgr9n05zq",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.6",
                                                                            ratingCount: "23 ratings",
                                                                            ratingCountV2: "23"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021822",
                                                                    name: "Chilli Garlic Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A spicy stir fry of assorted veggies and noodles tossed in hot chilli garlic sauce.",
                                                                    imageId: "fahvbq7m9vzrjyzcpl1i",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.3",
                                                                            ratingCount: "188 ratings",
                                                                            ratingCountV2: "188"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021825",
                                                                    name: "Chilli Paneer Dry",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | Diced Paneer (Indian Cottage Cheese) tossed in spicy sauce made with soya sauce, chilli sauce and Vinegar.",
                                                                    imageId: "eydcdhxfvdavqdpovbuo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 45000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "64 ratings",
                                                                            ratingCountV2: "64"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "60883672",
                                                                    name: "Veg Fried Rice",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "5614f60a7659fac365eac10e453d3b06",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806024",
                                                                    name: "Honey Chilli Potato",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | Finger potatoes tossed with sriracha, honey, sesame & spring onions.",
                                                                    imageId: "44f09c62ba809fb44e3f129de196fba1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.9",
                                                                            ratingCount: "41 ratings",
                                                                            ratingCountV2: "41"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806029",
                                                                    name: "Veg. Manchurian Dry",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "d62187bc8fa90a8ff08b4eb59cf84167",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "41 ratings",
                                                                            ratingCountV2: "41"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806031",
                                                                    name: "Chilli Mushroom Dry ",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    imageId: "f7f8c3947284c8ace4c08fff7d95256c",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806034",
                                                                    name: "Veg. Salt N Pepper",
                                                                    category: "Chinese",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 42000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021820",
                                                                    name: "Hakka Noodles",
                                                                    category: "Chinese",
                                                                    description: "Serves 1 | A mouth-watering noodle dish that combines the goodness of veggies.",
                                                                    imageId: "gwlgrufdtbwa6jizzuq3",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.3",
                                                                            ratingCount: "104 ratings",
                                                                            ratingCountV2: "104"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Coffees, Shakes And Crushers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044281",
                                                            name: "Nutella Brownie Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "127034563",
                                                            name: "Biscoff Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077865",
                                                            name: "Strawberry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "A refreshing milkshake prepared with strawberry sauce, ice cream and wholesome milk perfect to satisfy your cravings.",
                                                            imageId: "srrcen0hsajeed0pbsta",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "267 ratings",
                                                                    ratingCountV2: "267"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271203",
                                                            name: "Vanilla Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077862",
                                                            name: "Cold Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "thvril6hi8fwrftuuayg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "1555 ratings",
                                                                    ratingCountV2: "1555"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805969",
                                                            name: "Kitkat Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Combination of kitkat and chocolate sauce to make it a perfect thick shake.",
                                                            imageId: "sx5w4k7sovbg6ueogbxe",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "695 ratings",
                                                                    ratingCountV2: "695"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271204",
                                                            name: "Irish Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "224528e353a23792cf44cc67ac22dc4c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "23 ratings",
                                                                    ratingCountV2: "23"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805982",
                                                            name: "Nutella Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "A perfect blend of milk, nutella, and soft vanilla ice cream. A classic for summers. Serves 1-2",
                                                            imageId: "pfl2dfavnuwxxs3rifkg",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021805",
                                                            name: "Tiramisu Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Tiramisu Frappe Blended with Chocolate Choco Chips",
                                                            imageId: "pwvnpo8lxbvdgpllb09g",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373206",
                                                            name: "Chocolate Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "65373208",
                                                            name: "Ferrero Rocher Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077848",
                                                            name: "Cafe Choco Cookie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.2",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628463",
                                                            name: "Caramel Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628464",
                                                            name: "Hazelnut Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Serves 1",
                                                            imageId: "cd0763f82c02ecf62408f91aa237ead9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "60 ratings",
                                                                    ratingCountV2: "60"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271213",
                                                            name: "Mocha Frappe",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "53a1390972bbd7c63cdf1aaadff21385",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "91 ratings",
                                                                    ratingCountV2: "91"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077858",
                                                            name: "Davidoff Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "74d7b1706922352d5eb9d94dbc159ed9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "307 ratings",
                                                                    ratingCountV2: "307"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "85675793",
                                                            name: "Blackberry Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271214",
                                                            name: "Belgian Choco Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4978a35f9bf554b45da8fb795a722ade",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "226 ratings",
                                                                    ratingCountV2: "226"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628465",
                                                            name: "Ferrero Rocher Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "86729088fd68e7bbd28d54be175485b5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 34900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "43 ratings",
                                                                    ratingCountV2: "43"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021855",
                                                            name: "Peanut Butter",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "311a9f9ef4c5fa16d6495e66b4c5682d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805929",
                                                            name: "Almond Coffee",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805934",
                                                            name: "Tiramisu Chip ",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805937",
                                                            name: "Dark Brownie Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cd0f52cca7ee7dc16f734389e6a9d3ea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "109 ratings",
                                                                    ratingCountV2: "109"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805947",
                                                            name: "Oreo Chocolate",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "98 ratings",
                                                                    ratingCountV2: "98"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805949",
                                                            name: "Oreo Mint",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "4b6dddf2fc5c3d8c4b504d6d1cc9ee69",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805951",
                                                            name: "Oreo Strawberry",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805955",
                                                            name: "Berry Oreo Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805956",
                                                            name: "Oreo Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cuoech9pjhqtjmftyiyo",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805958",
                                                            name: "Oreo Walnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805960",
                                                            name: "Oreo Black Currant",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.1",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805962",
                                                            name: "Oreo Vanilla",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805964",
                                                            name: "Choco Banana Oreo Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "c58b8d7fd7a29e4f4f3c8b86d69d684e",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805966",
                                                            name: "Red Velvet Oreo",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805971",
                                                            name: "Blackcurrant Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "657332a561f2f18fdc3e4f800b88c7fe",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805972",
                                                            name: "Heartbeat Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805974",
                                                            name: "Chocolate Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "25 ratings",
                                                                    ratingCountV2: "25"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805976",
                                                            name: "Vanilla Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805978",
                                                            name: "Banana Walnut Choco chip",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805979",
                                                            name: "Mint Chocolate Chip Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805983",
                                                            name: "Nutella Peanut",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805984",
                                                            name: "Snickers Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805985",
                                                            name: "Peanut Banana",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "24bb523b11f330fffaa0c69f6d03cb2f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805989",
                                                            name: "Kesar Almond Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805993",
                                                            name: "Protein Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805994",
                                                            name: "Blueberry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805997",
                                                            name: "Mixed Berry Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805998",
                                                            name: "Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806001",
                                                            name: "Saffron Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806003",
                                                            name: "Chocolate Banana Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806006",
                                                            name: "Vanilla Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806008",
                                                            name: "Chocolate Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "rlvntu5uxy778d9ujhqd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806011",
                                                            name: "Pineapple Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "cf038b2e80057ee7f32ff3883cf6c83d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806013",
                                                            name: "Alphonso Mango",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "f10d92d6b69c6c7db113ec8b17ef2997",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806017",
                                                            name: "Strawberry Chocolate Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.2",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806018",
                                                            name: "Strawberry Walnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806021",
                                                            name: "Butterscotch Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "86bc8d2e39bcb3bd291e24d0b26a8a1c",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "92 ratings",
                                                                    ratingCountV2: "92"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806023",
                                                            name: "Caramel Lovers",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "db499d83469b01ef81c5c9b568cddcaf",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806026",
                                                            name: "Caramel Popcorn Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806028",
                                                            name: "Pina Alphonso Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "95a1c40dd30521c0e4a167f966392eb9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806030",
                                                            name: "Marshmallow Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806032",
                                                            name: "Love Rose Vanilla",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 20000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806035",
                                                            name: "Red Velvet Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806037",
                                                            name: "Vanilla Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "2a869e2f73b9adef412e600cdbd0626f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806039",
                                                            name: "Chocolate Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806041",
                                                            name: "Monkey Banana Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "083293181b88b7ba910c873ebe8dea78",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806044",
                                                            name: "Bubble-gum Marshmallow",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806046",
                                                            name: "Bubble-gum Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "10 ratings",
                                                                    ratingCountV2: "10"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806048",
                                                            name: "Fruit & Nut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806050",
                                                            name: "Banoffee Pie Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806052",
                                                            name: "Tiramisu Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806054",
                                                            name: "Nutella Cheese Cake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806056",
                                                            name: "Blueberry Cheesecake Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806058",
                                                            name: "Nutella Caramel Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806062",
                                                            name: "Kiwi Strawberry Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "7611804852b854642f932faf541f27c8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806064",
                                                            name: "Strawberry Banana Smoothie",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "bc231ce0b57f77eecd1091fbaeccb0c1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806066",
                                                            name: "Chocolate Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "0ff51573d1d68ad15c113280f954093f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806070",
                                                            name: "Five Star",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "103707100",
                                                            name: "Chocolate Hazelnut Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            description: "Richness of chocolate blended with hazelnut touch makes a deadly combination for shake lovers",
                                                            imageId: "a09bace04d68657d996e028f93284c3f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805946",
                                                            name: "Choco Brownie Crusher",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "140 ratings",
                                                                    ratingCountV2: "140"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805952",
                                                            name: "Nutella Oreo",
                                                            category: "Coffees, Shakes And Crushers",
                                                            imageId: "ad8aaa3ea9674eeee5e4a5775c56cfa2",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "40 ratings",
                                                                    ratingCountV2: "40"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579342",
                                                            name: "Tutti Fruitti Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579343",
                                                            name: "Rose Paan Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805967",
                                                            name: "Red Velvet Shake",
                                                            category: "Coffees, Shakes And Crushers",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Salads",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044961",
                                                            name: "Chicken Tikka Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563608",
                                                            name: "Veg Caesar Salad",
                                                            category: "Salads",
                                                            description: "Iceberg, lettuce green, olive, cherry tomato, broccoli and parmesan cheese and creamy dressing.",
                                                            imageId: "43eb7ec82b0b334ac76335309d9adcf6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.0",
                                                                    ratingCount: "70 ratings",
                                                                    ratingCountV2: "70"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563611",
                                                            name: "Grilled Veg Salad",
                                                            category: "Salads",
                                                            description: "Iceberg, broccoli, beans, zucchini, carrot, olives, onion, tomato [hot salad with olive oil].",
                                                            imageId: "c6b86b6430624f3b4eed461cb212a502",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "143 ratings",
                                                                    ratingCountV2: "143"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563609",
                                                            name: "Barbeque Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806074",
                                                            name: "Broccoli Mushroom Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "59 ratings",
                                                                    ratingCountV2: "59"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000926",
                                                            name: "Cottage Cheese Pineapple Salad",
                                                            category: "Salads",
                                                            imageId: "2713c5fd49af1b7088eef988bc21106f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676682",
                                                            name: "Smoke Chicken Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 44000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58162988",
                                                            name: "Brisket Chicken Creamy Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 39000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388245",
                                                            name: "Chicken Pineapple Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388247",
                                                            name: "Grilled Chicken Salad",
                                                            category: "Salads",
                                                            imageId: "b2233572d9e9a64f7e40e1ed2116e9da",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "73 ratings",
                                                                    ratingCountV2: "73"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806086",
                                                            name: "Chicken Caesar Salad ",
                                                            category: "Salads",
                                                            imageId: "42dfc1326334f98e56417eeaac98d364",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806090",
                                                            name: "Crispy Fish Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119532321",
                                                            name: "Aloo Tikki Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119532322",
                                                            name: "Paneer Tikka Salad",
                                                            category: "Salads",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Wraps",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119533397",
                                                            name: "Chilli Mushroom Wrap",
                                                            category: "Wraps",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563592",
                                                            name: "Paneer Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, garlic sauce and spicy oregano.",
                                                            imageId: "24047a9b9013325dc9256f7e29017925",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "103 ratings",
                                                                    ratingCountV2: "103"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563597",
                                                            name: "Spicy Paneer Tikka Wraps",
                                                            category: "Wraps",
                                                            description: "Medium Spicy | Serves 1 | Juicy grilled paneer tikka stuffed and rolled into a scrumptious wrap.",
                                                            imageId: "htpsddiwuuqybtsp4hyx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "366 ratings",
                                                                    ratingCountV2: "366"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563594",
                                                            name: "Soya Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, Nutella chunks, oregano, chilli flakes and sauce.",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "71 ratings",
                                                                    ratingCountV2: "71"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563598",
                                                            name: "Corny Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, sweet corn, oregano, chilli flakes and sauce.",
                                                            imageId: "53c1b023e1a0b88d6ae10027bd2be5e7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859012",
                                                            name: "Egg & Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "85a0321ca6e2da91d8156dcb80d73fba",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859011",
                                                            name: "Crispy Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "wm2pxqoge4u4dlqasnzl",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388417",
                                                            name: "Chilli Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "253c0d587fdb5db9d2309239e4f928b6",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388421",
                                                            name: "Pesto Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "7565ad519b92deeed37a5aa1a37ae783",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806116",
                                                            name: "Grilled Veg. Wraps",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "b58163bc53960b84a3d785c88d005ec6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "47 ratings",
                                                                    ratingCountV2: "47"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806166",
                                                            name: "Chicken Shawarma Wrap ",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            imageId: "z9vqfpotga887cb6okjc",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "29 ratings",
                                                                    ratingCountV2: "29"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388419",
                                                            name: "Grilled Chicken Wrap",
                                                            category: "Wraps",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Hot Beverages",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "62668406",
                                                            name: "Hot Chocolate Drink",
                                                            category: "Hot Beverages",
                                                            imageId: "5f64a8a54ba3fb81172807d6458ef955",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "25 ratings",
                                                                    ratingCountV2: "25"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806079",
                                                            name: "Molten Hot Chocolate Drink",
                                                            category: "Hot Beverages",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Sandwich",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044299",
                                                            name: "Mushroom Capsicum Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044300",
                                                            name: "Spinach & Corn Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22200,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563599",
                                                            name: "Grilled Veg Paneer Sandwich",
                                                            category: "Sandwich",
                                                            description: "Grilled Paneer + Tomato + Onion + Tandoori Mayonnaise",
                                                            imageId: "str6dgmj5eya9agsgnvb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "413 ratings",
                                                                    ratingCountV2: "413"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "4077798",
                                                            name: "Classic Tandoori Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "40e4f266cf84360d5d9627d5e6c72ae0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.6",
                                                                    ratingCount: "270 ratings",
                                                                    ratingCountV2: "270"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563604",
                                                            name: "Classic Spicy Sandwich",
                                                            category: "Sandwich",
                                                            description: "Medium Spicy | Serves 1 | Capsicum + Broccoli +Zucchini + Jalapeno with Spicy Red Sauce & Cheese",
                                                            imageId: "94a98482c0464145876da568c6798527",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                spiceLevel: "MEDIUMSPICY",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "47 ratings",
                                                                    ratingCountV2: "47"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "5628459",
                                                            name: "Aloo Tikki Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "84 ratings",
                                                                    ratingCountV2: "84"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563600",
                                                            name: "Cheese Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "xj01vjh08icbrhu420pc",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "27 ratings",
                                                                    ratingCountV2: "27"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563602",
                                                            name: "American Cheese Sandwich",
                                                            category: "Sandwich",
                                                            description: "Broccoli + Beans + Zucchini + Carrot + Capsicum + Onion + White Cream Sauce",
                                                            imageId: "c1adipam0khlnpzhs9dx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "33 ratings",
                                                                    ratingCountV2: "33"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563603",
                                                            name: "Club Sandwich",
                                                            category: "Sandwich",
                                                            description: "Broccoli + Zucchini + Beans + Carrot + Jalapeno with Creamy Red Sauce",
                                                            imageId: "jkjlc3veehrqrhnrnyoy",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "74 ratings",
                                                                    ratingCountV2: "74"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021815",
                                                            name: "Falafel Hummus Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "24 ratings",
                                                                    ratingCountV2: "24"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443767",
                                                            name: "Dark Brown Special Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "28 ratings",
                                                                    ratingCountV2: "28"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443770",
                                                            name: "Chicken Seekh Kabab Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "14dcb6590eae683347d10110e3e6e149",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388431",
                                                            name: "Grilled Chicken Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "ec63478e4ad42136c9487610eee216d1",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "30 ratings",
                                                                    ratingCountV2: "30"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388434",
                                                            name: "Open Melted Chicken Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388436",
                                                            name: "Chicken Club Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "ee1d9bc6bcf464604ff0cec46b9c02ef",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388441",
                                                            name: "Chicken Peri Peri Sandwich",
                                                            category: "Sandwich",
                                                            imageId: "2a442efd895aa9fa05506b2315abba04",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805936",
                                                            name: "Veg. Grilled Sandwich",
                                                            category: "Sandwich",
                                                            description: "Serves 1",
                                                            imageId: "091477b70271890f13a61d7780e819d6",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "216 ratings",
                                                                    ratingCountV2: "216"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805939",
                                                            name: "Veg. Delight Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "34 ratings",
                                                                    ratingCountV2: "34"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806078",
                                                            name: "Roast Chicken Crispy Club Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443768",
                                                            name: "Mutton Seekh Kabab Sandwich",
                                                            category: "Sandwich",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Burgers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831785",
                                                            name: "Aloo Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "3cc3ae08ba8560f910f0381f2566ce5d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "393 ratings",
                                                                    ratingCountV2: "393"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831787",
                                                            name: "Cheese Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "jsu8qp3kwejvrb0xrddl",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "317 ratings",
                                                                    ratingCountV2: "317"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831788",
                                                            name: "Herbs Chilli Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "vpkswls0bwkvma5y9x3j",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "674 ratings",
                                                                    ratingCountV2: "674"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "9831789",
                                                            name: "Paneer Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9ece4c79b3c9925160c8b5ed04aa5cca",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "162 ratings",
                                                                    ratingCountV2: "162"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563607",
                                                            name: "Green Garden Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "568be84be60e75c383cb48297f33cfc0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "68 ratings",
                                                                    ratingCountV2: "68"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021821",
                                                            name: "Open Veg Garden",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "18 ratings",
                                                                    ratingCountV2: "18"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676686",
                                                            name: "Juicy Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.3",
                                                                    ratingCount: "16 ratings",
                                                                    ratingCountV2: "16"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "71676685",
                                                            name: "Egg Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "9bddd257aa31d6cc24a916819c4cdb1e",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080568",
                                                            name: "Mutton Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "71c6bae748d2a5a672a09264d64b363e",
                                                            inStock: 1,
                                                            price: 33000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.3",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388387",
                                                            name: "Chicken Tikki Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "88750040ce94d78adb8ac68e2efac7bc",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388388",
                                                            name: "Pesto Chicken Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "75c578ed2633d445087409881a9f49b8",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806117",
                                                            name: "Falafel Hummus Wraps",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.5",
                                                                    ratingCount: "52 ratings",
                                                                    ratingCountV2: "52"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806154",
                                                            name: "Grilled Chicken Burger ",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "xzqv0r3aasdrdrahyfig",
                                                            inStock: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806155",
                                                            name: "Fish And Chips Burger",
                                                            category: "Burgers",
                                                            description: "Serves 1",
                                                            imageId: "2d720e91506f3c93c7f04dba210a64a5",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Side Offers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443796",
                                                            name: "Cheese Garlic Bread",
                                                            category: "Side Offers",
                                                            description: "Serves 1 | Everything is Better with cheese & Garlicky Goodness.",
                                                            imageId: "ljygnylffanzx7rcsrxv",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 20000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "152 ratings",
                                                                    ratingCountV2: "152"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443793",
                                                            name: "Cheese Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "0d5b791377da53cf7c2102a278980a0a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "17 ratings",
                                                                    ratingCountV2: "17"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443773",
                                                            name: "Crunchy French Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "535619e08224a48b22c816fb14f363dd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563572",
                                                            name: "French Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "b7551843b418ccdf3584d1d148588057",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "152 ratings",
                                                                    ratingCountV2: "152"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563573",
                                                            name: "Garlic Bread Plain",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "0148886a811d917f3952631ff0d093af",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563575",
                                                            name: "Falafel Pita Hummus",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "fd3068ca6121aa76c85425f2e1cf5969",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "94 ratings",
                                                                    ratingCountV2: "94"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805954",
                                                            name: "Peri Peri Fries",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "bae234a686ed5dbdb846fd0ffdee319f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805988",
                                                            name: "Stuff Garlic Bread",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "mstnbqyyxfbazybgeedi",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805996",
                                                            name: "Nachos With Cheese",
                                                            category: "Side Offers",
                                                            description: "Serves 1",
                                                            imageId: "69f5be1332c45ea91d13d59be7b20874",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "105 ratings",
                                                                    ratingCountV2: "105"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "112579341",
                                                            name: "Cheese Peri-peri Fries",
                                                            category: "Side Offers",
                                                            description: "Peri peri fries loaded with melted mozzarella cheese",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Crispers Kingdom",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "64346558",
                                                            name: "Crispy Chicken Burger ",
                                                            category: "Crispers Kingdom",
                                                            description: "Serves 1",
                                                            imageId: "vov2s292tdwfqmalrfg2",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.8",
                                                                    ratingCount: "15 ratings",
                                                                    ratingCountV2: "15"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806082",
                                                            name: "Crispy Chicken Salad",
                                                            category: "Crispers Kingdom",
                                                            description: "Serves 1",
                                                            imageId: "42dfc1326334f98e56417eeaac98d364",
                                                            inStock: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Thirsty Quenchers",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150142",
                                                            name: "Chilli Guava",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150141",
                                                            name: "Yuzu",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080573",
                                                            name: "Cumber Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080572",
                                                            name: "Strawberry Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080571",
                                                            name: "Masala Soda",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            imageId: "ab167572d31c1de981c8d713cf9ad3c1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.3",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60080570",
                                                            name: "Peach Masala",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "94150155",
                                                            name: "Kala Khatta",
                                                            category: "Thirsty Quenchers",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Combos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "68554181",
                                                            name: "Noodles With Chilli Paneer",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58999219",
                                                            name: "Fried Rice With Manchurian",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "75b34874b14a0b9acb07cd187f6218d8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "48 ratings",
                                                                    ratingCountV2: "48"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58999218",
                                                            name: "Fried Rice With Chilli Paneer",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "830033471bd61b441d228b36091fb8ee",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.7",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806049",
                                                            name: "Veg Noodles With Manchurian",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "4c152ef1e2f505f66faf957dccb097ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806096",
                                                            name: "Veg Noodles With Manchurian  ",
                                                            category: "Combos",
                                                            description: "Serves 1",
                                                            imageId: "4c152ef1e2f505f66faf957dccb097ff",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Dimsum",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736201",
                                                            name: "Chicken Gravy Dimsum (6pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736200",
                                                            name: "Achari Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "b283f2b5308d30b4f7267c1613adbb12",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.1",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736199",
                                                            name: "Malai Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "102736175",
                                                            name: "Gravy Dimsum (6 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60882574",
                                                            name: "Schezwan Chicken Dimsum ( 8 Pcs)",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "58994282",
                                                            name: "Kurkure Chicken Dimsum( 8 Pcs ) ",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "q6y6cmuqyvqz4crbjpvk",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "57097093",
                                                            name: "Chicken Dimsums ( 8 Pcs ) ",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "8a520958c2f2266213423a45a8e3d55f",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "21 ratings",
                                                                    ratingCountV2: "21"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806134",
                                                            name: "Veg Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "grmqhghpehvz5ifjhav7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.7",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806135",
                                                            name: "Paneer & Corn Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806136",
                                                            name: "Kurkure Veg Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "02c4be58106b16a0652be6dc4a988395",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806137",
                                                            name: "Kurkure Paneer & Corn Dimsum",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            imageId: "c36704a15ce6e88877122da04c888066",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 33000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806138",
                                                            name: "Schezwan Veg Dimsums",
                                                            category: "Dimsum",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Desserts",
                                            categories: [
                                                {
                                                    title: "Desserts",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "78155342",
                                                                    name: "Strawberry Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "73170624",
                                                                    name: "Oreo Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.1",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "66322201",
                                                                    name: "Double Oreo Delight",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.9",
                                                                            ratingCount: "38 ratings",
                                                                            ratingCountV2: "38"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805986",
                                                                    name: "Banoffee Pie",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "c7e12b4629fad2e1669b48daa382ae77",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805990",
                                                                    name: "Choco Torte",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 26000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.1",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805992",
                                                                    name: "Chocolate Mousse",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "ce6380d27931dd0812d94149d71aab13",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.8",
                                                                            ratingCount: "7 ratings",
                                                                            ratingCountV2: "7"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805995",
                                                                    name: "Nutella Cheese Cake  ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "ptzys9t2u1t8peqvivdo",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.5",
                                                                            ratingCount: "35 ratings",
                                                                            ratingCountV2: "35"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806002",
                                                                    name: "Blueberry Cheese Cake Pastry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "4337482ed72b9ecb7cca0ba8c57ffd9e",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.7",
                                                                            ratingCount: "8 ratings",
                                                                            ratingCountV2: "8"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806009",
                                                                    name: "Real Strawberry With Nutella ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806020",
                                                                    name: "Mango Flurry ",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 17000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806022",
                                                                    name: "Strawberry Mango Flurry",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 18000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805980",
                                                                    name: "Hot Brownie With Hot Chocolate",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "9079c5941e9c9ec99c9e1b3aed4c53ea",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 19900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "960 ratings",
                                                                            ratingCountV2: "960"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805981",
                                                                    name: "Hot Brownie With Hot Chocolate & Ice Cream",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "c5edcee7c15971037868516ee43925f7",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 24000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.4",
                                                                            ratingCount: "98 ratings",
                                                                            ratingCountV2: "98"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96805999",
                                                                    name: "Irish Tiramisu",
                                                                    category: "Desserts",
                                                                    description: "Serves 1",
                                                                    imageId: "bxaapk8pkvswkqxwsjyt",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.3",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Pancakes",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044297",
                                                            name: "Fruit Pancake ( Cocktail Fruit )",
                                                            category: "Pancakes",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712150",
                                                            name: "Banana Pancake",
                                                            category: "Pancakes",
                                                            imageId: "nzwzp9asfa3zgutxclaq",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712151",
                                                            name: "Nutella Pancake",
                                                            category: "Pancakes",
                                                            imageId: "tqyuxpb01t6fk8nozot8",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "61 ratings",
                                                                    ratingCountV2: "61"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712152",
                                                            name: "Strawberry Pancake",
                                                            category: "Pancakes",
                                                            imageId: "06a55fe03d94f07e0de7fe8c0554bcdd",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "67712154",
                                                            name: "Classic Pancake",
                                                            category: "Pancakes",
                                                            imageId: "2d6137d6432637c31325f64e59464b6b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.9",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Ice Creams",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820440",
                                                            name: "Vanilla with KitKat Ice Cream [2 Scoops]",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820441",
                                                            name: "Vanilla With Oreo",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820442",
                                                            name: "Vanilla with Hot Chocolate Ice Cream [2 Scoops]",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "77820449",
                                                            name: "Black Currant",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "47a331ccc02a2aec4e2b72a905ffe51a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806025",
                                                            name: "Vanilla",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "6f24f0ae20baedb3d3bb2843492a6f4a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806027",
                                                            name: "Chocolate",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "3eba4f8476892c1dc009f8a89ef77fd7",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806033",
                                                            name: "Butterscotch",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "efdcb4dfc667a0835f27b55796672649",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806036",
                                                            name: "Strawberry",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "a68ed28cf0610486535c4c0581792d37",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806038",
                                                            name: "Fruit & Nut  ",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806045",
                                                            name: "Mango ",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "03230051babe743f1bfa4fa32031adfa",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806047",
                                                            name: "Pineapple",
                                                            category: "Ice Creams",
                                                            description: "Serves 1",
                                                            imageId: "ac110bdd52bbe32e63c110435b218333",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 11000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Full Cakes",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59568174",
                                                            name: "Irish Tiramisu Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 237000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "59568175",
                                                            name: "Nutella Cheese Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            imageId: "ubc1k5nevhg4btmgtmkc",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 211000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "35 ratings",
                                                                    ratingCountV2: "35"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806075",
                                                            name: "Banoffee Pie  ",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            imageId: "c7e12b4629fad2e1669b48daa382ae77",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 211000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806076",
                                                            name: "Blueberry Cheese Cake   ",
                                                            category: "Full Cakes",
                                                            description: "Serves 1 | Blueberry jam topped on a rich cream and cheese dessert.",
                                                            imageId: "iso0xdar8lbewtjs5aqh",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 224000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806077",
                                                            name: "Chocolate Torte Cake",
                                                            category: "Full Cakes",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 165000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Chinese Soup",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388208",
                                                            name: "Chicken Manchow Soup",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            imageId: "49758aabff9bd651b59f7158ab09afd4",
                                                            inStock: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.6",
                                                                    ratingCount: "13 ratings",
                                                                    ratingCountV2: "13"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806167",
                                                            name: "Chicken Hot & Sour Soup",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 23000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806169",
                                                            name: "Lemon Chicken Herbs   ",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806170",
                                                            name: "Broccoli Chicken Almond Soup   ",
                                                            category: "Chinese Soup",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Main Course",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388454",
                                                            name: "Grilled Chicken Peri Peri Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388349",
                                                            name: "Fish In Lemon Butter",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            imageId: "rzvdmz5s8ark7ztsbtbf",
                                                            inStock: 1,
                                                            price: 71000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "28 ratings",
                                                                    ratingCountV2: "28"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388350",
                                                            name: "Grilled Fish Peri Peri",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            imageId: "bwdktio3gotz97y3qff3",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388352",
                                                            name: "Grilled Fish Mustard Cream Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806104",
                                                            name: "Chicken Pepper Sticks",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806105",
                                                            name: "Chicken Wings With BBQ Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1 | Chicken wings glazed in smoky barbeque sauce.",
                                                            inStock: 1,
                                                            price: 66000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806107",
                                                            name: "Chicken Finger With Cocktail Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 66000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806108",
                                                            name: "Grilled Chicken BBQ Sauce",
                                                            category: "Main Course",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 77000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.0",
                                                                    ratingCount: "1 rating",
                                                                    ratingCountV2: "1"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Chinese Starters",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "119533393",
                                                            name: "Schezwan Chicken Noodles",
                                                            category: "Chinese Starters",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883667",
                                                            name: "Schezwan Fried Rice",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "d8098eef65a1d6206c8c346de07cbc98",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883668",
                                                            name: "Schezwan Chicken",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "48d2bd0aa185209cc3a4554fa7ee2538",
                                                            inStock: 1,
                                                            price: 54000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883669",
                                                            name: "Chicken Chilli Garlic Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "3b0c49b1036dacc7ff13262dd6faef4e",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60883670",
                                                            name: "Chicken Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "ihp13zm3h9u12ymq7fti",
                                                            inStock: 1,
                                                            price: 36000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.7",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388374",
                                                            name: "Chilli Chicken Dry",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "xz4ex3t6g1ayctqkcmwz",
                                                            inStock: 1,
                                                            price: 56000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "39 ratings",
                                                                    ratingCountV2: "39"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388382",
                                                            name: "Chicken Hakka Noodles",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "b76c266831fe664e59abc336ad0fd53b",
                                                            inStock: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806171",
                                                            name: "Chicken Manchurian ",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "1fc87fae326ff5045b5cdfdcb179644e",
                                                            inStock: 1,
                                                            price: 54000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806172",
                                                            name: "Chicken Fried Rice",
                                                            category: "Chinese Starters",
                                                            description: "Serves 1",
                                                            imageId: "500a042557200e6298984c363fbd92a0",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Baked Paninis",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "131044302",
                                                            name: "Paneer Mushroom Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563585",
                                                            name: "Grilled Veg Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 36200,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.4",
                                                                    ratingCount: "56 ratings",
                                                                    ratingCountV2: "56"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563587",
                                                            name: "Grilled Veg Saucy Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563588",
                                                            name: "Cottage Cheese Panini",
                                                            category: "Baked Paninis",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "20 ratings",
                                                                    ratingCountV2: "20"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "19021798",
                                                            name: "Mushroom Olive Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "6 ratings",
                                                                    ratingCountV2: "6"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443776",
                                                            name: "Chicken Salami Sausage Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443777",
                                                            name: "Chicken Seekh Kabab Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443778",
                                                            name: "Mutton Seekh Kabab Panini",
                                                            category: "Baked Paninis",
                                                            inStock: 1,
                                                            price: 59900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27388423",
                                                            name: "Grilled Chicken Panini",
                                                            category: "Baked Paninis",
                                                            imageId: "e3224242c38d62a225bd1037ba7d4abc",
                                                            inStock: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Tacos",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563589",
                                                            name: "Paneer Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1 | Paneer, bell pepper, capsicum, onion, cabbage, creamy mayonnaise sauce.",
                                                            imageId: "12a8e7d99eab6f95536f7f08cf4af076",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 31000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "51 ratings",
                                                                    ratingCountV2: "51"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563591",
                                                            name: "Super Classic Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1 | Bell pepper, capsicum, onion, cabbage, zucchini, cheesy creamy mayonnaise.",
                                                            imageId: "f56606366c2db184f6a262591e2c419f",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "45 ratings",
                                                                    ratingCountV2: "45"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806109",
                                                            name: "Grilled Veg. Tacos",
                                                            category: "Tacos",
                                                            description: "Serves 1",
                                                            imageId: "ff5a15c4ce8b1c59a23d441f871a9190",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 28000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.7",
                                                                    ratingCount: "65 ratings",
                                                                    ratingCountV2: "65"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Bagel",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859014",
                                                            name: "Pesto Chicken Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "5a89357a633d22b5693ba921d898c8d9",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "60859013",
                                                            name: "Chicken Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "edc69ad93120c06f55266dc8fe0e4035",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "57916185",
                                                            name: "Grilled Chicken Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "25e3c34c7af8c524eaa64c12d01522b9",
                                                            inStock: 1,
                                                            price: 29900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806110",
                                                            name: "Aloo Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806112",
                                                            name: "Herbs Chilli Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "b8bcb318f382123eec1172928a8320e9",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 24000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806115",
                                                            name: "Paneer Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            imageId: "fb1f4a69f486d3ef31c1fafad7543145",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806156",
                                                            name: "Mutton Tikki Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 38000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806157",
                                                            name: "Fish And Chips Bagel",
                                                            category: "Bagel",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 34000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Lasagne",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000930",
                                                            name: "Mix Veg Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "44783dba22554b9ff18845d8fe922de0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 49000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.5",
                                                                    ratingCount: "41 ratings",
                                                                    ratingCountV2: "41"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "25000932",
                                                            name: "Lasagne Au Gratin",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "c861891be6cc3fa64f67365e84163c92",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 51000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "9 ratings",
                                                                    ratingCountV2: "9"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443779",
                                                            name: "Chicken Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "60173f4337a1c98baf3c3f938e379cbc",
                                                            inStock: 1,
                                                            price: 65000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "26 ratings",
                                                                    ratingCountV2: "26"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443780",
                                                            name: "Bolognese Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            price: 65000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.3",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806132",
                                                            name: "Spinach & Mushroom Lasagne",
                                                            category: "Lasagne",
                                                            description: "Serves 1",
                                                            imageId: "d1cc2859dd50af644da76c84eb510461",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 49000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Pizza",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443763",
                                                            name: "Mutton Seekh Kabab Pizza [Thin Crust, 10 Inches]",
                                                            category: "Pizza",
                                                            description: "(Mutton Seekh kabab & mutton keema)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806164",
                                                            name: "Dark Brown Special Pizza",
                                                            category: "Pizza",
                                                            description: "( Onion, Bell pepper, Green capsicum, Chicken Salami, Sausage, Cherry tomato )",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "27443764",
                                                            name: "Roast Chicken Pizza",
                                                            category: "Pizza",
                                                            description: "(Roast Chicken & Onion)",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806120",
                                                            name: "Farmhouse Pizza",
                                                            category: "Pizza",
                                                            description: "Serves 1 | ( Red Capsicum, yellow Capsicum, Green capsicum , Zucchini, Mushroom, Broccoli, onion, Black olive & jalapeno )",
                                                            imageId: "018ad788525ec67d39c1e8597a0b0122",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806121",
                                                            name: "Dark Brown Special Pizza ",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, onion, Cherry Tomato, paneer, Black olive, jalapeno)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.9",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806122",
                                                            name: "Spicy Corn Pizza",
                                                            category: "Pizza",
                                                            description: "Green capsicum, onion, Corn, black olive, jalapeno)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806124",
                                                            name: "Paneer Pizza",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Paneer, Onion, black Olive, jalapeno  )",
                                                            imageId: "5b09fbb51bd0f2a0d0784fe17a66bdc1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 52000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806125",
                                                            name: "Margarita Pizza",
                                                            category: "Pizza",
                                                            imageId: "5b1ee7b75a9b6b041ab45b9c1f95b22d",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 35000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.1",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806126",
                                                            name: "Four Season Pizza",
                                                            category: "Pizza",
                                                            description: "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, Mushroom, zucchini, Onion, black Olive, jalapeno  )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 46000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806129",
                                                            name: "Simply English Vegetable Pizza",
                                                            category: "Pizza",
                                                            description: "( Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Cherry tomato, black Olive, jalapeno  )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 45000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806131",
                                                            name: "Grilled Vegetable Pizza",
                                                            category: "Pizza",
                                                            description: "Red Capsicum, yellow Capsicum, Green capsicum, Broccoli, zucchini, Onion, black Olive, jalapeno  )",
                                                            imageId: "018ad788525ec67d39c1e8597a0b0122",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 43000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.1",
                                                                    ratingCount: "8 ratings",
                                                                    ratingCountV2: "8"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806158",
                                                            name: "BBQ Chicken Pizza",
                                                            category: "Pizza",
                                                            description: "( Onion, Bell pepper, Green capsicum, jalapeno & Grilled chicken )",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806159",
                                                            name: "Chicken Sausage Salami Pizza ",
                                                            category: "Pizza",
                                                            description: "chicken sausage & chicken salami)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806161",
                                                            name: "Chicken Seekh Kabab Pizza ",
                                                            category: "Pizza",
                                                            description: "Chicken Seekh Kabab & chicken Keema)",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806163",
                                                            name: "Bolognese Pizza",
                                                            category: "Pizza",
                                                            description: "(Bolognese Sauce)",
                                                            inStock: 1,
                                                            price: 78000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806165",
                                                            name: "Pepperoni Pizza Chicken ",
                                                            category: "Pizza",
                                                            inStock: 1,
                                                            price: 71900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "NONVEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                                            title: "Pastas",
                                            categories: [
                                                {
                                                    title: "Others",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "27388442",
                                                                    name: "Fusilli Chicken Peri Peri Pasta",
                                                                    category: "Pastas",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "1.1",
                                                                            ratingCount: "5 ratings",
                                                                            ratingCountV2: "5"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "27388445",
                                                                    name: "Angry Chicken Pasta",
                                                                    category: "Pastas",
                                                                    imageId: "c0bfda4a4b0dbb1fa4125334cf2c854d",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "5.0",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806087",
                                                                    name: "Spaghetti Agli -E- Olio With Chicken Sausage",
                                                                    category: "Pastas",
                                                                    inStock: 1,
                                                                    price: 62000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "96806088",
                                                                    name: "Chicken Special Pasta",
                                                                    category: "Pastas",
                                                                    imageId: "40db6ecddd849b636b32e4085a40eec7",
                                                                    inStock: 1,
                                                                    price: 59900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "NONVEG"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    title: "veg",
                                                    itemCards: [
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949071",
                                                                    name: "Red Sauce Pasta (penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.3",
                                                                            ratingCount: "15 ratings",
                                                                            ratingCountV2: "15"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949072",
                                                                    name: "White Sauce Pasta (penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.8",
                                                                            ratingCount: "84 ratings",
                                                                            ratingCountV2: "84"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949073",
                                                                    name: "Mix Sauce Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 29000,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "193 ratings",
                                                                            ratingCountV2: "193"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949074",
                                                                    name: "Cheese Red Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "536e15c646ffd0f83a2e8eadd604d54d",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.5",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949075",
                                                                    name: "Cheese White Pasta (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "5c04c7cb43b0568e32214f49a53dbd30",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.1",
                                                                            ratingCount: "28 ratings",
                                                                            ratingCountV2: "28"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100949078",
                                                                    name: "Cheese Mix Pasta  (Penne)",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "59a99f7eee5a4656b7b6d82490857463",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 28900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "35 ratings",
                                                                            ratingCountV2: "35"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "19021816",
                                                                    name: "Penne Arrabiata",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "40ba0ede04a674f12e64b09029be1345",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 34900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "12 ratings",
                                                                            ratingCountV2: "12"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893292",
                                                                    name: "Fusili Mushroom White Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "d5df473cf89e89a7f0cae44553ae9fea",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "4.2",
                                                                            ratingCount: "6 ratings",
                                                                            ratingCountV2: "6"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893295",
                                                                    name: "Penne Al Pesto",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893347",
                                                                    name: "Fusili Mushroom Mix Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.4",
                                                                            ratingCount: "3 ratings",
                                                                            ratingCountV2: "3"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893450",
                                                                    name: "Spaghetti Agli e olio",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "12563580",
                                                                    name: "Penne Veg White Sauce Creamy Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "96820e37b9482a60aca119d095cf729b",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "2.9",
                                                                            ratingCount: "21 ratings",
                                                                            ratingCountV2: "21"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893523",
                                                                    name: "Penne Veg Peri Peri",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {}
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        },
                                                        {
                                                            card: {
                                                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                                info: {
                                                                    id: "100893530",
                                                                    name: "Spaghetti Mix Sauce Pasta",
                                                                    category: "Pastas",
                                                                    description: "Serves 1",
                                                                    imageId: "9dcee1b5913aae284ffd57c00627bf35",
                                                                    inStock: 1,
                                                                    isVeg: 1,
                                                                    price: 39900,
                                                                    variants: {},
                                                                    variantsV2: {},
                                                                    itemAttribute: {
                                                                        vegClassifier: "VEG",
                                                                        portionSize: "Serves 1"
                                                                    },
                                                                    ribbon: {},
                                                                    type: "ITEM",
                                                                    itemBadge: {},
                                                                    badgesV2: {},
                                                                    ratings: {
                                                                        aggregatedRating: {
                                                                            rating: "3.4",
                                                                            ratingCount: "13 ratings",
                                                                            ratingCountV2: "13"
                                                                        }
                                                                    }
                                                                },
                                                                analytics: {},
                                                                hideRestaurantDetails: true
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Mocktails",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "7056301",
                                                            name: "Virgin Mojito",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "d0jjfnhf4t4brhchlw4b",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "183 ratings",
                                                                    ratingCountV2: "183"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "7056311",
                                                            name: "Green Apple Mojito",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "776a4a120fbce02806951ade1b97ded0",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.7",
                                                                    ratingCount: "50 ratings",
                                                                    ratingCountV2: "50"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805942",
                                                            name: "Blue Curacao",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805945",
                                                            name: "Passion Fruit",
                                                            category: "Mocktails",
                                                            description: "Serves 1",
                                                            imageId: "a134dc0225e7ca4b8e4b853a6b65407a",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "116447672",
                                                            name: "Spiced Jamun",
                                                            category: "Mocktails",
                                                            description: "Spicy flavour blended with special jamun flavour",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Iced Tea",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "73170623",
                                                            name: "Rose Ice Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271207",
                                                            name: "Lemon Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "52a616fff6521fcb4c28570bb91b84e5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 16000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "57 ratings",
                                                                    ratingCountV2: "57"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271209",
                                                            name: "Passion Fruit Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.6",
                                                                    ratingCount: "12 ratings",
                                                                    ratingCountV2: "12"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "12563606",
                                                            name: "Peach Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "r6g0oromxk8kkjqqrkrx",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.9",
                                                                    ratingCount: "19 ratings",
                                                                    ratingCountV2: "19"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "8271208",
                                                            name: "Green Apple Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.0",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806000",
                                                            name: "Black Berry Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806004",
                                                            name: "Pomegranate Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806012",
                                                            name: "Paan Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806015",
                                                            name: "Grenadine Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806016",
                                                            name: "Saffron Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806019",
                                                            name: "Watermelon Iced Tea",
                                                            category: "Iced Tea",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "117181217",
                                                            name: "Strawberry Iced Tea",
                                                            category: "Iced Tea",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 18000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Waffle",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805928",
                                                            name: "Double Banana Toffee Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805930",
                                                            name: "Single classic Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (Maple Syrup, Butter & Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805932",
                                                            name: "Double Classic Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 27000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805933",
                                                            name: "Single Strawberry Waffle With Nutella",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (real Strawberries, maple Syrup & Nutella)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "1.8",
                                                                    ratingCount: "3 ratings",
                                                                    ratingCountV2: "3"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805935",
                                                            name: "Double Strawberry Waffle With Nutella",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805938",
                                                            name: "Single Kitkat Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Nutella, Maple Syrup, Crushed Nuts, KitKat & Vanilla Ice-cream)",
                                                            imageId: "5d4d64797a3e4c43409eb3b79b826420",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805940",
                                                            name: "Double Kitkat Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.4",
                                                                    ratingCount: "14 ratings",
                                                                    ratingCountV2: "14"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805941",
                                                            name: "Single Oreo Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Nutella, Vanilla Ice-cream, Crushed Nuts & Oreo)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.8",
                                                                    ratingCount: "22 ratings",
                                                                    ratingCountV2: "22"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805943",
                                                            name: "Double Oreo Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805950",
                                                            name: "Single Fresh Fruits Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (Fresh Fruits, Maple Syrup, Whip cream, Vanilla ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.5",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805953",
                                                            name: "Double Fresh Fruits Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805963",
                                                            name: "Single Pineapple Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Real pineapple with Maple Syrup & vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805965",
                                                            name: "Double Pineapple Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805968",
                                                            name: "Single Ferrero Rocher Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Ferrero Rocher Chocolate with Nutella Topping & vanilla Ice-cream )",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 26000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "17 ratings",
                                                                    ratingCountV2: "17"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805970",
                                                            name: "Double Ferrero Rocher Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 48000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.4",
                                                                    ratingCount: "4 ratings",
                                                                    ratingCountV2: "4"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806051",
                                                            name: "Single Nutella Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple syrup, Nutella, Crushed Nuts & Vanilla Ice-cream)",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.2",
                                                                    ratingCount: "125 ratings",
                                                                    ratingCountV2: "125"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806055",
                                                            name: "Single Peanut Butter",
                                                            category: "Waffle",
                                                            description: "Serves 1 | ( Maple Syrup, Peanut Butter with Crushed nuts, Whip Cream & Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806057",
                                                            name: "Double Peanut Butter",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806059",
                                                            name: "Single Blueberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Whip Cream, Blueberry jam, Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "15 ratings",
                                                                    ratingCountV2: "15"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806061",
                                                            name: "Double Blueberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806063",
                                                            name: "Single Chocolate Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | (maple Syrup, Dark Chocolate, Crushed Nuts & Chocolate Ice-cream)",
                                                            imageId: "5d6f3edb647b154304beedd932887dbb",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "11 ratings",
                                                                    ratingCountV2: "11"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806065",
                                                            name: "Double Chocolate Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "2.8",
                                                                    ratingCount: "7 ratings",
                                                                    ratingCountV2: "7"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806067",
                                                            name: "Single Strawberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Maple Syrup, Whip Cream, Strawberry jam, Vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806068",
                                                            name: "Double Strawberry Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806069",
                                                            name: "Single Banana Toffee Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Fresh banana, maple Syrup, Whip Topping Cream, toffee Caramel)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 17000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "5.0",
                                                                    ratingCount: "5 ratings",
                                                                    ratingCountV2: "5"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96806053",
                                                            name: "Double Nutella Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            imageId: "1deeb6515010bf8158f3f9359f330951",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 32000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "4.0",
                                                                    ratingCount: "75 ratings",
                                                                    ratingCountV2: "75"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805957",
                                                            name: "Single Real Mango Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1 | Real Mangoes with Maple Syrup & vanilla Ice-cream)",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 22000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "96805959",
                                                            name: "Double Real Mango Waffle",
                                                            category: "Waffle",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 42000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                                            title: "Ice Teas",
                                            itemCards: [
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310298",
                                                            name: "Rose Ice Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310299",
                                                            name: "Lemon Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            imageId: "52a616fff6521fcb4c28570bb91b84e5",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 14000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {
                                                                    rating: "3.6",
                                                                    ratingCount: "57 ratings",
                                                                    ratingCountV2: "57"
                                                                }
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310300",
                                                            name: "Passion Fruit Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310301",
                                                            name: "Peach Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "101310302",
                                                            name: "Green Apple Iced Tea     ",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            imageId: "e49efb6c2db991b1b01fcea12a9980e4",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 15000,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                },
                                                {
                                                    card: {
                                                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                                        info: {
                                                            id: "124109210",
                                                            name: "Passion Fruit Mango Shake",
                                                            category: "Ice Teas",
                                                            description: "Serves 1",
                                                            inStock: 1,
                                                            isVeg: 1,
                                                            price: 19900,
                                                            variants: {},
                                                            variantsV2: {},
                                                            itemAttribute: {
                                                                vegClassifier: "VEG",
                                                                portionSize: "Serves 1"
                                                            },
                                                            ribbon: {},
                                                            type: "ITEM",
                                                            itemBadge: {},
                                                            badgesV2: {},
                                                            ratings: {
                                                                aggregatedRating: {}
                                                            }
                                                        },
                                                        analytics: {},
                                                        hideRestaurantDetails: true
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                                            type: "FSSAI",
                                            imageId: "fssai_final_edss9i",
                                            text: [
                                                "License No. 20821003000690"
                                            ]
                                        }
                                    }
                                },
                                {
                                    card: {
                                        card: {
                                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                                            name: "Lorem, ipsum",
                                            area: "Sector 15",
                                            completeAddress: "Shop - 144, booth no.163, Huda Market, sec15, faridabad"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        ],
        firstOffsetRequest: true,
        isQCLink: false
    },
    tid: "77533f11-5e8d-4b54-a4a7-1c92985210c7",
    sid: "d3bd968b-8262-4755-a5c0-d4ee42f09309",
    deviceId: "e0e3e09d-6aa7-46bd-b66e-86c981ba45d9",
    csrfToken: "QrzNyc0FD7FG-mWnJKo-_NXJdT_1A8Z2tGSo8wHQ"
};


const $4ba6a158d93aa7ac$var$useResData = ()=>{
    // console.log("inside my custom hooks");
    const [list, setList] = (0, $jzmb2.useState)(null);
    (0, $jzmb2.useEffect)(()=>{
        fetchData();
    }, []);
    async function fetchData() {
        // console.log("fetching data");
        let resDataJSON;
        let resData = await fetch((0, $3e8f8bb6c362ab6e$export$1087355e69a7a68)).then(async (val)=>resDataJSON = await val.json()).catch((err)=>resDataJSON = (0, $5c05fa9443b5f182$export$52daddf863f66fd0));
        // resDataJSON = await resData.json();
        let data = resDataJSON?.data?.cards[3]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
        let data2 = resDataJSON?.data?.cards.filter((res)=>res?.card?.card?.id == "restaurant_grid_listing")[0]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
        // console.log(data2);
        // let chkData = await fetch("https://www.swiggy.com/dapi/restaurants/list/update", {
        //   credentials: "include",
        //   body: '{"lat":28.4089123,"lng":77.3177894,"nextOffset":"COVCELQ4KIDAuc6q2JOxbTCnEw==","widgetOffset":{"NewListingView_category_bar_chicletranking_TwoRows":"","NewListingView_category_bar_chicletranking_TwoRows_Rendition":"","collectionV5RestaurantListWidget_SimRestoRelevance_food_seo":"10","inlineFacetFilter":"","restaurantCountWidget":""},"filters":{},"seoParams":{"seoUrl":"https://www.swiggy.com/","pageType":"FOOD_HOMEPAGE","apiName":"FoodHomePage"},"page_type":"DESKTOP_WEB_LISTING","_csrf":"xMtPPKeGppH7-ybrADDQf0wY8H0O3EnmPeJ2bjZs"}',
        //   method: "POST",
        // });
        // let json2=await chkData.json();
        // console.log(chkData);
        setList(data2);
    }
    return list;
};
var $4ba6a158d93aa7ac$export$2e2bcd8739ae039 = $4ba6a158d93aa7ac$var$useResData;


const $4453a727e0bf17f1$var$Filter = (props)=>{
    const { filteredListOfRest: filteredListOfRest, setfilteredListOfRest: setfilteredListOfRest } = props.Data;
    let listOfRest = (0, $4ba6a158d93aa7ac$export$2e2bcd8739ae039)();
    let [inputValue, setInputValue] = (0, $jzmb2.useState)("");
    let [showBestRest, setShowBestRest] = (0, $jzmb2.useState)(false);
    //console.log(props.Data, listOfRest);
    if (listOfRest != null && filteredListOfRest == null) setfilteredListOfRest(listOfRest);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "buttons filter flex items-center justify-center flex-wrap-reverse mb-4 gap-4 ",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                children: /*#__PURE__*/ (0, $hAhso.jsxs)("button", {
                    variant: "contained",
                    className: "hover:cursor-pointer uppercase hover:shadow-sm px-4 py-1.5 rounded text-white m-10 bg-[#F16667] hover:bg-[#dd4747]  dark:bg-[#dd4747]  dark:hover:bg-[#F16667] transition-colors duration-300 ease-in-out",
                    onClick: ()=>{
                        setInputValue("");
                        if (showBestRest == false) {
                            setfilteredListOfRest(listOfRest.filter((val)=>val.info.avgRating > 4.0));
                            setShowBestRest(true);
                        } else {
                            setfilteredListOfRest(listOfRest);
                            setShowBestRest(false);
                        }
                    },
                    children: [
                        showBestRest == false ? "Best" : "All",
                        " restaurants"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: " search ",
                children: /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                    className: "ml-5 mr-1 h-10 bg-slate-200 dark:text-black  px-3 outline-none rounded-lg ",
                    type: "text",
                    placeholder: "Search Hotels",
                    value: inputValue,
                    onChange: (e)=>{
                        console.log(e.target.value);
                        setInputValue(e.target.value);
                        setfilteredListOfRest(listOfRest.filter((res)=>{
                            return res.info.name.toLowerCase().includes(e.target.value.toLowerCase());
                        }));
                    }
                })
            })
        ]
    });
};
var $4453a727e0bf17f1$export$2e2bcd8739ae039 = $4453a727e0bf17f1$var$Filter;


//cardData[i].info.[name,id,cloudinaryImageId,cuisines,avgRatingString,.sla.slaString,locality,areaName]
// card data from swiggy
let $087d58400f5ed2f6$var$Cardcontainer = ()=>{
    let [filteredListOfRest, setfilteredListOfRest] = (0, $jzmb2.useState)(null);
    // console.log("im in body" ,filteredListOfRest)
    const status = (0, $c41a90b8b24590b3$export$2e2bcd8739ae039)();
    const CardWithVeg = (0, $285ce1d9de3b0754$export$e707e773b106c157)((0, $285ce1d9de3b0754$export$2e2bcd8739ae039));
    if (status == false) return /*#__PURE__*/ (0, $hAhso.jsx)((0, $632b8205818cb504$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: " mx-auto p-3  ",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)((0, $4453a727e0bf17f1$export$2e2bcd8739ae039), {
                Data: {
                    filteredListOfRest: filteredListOfRest,
                    setfilteredListOfRest: setfilteredListOfRest
                }
            }),
            filteredListOfRest == null ? /*#__PURE__*/ (0, $hAhso.jsx)((0, $1e8f367942753092$export$809644b82cfe94b1), {}) : /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: "Cardcontainer grid  grid-cols-[repeat(auto-fit,_minmax(320px,_1fr))] gap-6  justify-items-center items-center ",
                children: filteredListOfRest.map((res)=>{
                    // console.log(res?.info?.veg, res.info.name);
                    // console.log(res);
                    return /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        to: "/restraurant/" + res.info.id,
                        "data-testid": "rescard",
                        children: res?.info?.veg ? /*#__PURE__*/ (0, $hAhso.jsx)(CardWithVeg, {
                            data: res
                        }, res?.info?.id) : /*#__PURE__*/ (0, $hAhso.jsx)((0, $285ce1d9de3b0754$export$2e2bcd8739ae039), {
                            data: res
                        }, res?.info?.id)
                    });
                })
            })
        ]
    });
};
var $087d58400f5ed2f6$export$2e2bcd8739ae039 = $087d58400f5ed2f6$var$Cardcontainer;



var $hAhso = parcelRequire("hAhso");

var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");

class $782b0eef0d0a09ac$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($jzmb2))).Component {
    constructor(props){
        // to access props
        super(props);
        // console.log(props);
        // this.state = {
        //   // big object of state variable stores all state variables
        //   count: 0,
        //   count2: 2,
        // };
        // console.log(this.props.name+ " constructor ");
        this.state = {
            name: "Dummy",
            login: "Dummy",
            location: "Dummy"
        };
    }
    async componentDidMount() {
        // console.log(this.props.name + " comp did mount");
        // basically like useEffect with [] dependency
        //used for api calls
        //called after 1st render only
        const data = await fetch("https://api.github.com/users/PriyanshuD24");
        const json = await data.json();
        this.setState(json);
    }
    render() {
        //destructuring
        console.log(this.state);
        const { avatar_url: avatar_url, name: name, login: login, location: location } = this.state;
        // console.log(this.props.name + " rendered");
        return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
            className: "border-2 border-black dark:border-[#dedede] flex justify-between items-center  p-2 ",
            children: [
                " ",
                /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                    className: " text-xl flex flex-col  h-[148px] justify-evenly  ",
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                            children: [
                                "Name : ",
                                name,
                                " "
                            ]
                        }),
                        " ",
                        /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                            children: [
                                "Location : ",
                                location
                            ]
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                            to: "https://github.com/PriyanshuD24",
                            children: /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                                className: "hover:text-[#dd4747]  dark:hover:text-[#F16667]",
                                children: [
                                    "@",
                                    login
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "w-[148px] h-[148px] bg-[#f0f0f0]",
                    children: avatar_url ? /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                        src: avatar_url,
                        alt: "Github-avatar"
                    }) : null
                })
            ]
        });
    }
}
var $782b0eef0d0a09ac$export$2e2bcd8739ae039 = $782b0eef0d0a09ac$var$UserClass;



var $jzmb2 = parcelRequire("jzmb2");

class $7ef853266d152ac0$var$About extends (0, (/*@__PURE__*/$parcel$interopDefault($jzmb2))).Component {
    constructor(props){
        super(props);
    // console.log("parent constructor ");
    }
    componentDidMount() {
    // console.log("parent component did mount ");
    }
    render() {
        // console.log("parent render ");
        // a
        return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
            className: "max-w-[800px] mx-auto  ",
            children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $782b0eef0d0a09ac$export$2e2bcd8739ae039), {
                name: "child 1",
                locality: "Faridabad"
            })
        });
    }
}
var $7ef853266d152ac0$export$2e2bcd8739ae039 = $7ef853266d152ac0$var$About;



var $hAhso = parcelRequire("hAhso");
const $b4e8f7c8324af23f$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)("h1", {
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $hAhso.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                        type: "text",
                        placeholder: "name"
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                        type: "text",
                        name: "",
                        id: "",
                        placeholder: "message"
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        type: "submit",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $b4e8f7c8324af23f$export$2e2bcd8739ae039 = $b4e8f7c8324af23f$var$Contact;



var $hAhso = parcelRequire("hAhso");

const $9f8dc409fb6ebfc5$var$Error = ()=>{
    let err = (0, $545ec7bc5bb917bf$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hAhso.jsxs)("h1", {
                children: [
                    " ",
                    err.status,
                    ": ",
                    err.statusText,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("h2", {
                children: err.data
            })
        ]
    });
};
var $9f8dc409fb6ebfc5$export$2e2bcd8739ae039 = $9f8dc409fb6ebfc5$var$Error;



var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");



var $jzmb2 = parcelRequire("jzmb2");


const $b092db203bbafc92$var$useRestMenu = (resId)=>{
    const [resMenu, setResMenu] = (0, $jzmb2.useState)(null);
    (0, $jzmb2.useEffect)(()=>{
        fetchData();
    }, []);
    async function fetchData() {
        var json;
        const data = await fetch((0, $3e8f8bb6c362ab6e$export$b77c1aa4fb57bd1c) + resId).then(async (val)=>json = await val.json()).catch((err)=>json = (0, $5c05fa9443b5f182$export$bc4d6c843416a567));
        // json = await data.json();
        //console.log(json);
        // const cards = json?.data?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
        const cards = json?.data?.cards.filter((res)=>{
            return "groupedCard" in res;
        });
        setResMenu(cards[0].groupedCard?.cardGroupMap?.REGULAR?.cards);
    }
    // console.log(resMenu);
    return resMenu;
};
var $b092db203bbafc92$export$2e2bcd8739ae039 = $b092db203bbafc92$var$useRestMenu;



var $hAhso = parcelRequire("hAhso");
// show items of specific categories

var $hAhso = parcelRequire("hAhso");



const $e69d8c309e246038$var$cartSlice = (0, $b6edb054d04e55c6$export$4d8d9bd83c24ae8b)({
    //takes configratution
    name: "cart",
    initialState: {
        items: [],
        totalSum: 0
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            const element = action.payload;
            const idx = (0, $f0300f660fb65742$export$97aac956da55dae9)(state).items.indexOf(element);
            console.log(element, idx, state);
            state.items.splice(idx, 1);
        },
        clearCart: (state, action)=>{
            // state.items=[];
            state.items.length = 0;
            console.log((0, $f0300f660fb65742$export$97aac956da55dae9)(state));
            state.totalSum = 0;
        //return { items: [] , totalSum :0}; // returns the new state with items=[] & totalSum=0
        },
        getTotal: (state, action)=>{
            let Sum = 0;
            state.items.map((res)=>{
                const { price: price, defaultPrice: defaultPrice } = res?.card?.info;
                Sum += price || defaultPrice;
            });
            state.totalSum = Sum / 100;
        }
    }
});
var /*
basically this createSlice return an object with 2 keys ie
reducer (contains all the reducers)
and actions (contains all actions) 

cartSlice = {
    actions : {
        addItem : ,
        removeItem : ,
        clearCart : ,
    },
    reducers :
}
*/ $e69d8c309e246038$export$2e2bcd8739ae039 = $e69d8c309e246038$var$cartSlice.reducer;
const { addItem: $e69d8c309e246038$export$fb9705de59d96855, removeItem: $e69d8c309e246038$export$fe2d9b4e03920b4c, clearCart: $e69d8c309e246038$export$810121176e3e3671, getTotal: $e69d8c309e246038$export$94860ac4a286a8d9 } = $e69d8c309e246038$var$cartSlice.actions;


const $0cda065d7c0c4e9f$var$RestMenuCategoriesItems = (props)=>{
    const itemCards = props.data;
    const key = props?.Key; // to check rwhether this list is rendered from cart or not
    // console.log(props);
    const dispatch = (0, $13a78b650353eebe$export$8ad76b76a4c905f8)(); // returns a functions
    function handleAddItem(item) {
        dispatch((0, $e69d8c309e246038$export$fb9705de59d96855)(item)); // in this dipatch fn we send an action and in action we send the data ie (action.payload)
        dispatch((0, $e69d8c309e246038$export$94860ac4a286a8d9)());
    }
    function handleDelItem(item) {
        dispatch((0, $e69d8c309e246038$export$fe2d9b4e03920b4c)(item)); // in this dipatch fn we send an action and in action we send the data ie (action.payload)
        dispatch((0, $e69d8c309e246038$export$94860ac4a286a8d9)());
    }
    return /*#__PURE__*/ (0, $hAhso.jsx)("ul", {
        className: true,
        children: itemCards.map((res)=>{
            const { name: name, price: price, defaultPrice: defaultPrice, imageId: imageId, description: description, isVeg: isVeg } = res?.card?.info;
            return /*#__PURE__*/ (0, $hAhso.jsxs)("li", {
                className: "  pb-2  flex justify-between items-center  py-4 border-b-2 border-[#f0f0f0] relative",
                "data-testid": key != undefined ? "addedResCart" : "addedRes",
                children: [
                    /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                                className: "w-4 mb-2",
                                children: isVeg ? /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                    src: (0, $3e8f8bb6c362ab6e$export$f89a830e1c49df8f),
                                    alt: ""
                                }) : /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                    src: (0, $3e8f8bb6c362ab6e$export$ecdeacdb356c62b),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                                className: "text-lg",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                                className: "my-2 font-semibold",
                                children: [
                                    " \u20B9",
                                    price / 100 || defaultPrice / 100
                                ]
                            }),
                            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                                className: " text-sm text-[#8b8b8b]  overflow-hidden",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                        className: " w-32 flex flex-col justify-center items-center  ml-6",
                        children: [
                            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                                className: "w-[118px] h-[96px]",
                                children: imageId ? /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                    className: " w-[118px] h-[96px] object-cover overflow-hidden rounded-md outline-none",
                                    alt: "",
                                    src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + imageId
                                }) : /*#__PURE__*/ (0, $hAhso.jsx)((0, $hAhso.Fragment), {})
                            }),
                            key != "incart" ? /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                className: " relative bottom-6 bg-white w-[100px]   border-2 text-green-400 border-[#f0f0f0] px-2 mt-2 hover:shadow-xl ",
                                onClick: ()=>handleAddItem(res),
                                "data-testid": name,
                                children: "ADD"
                            }) : /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                className: " relative bottom-6 bg-white w-[100px]   border-2 text-green-400 border-[#f0f0f0] px-2 mt-2 hover:shadow-xl ",
                                onClick: ()=>{
                                    handleDelItem(res);
                                },
                                "data-testid": name + "remove",
                                children: "Remove"
                            })
                        ]
                    })
                ]
            });
        })
    });
};
var $0cda065d7c0c4e9f$export$2e2bcd8739ae039 = $0cda065d7c0c4e9f$var$RestMenuCategoriesItems;


const $89530b78aa4ea1f2$var$RestMenuCategories = (props)=>{
    // console.log("inside RestMenuCat");
    // const [isVisible, setIsVisible] = useState(true);
    const { itemCards: itemCards, title: title } = props.data;
    const { open: open, setIsVisible: setIsVisible, idx: idx } = props;
    // console.log("in categories " , idx ,open);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "my-4",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                className: "font-bold text-2xl pb-4  hover:cursor-pointer  ",
                onClick: ()=>{
                    setIsVisible();
                },
                children: [
                    title,
                    " (",
                    itemCards.length,
                    ")"
                ]
            }),
            open == idx && /*#__PURE__*/ (0, $hAhso.jsx)((0, $0cda065d7c0c4e9f$export$2e2bcd8739ae039), {
                data: itemCards
            })
        ]
    });
};
var $89530b78aa4ea1f2$export$2e2bcd8739ae039 = $89530b78aa4ea1f2$var$RestMenuCategories;


// import Collapsible from 'react-collapsible';
// import { RES_LOGO } from "../utils/cdn_url";
const $b4a2759169df00e9$var$RestMenu = ()=>{
    var { resId: resId } = (0, $545ec7bc5bb917bf$export$99eaa27ddbbb95ef)();
    const resMenu = (0, $b092db203bbafc92$export$2e2bcd8739ae039)(resId);
    const [isVisible, setIsVisible] = (0, $jzmb2.useState)(null); // index that is visible
    (0, $jzmb2.useEffect)(()=>{
        window.scrollTo(0, 0); // to scroll on top
    }, []);
    if (resMenu == null || resMenu == undefined) return /*#__PURE__*/ (0, $hAhso.jsx)((0, $1e8f367942753092$export$809644b82cfe94b1), {});
    const len = resMenu.length - 1;
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "max-w-[800px] mx-auto px-4",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: " font-extrabold text-4xl pb-6 ",
                children: resMenu[len]?.card?.card?.name
            }),
            resMenu.map((arr, index)=>{
                if (arr?.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory") // console.log("hi");
                return /*#__PURE__*/ (0, $hAhso.jsx)((0, $89530b78aa4ea1f2$export$2e2bcd8739ae039), {
                    data: arr?.card?.card,
                    setIsVisible: ()=>{
                        return index == isVisible ? setIsVisible(null) : setIsVisible(index);
                    },
                    open: isVisible,
                    idx: index
                });
            })
        ]
    });
};
var $b4a2759169df00e9$export$2e2bcd8739ae039 = $b4a2759169df00e9$var$RestMenu;




var $hAhso = parcelRequire("hAhso");




const $7153db29559b9b7c$var$Cart = ()=>{
    const cartItems = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.cart.items);
    const totalPrice = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.cart.totalSum);
    const dispatch = (0, $13a78b650353eebe$export$8ad76b76a4c905f8)();
    function handleClick() {
        dispatch((0, $e69d8c309e246038$export$810121176e3e3671)());
    }
    // console.log(cartItems);
    return /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
        className: "max-w-[800px] mx-auto p-3 px-4 ",
        children: [
            /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                        className: "font-bold text-center text-3xl",
                        children: "Cart"
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        className: "px-4 py-1.5 bg-[#F16667] hover:bg-[#dd4747] text-white rounded dark:bg-[#dd4747]  dark:hover:bg-[#F16667]  transition-colors duration-300 ease-in-out",
                        onClick: handleClick,
                        children: "Clear All"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                className: "mb-8 ",
                children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $0cda065d7c0c4e9f$export$2e2bcd8739ae039), {
                    data: cartItems,
                    Key: "incart"
                })
            }),
            totalPrice != 0 && /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                className: " flex justify-between items-center ",
                children: [
                    /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                        className: "font-semibold text-xl text-left",
                        children: [
                            "Total : \u20B9",
                            totalPrice,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        to: "/payment",
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                            className: "px-4 py-1.5 bg-[#F16667] hover:bg-[#dd4747] text-white rounded dark:bg-[#dd4747]  dark:hover:bg-[#F16667] transition duration-300 ease-in-out",
                            children: "PAY"
                        })
                    })
                ]
            })
        ]
    });
};
var $7153db29559b9b7c$export$2e2bcd8739ae039 = $7153db29559b9b7c$var$Cart;




var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");



function $c128e8997dd388a2$export$2e2bcd8739ae039() {
    const [val, setVal] = (0, $jzmb2.useState)("");
    const data = (0, $jzmb2.useContext)((0, $ff6d97cdc0613e88$export$2e2bcd8739ae039));
    const { dummyData: dummyData, changeDummyData: changeDummyData } = data;
    const [user, setUser] = (0, $jzmb2.useState)("");
    const [email, setEmail] = (0, $jzmb2.useState)("");
    const [password, setPassword] = (0, $jzmb2.useState)("");
    const firebase = (0, $jzmb2.useContext)((0, $5741cae07859eab0$export$a0fd8390cfe8ae69));
    //   console.log(data);
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: "max-w-md w-full mx-auto rounded-lg shadow-lg overflow-hidden ",
        children: /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
            className: "bg-white px-6 py-8 ",
            children: [
                /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                    className: "text-center mb-6",
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsx)("h2", {
                            className: "text-2xl font-semibold text-gray-800",
                            children: "Welcome Back!"
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)("p", {
                            className: "mt-2 text-sm text-gray-600",
                            children: "Sign in to your account"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsx)("label", {
                            htmlFor: "email",
                            className: "block text-sm font-medium text-gray-700",
                            children: "Email Address"
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                            type: "email",
                            name: "email",
                            id: "email",
                            className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                            placeholder: "Enter your email address",
                            onChange: (e)=>setEmail(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsx)("label", {
                            htmlFor: "password",
                            className: "block text-sm font-medium  text-gray-700",
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                            type: "password",
                            name: "password",
                            id: "password",
                            className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                            placeholder: "Enter your password",
                            onChange: (e)=>setPassword(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                            className: "w-full px-4 py-2 text-base font-semibold text-white bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:bg-indigo-700",
                            onClick: ()=>{
                                console.log("clicked");
                            },
                            children: "Sign In"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $hAhso.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Sign in with google",
                            /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                    className: "text-indigo-600 hover:text-indigo-500 ml-1",
                                    onClick: ()=>{
                                        firebase.signInWithGoogle();
                                    },
                                    children: "Google"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $hAhso.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Don't have an account yet?",
                            /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                                to: "/signup",
                                children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                    className: "text-indigo-600 hover:text-indigo-500 ml-1",
                                    children: "Sign Up"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}






const $0460a2b3c65be6be$var$appStore = (0, $b6edb054d04e55c6$export$7d8a5b498da695ac)({
    reducer: {
        // this reducer contains all the slices of main redux store
        cart: (0, $e69d8c309e246038$export$2e2bcd8739ae039),
        themeChanger: (0, $6f1d62e9ba514404$export$2e2bcd8739ae039)
    }
}); // initially it empty
var $0460a2b3c65be6be$export$2e2bcd8739ae039 = $0460a2b3c65be6be$var$appStore;



var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");








const $1332c412b58f1ff3$var$HeaderMobile = ()=>{
    const [btn, setbtn] = (0, $jzmb2.useState)("Login");
    const status = (0, $c41a90b8b24590b3$export$2e2bcd8739ae039)();
    const data = (0, $jzmb2.useContext)((0, $ff6d97cdc0613e88$export$2e2bcd8739ae039));
    const { dummyData: dummyData, changeDummyData: changeDummyData } = data;
    let { myName: myName } = dummyData;
    const themeData = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.themeChanger.theme);
    const dispatch = (0, $13a78b650353eebe$export$8ad76b76a4c905f8)();
    // console.log(dummyData);
    let cartItems = (0, $13a78b650353eebe$export$2105062e25df4afe)((store)=>store.cart.items); // cartItems = [] (initialstate.items)
    // console.log(cartItems);
    const firebase = (0, $jzmb2.useContext)((0, $5741cae07859eab0$export$a0fd8390cfe8ae69));
    const [isUserLoggedIn, setisUserLoggedIn] = (0, $jzmb2.useState)(null);
    const auth = (0, $1d3138fe302b21d0$export$ae1af26003f05816)((0, $5741cae07859eab0$export$729c8b7179294ba));
    (0, $jzmb2.useEffect)(()=>{
        console.log("header use effect called");
        (0, $1d3138fe302b21d0$export$4a5767248b18ef41)(auth, (user)=>{
            console.log("header on auth change run");
            if (user != isUserLoggedIn) {
                console.log("header ", user, user?.displayName);
                setisUserLoggedIn(user);
            } else setisUserLoggedIn(null);
        });
    }, []);
    function handleThemeClick() {
        console.log(themeData);
        //themeData=="light" ? dispatch(toogleTheme("dark")) : dispatch(toogleTheme("light"));
        if (themeData == "light") {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $6f1d62e9ba514404$export$9443a770e75d2a08)("dark"));
        } else {
            document.documentElement.classList.toggle("dark");
            dispatch((0, $6f1d62e9ba514404$export$9443a770e75d2a08)("light"));
        }
    }
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        children: /*#__PURE__*/ (0, $hAhso.jsxs)("ul", {
            className: " md:hidden flex flex-col items-center gap-8 lg:gap-10 ",
            id: "list",
            children: [
                isUserLoggedIn?.displayName && /*#__PURE__*/ (0, $hAhso.jsxs)("li", {
                    children: [
                        "Hey, ",
                        isUserLoggedIn?.displayName,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        className: "w-8 ",
                        onClick: handleThemeClick,
                        children: /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                            src: themeData == "light" ? (0, $3e8f8bb6c362ab6e$export$3e936a8db52a10a0) : (0, $3e8f8bb6c362ab6e$export$f30cb9bc4f736419)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsxs)("li", {
                    children: [
                        "Online Status:",
                        status ? "\u2705" : "\u274C",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/",
                        children: "Home"
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/about",
                        children: "About Us"
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/grocery",
                        children: "Grocery"
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: /*#__PURE__*/ (0, $hAhso.jsxs)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        className: "hover:text-[#dd4747]",
                        to: "/cart",
                        children: [
                            /*#__PURE__*/ (0, $hAhso.jsx)("img", {
                                src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Shopping_cart_icon.svg/1250px-Shopping_cart_icon.svg.png",
                                className: "w-8 inline"
                            }),
                            /*#__PURE__*/ (0, $hAhso.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    "(",
                                    cartItems.length,
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("li", {
                    children: isUserLoggedIn?.displayName ? /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                        onClick: ()=>firebase.signout(),
                        children: "Logout"
                    }) : /*#__PURE__*/ (0, $hAhso.jsxs)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        children: [
                            /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                className: " hover:cursor-pointer bg-[#F16667] hover:bg-[#dd4747]  text-white hover:shadow-sm px-4 py-1.5 dark:bg-[#dd4747]  dark:hover:bg-[#F16667] rounded transition duration-300 ease-in-out ",
                                children: "Login"
                            }),
                            " "
                        ]
                    })
                })
            ]
        })
    });
};
var $1332c412b58f1ff3$export$2e2bcd8739ae039 = $1332c412b58f1ff3$var$HeaderMobile;



var $hAhso = parcelRequire("hAhso");
const $3e85d21dcb915cd6$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: "py-3  text-center bg-slate-500 text-white dark:bg-slate-700  absolute bottom-0 left-0 w-[100%] ",
        children: "\xa9 2024 Food Delivery App"
    });
};



var $hAhso = parcelRequire("hAhso");



const $a1f9629d3bef246d$export$ad8b2382ee557dc0 = ()=>{
    let dispatch = (0, $13a78b650353eebe$export$8ad76b76a4c905f8)();
    function handleclick() {
        dispatch((0, $e69d8c309e246038$export$810121176e3e3671)());
    }
    return(// <div class="bg-gray-100">
    /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: "flex justify-center items-center p-2  ",
        children: /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
            className: "bg-white rounded-lg shadow-md p-8 max-w-md text-center",
            children: [
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "text-4xl text-green-500",
                    children: "\u2713"
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("h1", {
                    className: "text-2xl font-bold text-gray-800 mt-4",
                    children: "Order Successfully Placed"
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("p", {
                    className: "text-gray-600 mt-2",
                    children: "Your order has been successfully placed. Thank you!"
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                        className: "bg-[#F16667] hover:bg-[#dd4747] dark:bg-[#dd4747]  dark:hover:bg-[#F16667] text-white font-bold py-2 px-4 rounded mt-4 transition duration-300 ease-in-out",
                        onClick: handleclick,
                        children: "Continue Shopping"
                    })
                })
            ]
        })
    }));
};




var $hAhso = parcelRequire("hAhso");

var $jzmb2 = parcelRequire("jzmb2");


function $2f8a13c4fcbad374$export$2e2bcd8739ae039() {
    const [user, setUser] = (0, $jzmb2.useState)("");
    const [email, setEmail] = (0, $jzmb2.useState)("");
    const [name, setName] = (0, $jzmb2.useState)("");
    const [password, setPassword] = (0, $jzmb2.useState)("");
    const firebase = (0, $jzmb2.useContext)((0, $5741cae07859eab0$export$a0fd8390cfe8ae69));
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: "max-w-md w-full mx-auto rounded-lg shadow-lg overflow-hidden",
        children: /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
            className: "bg-white px-6 py-8",
            children: [
                /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsx)("h2", {
                            className: "text-2xl font-semibold text-gray-800",
                            children: "Welcome Back!"
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)("p", {
                            className: "mt-2 text-sm text-gray-600",
                            children: "Sign up to your account"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsxs)("form", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $hAhso.jsx)("label", {
                                    htmlFor: "email",
                                    className: "block text-sm font-medium text-gray-700",
                                    children: "Full Name"
                                }),
                                /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                                    type: "text",
                                    name: "email",
                                    id: "email",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your full name",
                                    required: true,
                                    onChange: (e)=>setName(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $hAhso.jsx)("label", {
                                    htmlFor: "email",
                                    className: "block text-sm font-medium text-gray-700",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your email address",
                                    onChange: (e)=>setEmail(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $hAhso.jsx)("label", {
                                    htmlFor: "password",
                                    className: "block text-sm font-medium  text-gray-700",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $hAhso.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    className: "mt-1 text-black focus:ring-indigo-500 focus:border-indigo-500 py-1 px-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    placeholder: "Enter your password",
                                    onChange: (e)=>setPassword(e.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                    type: "submit",
                                    className: "w-full px-4 py-2 text-base font-semibold text-white bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:bg-indigo-700",
                                    onClick: ()=>{
                                        firebase.signUp(email, password, name);
                                    },
                                    children: "Sign Up"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $hAhso.jsxs)("p", {
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            "Already have account?",
                            " ",
                            /*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$a6c7ac8248d6e38a), {
                                to: "/login",
                                children: /*#__PURE__*/ (0, $hAhso.jsx)("button", {
                                    type: "submit",
                                    className: "text-indigo-600 hover:text-indigo-500",
                                    children: "Sign In"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}



const $224d778d687a695c$var$Grocery = /*#__PURE__*/ (0, $jzmb2.lazy)(()=>(parcelRequire("1XB36")));
let $224d778d687a695c$var$Container = ()=>{
    console.log(window.screen.width);
    const defContext = (0, $jzmb2.useContext)((0, $ff6d97cdc0613e88$export$2e2bcd8739ae039));
    const [dummyData, setdummyData] = (0, $jzmb2.useState)(defContext);
    function changeDummyData(newData) {
        // console.log(newData);
        setdummyData({
            myName: newData
        });
    }
    return /*#__PURE__*/ (0, $hAhso.jsx)("div", {
        className: "dark:bg-[#111111] dark:text-white bg-fixed backdrop-blur-lg duration-100 max-w-[100vw] ",
        children: /*#__PURE__*/ (0, $hAhso.jsx)("div", {
            className: "max-w-[1400px] mx-auto min-h-screen px-2 ",
            children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $13a78b650353eebe$export$2881499e37b75b9a), {
                store: (0, $0460a2b3c65be6be$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $ff6d97cdc0613e88$export$2e2bcd8739ae039).Provider, {
                    value: {
                        dummyData: dummyData,
                        changeDummyData: changeDummyData
                    },
                    children: /*#__PURE__*/ (0, $hAhso.jsxs)((0, $5741cae07859eab0$export$87091915187a1a85), {
                        children: [
                            /*#__PURE__*/ (0, $hAhso.jsx)((0, $d3e879c95fd97bd4$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $hAhso.jsx)("div", {
                                className: "pb-20",
                                children: /*#__PURE__*/ (0, $hAhso.jsx)((0, $545ec7bc5bb917bf$export$910ae8079b2c2852), {})
                            }),
                            /*#__PURE__*/ (0, $hAhso.jsx)((0, $3e85d21dcb915cd6$export$a06f1c675e846f6f), {})
                        ]
                    })
                })
            })
        })
    });
};
const $224d778d687a695c$var$approuter = (0, $d210e937315889a3$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $hAhso.jsx)($224d778d687a695c$var$Container, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $087d58400f5ed2f6$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $7ef853266d152ac0$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $b4e8f7c8324af23f$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $hAhso.jsxs)((0, $jzmb2.Suspense), {
                    fallback: /*#__PURE__*/ (0, $hAhso.jsx)("h1", {
                        children: "Loading....."
                    }),
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $hAhso.jsx)($224d778d687a695c$var$Grocery, {}),
                        " "
                    ]
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $7153db29559b9b7c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/login",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $c128e8997dd388a2$export$2e2bcd8739ae039), {})
            },
            {
                path: "/signup",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $2f8a13c4fcbad374$export$2e2bcd8739ae039), {})
            },
            {
                path: "/payment",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $a1f9629d3bef246d$export$ad8b2382ee557dc0), {})
            },
            {
                path: "/restraurant/:resId",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $b4a2759169df00e9$export$2e2bcd8739ae039), {})
            },
            window.screen.width < 768 && {
                path: "/header",
                element: /*#__PURE__*/ (0, $hAhso.jsx)((0, $1332c412b58f1ff3$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $hAhso.jsx)((0, $9f8dc409fb6ebfc5$export$2e2bcd8739ae039), {})
    }
]);
let $224d778d687a695c$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($808d048e85732009$exports))).createRoot(document.querySelector(".root"));
// root.render(<Container/>)
$224d778d687a695c$var$root.render(/*#__PURE__*/ (0, $hAhso.jsx)((0, $d210e937315889a3$export$323e4fc2fa4753fb), {
    router: $224d778d687a695c$var$approuter
}));


//# sourceMappingURL=index.79c54a96.js.map
